var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);

// node_modules/@algolia/recommend/dist/recommend.umd.js
var require_recommend_umd = __commonJS({
  "node_modules/@algolia/recommend/dist/recommend.umd.js"(exports, module) {
    !function(e, t) {
      "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = e || self)["@algolia/recommend"] = t();
    }(exports, function() {
      "use strict";
      function e(e2, t2, r2) {
        return t2 in e2 ? Object.defineProperty(e2, t2, { value: r2, enumerable: true, configurable: true, writable: true }) : e2[t2] = r2, e2;
      }
      function t(e2, t2) {
        var r2 = Object.keys(e2);
        if (Object.getOwnPropertySymbols) {
          var n2 = Object.getOwnPropertySymbols(e2);
          t2 && (n2 = n2.filter(function(t3) {
            return Object.getOwnPropertyDescriptor(e2, t3).enumerable;
          })), r2.push.apply(r2, n2);
        }
        return r2;
      }
      function r(r2) {
        for (var n2 = 1; n2 < arguments.length; n2++) {
          var o2 = null != arguments[n2] ? arguments[n2] : {};
          n2 % 2 ? t(Object(o2), true).forEach(function(t2) {
            e(r2, t2, o2[t2]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r2, Object.getOwnPropertyDescriptors(o2)) : t(Object(o2)).forEach(function(e2) {
            Object.defineProperty(r2, e2, Object.getOwnPropertyDescriptor(o2, e2));
          });
        }
        return r2;
      }
      function n(e2, t2) {
        return function(e3) {
          if (Array.isArray(e3)) return e3;
        }(e2) || function(e3, t3) {
          if (!(Symbol.iterator in Object(e3) || "[object Arguments]" === Object.prototype.toString.call(e3))) return;
          var r2 = [], n2 = true, o2 = false, a2 = void 0;
          try {
            for (var i2, u2 = e3[Symbol.iterator](); !(n2 = (i2 = u2.next()).done) && (r2.push(i2.value), !t3 || r2.length !== t3); n2 = true) ;
          } catch (e4) {
            o2 = true, a2 = e4;
          } finally {
            try {
              n2 || null == u2.return || u2.return();
            } finally {
              if (o2) throw a2;
            }
          }
          return r2;
        }(e2, t2) || function() {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }();
      }
      function o(e2) {
        return function(e3) {
          if (Array.isArray(e3)) {
            for (var t2 = 0, r2 = new Array(e3.length); t2 < e3.length; t2++) r2[t2] = e3[t2];
            return r2;
          }
        }(e2) || function(e3) {
          if (Symbol.iterator in Object(e3) || "[object Arguments]" === Object.prototype.toString.call(e3)) return Array.from(e3);
        }(e2) || function() {
          throw new TypeError("Invalid attempt to spread non-iterable instance");
        }();
      }
      function a(e2) {
        var t2, r2 = "algoliasearch-client-js-".concat(e2.key), o2 = function() {
          return void 0 === t2 && (t2 = e2.localStorage || window.localStorage), t2;
        }, a2 = function() {
          return JSON.parse(o2().getItem(r2) || "{}");
        }, i2 = function(e3) {
          o2().setItem(r2, JSON.stringify(e3));
        }, u2 = function() {
          var t3 = e2.timeToLive ? 1e3 * e2.timeToLive : null, r3 = a2(), o3 = Object.fromEntries(Object.entries(r3).filter(function(e3) {
            return void 0 !== n(e3, 2)[1].timestamp;
          }));
          if (i2(o3), t3) {
            var u3 = Object.fromEntries(Object.entries(o3).filter(function(e3) {
              var r4 = n(e3, 2)[1], o4 = (/* @__PURE__ */ new Date()).getTime();
              return !(r4.timestamp + t3 < o4);
            }));
            i2(u3);
          }
        };
        return { get: function(e3, t3) {
          var r3 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : { miss: function() {
            return Promise.resolve();
          } };
          return Promise.resolve().then(function() {
            u2();
            var t4 = JSON.stringify(e3);
            return a2()[t4];
          }).then(function(e4) {
            return Promise.all([e4 ? e4.value : t3(), void 0 !== e4]);
          }).then(function(e4) {
            var t4 = n(e4, 2), o3 = t4[0], a3 = t4[1];
            return Promise.all([o3, a3 || r3.miss(o3)]);
          }).then(function(e4) {
            return n(e4, 1)[0];
          });
        }, set: function(e3, t3) {
          return Promise.resolve().then(function() {
            var n2 = a2();
            return n2[JSON.stringify(e3)] = { timestamp: (/* @__PURE__ */ new Date()).getTime(), value: t3 }, o2().setItem(r2, JSON.stringify(n2)), t3;
          });
        }, delete: function(e3) {
          return Promise.resolve().then(function() {
            var t3 = a2();
            delete t3[JSON.stringify(e3)], o2().setItem(r2, JSON.stringify(t3));
          });
        }, clear: function() {
          return Promise.resolve().then(function() {
            o2().removeItem(r2);
          });
        } };
      }
      function i(e2) {
        var t2 = o(e2.caches), r2 = t2.shift();
        return void 0 === r2 ? { get: function(e3, t3) {
          var r3 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : { miss: function() {
            return Promise.resolve();
          } }, o2 = t3();
          return o2.then(function(e4) {
            return Promise.all([e4, r3.miss(e4)]);
          }).then(function(e4) {
            return n(e4, 1)[0];
          });
        }, set: function(e3, t3) {
          return Promise.resolve(t3);
        }, delete: function(e3) {
          return Promise.resolve();
        }, clear: function() {
          return Promise.resolve();
        } } : { get: function(e3, n2) {
          var o2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : { miss: function() {
            return Promise.resolve();
          } };
          return r2.get(e3, n2, o2).catch(function() {
            return i({ caches: t2 }).get(e3, n2, o2);
          });
        }, set: function(e3, n2) {
          return r2.set(e3, n2).catch(function() {
            return i({ caches: t2 }).set(e3, n2);
          });
        }, delete: function(e3) {
          return r2.delete(e3).catch(function() {
            return i({ caches: t2 }).delete(e3);
          });
        }, clear: function() {
          return r2.clear().catch(function() {
            return i({ caches: t2 }).clear();
          });
        } };
      }
      function u() {
        var e2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : { serializable: true }, t2 = {};
        return { get: function(r2, n2) {
          var o2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : { miss: function() {
            return Promise.resolve();
          } }, a2 = JSON.stringify(r2);
          if (a2 in t2) return Promise.resolve(e2.serializable ? JSON.parse(t2[a2]) : t2[a2]);
          var i2 = n2(), u2 = o2 && o2.miss || function() {
            return Promise.resolve();
          };
          return i2.then(function(e3) {
            return u2(e3);
          }).then(function() {
            return i2;
          });
        }, set: function(r2, n2) {
          return t2[JSON.stringify(r2)] = e2.serializable ? JSON.stringify(n2) : n2, Promise.resolve(n2);
        }, delete: function(e3) {
          return delete t2[JSON.stringify(e3)], Promise.resolve();
        }, clear: function() {
          return t2 = {}, Promise.resolve();
        } };
      }
      function s(e2) {
        for (var t2 = e2.length - 1; t2 > 0; t2--) {
          var r2 = Math.floor(Math.random() * (t2 + 1)), n2 = e2[t2];
          e2[t2] = e2[r2], e2[r2] = n2;
        }
        return e2;
      }
      var c = { WithinQueryParameters: 0, WithinHeaders: 1 }, l = 1, f = 2, m = 3;
      function d(e2, t2) {
        var r2 = e2 || {}, n2 = r2.data || {};
        return Object.keys(r2).forEach(function(e3) {
          -1 === ["timeout", "headers", "queryParameters", "data", "cacheable"].indexOf(e3) && (n2[e3] = r2[e3]);
        }), { data: Object.entries(n2).length > 0 ? n2 : void 0, timeout: r2.timeout || t2, headers: r2.headers || {}, queryParameters: r2.queryParameters || {}, cacheable: r2.cacheable };
      }
      var h = { Read: 1, Write: 2, Any: 3 }, p = 1, g = 2, v = 3;
      function y2(e2) {
        var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : p;
        return r(r({}, e2), {}, { status: t2, lastUpdate: Date.now() });
      }
      function b(e2) {
        return "string" == typeof e2 ? { protocol: "https", url: e2, accept: h.Any } : { protocol: e2.protocol || "https", url: e2.url, accept: e2.accept || h.Any };
      }
      var O2 = "GET", P = "POST";
      function q2(e2, t2) {
        return Promise.all(t2.map(function(t3) {
          return e2.get(t3, function() {
            return Promise.resolve(y2(t3));
          });
        })).then(function(e3) {
          var r2 = e3.filter(function(e4) {
            return function(e5) {
              return e5.status === p || Date.now() - e5.lastUpdate > 12e4;
            }(e4);
          }), n2 = e3.filter(function(e4) {
            return function(e5) {
              return e5.status === v && Date.now() - e5.lastUpdate <= 12e4;
            }(e4);
          }), a2 = [].concat(o(r2), o(n2));
          return { getTimeout: function(e4, t3) {
            return (0 === n2.length && 0 === e4 ? 1 : n2.length + 3 + e4) * t3;
          }, statelessHosts: a2.length > 0 ? a2.map(function(e4) {
            return b(e4);
          }) : t2 };
        });
      }
      function S2(e2, t2, n2, a2) {
        var i2 = [], u2 = function(e3, t3) {
          if (e3.method === O2 || void 0 === e3.data && void 0 === t3.data) return;
          var n3 = Array.isArray(e3.data) ? e3.data : r(r({}, e3.data), t3.data);
          return JSON.stringify(n3);
        }(n2, a2), s2 = function(e3, t3) {
          var n3 = r(r({}, e3.headers), t3.headers), o2 = {};
          return Object.keys(n3).forEach(function(e4) {
            var t4 = n3[e4];
            o2[e4.toLowerCase()] = t4;
          }), o2;
        }(e2, a2), c2 = n2.method, l2 = n2.method !== O2 ? {} : r(r({}, n2.data), a2.data), f2 = r(r(r({ "x-algolia-agent": e2.userAgent.value }, e2.queryParameters), l2), a2.queryParameters), m2 = 0, d2 = function t3(r2, o2) {
          var l3 = r2.pop();
          if (void 0 === l3) throw { name: "RetryError", message: "Unreachable hosts - your application id may be incorrect. If the error persists, please reach out to the Algolia Support team: https://alg.li/support .", transporterStackTrace: w(i2) };
          var d3 = { data: u2, headers: s2, method: c2, url: T2(l3, n2.path, f2), connectTimeout: o2(m2, e2.timeouts.connect), responseTimeout: o2(m2, a2.timeout) }, h2 = function(e3) {
            var t4 = { request: d3, response: e3, host: l3, triesLeft: r2.length };
            return i2.push(t4), t4;
          }, p2 = { onSuccess: function(e3) {
            return function(e4) {
              try {
                return JSON.parse(e4.content);
              } catch (t4) {
                throw /* @__PURE__ */ function(e5, t5) {
                  return { name: "DeserializationError", message: e5, response: t5 };
                }(t4.message, e4);
              }
            }(e3);
          }, onRetry: function(n3) {
            var a3 = h2(n3);
            return n3.isTimedOut && m2++, Promise.all([e2.logger.info("Retryable failure", A2(a3)), e2.hostsCache.set(l3, y2(l3, n3.isTimedOut ? v : g))]).then(function() {
              return t3(r2, o2);
            });
          }, onFail: function(e3) {
            throw h2(e3), function(e4, t4) {
              var r3 = e4.content, n3 = e4.status, o3 = r3;
              try {
                o3 = JSON.parse(r3).message;
              } catch (e5) {
              }
              return /* @__PURE__ */ function(e5, t5, r4) {
                return { name: "ApiError", message: e5, status: t5, transporterStackTrace: r4 };
              }(o3, n3, t4);
            }(e3, w(i2));
          } };
          return e2.requester.send(d3).then(function(e3) {
            return function(e4, t4) {
              return function(e5) {
                var t5 = e5.status;
                return e5.isTimedOut || function(e6) {
                  var t6 = e6.isTimedOut, r3 = e6.status;
                  return !t6 && 0 == ~~r3;
                }(e5) || 2 != ~~(t5 / 100) && 4 != ~~(t5 / 100);
              }(e4) ? t4.onRetry(e4) : 2 == ~~(e4.status / 100) ? t4.onSuccess(e4) : t4.onFail(e4);
            }(e3, p2);
          });
        };
        return q2(e2.hostsCache, t2).then(function(e3) {
          return d2(o(e3.statelessHosts).reverse(), e3.getTimeout);
        });
      }
      function j2(e2) {
        var t2 = { value: "Algolia for JavaScript (".concat(e2, ")"), add: function(e3) {
          var r2 = "; ".concat(e3.segment).concat(void 0 !== e3.version ? " (".concat(e3.version, ")") : "");
          return -1 === t2.value.indexOf(r2) && (t2.value = "".concat(t2.value).concat(r2)), t2;
        } };
        return t2;
      }
      function T2(e2, t2, r2) {
        var n2, o2 = (n2 = r2, Object.keys(n2).map(function(e3) {
          return function(e4) {
            for (var t4 = arguments.length, r3 = new Array(t4 > 1 ? t4 - 1 : 0), n3 = 1; n3 < t4; n3++) r3[n3 - 1] = arguments[n3];
            var o3 = 0;
            return e4.replace(/%s/g, function() {
              return encodeURIComponent(r3[o3++]);
            });
          }("%s=%s", e3, (t3 = n2[e3], "[object Object]" === Object.prototype.toString.call(t3) || "[object Array]" === Object.prototype.toString.call(t3) ? JSON.stringify(n2[e3]) : n2[e3]));
          var t3;
        }).join("&")), a2 = "".concat(e2.protocol, "://").concat(e2.url, "/").concat("/" === t2.charAt(0) ? t2.substr(1) : t2);
        return o2.length && (a2 += "?".concat(o2)), a2;
      }
      function w(e2) {
        return e2.map(function(e3) {
          return A2(e3);
        });
      }
      function A2(e2) {
        var t2 = e2.request.headers["x-algolia-api-key"] ? { "x-algolia-api-key": "*****" } : {};
        return r(r({}, e2), {}, { request: r(r({}, e2.request), {}, { headers: r(r({}, e2.request.headers), t2) }) });
      }
      var C2 = function(e2) {
        var t2 = e2.appId, o2 = /* @__PURE__ */ function(e3, t3, r2) {
          var n2 = { "x-algolia-api-key": r2, "x-algolia-application-id": t3 };
          return { headers: function() {
            return e3 === c.WithinHeaders ? n2 : {};
          }, queryParameters: function() {
            return e3 === c.WithinQueryParameters ? n2 : {};
          } };
        }(void 0 !== e2.authMode ? e2.authMode : c.WithinHeaders, t2, e2.apiKey), a2 = function(e3) {
          var t3 = e3.hostsCache, r2 = e3.logger, o3 = e3.requester, a3 = e3.requestsCache, i2 = e3.responsesCache, u2 = e3.timeouts, s2 = e3.userAgent, c2 = e3.hosts, l2 = e3.queryParameters, f2 = { hostsCache: t3, logger: r2, requester: o3, requestsCache: a3, responsesCache: i2, timeouts: u2, userAgent: s2, headers: e3.headers, queryParameters: l2, hosts: c2.map(function(e4) {
            return b(e4);
          }), read: function(e4, t4) {
            var r3 = d(t4, f2.timeouts.read), o4 = function() {
              return S2(f2, f2.hosts.filter(function(e5) {
                return 0 != (e5.accept & h.Read);
              }), e4, r3);
            };
            if (true !== (void 0 !== r3.cacheable ? r3.cacheable : e4.cacheable)) return o4();
            var a4 = { request: e4, mappedRequestOptions: r3, transporter: { queryParameters: f2.queryParameters, headers: f2.headers } };
            return f2.responsesCache.get(a4, function() {
              return f2.requestsCache.get(a4, function() {
                return f2.requestsCache.set(a4, o4()).then(function(e5) {
                  return Promise.all([f2.requestsCache.delete(a4), e5]);
                }, function(e5) {
                  return Promise.all([f2.requestsCache.delete(a4), Promise.reject(e5)]);
                }).then(function(e5) {
                  var t5 = n(e5, 2);
                  t5[0];
                  return t5[1];
                });
              });
            }, { miss: function(e5) {
              return f2.responsesCache.set(a4, e5);
            } });
          }, write: function(e4, t4) {
            return S2(f2, f2.hosts.filter(function(e5) {
              return 0 != (e5.accept & h.Write);
            }), e4, d(t4, f2.timeouts.write));
          } };
          return f2;
        }(r(r({ hosts: [{ url: "".concat(t2, "-dsn.algolia.net"), accept: h.Read }, { url: "".concat(t2, ".algolia.net"), accept: h.Write }].concat(s([{ url: "".concat(t2, "-1.algolianet.com") }, { url: "".concat(t2, "-2.algolianet.com") }, { url: "".concat(t2, "-3.algolianet.com") }])) }, e2), {}, { headers: r(r(r({}, o2.headers()), { "content-type": "application/x-www-form-urlencoded" }), e2.headers), queryParameters: r(r({}, o2.queryParameters()), e2.queryParameters) }));
        return function(e3, t3) {
          return t3 ? (Object.keys(t3).forEach(function(r2) {
            e3[r2] = t3[r2](e3);
          }), e3) : e3;
        }({ transporter: a2, appId: t2, addAlgoliaAgent: function(e3, t3) {
          a2.userAgent.add({ segment: e3, version: t3 });
        }, clearCache: function() {
          return Promise.all([a2.requestsCache.clear(), a2.responsesCache.clear()]).then(function() {
          });
        } }, e2.methods);
      }, k2 = function(e2) {
        return function(t2, n2) {
          var o2 = t2.map(function(e3) {
            return r(r({}, e3), {}, { threshold: e3.threshold || 0 });
          });
          return e2.transporter.read({ method: P, path: "1/indexes/*/recommendations", data: { requests: o2 }, cacheable: true }, n2);
        };
      }, N2 = function(e2) {
        return function(t2, n2) {
          return k2(e2)(t2.map(function(e3) {
            return r(r({}, e3), {}, { fallbackParameters: {}, model: "bought-together" });
          }), n2);
        };
      }, R = function(e2) {
        return function(t2, n2) {
          return k2(e2)(t2.map(function(e3) {
            return r(r({}, e3), {}, { model: "related-products" });
          }), n2);
        };
      }, x = function(e2) {
        return function(t2, n2) {
          var o2 = t2.map(function(e3) {
            return r(r({}, e3), {}, { model: "trending-facets", threshold: e3.threshold || 0 });
          });
          return e2.transporter.read({ method: P, path: "1/indexes/*/recommendations", data: { requests: o2 }, cacheable: true }, n2);
        };
      }, J = function(e2) {
        return function(t2, n2) {
          var o2 = t2.map(function(e3) {
            return r(r({}, e3), {}, { model: "trending-items", threshold: e3.threshold || 0 });
          });
          return e2.transporter.read({ method: P, path: "1/indexes/*/recommendations", data: { requests: o2 }, cacheable: true }, n2);
        };
      }, E = function(e2) {
        return function(t2, n2) {
          return k2(e2)(t2.map(function(e3) {
            return r(r({}, e3), {}, { model: "looking-similar" });
          }), n2);
        };
      }, I2 = function(e2) {
        return function(t2, n2) {
          var o2 = t2.map(function(e3) {
            return r(r({}, e3), {}, { model: "recommended-for-you", threshold: e3.threshold || 0 });
          });
          return e2.transporter.read({ method: P, path: "1/indexes/*/recommendations", data: { requests: o2 }, cacheable: true }, n2);
        };
      };
      function D2(e2, t2, n2) {
        var o2, s2 = { appId: e2, apiKey: t2, timeouts: { connect: 1, read: 2, write: 30 }, requester: { send: function(e3) {
          return new Promise(function(t3) {
            var r2 = new XMLHttpRequest();
            r2.open(e3.method, e3.url, true), Object.keys(e3.headers).forEach(function(t4) {
              return r2.setRequestHeader(t4, e3.headers[t4]);
            });
            var n3, o3 = function(e4, n4) {
              return setTimeout(function() {
                r2.abort(), t3({ status: 0, content: n4, isTimedOut: true });
              }, 1e3 * e4);
            }, a2 = o3(e3.connectTimeout, "Connection timeout");
            r2.onreadystatechange = function() {
              r2.readyState > r2.OPENED && void 0 === n3 && (clearTimeout(a2), n3 = o3(e3.responseTimeout, "Socket timeout"));
            }, r2.onerror = function() {
              0 === r2.status && (clearTimeout(a2), clearTimeout(n3), t3({ content: r2.responseText || "Network request failed", status: r2.status, isTimedOut: false }));
            }, r2.onload = function() {
              clearTimeout(a2), clearTimeout(n3), t3({ content: r2.responseText, status: r2.status, isTimedOut: false });
            }, r2.send(e3.data);
          });
        } }, logger: (o2 = m, { debug: function(e3, t3) {
          return l >= o2 && console.debug(e3, t3), Promise.resolve();
        }, info: function(e3, t3) {
          return f >= o2 && console.info(e3, t3), Promise.resolve();
        }, error: function(e3, t3) {
          return console.error(e3, t3), Promise.resolve();
        } }), responsesCache: u(), requestsCache: u({ serializable: false }), hostsCache: i({ caches: [a({ key: "".concat("4.24.0", "-").concat(e2) }), u()] }), userAgent: j2("4.24.0").add({ segment: "Recommend", version: "4.24.0" }).add({ segment: "Browser" }), authMode: c.WithinQueryParameters };
        return C2(r(r(r({}, s2), n2), {}, { methods: { getFrequentlyBoughtTogether: N2, getRecommendations: k2, getRelatedProducts: R, getTrendingFacets: x, getTrendingItems: J, getLookingSimilar: E, getRecommendedForYou: I2 } }));
      }
      return D2.version = "4.24.0", D2.getFrequentlyBoughtTogether = N2, D2.getRecommendations = k2, D2.getRelatedProducts = R, D2.getTrendingFacets = x, D2.getTrendingItems = J, D2.getLookingSimilar = E, D2.getRecommendedForYou = I2, D2;
    });
  }
});

// node_modules/algoliasearch/dist/algoliasearch.umd.js
var require_algoliasearch_umd = __commonJS({
  "node_modules/algoliasearch/dist/algoliasearch.umd.js"(exports, module) {
    !function(t, e) {
      "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t = t || self).algoliasearch = e();
    }(exports, function() {
      "use strict";
      function t(t2, e2, r2) {
        return e2 in t2 ? Object.defineProperty(t2, e2, { value: r2, enumerable: true, configurable: true, writable: true }) : t2[e2] = r2, t2;
      }
      function e(t2, e2) {
        var r2 = Object.keys(t2);
        if (Object.getOwnPropertySymbols) {
          var n2 = Object.getOwnPropertySymbols(t2);
          e2 && (n2 = n2.filter(function(e3) {
            return Object.getOwnPropertyDescriptor(t2, e3).enumerable;
          })), r2.push.apply(r2, n2);
        }
        return r2;
      }
      function r(r2) {
        for (var n2 = 1; n2 < arguments.length; n2++) {
          var a2 = null != arguments[n2] ? arguments[n2] : {};
          n2 % 2 ? e(Object(a2), true).forEach(function(e2) {
            t(r2, e2, a2[e2]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r2, Object.getOwnPropertyDescriptors(a2)) : e(Object(a2)).forEach(function(t2) {
            Object.defineProperty(r2, t2, Object.getOwnPropertyDescriptor(a2, t2));
          });
        }
        return r2;
      }
      function n(t2, e2) {
        if (null == t2) return {};
        var r2, n2, a2 = function(t3, e3) {
          if (null == t3) return {};
          var r3, n3, a3 = {}, o3 = Object.keys(t3);
          for (n3 = 0; n3 < o3.length; n3++) r3 = o3[n3], e3.indexOf(r3) >= 0 || (a3[r3] = t3[r3]);
          return a3;
        }(t2, e2);
        if (Object.getOwnPropertySymbols) {
          var o2 = Object.getOwnPropertySymbols(t2);
          for (n2 = 0; n2 < o2.length; n2++) r2 = o2[n2], e2.indexOf(r2) >= 0 || Object.prototype.propertyIsEnumerable.call(t2, r2) && (a2[r2] = t2[r2]);
        }
        return a2;
      }
      function a(t2, e2) {
        return function(t3) {
          if (Array.isArray(t3)) return t3;
        }(t2) || function(t3, e3) {
          if (!(Symbol.iterator in Object(t3) || "[object Arguments]" === Object.prototype.toString.call(t3))) return;
          var r2 = [], n2 = true, a2 = false, o2 = void 0;
          try {
            for (var i2, u2 = t3[Symbol.iterator](); !(n2 = (i2 = u2.next()).done) && (r2.push(i2.value), !e3 || r2.length !== e3); n2 = true) ;
          } catch (t4) {
            a2 = true, o2 = t4;
          } finally {
            try {
              n2 || null == u2.return || u2.return();
            } finally {
              if (a2) throw o2;
            }
          }
          return r2;
        }(t2, e2) || function() {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }();
      }
      function o(t2) {
        return function(t3) {
          if (Array.isArray(t3)) {
            for (var e2 = 0, r2 = new Array(t3.length); e2 < t3.length; e2++) r2[e2] = t3[e2];
            return r2;
          }
        }(t2) || function(t3) {
          if (Symbol.iterator in Object(t3) || "[object Arguments]" === Object.prototype.toString.call(t3)) return Array.from(t3);
        }(t2) || function() {
          throw new TypeError("Invalid attempt to spread non-iterable instance");
        }();
      }
      function i(t2) {
        var e2, r2 = "algoliasearch-client-js-".concat(t2.key), n2 = function() {
          return void 0 === e2 && (e2 = t2.localStorage || window.localStorage), e2;
        }, o2 = function() {
          return JSON.parse(n2().getItem(r2) || "{}");
        }, i2 = function(t3) {
          n2().setItem(r2, JSON.stringify(t3));
        }, u2 = function() {
          var e3 = t2.timeToLive ? 1e3 * t2.timeToLive : null, r3 = o2(), n3 = Object.fromEntries(Object.entries(r3).filter(function(t3) {
            return void 0 !== a(t3, 2)[1].timestamp;
          }));
          if (i2(n3), e3) {
            var u3 = Object.fromEntries(Object.entries(n3).filter(function(t3) {
              var r4 = a(t3, 2)[1], n4 = (/* @__PURE__ */ new Date()).getTime();
              return !(r4.timestamp + e3 < n4);
            }));
            i2(u3);
          }
        };
        return { get: function(t3, e3) {
          var r3 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : { miss: function() {
            return Promise.resolve();
          } };
          return Promise.resolve().then(function() {
            u2();
            var e4 = JSON.stringify(t3);
            return o2()[e4];
          }).then(function(t4) {
            return Promise.all([t4 ? t4.value : e3(), void 0 !== t4]);
          }).then(function(t4) {
            var e4 = a(t4, 2), n3 = e4[0], o3 = e4[1];
            return Promise.all([n3, o3 || r3.miss(n3)]);
          }).then(function(t4) {
            return a(t4, 1)[0];
          });
        }, set: function(t3, e3) {
          return Promise.resolve().then(function() {
            var a2 = o2();
            return a2[JSON.stringify(t3)] = { timestamp: (/* @__PURE__ */ new Date()).getTime(), value: e3 }, n2().setItem(r2, JSON.stringify(a2)), e3;
          });
        }, delete: function(t3) {
          return Promise.resolve().then(function() {
            var e3 = o2();
            delete e3[JSON.stringify(t3)], n2().setItem(r2, JSON.stringify(e3));
          });
        }, clear: function() {
          return Promise.resolve().then(function() {
            n2().removeItem(r2);
          });
        } };
      }
      function u(t2) {
        var e2 = o(t2.caches), r2 = e2.shift();
        return void 0 === r2 ? { get: function(t3, e3) {
          var r3 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : { miss: function() {
            return Promise.resolve();
          } }, n2 = e3();
          return n2.then(function(t4) {
            return Promise.all([t4, r3.miss(t4)]);
          }).then(function(t4) {
            return a(t4, 1)[0];
          });
        }, set: function(t3, e3) {
          return Promise.resolve(e3);
        }, delete: function(t3) {
          return Promise.resolve();
        }, clear: function() {
          return Promise.resolve();
        } } : { get: function(t3, n2) {
          var a2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : { miss: function() {
            return Promise.resolve();
          } };
          return r2.get(t3, n2, a2).catch(function() {
            return u({ caches: e2 }).get(t3, n2, a2);
          });
        }, set: function(t3, n2) {
          return r2.set(t3, n2).catch(function() {
            return u({ caches: e2 }).set(t3, n2);
          });
        }, delete: function(t3) {
          return r2.delete(t3).catch(function() {
            return u({ caches: e2 }).delete(t3);
          });
        }, clear: function() {
          return r2.clear().catch(function() {
            return u({ caches: e2 }).clear();
          });
        } };
      }
      function s() {
        var t2 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : { serializable: true }, e2 = {};
        return { get: function(r2, n2) {
          var a2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : { miss: function() {
            return Promise.resolve();
          } }, o2 = JSON.stringify(r2);
          if (o2 in e2) return Promise.resolve(t2.serializable ? JSON.parse(e2[o2]) : e2[o2]);
          var i2 = n2(), u2 = a2 && a2.miss || function() {
            return Promise.resolve();
          };
          return i2.then(function(t3) {
            return u2(t3);
          }).then(function() {
            return i2;
          });
        }, set: function(r2, n2) {
          return e2[JSON.stringify(r2)] = t2.serializable ? JSON.stringify(n2) : n2, Promise.resolve(n2);
        }, delete: function(t3) {
          return delete e2[JSON.stringify(t3)], Promise.resolve();
        }, clear: function() {
          return e2 = {}, Promise.resolve();
        } };
      }
      function c(t2, e2, r2) {
        var n2 = { "x-algolia-api-key": r2, "x-algolia-application-id": e2 };
        return { headers: function() {
          return t2 === m.WithinHeaders ? n2 : {};
        }, queryParameters: function() {
          return t2 === m.WithinQueryParameters ? n2 : {};
        } };
      }
      function f(t2) {
        var e2 = 0;
        return t2(function r2() {
          return e2++, new Promise(function(n2) {
            setTimeout(function() {
              n2(t2(r2));
            }, Math.min(100 * e2, 1e3));
          });
        });
      }
      function d(t2) {
        var e2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function(t3, e3) {
          return Promise.resolve();
        };
        return Object.assign(t2, { wait: function(r2) {
          return d(t2.then(function(t3) {
            return Promise.all([e2(t3, r2), t3]);
          }).then(function(t3) {
            return t3[1];
          }));
        } });
      }
      function l(t2) {
        for (var e2 = t2.length - 1; e2 > 0; e2--) {
          var r2 = Math.floor(Math.random() * (e2 + 1)), n2 = t2[e2];
          t2[e2] = t2[r2], t2[r2] = n2;
        }
        return t2;
      }
      function h(t2, e2) {
        return e2 ? (Object.keys(e2).forEach(function(r2) {
          t2[r2] = e2[r2](t2);
        }), t2) : t2;
      }
      function p(t2) {
        for (var e2 = arguments.length, r2 = new Array(e2 > 1 ? e2 - 1 : 0), n2 = 1; n2 < e2; n2++) r2[n2 - 1] = arguments[n2];
        var a2 = 0;
        return t2.replace(/%s/g, function() {
          return encodeURIComponent(r2[a2++]);
        });
      }
      var m = { WithinQueryParameters: 0, WithinHeaders: 1 };
      function y2(t2, e2) {
        var r2 = t2 || {}, n2 = r2.data || {};
        return Object.keys(r2).forEach(function(t3) {
          -1 === ["timeout", "headers", "queryParameters", "data", "cacheable"].indexOf(t3) && (n2[t3] = r2[t3]);
        }), { data: Object.entries(n2).length > 0 ? n2 : void 0, timeout: r2.timeout || e2, headers: r2.headers || {}, queryParameters: r2.queryParameters || {}, cacheable: r2.cacheable };
      }
      var g = { Read: 1, Write: 2, Any: 3 }, v = 1, b = 2, P = 3;
      function O2(t2) {
        var e2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : v;
        return r(r({}, t2), {}, { status: e2, lastUpdate: Date.now() });
      }
      function w(t2) {
        return "string" == typeof t2 ? { protocol: "https", url: t2, accept: g.Any } : { protocol: t2.protocol || "https", url: t2.url, accept: t2.accept || g.Any };
      }
      var I2 = "DELETE", x = "GET", j2 = "POST", D2 = "PUT";
      function q2(t2, e2) {
        return Promise.all(e2.map(function(e3) {
          return t2.get(e3, function() {
            return Promise.resolve(O2(e3));
          });
        })).then(function(t3) {
          var r2 = t3.filter(function(t4) {
            return function(t5) {
              return t5.status === v || Date.now() - t5.lastUpdate > 12e4;
            }(t4);
          }), n2 = t3.filter(function(t4) {
            return function(t5) {
              return t5.status === P && Date.now() - t5.lastUpdate <= 12e4;
            }(t4);
          }), a2 = [].concat(o(r2), o(n2));
          return { getTimeout: function(t4, e3) {
            return (0 === n2.length && 0 === t4 ? 1 : n2.length + 3 + t4) * e3;
          }, statelessHosts: a2.length > 0 ? a2.map(function(t4) {
            return w(t4);
          }) : e2 };
        });
      }
      function S2(t2, e2, n2, a2) {
        var i2 = [], u2 = function(t3, e3) {
          if (t3.method === x || void 0 === t3.data && void 0 === e3.data) return;
          var n3 = Array.isArray(t3.data) ? t3.data : r(r({}, t3.data), e3.data);
          return JSON.stringify(n3);
        }(n2, a2), s2 = function(t3, e3) {
          var n3 = r(r({}, t3.headers), e3.headers), a3 = {};
          return Object.keys(n3).forEach(function(t4) {
            var e4 = n3[t4];
            a3[t4.toLowerCase()] = e4;
          }), a3;
        }(t2, a2), c2 = n2.method, f2 = n2.method !== x ? {} : r(r({}, n2.data), a2.data), d2 = r(r(r({ "x-algolia-agent": t2.userAgent.value }, t2.queryParameters), f2), a2.queryParameters), l2 = 0, h2 = function e3(r2, o2) {
          var f3 = r2.pop();
          if (void 0 === f3) throw { name: "RetryError", message: "Unreachable hosts - your application id may be incorrect. If the error persists, please reach out to the Algolia Support team: https://alg.li/support .", transporterStackTrace: E(i2) };
          var h3 = { data: u2, headers: s2, method: c2, url: N2(f3, n2.path, d2), connectTimeout: o2(l2, t2.timeouts.connect), responseTimeout: o2(l2, a2.timeout) }, p2 = function(t3) {
            var e4 = { request: h3, response: t3, host: f3, triesLeft: r2.length };
            return i2.push(e4), e4;
          }, m2 = { onSuccess: function(t3) {
            return function(t4) {
              try {
                return JSON.parse(t4.content);
              } catch (e4) {
                throw /* @__PURE__ */ function(t5, e5) {
                  return { name: "DeserializationError", message: t5, response: e5 };
                }(e4.message, t4);
              }
            }(t3);
          }, onRetry: function(n3) {
            var a3 = p2(n3);
            return n3.isTimedOut && l2++, Promise.all([t2.logger.info("Retryable failure", A2(a3)), t2.hostsCache.set(f3, O2(f3, n3.isTimedOut ? P : b))]).then(function() {
              return e3(r2, o2);
            });
          }, onFail: function(t3) {
            throw p2(t3), function(t4, e4) {
              var r3 = t4.content, n3 = t4.status, a3 = r3;
              try {
                a3 = JSON.parse(r3).message;
              } catch (t5) {
              }
              return /* @__PURE__ */ function(t5, e5, r4) {
                return { name: "ApiError", message: t5, status: e5, transporterStackTrace: r4 };
              }(a3, n3, e4);
            }(t3, E(i2));
          } };
          return t2.requester.send(h3).then(function(t3) {
            return function(t4, e4) {
              return function(t5) {
                var e5 = t5.status;
                return t5.isTimedOut || function(t6) {
                  var e6 = t6.isTimedOut, r3 = t6.status;
                  return !e6 && 0 == ~~r3;
                }(t5) || 2 != ~~(e5 / 100) && 4 != ~~(e5 / 100);
              }(t4) ? e4.onRetry(t4) : 2 == ~~(t4.status / 100) ? e4.onSuccess(t4) : e4.onFail(t4);
            }(t3, m2);
          });
        };
        return q2(t2.hostsCache, e2).then(function(t3) {
          return h2(o(t3.statelessHosts).reverse(), t3.getTimeout);
        });
      }
      function k2(t2) {
        var e2 = t2.hostsCache, r2 = t2.logger, n2 = t2.requester, o2 = t2.requestsCache, i2 = t2.responsesCache, u2 = t2.timeouts, s2 = t2.userAgent, c2 = t2.hosts, f2 = t2.queryParameters, d2 = { hostsCache: e2, logger: r2, requester: n2, requestsCache: o2, responsesCache: i2, timeouts: u2, userAgent: s2, headers: t2.headers, queryParameters: f2, hosts: c2.map(function(t3) {
          return w(t3);
        }), read: function(t3, e3) {
          var r3 = y2(e3, d2.timeouts.read), n3 = function() {
            return S2(d2, d2.hosts.filter(function(t4) {
              return 0 != (t4.accept & g.Read);
            }), t3, r3);
          };
          if (true !== (void 0 !== r3.cacheable ? r3.cacheable : t3.cacheable)) return n3();
          var o3 = { request: t3, mappedRequestOptions: r3, transporter: { queryParameters: d2.queryParameters, headers: d2.headers } };
          return d2.responsesCache.get(o3, function() {
            return d2.requestsCache.get(o3, function() {
              return d2.requestsCache.set(o3, n3()).then(function(t4) {
                return Promise.all([d2.requestsCache.delete(o3), t4]);
              }, function(t4) {
                return Promise.all([d2.requestsCache.delete(o3), Promise.reject(t4)]);
              }).then(function(t4) {
                var e4 = a(t4, 2);
                e4[0];
                return e4[1];
              });
            });
          }, { miss: function(t4) {
            return d2.responsesCache.set(o3, t4);
          } });
        }, write: function(t3, e3) {
          return S2(d2, d2.hosts.filter(function(t4) {
            return 0 != (t4.accept & g.Write);
          }), t3, y2(e3, d2.timeouts.write));
        } };
        return d2;
      }
      function T2(t2) {
        var e2 = { value: "Algolia for JavaScript (".concat(t2, ")"), add: function(t3) {
          var r2 = "; ".concat(t3.segment).concat(void 0 !== t3.version ? " (".concat(t3.version, ")") : "");
          return -1 === e2.value.indexOf(r2) && (e2.value = "".concat(e2.value).concat(r2)), e2;
        } };
        return e2;
      }
      function N2(t2, e2, r2) {
        var n2 = R(r2), a2 = "".concat(t2.protocol, "://").concat(t2.url, "/").concat("/" === e2.charAt(0) ? e2.substr(1) : e2);
        return n2.length && (a2 += "?".concat(n2)), a2;
      }
      function R(t2) {
        return Object.keys(t2).map(function(e2) {
          return p("%s=%s", e2, (r2 = t2[e2], "[object Object]" === Object.prototype.toString.call(r2) || "[object Array]" === Object.prototype.toString.call(r2) ? JSON.stringify(t2[e2]) : t2[e2]));
          var r2;
        }).join("&");
      }
      function E(t2) {
        return t2.map(function(t3) {
          return A2(t3);
        });
      }
      function A2(t2) {
        var e2 = t2.request.headers["x-algolia-api-key"] ? { "x-algolia-api-key": "*****" } : {};
        return r(r({}, t2), {}, { request: r(r({}, t2.request), {}, { headers: r(r({}, t2.request.headers), e2) }) });
      }
      var C2 = function(t2) {
        return function(e2, r2) {
          return t2.transporter.write({ method: j2, path: "2/abtests", data: e2 }, r2);
        };
      }, U2 = function(t2) {
        return function(e2, r2) {
          return t2.transporter.write({ method: I2, path: p("2/abtests/%s", e2) }, r2);
        };
      }, z2 = function(t2) {
        return function(e2, r2) {
          return t2.transporter.read({ method: x, path: p("2/abtests/%s", e2) }, r2);
        };
      }, J = function(t2) {
        return function(e2) {
          return t2.transporter.read({ method: x, path: "2/abtests" }, e2);
        };
      }, F2 = function(t2) {
        return function(e2, r2) {
          return t2.transporter.write({ method: j2, path: p("2/abtests/%s/stop", e2) }, r2);
        };
      }, H2 = function(t2) {
        return function(e2) {
          return t2.transporter.read({ method: x, path: "1/strategies/personalization" }, e2);
        };
      }, M = function(t2) {
        return function(e2, r2) {
          return t2.transporter.write({ method: j2, path: "1/strategies/personalization", data: e2 }, r2);
        };
      };
      function B2(t2) {
        return function e2(r2) {
          return t2.request(r2).then(function(n2) {
            if (void 0 !== t2.batch && t2.batch(n2.hits), !t2.shouldStop(n2)) return n2.cursor ? e2({ cursor: n2.cursor }) : e2({ page: (r2.page || 0) + 1 });
          });
        }({});
      }
      var K2 = function(t2) {
        return function(e2, a2) {
          var o2 = a2 || {}, i2 = o2.queryParameters, u2 = n(o2, ["queryParameters"]), s2 = r({ acl: e2 }, void 0 !== i2 ? { queryParameters: i2 } : {});
          return d(t2.transporter.write({ method: j2, path: "1/keys", data: s2 }, u2), function(e3, r2) {
            return f(function(n2) {
              return tt2(t2)(e3.key, r2).catch(function(t3) {
                if (404 !== t3.status) throw t3;
                return n2();
              });
            });
          });
        };
      }, W2 = function(t2) {
        return function(e2, r2, n2) {
          var a2 = y2(n2);
          return a2.queryParameters["X-Algolia-User-ID"] = e2, t2.transporter.write({ method: j2, path: "1/clusters/mapping", data: { cluster: r2 } }, a2);
        };
      }, L = function(t2) {
        return function(e2, r2, n2) {
          return t2.transporter.write({ method: j2, path: "1/clusters/mapping/batch", data: { users: e2, cluster: r2 } }, n2);
        };
      }, Q2 = function(t2) {
        return function(e2, r2) {
          return d(t2.transporter.write({ method: j2, path: p("/1/dictionaries/%s/batch", e2), data: { clearExistingDictionaryEntries: true, requests: { action: "addEntry", body: [] } } }, r2), function(e3, r3) {
            return jt2(t2)(e3.taskID, r3);
          });
        };
      }, G2 = function(t2) {
        return function(e2, r2, n2) {
          return d(t2.transporter.write({ method: j2, path: p("1/indexes/%s/operation", e2), data: { operation: "copy", destination: r2 } }, n2), function(r3, n3) {
            return ut2(t2)(e2, { methods: { waitTask: de2 } }).waitTask(r3.taskID, n3);
          });
        };
      }, V2 = function(t2) {
        return function(e2, n2, a2) {
          return G2(t2)(e2, n2, r(r({}, a2), {}, { scope: [he.Rules] }));
        };
      }, _ = function(t2) {
        return function(e2, n2, a2) {
          return G2(t2)(e2, n2, r(r({}, a2), {}, { scope: [he.Settings] }));
        };
      }, X2 = function(t2) {
        return function(e2, n2, a2) {
          return G2(t2)(e2, n2, r(r({}, a2), {}, { scope: [he.Synonyms] }));
        };
      }, Y2 = function(t2) {
        return function(e2, r2) {
          return e2.method === x ? t2.transporter.read(e2, r2) : t2.transporter.write(e2, r2);
        };
      }, Z = function(t2) {
        return function(e2, r2) {
          return d(t2.transporter.write({ method: I2, path: p("1/keys/%s", e2) }, r2), function(r3, n2) {
            return f(function(r4) {
              return tt2(t2)(e2, n2).then(r4).catch(function(t3) {
                if (404 !== t3.status) throw t3;
              });
            });
          });
        };
      }, $2 = function(t2) {
        return function(e2, r2, n2) {
          var a2 = r2.map(function(t3) {
            return { action: "deleteEntry", body: { objectID: t3 } };
          });
          return d(t2.transporter.write({ method: j2, path: p("/1/dictionaries/%s/batch", e2), data: { clearExistingDictionaryEntries: false, requests: a2 } }, n2), function(e3, r3) {
            return jt2(t2)(e3.taskID, r3);
          });
        };
      }, tt2 = function(t2) {
        return function(e2, r2) {
          return t2.transporter.read({ method: x, path: p("1/keys/%s", e2) }, r2);
        };
      }, et = function(t2) {
        return function(e2, r2) {
          return t2.transporter.read({ method: x, path: p("1/task/%s", e2.toString()) }, r2);
        };
      }, rt2 = function(t2) {
        return function(e2) {
          return t2.transporter.read({ method: x, path: "/1/dictionaries/*/settings" }, e2);
        };
      }, nt2 = function(t2) {
        return function(e2) {
          return t2.transporter.read({ method: x, path: "1/logs" }, e2);
        };
      }, at2 = function(t2) {
        return function(e2) {
          return t2.transporter.read({ method: x, path: "1/clusters/mapping/top" }, e2);
        };
      }, ot2 = function(t2) {
        return function(e2, r2) {
          return t2.transporter.read({ method: x, path: p("1/clusters/mapping/%s", e2) }, r2);
        };
      }, it2 = function(t2) {
        return function(e2) {
          var r2 = e2 || {}, a2 = r2.retrieveMappings, o2 = n(r2, ["retrieveMappings"]);
          return true === a2 && (o2.getClusters = true), t2.transporter.read({ method: x, path: "1/clusters/mapping/pending" }, o2);
        };
      }, ut2 = function(t2) {
        return function(e2) {
          var r2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n2 = { transporter: t2.transporter, appId: t2.appId, indexName: e2 };
          return h(n2, r2.methods);
        };
      }, st2 = function(t2) {
        return function(e2) {
          return t2.transporter.read({ method: x, path: "1/keys" }, e2);
        };
      }, ct2 = function(t2) {
        return function(e2) {
          return t2.transporter.read({ method: x, path: "1/clusters" }, e2);
        };
      }, ft2 = function(t2) {
        return function(e2) {
          return t2.transporter.read({ method: x, path: "1/indexes" }, e2);
        };
      }, dt2 = function(t2) {
        return function(e2) {
          return t2.transporter.read({ method: x, path: "1/clusters/mapping" }, e2);
        };
      }, lt2 = function(t2) {
        return function(e2, r2, n2) {
          return d(t2.transporter.write({ method: j2, path: p("1/indexes/%s/operation", e2), data: { operation: "move", destination: r2 } }, n2), function(r3, n3) {
            return ut2(t2)(e2, { methods: { waitTask: de2 } }).waitTask(r3.taskID, n3);
          });
        };
      }, ht2 = function(t2) {
        return function(e2, r2) {
          return d(t2.transporter.write({ method: j2, path: "1/indexes/*/batch", data: { requests: e2 } }, r2), function(e3, r3) {
            return Promise.all(Object.keys(e3.taskID).map(function(n2) {
              return ut2(t2)(n2, { methods: { waitTask: de2 } }).waitTask(e3.taskID[n2], r3);
            }));
          });
        };
      }, pt2 = function(t2) {
        return function(e2, r2) {
          return t2.transporter.read({ method: j2, path: "1/indexes/*/objects", data: { requests: e2 } }, r2);
        };
      }, mt2 = function(t2) {
        return function(e2, n2) {
          var a2 = e2.map(function(t3) {
            return r(r({}, t3), {}, { params: R(t3.params || {}) });
          });
          return t2.transporter.read({ method: j2, path: "1/indexes/*/queries", data: { requests: a2 }, cacheable: true }, n2);
        };
      }, yt2 = function(t2) {
        return function(e2, a2) {
          return Promise.all(e2.map(function(e3) {
            var o2 = e3.params, i2 = o2.facetName, u2 = o2.facetQuery, s2 = n(o2, ["facetName", "facetQuery"]);
            return ut2(t2)(e3.indexName, { methods: { searchForFacetValues: ue2 } }).searchForFacetValues(i2, u2, r(r({}, a2), s2));
          }));
        };
      }, gt2 = function(t2) {
        return function(e2, r2) {
          var n2 = y2(r2);
          return n2.queryParameters["X-Algolia-User-ID"] = e2, t2.transporter.write({ method: I2, path: "1/clusters/mapping" }, n2);
        };
      }, vt2 = function(t2) {
        return function(e2, r2, n2) {
          var a2 = r2.map(function(t3) {
            return { action: "addEntry", body: t3 };
          });
          return d(t2.transporter.write({ method: j2, path: p("/1/dictionaries/%s/batch", e2), data: { clearExistingDictionaryEntries: true, requests: a2 } }, n2), function(e3, r3) {
            return jt2(t2)(e3.taskID, r3);
          });
        };
      }, bt2 = function(t2) {
        return function(e2, r2) {
          return d(t2.transporter.write({ method: j2, path: p("1/keys/%s/restore", e2) }, r2), function(r3, n2) {
            return f(function(r4) {
              return tt2(t2)(e2, n2).catch(function(t3) {
                if (404 !== t3.status) throw t3;
                return r4();
              });
            });
          });
        };
      }, Pt2 = function(t2) {
        return function(e2, r2, n2) {
          var a2 = r2.map(function(t3) {
            return { action: "addEntry", body: t3 };
          });
          return d(t2.transporter.write({ method: j2, path: p("/1/dictionaries/%s/batch", e2), data: { clearExistingDictionaryEntries: false, requests: a2 } }, n2), function(e3, r3) {
            return jt2(t2)(e3.taskID, r3);
          });
        };
      }, Ot2 = function(t2) {
        return function(e2, r2, n2) {
          return t2.transporter.read({ method: j2, path: p("/1/dictionaries/%s/search", e2), data: { query: r2 }, cacheable: true }, n2);
        };
      }, wt2 = function(t2) {
        return function(e2, r2) {
          return t2.transporter.read({ method: j2, path: "1/clusters/mapping/search", data: { query: e2 } }, r2);
        };
      }, It2 = function(t2) {
        return function(e2, r2) {
          return d(t2.transporter.write({ method: D2, path: "/1/dictionaries/*/settings", data: e2 }, r2), function(e3, r3) {
            return jt2(t2)(e3.taskID, r3);
          });
        };
      }, xt2 = function(t2) {
        return function(e2, r2) {
          var a2 = Object.assign({}, r2), o2 = r2 || {}, i2 = o2.queryParameters, u2 = n(o2, ["queryParameters"]), s2 = i2 ? { queryParameters: i2 } : {}, c2 = ["acl", "indexes", "referers", "restrictSources", "queryParameters", "description", "maxQueriesPerIPPerHour", "maxHitsPerQuery"];
          return d(t2.transporter.write({ method: D2, path: p("1/keys/%s", e2), data: s2 }, u2), function(r3, n2) {
            return f(function(r4) {
              return tt2(t2)(e2, n2).then(function(t3) {
                return function(t4) {
                  return Object.keys(a2).filter(function(t5) {
                    return -1 !== c2.indexOf(t5);
                  }).every(function(e3) {
                    if (Array.isArray(t4[e3]) && Array.isArray(a2[e3])) {
                      var r5 = t4[e3];
                      return r5.length === a2[e3].length && r5.every(function(t5, r6) {
                        return t5 === a2[e3][r6];
                      });
                    }
                    return t4[e3] === a2[e3];
                  });
                }(t3) ? Promise.resolve() : r4();
              });
            });
          });
        };
      }, jt2 = function(t2) {
        return function(e2, r2) {
          return f(function(n2) {
            return et(t2)(e2, r2).then(function(t3) {
              return "published" !== t3.status ? n2() : void 0;
            });
          });
        };
      }, Dt2 = function(t2) {
        return function(e2, r2) {
          return d(t2.transporter.write({ method: j2, path: p("1/indexes/%s/batch", t2.indexName), data: { requests: e2 } }, r2), function(e3, r3) {
            return de2(t2)(e3.taskID, r3);
          });
        };
      }, qt2 = function(t2) {
        return function(e2) {
          return B2(r(r({ shouldStop: function(t3) {
            return void 0 === t3.cursor;
          } }, e2), {}, { request: function(r2) {
            return t2.transporter.read({ method: j2, path: p("1/indexes/%s/browse", t2.indexName), data: r2 }, e2);
          } }));
        };
      }, St2 = function(t2) {
        return function(e2) {
          var n2 = r({ hitsPerPage: 1e3 }, e2);
          return B2(r(r({ shouldStop: function(t3) {
            return t3.hits.length < n2.hitsPerPage;
          } }, n2), {}, { request: function(e3) {
            return se2(t2)("", r(r({}, n2), e3)).then(function(t3) {
              return r(r({}, t3), {}, { hits: t3.hits.map(function(t4) {
                return delete t4._highlightResult, t4;
              }) });
            });
          } }));
        };
      }, kt2 = function(t2) {
        return function(e2) {
          var n2 = r({ hitsPerPage: 1e3 }, e2);
          return B2(r(r({ shouldStop: function(t3) {
            return t3.hits.length < n2.hitsPerPage;
          } }, n2), {}, { request: function(e3) {
            return ce2(t2)("", r(r({}, n2), e3)).then(function(t3) {
              return r(r({}, t3), {}, { hits: t3.hits.map(function(t4) {
                return delete t4._highlightResult, t4;
              }) });
            });
          } }));
        };
      }, Tt2 = function(t2) {
        return function(e2, r2, a2) {
          var o2 = a2 || {}, i2 = o2.batchSize, u2 = n(o2, ["batchSize"]), s2 = { taskIDs: [], objectIDs: [] };
          return d(function n2() {
            var a3, o3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, c2 = [];
            for (a3 = o3; a3 < e2.length && (c2.push(e2[a3]), c2.length !== (i2 || 1e3)); a3++) ;
            return 0 === c2.length ? Promise.resolve(s2) : Dt2(t2)(c2.map(function(t3) {
              return { action: r2, body: t3 };
            }), u2).then(function(t3) {
              return s2.objectIDs = s2.objectIDs.concat(t3.objectIDs), s2.taskIDs.push(t3.taskID), a3++, n2(a3);
            });
          }(), function(e3, r3) {
            return Promise.all(e3.taskIDs.map(function(e4) {
              return de2(t2)(e4, r3);
            }));
          });
        };
      }, Nt2 = function(t2) {
        return function(e2) {
          return d(t2.transporter.write({ method: j2, path: p("1/indexes/%s/clear", t2.indexName) }, e2), function(e3, r2) {
            return de2(t2)(e3.taskID, r2);
          });
        };
      }, Rt2 = function(t2) {
        return function(e2) {
          var r2 = e2 || {}, a2 = r2.forwardToReplicas, o2 = y2(n(r2, ["forwardToReplicas"]));
          return a2 && (o2.queryParameters.forwardToReplicas = 1), d(t2.transporter.write({ method: j2, path: p("1/indexes/%s/rules/clear", t2.indexName) }, o2), function(e3, r3) {
            return de2(t2)(e3.taskID, r3);
          });
        };
      }, Et2 = function(t2) {
        return function(e2) {
          var r2 = e2 || {}, a2 = r2.forwardToReplicas, o2 = y2(n(r2, ["forwardToReplicas"]));
          return a2 && (o2.queryParameters.forwardToReplicas = 1), d(t2.transporter.write({ method: j2, path: p("1/indexes/%s/synonyms/clear", t2.indexName) }, o2), function(e3, r3) {
            return de2(t2)(e3.taskID, r3);
          });
        };
      }, At2 = function(t2) {
        return function(e2, r2) {
          return d(t2.transporter.write({ method: j2, path: p("1/indexes/%s/deleteByQuery", t2.indexName), data: e2 }, r2), function(e3, r3) {
            return de2(t2)(e3.taskID, r3);
          });
        };
      }, Ct2 = function(t2) {
        return function(e2) {
          return d(t2.transporter.write({ method: I2, path: p("1/indexes/%s", t2.indexName) }, e2), function(e3, r2) {
            return de2(t2)(e3.taskID, r2);
          });
        };
      }, Ut2 = function(t2) {
        return function(e2, r2) {
          return d(zt2(t2)([e2], r2).then(function(t3) {
            return { taskID: t3.taskIDs[0] };
          }), function(e3, r3) {
            return de2(t2)(e3.taskID, r3);
          });
        };
      }, zt2 = function(t2) {
        return function(e2, r2) {
          var n2 = e2.map(function(t3) {
            return { objectID: t3 };
          });
          return Tt2(t2)(n2, le2.DeleteObject, r2);
        };
      }, Jt2 = function(t2) {
        return function(e2, r2) {
          var a2 = r2 || {}, o2 = a2.forwardToReplicas, i2 = y2(n(a2, ["forwardToReplicas"]));
          return o2 && (i2.queryParameters.forwardToReplicas = 1), d(t2.transporter.write({ method: I2, path: p("1/indexes/%s/rules/%s", t2.indexName, e2) }, i2), function(e3, r3) {
            return de2(t2)(e3.taskID, r3);
          });
        };
      }, Ft2 = function(t2) {
        return function(e2, r2) {
          var a2 = r2 || {}, o2 = a2.forwardToReplicas, i2 = y2(n(a2, ["forwardToReplicas"]));
          return o2 && (i2.queryParameters.forwardToReplicas = 1), d(t2.transporter.write({ method: I2, path: p("1/indexes/%s/synonyms/%s", t2.indexName, e2) }, i2), function(e3, r3) {
            return de2(t2)(e3.taskID, r3);
          });
        };
      }, Ht2 = function(t2) {
        return function(e2) {
          return Gt2(t2)(e2).then(function() {
            return true;
          }).catch(function(t3) {
            if (404 !== t3.status) throw t3;
            return false;
          });
        };
      }, Mt2 = function(t2) {
        return function(e2, r2, n2) {
          return t2.transporter.read({ method: j2, path: p("1/answers/%s/prediction", t2.indexName), data: { query: e2, queryLanguages: r2 }, cacheable: true }, n2);
        };
      }, Bt2 = function(t2) {
        return function(e2, o2) {
          var i2 = o2 || {}, u2 = i2.query, s2 = i2.paginate, c2 = n(i2, ["query", "paginate"]), f2 = 0;
          return function n2() {
            return ie2(t2)(u2 || "", r(r({}, c2), {}, { page: f2 })).then(function(t3) {
              for (var r2 = 0, o3 = Object.entries(t3.hits); r2 < o3.length; r2++) {
                var i3 = a(o3[r2], 2), u3 = i3[0], c3 = i3[1];
                if (e2(c3)) return { object: c3, position: parseInt(u3, 10), page: f2 };
              }
              if (f2++, false === s2 || f2 >= t3.nbPages) throw { name: "ObjectNotFoundError", message: "Object not found." };
              return n2();
            });
          }();
        };
      }, Kt2 = function(t2) {
        return function(e2, r2) {
          return t2.transporter.read({ method: x, path: p("1/indexes/%s/%s", t2.indexName, e2) }, r2);
        };
      }, Wt2 = function() {
        return function(t2, e2) {
          for (var r2 = 0, n2 = Object.entries(t2.hits); r2 < n2.length; r2++) {
            var o2 = a(n2[r2], 2), i2 = o2[0];
            if (o2[1].objectID === e2) return parseInt(i2, 10);
          }
          return -1;
        };
      }, Lt2 = function(t2) {
        return function(e2, a2) {
          var o2 = a2 || {}, i2 = o2.attributesToRetrieve, u2 = n(o2, ["attributesToRetrieve"]), s2 = e2.map(function(e3) {
            return r({ indexName: t2.indexName, objectID: e3 }, i2 ? { attributesToRetrieve: i2 } : {});
          });
          return t2.transporter.read({ method: j2, path: "1/indexes/*/objects", data: { requests: s2 } }, u2);
        };
      }, Qt2 = function(t2) {
        return function(e2, r2) {
          return t2.transporter.read({ method: x, path: p("1/indexes/%s/rules/%s", t2.indexName, e2) }, r2);
        };
      }, Gt2 = function(t2) {
        return function(e2) {
          return t2.transporter.read({ method: x, path: p("1/indexes/%s/settings", t2.indexName), data: { getVersion: 2 } }, e2);
        };
      }, Vt2 = function(t2) {
        return function(e2, r2) {
          return t2.transporter.read({ method: x, path: p("1/indexes/%s/synonyms/%s", t2.indexName, e2) }, r2);
        };
      }, _t2 = function(t2) {
        return function(e2, r2) {
          return d(Xt2(t2)([e2], r2).then(function(t3) {
            return { objectID: t3.objectIDs[0], taskID: t3.taskIDs[0] };
          }), function(e3, r3) {
            return de2(t2)(e3.taskID, r3);
          });
        };
      }, Xt2 = function(t2) {
        return function(e2, r2) {
          var a2 = r2 || {}, o2 = a2.createIfNotExists, i2 = n(a2, ["createIfNotExists"]), u2 = o2 ? le2.PartialUpdateObject : le2.PartialUpdateObjectNoCreate;
          return Tt2(t2)(e2, u2, i2);
        };
      }, Yt2 = function(t2) {
        return function(e2, i2) {
          var u2 = i2 || {}, s2 = u2.safe, c2 = u2.autoGenerateObjectIDIfNotExist, f2 = u2.batchSize, l2 = n(u2, ["safe", "autoGenerateObjectIDIfNotExist", "batchSize"]), h2 = function(e3, r2, n2, a2) {
            return d(t2.transporter.write({ method: j2, path: p("1/indexes/%s/operation", e3), data: { operation: n2, destination: r2 } }, a2), function(e4, r3) {
              return de2(t2)(e4.taskID, r3);
            });
          }, m2 = Math.random().toString(36).substring(7), y3 = "".concat(t2.indexName, "_tmp_").concat(m2), g2 = ee2({ appId: t2.appId, transporter: t2.transporter, indexName: y3 }), v2 = [], b2 = h2(t2.indexName, y3, "copy", r(r({}, l2), {}, { scope: ["settings", "synonyms", "rules"] }));
          return v2.push(b2), d((s2 ? b2.wait(l2) : b2).then(function() {
            var t3 = g2(e2, r(r({}, l2), {}, { autoGenerateObjectIDIfNotExist: c2, batchSize: f2 }));
            return v2.push(t3), s2 ? t3.wait(l2) : t3;
          }).then(function() {
            var e3 = h2(y3, t2.indexName, "move", l2);
            return v2.push(e3), s2 ? e3.wait(l2) : e3;
          }).then(function() {
            return Promise.all(v2);
          }).then(function(t3) {
            var e3 = a(t3, 3), r2 = e3[0], n2 = e3[1], i3 = e3[2];
            return { objectIDs: n2.objectIDs, taskIDs: [r2.taskID].concat(o(n2.taskIDs), [i3.taskID]) };
          }), function(t3, e3) {
            return Promise.all(v2.map(function(t4) {
              return t4.wait(e3);
            }));
          });
        };
      }, Zt2 = function(t2) {
        return function(e2, n2) {
          return ne2(t2)(e2, r(r({}, n2), {}, { clearExistingRules: true }));
        };
      }, $t2 = function(t2) {
        return function(e2, n2) {
          return oe2(t2)(e2, r(r({}, n2), {}, { clearExistingSynonyms: true }));
        };
      }, te2 = function(t2) {
        return function(e2, r2) {
          return d(ee2(t2)([e2], r2).then(function(t3) {
            return { objectID: t3.objectIDs[0], taskID: t3.taskIDs[0] };
          }), function(e3, r3) {
            return de2(t2)(e3.taskID, r3);
          });
        };
      }, ee2 = function(t2) {
        return function(e2, r2) {
          var a2 = r2 || {}, o2 = a2.autoGenerateObjectIDIfNotExist, i2 = n(a2, ["autoGenerateObjectIDIfNotExist"]), u2 = o2 ? le2.AddObject : le2.UpdateObject;
          if (u2 === le2.UpdateObject) {
            var s2 = true, c2 = false, f2 = void 0;
            try {
              for (var l2, h2 = e2[Symbol.iterator](); !(s2 = (l2 = h2.next()).done); s2 = true) {
                if (void 0 === l2.value.objectID) return d(Promise.reject({ name: "MissingObjectIDError", message: "All objects must have an unique objectID (like a primary key) to be valid. Algolia is also able to generate objectIDs automatically but *it's not recommended*. To do it, use the `{'autoGenerateObjectIDIfNotExist': true}` option." }));
              }
            } catch (t3) {
              c2 = true, f2 = t3;
            } finally {
              try {
                s2 || null == h2.return || h2.return();
              } finally {
                if (c2) throw f2;
              }
            }
          }
          return Tt2(t2)(e2, u2, i2);
        };
      }, re2 = function(t2) {
        return function(e2, r2) {
          return ne2(t2)([e2], r2);
        };
      }, ne2 = function(t2) {
        return function(e2, r2) {
          var a2 = r2 || {}, o2 = a2.forwardToReplicas, i2 = a2.clearExistingRules, u2 = y2(n(a2, ["forwardToReplicas", "clearExistingRules"]));
          return o2 && (u2.queryParameters.forwardToReplicas = 1), i2 && (u2.queryParameters.clearExistingRules = 1), d(t2.transporter.write({ method: j2, path: p("1/indexes/%s/rules/batch", t2.indexName), data: e2 }, u2), function(e3, r3) {
            return de2(t2)(e3.taskID, r3);
          });
        };
      }, ae2 = function(t2) {
        return function(e2, r2) {
          return oe2(t2)([e2], r2);
        };
      }, oe2 = function(t2) {
        return function(e2, r2) {
          var a2 = r2 || {}, o2 = a2.forwardToReplicas, i2 = a2.clearExistingSynonyms, u2 = a2.replaceExistingSynonyms, s2 = y2(n(a2, ["forwardToReplicas", "clearExistingSynonyms", "replaceExistingSynonyms"]));
          return o2 && (s2.queryParameters.forwardToReplicas = 1), (u2 || i2) && (s2.queryParameters.replaceExistingSynonyms = 1), d(t2.transporter.write({ method: j2, path: p("1/indexes/%s/synonyms/batch", t2.indexName), data: e2 }, s2), function(e3, r3) {
            return de2(t2)(e3.taskID, r3);
          });
        };
      }, ie2 = function(t2) {
        return function(e2, r2) {
          return t2.transporter.read({ method: j2, path: p("1/indexes/%s/query", t2.indexName), data: { query: e2 }, cacheable: true }, r2);
        };
      }, ue2 = function(t2) {
        return function(e2, r2, n2) {
          return t2.transporter.read({ method: j2, path: p("1/indexes/%s/facets/%s/query", t2.indexName, e2), data: { facetQuery: r2 }, cacheable: true }, n2);
        };
      }, se2 = function(t2) {
        return function(e2, r2) {
          return t2.transporter.read({ method: j2, path: p("1/indexes/%s/rules/search", t2.indexName), data: { query: e2 } }, r2);
        };
      }, ce2 = function(t2) {
        return function(e2, r2) {
          return t2.transporter.read({ method: j2, path: p("1/indexes/%s/synonyms/search", t2.indexName), data: { query: e2 } }, r2);
        };
      }, fe2 = function(t2) {
        return function(e2, r2) {
          var a2 = r2 || {}, o2 = a2.forwardToReplicas, i2 = y2(n(a2, ["forwardToReplicas"]));
          return o2 && (i2.queryParameters.forwardToReplicas = 1), d(t2.transporter.write({ method: D2, path: p("1/indexes/%s/settings", t2.indexName), data: e2 }, i2), function(e3, r3) {
            return de2(t2)(e3.taskID, r3);
          });
        };
      }, de2 = function(t2) {
        return function(e2, r2) {
          return f(function(n2) {
            return (/* @__PURE__ */ function(t3) {
              return function(e3, r3) {
                return t3.transporter.read({ method: x, path: p("1/indexes/%s/task/%s", t3.indexName, e3.toString()) }, r3);
              };
            }(t2))(e2, r2).then(function(t3) {
              return "published" !== t3.status ? n2() : void 0;
            });
          });
        };
      }, le2 = { AddObject: "addObject", UpdateObject: "updateObject", PartialUpdateObject: "partialUpdateObject", PartialUpdateObjectNoCreate: "partialUpdateObjectNoCreate", DeleteObject: "deleteObject", DeleteIndex: "delete", ClearIndex: "clear" }, he = { Settings: "settings", Synonyms: "synonyms", Rules: "rules" }, pe = 1, me2 = 2, ye2 = 3;
      var ge2 = function(t2) {
        return function(e2, n2) {
          var a2 = e2.map(function(t3) {
            return r(r({}, t3), {}, { threshold: t3.threshold || 0 });
          });
          return t2.transporter.read({ method: j2, path: "1/indexes/*/recommendations", data: { requests: a2 }, cacheable: true }, n2);
        };
      }, ve2 = function(t2) {
        return function(e2, n2) {
          return ge2(t2)(e2.map(function(t3) {
            return r(r({}, t3), {}, { fallbackParameters: {}, model: "bought-together" });
          }), n2);
        };
      }, be2 = function(t2) {
        return function(e2, n2) {
          return ge2(t2)(e2.map(function(t3) {
            return r(r({}, t3), {}, { model: "related-products" });
          }), n2);
        };
      }, Pe2 = function(t2) {
        return function(e2, n2) {
          var a2 = e2.map(function(t3) {
            return r(r({}, t3), {}, { model: "trending-facets", threshold: t3.threshold || 0 });
          });
          return t2.transporter.read({ method: j2, path: "1/indexes/*/recommendations", data: { requests: a2 }, cacheable: true }, n2);
        };
      }, Oe2 = function(t2) {
        return function(e2, n2) {
          var a2 = e2.map(function(t3) {
            return r(r({}, t3), {}, { model: "trending-items", threshold: t3.threshold || 0 });
          });
          return t2.transporter.read({ method: j2, path: "1/indexes/*/recommendations", data: { requests: a2 }, cacheable: true }, n2);
        };
      }, we2 = function(t2) {
        return function(e2, n2) {
          return ge2(t2)(e2.map(function(t3) {
            return r(r({}, t3), {}, { model: "looking-similar" });
          }), n2);
        };
      }, Ie2 = function(t2) {
        return function(e2, n2) {
          var a2 = e2.map(function(t3) {
            return r(r({}, t3), {}, { model: "recommended-for-you", threshold: t3.threshold || 0 });
          });
          return t2.transporter.read({ method: j2, path: "1/indexes/*/recommendations", data: { requests: a2 }, cacheable: true }, n2);
        };
      };
      function xe2(t2, e2, n2) {
        var a2, o2 = { appId: t2, apiKey: e2, timeouts: { connect: 1, read: 2, write: 30 }, requester: { send: function(t3) {
          return new Promise(function(e3) {
            var r2 = new XMLHttpRequest();
            r2.open(t3.method, t3.url, true), Object.keys(t3.headers).forEach(function(e4) {
              return r2.setRequestHeader(e4, t3.headers[e4]);
            });
            var n3, a3 = function(t4, n4) {
              return setTimeout(function() {
                r2.abort(), e3({ status: 0, content: n4, isTimedOut: true });
              }, 1e3 * t4);
            }, o3 = a3(t3.connectTimeout, "Connection timeout");
            r2.onreadystatechange = function() {
              r2.readyState > r2.OPENED && void 0 === n3 && (clearTimeout(o3), n3 = a3(t3.responseTimeout, "Socket timeout"));
            }, r2.onerror = function() {
              0 === r2.status && (clearTimeout(o3), clearTimeout(n3), e3({ content: r2.responseText || "Network request failed", status: r2.status, isTimedOut: false }));
            }, r2.onload = function() {
              clearTimeout(o3), clearTimeout(n3), e3({ content: r2.responseText, status: r2.status, isTimedOut: false });
            }, r2.send(t3.data);
          });
        } }, logger: (a2 = ye2, { debug: function(t3, e3) {
          return pe >= a2 && console.debug(t3, e3), Promise.resolve();
        }, info: function(t3, e3) {
          return me2 >= a2 && console.info(t3, e3), Promise.resolve();
        }, error: function(t3, e3) {
          return console.error(t3, e3), Promise.resolve();
        } }), responsesCache: s(), requestsCache: s({ serializable: false }), hostsCache: u({ caches: [i({ key: "".concat("4.24.0", "-").concat(t2) }), s()] }), userAgent: T2("4.24.0").add({ segment: "Browser" }) }, f2 = r(r({}, o2), n2), d2 = function() {
          return function(t3) {
            return function(t4) {
              var e3 = t4.region || "us", n3 = c(m.WithinHeaders, t4.appId, t4.apiKey), a3 = k2(r(r({ hosts: [{ url: "personalization.".concat(e3, ".algolia.com") }] }, t4), {}, { headers: r(r(r({}, n3.headers()), { "content-type": "application/json" }), t4.headers), queryParameters: r(r({}, n3.queryParameters()), t4.queryParameters) }));
              return h({ appId: t4.appId, transporter: a3 }, t4.methods);
            }(r(r(r({}, o2), t3), {}, { methods: { getPersonalizationStrategy: H2, setPersonalizationStrategy: M } }));
          };
        };
        return function(t3) {
          var e3 = t3.appId, n3 = c(void 0 !== t3.authMode ? t3.authMode : m.WithinHeaders, e3, t3.apiKey), a3 = k2(r(r({ hosts: [{ url: "".concat(e3, "-dsn.algolia.net"), accept: g.Read }, { url: "".concat(e3, ".algolia.net"), accept: g.Write }].concat(l([{ url: "".concat(e3, "-1.algolianet.com") }, { url: "".concat(e3, "-2.algolianet.com") }, { url: "".concat(e3, "-3.algolianet.com") }])) }, t3), {}, { headers: r(r(r({}, n3.headers()), { "content-type": "application/x-www-form-urlencoded" }), t3.headers), queryParameters: r(r({}, n3.queryParameters()), t3.queryParameters) }));
          return h({ transporter: a3, appId: e3, addAlgoliaAgent: function(t4, e4) {
            a3.userAgent.add({ segment: t4, version: e4 });
          }, clearCache: function() {
            return Promise.all([a3.requestsCache.clear(), a3.responsesCache.clear()]).then(function() {
            });
          } }, t3.methods);
        }(r(r({}, f2), {}, { methods: { search: mt2, searchForFacetValues: yt2, multipleBatch: ht2, multipleGetObjects: pt2, multipleQueries: mt2, copyIndex: G2, copySettings: _, copySynonyms: X2, copyRules: V2, moveIndex: lt2, listIndices: ft2, getLogs: nt2, listClusters: ct2, multipleSearchForFacetValues: yt2, getApiKey: tt2, addApiKey: K2, listApiKeys: st2, updateApiKey: xt2, deleteApiKey: Z, restoreApiKey: bt2, assignUserID: W2, assignUserIDs: L, getUserID: ot2, searchUserIDs: wt2, listUserIDs: dt2, getTopUserIDs: at2, removeUserID: gt2, hasPendingMappings: it2, clearDictionaryEntries: Q2, deleteDictionaryEntries: $2, getDictionarySettings: rt2, getAppTask: et, replaceDictionaryEntries: vt2, saveDictionaryEntries: Pt2, searchDictionaryEntries: Ot2, setDictionarySettings: It2, waitAppTask: jt2, customRequest: Y2, initIndex: function(t3) {
          return function(e3) {
            return ut2(t3)(e3, { methods: { batch: Dt2, delete: Ct2, findAnswers: Mt2, getObject: Kt2, getObjects: Lt2, saveObject: te2, saveObjects: ee2, search: ie2, searchForFacetValues: ue2, waitTask: de2, setSettings: fe2, getSettings: Gt2, partialUpdateObject: _t2, partialUpdateObjects: Xt2, deleteObject: Ut2, deleteObjects: zt2, deleteBy: At2, clearObjects: Nt2, browseObjects: qt2, getObjectPosition: Wt2, findObject: Bt2, exists: Ht2, saveSynonym: ae2, saveSynonyms: oe2, getSynonym: Vt2, searchSynonyms: ce2, browseSynonyms: kt2, deleteSynonym: Ft2, clearSynonyms: Et2, replaceAllObjects: Yt2, replaceAllSynonyms: $t2, searchRules: se2, getRule: Qt2, deleteRule: Jt2, saveRule: re2, saveRules: ne2, replaceAllRules: Zt2, browseRules: St2, clearRules: Rt2 } });
          };
        }, initAnalytics: function() {
          return function(t3) {
            return function(t4) {
              var e3 = t4.region || "us", n3 = c(m.WithinHeaders, t4.appId, t4.apiKey), a3 = k2(r(r({ hosts: [{ url: "analytics.".concat(e3, ".algolia.com") }] }, t4), {}, { headers: r(r(r({}, n3.headers()), { "content-type": "application/json" }), t4.headers), queryParameters: r(r({}, n3.queryParameters()), t4.queryParameters) }));
              return h({ appId: t4.appId, transporter: a3 }, t4.methods);
            }(r(r(r({}, o2), t3), {}, { methods: { addABTest: C2, getABTest: z2, getABTests: J, stopABTest: F2, deleteABTest: U2 } }));
          };
        }, initPersonalization: d2, initRecommendation: function() {
          return function(t3) {
            return f2.logger.info("The `initRecommendation` method is deprecated. Use `initPersonalization` instead."), d2()(t3);
          };
        }, getRecommendations: ge2, getFrequentlyBoughtTogether: ve2, getLookingSimilar: we2, getRecommendedForYou: Ie2, getRelatedProducts: be2, getTrendingFacets: Pe2, getTrendingItems: Oe2 } }));
      }
      return xe2.version = "4.24.0", xe2;
    });
  }
});

// js/common/actions/copy-button.js
import { timeline } from "vendor";
var CopyButton = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this._copyToClipboard.bind(this));
  }
  get contentElement() {
    return this.querySelector(".icon-copy");
  }
  get animationElement() {
    return this.querySelector(".icon-feedback");
  }
  async _copyToClipboard() {
    if (!navigator.clipboard) {
      return;
    }
    await navigator.clipboard.writeText(this.getAttribute("data-text") || "");
    timeline([
      [this.contentElement, { y: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
      [this.animationElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: [0, 1] }, { duration: 0.15 }],
      [this.animationElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15, at: "+0.5" }],
      [this.contentElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
    ]);
  }
};
if (!window.customElements.get("copy-button")) {
  window.customElements.define("copy-button", CopyButton);
}

// js/common/animation/marquee-text.js
import { inView, animate } from "vendor";
var MarqueeText = class extends HTMLElement {
  constructor() {
    super();
    this.resizeObserver = new ResizeObserver(this.createElements.bind(this));
    inView(this, this.initializeShadowDom.bind(this), { margin: "400px" });
  }
  get direction() {
    return this.getAttribute("direction") === "right" ? 1 : -1;
  }
  get scroller() {
    return this.shadowRoot.querySelector('[part="scroller"]');
  }
  initializeShadowDom() {
    if (!this.shadowRoot) {
      this.attachShadow({ mode: "open" }).appendChild(document.createRange().createContextualFragment(`
        <slot part="scroller"></slot>
      `));
      this.resizeObserver.observe(this);
    }
  }
  createElements() {
    const duplicateCount = Math.ceil(this.clientWidth / this.firstElementChild.clientWidth);
    const fragment = document.createDocumentFragment();
    fragment.appendChild(this.firstElementChild.cloneNode(true));
    for (let i = 1; i <= duplicateCount; ++i) {
      const node = this.firstElementChild.cloneNode(true);
      node.setAttribute("aria-hidden", "true");
      node.style.cssText = `position: absolute; inset-inline-start: ${100 * i * -this.direction}%;`;
      fragment.appendChild(node);
    }
    this.replaceChildren(fragment);
    animate(this.scroller, { transform: ["translateX(0)", `translateX(${this.direction * 100}%)`] }, {
      duration: 1 / parseFloat(this.getAttribute("speed")) * (this.scroller.clientWidth / 300),
      easing: "linear",
      repeat: Infinity
    });
  }
};
if (!window.customElements.get("marquee-text")) {
  window.customElements.define("marquee-text", MarqueeText);
}

// js/common/behavior/custom-cursor.js
var CustomCursor = class extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    this.parentElement.addEventListener("pointermove", this.onPointerMove.bind(this), { passive: true, signal: this.abortController.signal });
    this.parentElement.addEventListener("pointerleave", this.onPointerLeave.bind(this), { signal: this.abortController.signal });
  }
  disconnectedCallback() {
    this.abortController.abort();
  }
  onPointerLeave() {
    this.classList.remove("is-visible", "is-half-start", "is-half-end");
  }
  onPointerMove(event) {
    if (event.target.matches("button, a[href], button :scope, a[href] :scope, .video-controls, .shop-the-look__product-card, .button-group")) {
      return this.classList.remove("is-visible");
    }
    const parentBoundingRect = this.parentElement.getBoundingClientRect(), parentXCenter = (parentBoundingRect.left + parentBoundingRect.right) / 2, isOnStartHalfPart = event.pageX < parentXCenter;
    this.classList.toggle("is-half-start", isOnStartHalfPart);
    this.classList.toggle("is-half-end", !isOnStartHalfPart);
    this.classList.add("is-visible");
    const mouseY = event.clientY - parentBoundingRect.y - this.clientHeight / 2, mouseX = event.clientX - parentBoundingRect.x - this.clientWidth / 2;
    this.style.translate = `${mouseX.toFixed(3)}px ${mouseY.toFixed(3)}px`;
    this.style.transform = `${mouseX.toFixed(3)}px ${mouseY.toFixed(3)}px`;
  }
};
if (!window.customElements.get("custom-cursor")) {
  window.customElements.define("custom-cursor", CustomCursor);
}

// js/common/behavior/gender-manager.js
var GenderManager = class extends HTMLElement {
  constructor() {
    super();
    this.checkAction();
  }
  connectedCallback() {
    this.abortController = new AbortController();
  }
  disconnectedCallback() {
    this.abortController.abort();
  }
  checkAction() {
    if (this.hasAttribute("set-collection-gender")) {
      this.setCollectionGender();
    }
    if (this.hasAttribute("set-home-gender-url")) {
      this.setHomeGender();
    }
    if (this.hasAttribute("set-gender")) {
      this.setGender();
    }
    if (this.hasAttribute("set-active-link-gender")) {
      this.setActiveLinkGender();
    }
  }
  setCollectionGender() {
    let link = this.querySelector("a[href]");
    link == null ? void 0 : link.setAttribute("href", `${link.getAttribute("href")}?filter.p.m.custom.gender_web=${this.currentGender}`);
  }
  setHomeGender() {
    let link = this.querySelector("a[href]");
    link == null ? void 0 : link.setAttribute("href", `${window.themeVariables.genderURL[this.currentGender]}`);
  }
  setGender() {
    this.currentGender = this.getAttribute("set-gender");
  }
  setActiveLinkGender() {
    this.getAttribute("set-active-link-gender") === this.currentGender ? this.setAttribute("aria-selected", "true") : "";
  }
  get currentGender() {
    return localStorage.getItem("letanneur:currentGender") || "women";
  }
  set currentGender(gender) {
    localStorage.setItem("letanneur:currentGender", gender);
  }
  // public method
  static getCurrentGender() {
    return localStorage.getItem("letanneur:currentGender") || "women";
  }
};
var HomeSplash = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      if (!event.target.closest("a")) {
        window.location.href = this.getAttribute("data-redirect");
      }
    });
    this.style.setProperty(`--window-initial-inner-height`, `${window.innerHeight}px`);
  }
};
if (!window.customElements.get("home-splash")) {
  window.customElements.define("home-splash", HomeSplash);
}
if (!window.customElements.get("gender-manager")) {
  window.customElements.define("gender-manager", GenderManager);
}

// js/common/behavior/gesture-area.js
var GestureArea = class {
  constructor(domElement, { thresholdDistance = 80, thresholdTime = 500, signal = null } = {}) {
    this.domElement = domElement;
    this.thresholdDistance = thresholdDistance;
    this.thresholdTime = thresholdTime;
    this.signal = signal != null ? signal : new AbortController().signal;
    this.tracking = false;
    this.start = {};
    this.domElement.addEventListener("touchstart", this.touchStart.bind(this), { passive: true, signal: this.signal });
    this.domElement.addEventListener("touchmove", this.preventTouch.bind(this), { passive: false, signal: this.signal });
    this.domElement.addEventListener("pointerdown", this.gestureStart.bind(this), { signal: this.signal });
    this.domElement.addEventListener("pointermove", this.gestureMove.bind(this), { passive: false, signal: this.signal });
    this.domElement.addEventListener("pointerup", this.gestureEnd.bind(this), { signal: this.signal });
    this.domElement.addEventListener("pointerleave", this.gestureEnd.bind(this), { signal: this.signal });
    this.domElement.addEventListener("pointercancel", this.gestureEnd.bind(this), { signal: this.signal });
  }
  touchStart(event) {
    this.firstClientX = event.touches[0].clientX;
  }
  preventTouch(event) {
    if (Math.abs(event.touches[0].clientX - this.firstClientX) > 10) {
      event.preventDefault();
    }
  }
  gestureStart(event) {
    this.tracking = true;
    this.start = {
      time: (/* @__PURE__ */ new Date()).getTime(),
      x: event.clientX,
      y: event.clientY
    };
  }
  gestureMove(event) {
    if (this.tracking) {
      event.preventDefault();
    }
  }
  gestureEnd(event) {
    if (!this.tracking) {
      return;
    }
    this.tracking = false;
    const now = (/* @__PURE__ */ new Date()).getTime(), deltaTime = now - this.start.time, deltaX = event.clientX - this.start.x, deltaY = event.clientY - this.start.y;
    if (deltaTime > this.thresholdTime) {
      return;
    }
    let matchedEvent;
    if (deltaX === 0 && deltaY === 0 && !event.target.matches("a, button, a :scope, button :scope")) {
      matchedEvent = "tap";
    } else if (deltaX > this.thresholdDistance && Math.abs(deltaY) < this.thresholdDistance) {
      matchedEvent = "swiperight";
    } else if (-deltaX > this.thresholdDistance && Math.abs(deltaY) < this.thresholdDistance) {
      matchedEvent = "swipeleft";
    } else if (deltaY > this.thresholdDistance && Math.abs(deltaX) < this.thresholdDistance) {
      matchedEvent = "swipedown";
    } else if (-deltaY > this.thresholdDistance && Math.abs(deltaX) < this.thresholdDistance) {
      matchedEvent = "swipeup";
    }
    if (matchedEvent) {
      this.domElement.dispatchEvent(new CustomEvent(matchedEvent, { bubbles: true, composed: true, detail: { originalEvent: event } }));
    }
  }
};

// js/common/utilities/country-selector.js
var CountrySelector = class extends HTMLElement {
  connectedCallback() {
    this.onCountryChangedListener = this.onCountryChanged.bind(this);
    this.countryElement = this.querySelector('[name="address[country]"]');
    this.provinceElement = this.querySelector('[name="address[province]"]');
    this.countryElement.addEventListener("change", this.onCountryChangedListener);
    if (this.hasAttribute("country") && this.getAttribute("country") !== "") {
      this.countryElement.selectedIndex = Math.max(0, Array.from(this.countryElement.options).findIndex((option) => option.textContent === this.getAttribute("country")));
    }
    this.countryElement.dispatchEvent(new Event("change"));
  }
  disconnectedCallback() {
    this.countryElement.removeEventListener("change", this.onCountryChangedListener);
  }
  onCountryChanged() {
    const option = this.countryElement.options[this.countryElement.selectedIndex], provinces = JSON.parse(option.getAttribute("data-provinces"));
    this.provinceElement.parentElement.hidden = provinces.length === 0;
    if (provinces.length === 0) {
      return;
    }
    this.provinceElement.innerHTML = "";
    provinces.forEach((data2) => {
      const selected = data2[1] === this.getAttribute("province") || data2[0] === this.getAttribute("province");
      this.provinceElement.options.add(new Option(data2[1], data2[0], selected, selected));
    });
  }
};
if (!window.customElements.get("country-selector")) {
  window.customElements.define("country-selector", CountrySelector);
}

// js/common/utilities/format-money.js
function formatMoney(cents, format2 = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format2 || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

// js/common/utilities/cached-fetch.js
var cachedMap = /* @__PURE__ */ new Map();
function cachedFetch(url, options) {
  const cacheKey = url;
  if (cachedMap.has(cacheKey)) {
    return Promise.resolve(new Response(new Blob([cachedMap.get(cacheKey)])));
  }
  return fetch(url, options).then((response) => {
    if (response.status === 200) {
      const contentType = response.headers.get("Content-Type");
      if (contentType && (contentType.match(/application\/json/i) || contentType.match(/text\//i))) {
        response.clone().text().then((content) => {
          cachedMap.set(cacheKey, content);
        });
      }
    }
    return response;
  });
}

// js/common/utilities/extract-section-id.js
function extractSectionId(element) {
  element = element.classList.contains("shopify-section") ? element : element.closest(".shopify-section");
  return element.id.replace("shopify-section-", "");
}

// js/common/utilities/dom.js
function throttle(callback) {
  let requestId = null, lastArgs;
  const later = (context) => () => {
    requestId = null;
    callback.apply(context, lastArgs);
  };
  const throttled = (...args) => {
    lastArgs = args;
    if (requestId === null) {
      requestId = requestAnimationFrame(later(this));
    }
  };
  throttled.cancel = () => {
    cancelAnimationFrame(requestId);
    requestId = null;
  };
  return throttled;
}
function debounce(fn2, delay) {
  let timer = null;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn2.apply(this, args);
    }, delay);
  };
}
function waitForEvent(element, eventName) {
  return new Promise((resolve) => {
    const done = (event) => {
      if (event.target === element) {
        element.removeEventListener(eventName, done);
        resolve(event);
      }
    };
    element.addEventListener(eventName, done);
  });
}

// js/common/utilities/media.js
function videoLoaded(videoOrArray) {
  if (!videoOrArray) {
    return Promise.resolve();
  }
  videoOrArray = videoOrArray instanceof Element ? [videoOrArray] : Array.from(videoOrArray);
  return Promise.all(videoOrArray.map((video) => {
    return new Promise((resolve) => {
      if (video.tagName === "VIDEO" && video.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA || !video.offsetParent || video.parentNode.hasAttribute("suspended")) {
        resolve();
      } else {
        video.oncanplay = () => resolve();
      }
    });
  }));
}
function imageLoaded(imageOrArray) {
  if (!imageOrArray) {
    return Promise.resolve();
  }
  imageOrArray = imageOrArray instanceof Element ? [imageOrArray] : Array.from(imageOrArray);
  return Promise.all(imageOrArray.map((image) => {
    return new Promise((resolve) => {
      if (image.tagName === "IMG" && image.complete || !image.offsetParent) {
        resolve();
      } else {
        image.onload = () => resolve();
      }
    });
  }));
}
function generateSrcset(imageObjectOrString, widths = []) {
  let imageUrl, maxWidth;
  if (typeof imageObjectOrString === "string") {
    imageUrl = new URL(imageObjectOrString.startsWith("//") ? `https:${imageObjectOrString}` : imageObjectOrString);
    maxWidth = parseInt(imageUrl.searchParams.get("width"));
  } else {
    imageUrl = new URL(imageObjectOrString["src"]);
    maxWidth = imageObjectOrString["width"];
  }
  return widths.filter((width) => width <= maxWidth).map((width) => {
    imageUrl.searchParams.set("width", width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
}
function createMediaImg(media, widths = [], attributes = {}) {
  const image = new Image(media["preview_image"]["width"], media["preview_image"]["height"]), featuredMediaUrl = new URL(media["preview_image"]["src"]);
  for (const attributeKey in attributes) {
    image.setAttribute(attributeKey, attributes[attributeKey]);
  }
  image.alt = media["alt"] || "";
  image.src = featuredMediaUrl.href;
  image.srcset = generateSrcset(media["preview_image"], widths);
  return image;
}

// js/common/utilities/media-query.js
function matchesMediaQuery(breakpointName) {
  if (!window.themeVariables.mediaQueries.hasOwnProperty(breakpointName)) {
    return false;
  }
  return window.matchMedia(window.themeVariables.mediaQueries[breakpointName]).matches;
}
function mediaQueryListener(breakpointName, func) {
  if (!window.themeVariables.mediaQueries.hasOwnProperty(breakpointName)) {
    throw `Media query ${breakpointName} does not exist`;
  }
  return window.matchMedia(window.themeVariables.mediaQueries[breakpointName]).addEventListener("change", func);
}

// js/common/utilities/player.js
var _callback, _duration, _remainingTime, _startTime, _timer, _state, _onVisibilityChangeListener, _mustResumeOnVisibility, _Player_instances, onVisibilityChange_fn;
var Player = class extends EventTarget {
  constructor(durationInSec, stopOnVisibility = true) {
    super();
    __privateAdd(this, _Player_instances);
    __privateAdd(this, _callback);
    __privateAdd(this, _duration);
    __privateAdd(this, _remainingTime);
    __privateAdd(this, _startTime);
    __privateAdd(this, _timer);
    __privateAdd(this, _state, "paused");
    __privateAdd(this, _onVisibilityChangeListener, __privateMethod(this, _Player_instances, onVisibilityChange_fn).bind(this));
    __privateAdd(this, _mustResumeOnVisibility, true);
    __privateSet(this, _callback, () => this.dispatchEvent(new CustomEvent("player:end")));
    __privateSet(this, _duration, __privateSet(this, _remainingTime, durationInSec * 1e3));
    if (stopOnVisibility) {
      document.addEventListener("visibilitychange", __privateGet(this, _onVisibilityChangeListener));
    }
  }
  pause() {
    if (__privateGet(this, _state) !== "started") {
      return;
    }
    clearTimeout(__privateGet(this, _timer));
    __privateSet(this, _state, "paused");
    __privateSet(this, _remainingTime, __privateGet(this, _remainingTime) - ((/* @__PURE__ */ new Date()).getTime() - __privateGet(this, _startTime)));
    this.dispatchEvent(new CustomEvent("player:pause"));
  }
  resume(restartTimer = false) {
    if (__privateGet(this, _state) !== "stopped") {
      if (restartTimer) {
        this.start();
      } else {
        clearTimeout(__privateGet(this, _timer));
        __privateSet(this, _startTime, (/* @__PURE__ */ new Date()).getTime());
        __privateSet(this, _state, "started");
        __privateSet(this, _timer, setTimeout(__privateGet(this, _callback), __privateGet(this, _remainingTime)));
        this.dispatchEvent(new CustomEvent("player:resume"));
      }
    }
  }
  start() {
    clearTimeout(__privateGet(this, _timer));
    __privateSet(this, _startTime, (/* @__PURE__ */ new Date()).getTime());
    __privateSet(this, _state, "started");
    __privateSet(this, _remainingTime, __privateGet(this, _duration));
    __privateSet(this, _timer, setTimeout(__privateGet(this, _callback), __privateGet(this, _remainingTime)));
    this.dispatchEvent(new CustomEvent("player:start"));
  }
  stop() {
    clearTimeout(__privateGet(this, _timer));
    __privateSet(this, _state, "stopped");
    this.dispatchEvent(new CustomEvent("player:stop"));
  }
};
_callback = new WeakMap();
_duration = new WeakMap();
_remainingTime = new WeakMap();
_startTime = new WeakMap();
_timer = new WeakMap();
_state = new WeakMap();
_onVisibilityChangeListener = new WeakMap();
_mustResumeOnVisibility = new WeakMap();
_Player_instances = new WeakSet();
onVisibilityChange_fn = function() {
  if (document.visibilityState === "hidden") {
    __privateSet(this, _mustResumeOnVisibility, __privateGet(this, _state) === "started");
    this.pause();
    this.dispatchEvent(new CustomEvent("player:visibility-pause"));
  } else if (document.visibilityState === "visible" && __privateGet(this, _mustResumeOnVisibility)) {
    this.resume();
    this.dispatchEvent(new CustomEvent("player:visibility-resume"));
  }
};

// js/common/utilities/qr-code.js
var QrCode = class extends HTMLElement {
  connectedCallback() {
    new window.QRCode(this, {
      text: this.getAttribute("identifier"),
      width: this.hasAttribute("width") ? parseInt(this.getAttribute("width")) : 200,
      height: this.hasAttribute("height") ? parseInt(this.getAttribute("height")) : 200
    });
  }
};
if (!window.customElements.get("qr-code")) {
  window.customElements.define("qr-code", QrCode);
}

// js/common/utilities/lt-request.js
async function ltRequest(formData, formType, formName) {
  let email = formData.get("email");
  const response = await fetch(`${Shopify.routes.root}search?view=lt-request-manager&q=${email}`);
  const key = await response.text();
  let token = key.split(":");
  let data2 = {};
  let formDataObject = {};
  for (let [key2, value] of formData.entries()) {
    if (key2 !== "email") {
      formDataObject[key2] = value;
    }
    let formElement = document.querySelector(`[data-form-type="${formType}"][data-form-name="${formName}"] [name="${key2}"]`);
    if (formElement && formElement.type === "checkbox") {
      formDataObject[key2] = formElement.checked;
    } else {
      if (key2 === "shopify_customer_id") {
        formDataObject[key2] = JSON.parse(value);
      }
    }
  }
  data2["token"] = token[1];
  data2["email"] = email;
  data2["form_type"] = formType;
  data2["form_name"] = formName;
  data2["form_data"] = formDataObject;
  data2["market_handle"] = window.themeVariables.settings.currentMarket;
  data2["locale"] = window.Shopify.locale;
  let options = {
    "body": JSON.stringify(data2),
    "method": "POST",
    "contentType": "application/json",
    "dataType": "json",
    "headers": {
      "X-Requested-With": "XMLHttpRequest",
      "User-Agent": "insomnia/8.6.0",
      "Authorization": `api_user ${token[0]}`
    }
  };
  return await fetch(window.themeVariables.apiFormURL, options);
}

// js/common/behavior/height-observer.js
var HeightObserver = class extends HTMLElement {
  constructor() {
    super();
    if (window.ResizeObserver) {
      new ResizeObserver(throttle(this.updateCustomProperties.bind(this))).observe(this);
    }
  }
  connectedCallback() {
    if (!window.ResizeObserver) {
      document.documentElement.style.setProperty(`--${this.getAttribute("variable")}-height`, `${Math.round(this.clientHeight)}px`);
    }
  }
  updateCustomProperties(entries) {
    entries.forEach((entry) => {
      if (entry.target === this) {
        const height = entry.borderBoxSize ? entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.borderBoxSize.blockSize : entry.target.clientHeight;
        document.documentElement.style.setProperty(`--${this.getAttribute("variable")}-height`, `${Math.round(height)}px`);
      }
    });
  }
};
var WindowInnerHeight = class {
  constructor() {
    window.addEventListener("resize", throttle(this.updateCustomProperties.bind(this)));
    this.updateCustomProperties();
  }
  updateCustomProperties() {
    document.documentElement.style.setProperty(`--window-inner-height`, `${window.innerHeight}px`);
  }
};
new WindowInnerHeight();
if (!window.customElements.get("height-observer")) {
  window.customElements.define("height-observer", HeightObserver);
}

// js/common/behavior/loading-bar.js
import { animate as animate2 } from "vendor";
var _LoadingBar_instances, onLoadingStart_fn, onLoadingEnd_fn;
var LoadingBar = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _LoadingBar_instances);
    document.addEventListener("theme:loading:start", __privateMethod(this, _LoadingBar_instances, onLoadingStart_fn).bind(this));
    document.addEventListener("theme:loading:end", __privateMethod(this, _LoadingBar_instances, onLoadingEnd_fn).bind(this));
  }
};
_LoadingBar_instances = new WeakSet();
onLoadingStart_fn = function() {
  animate2(this, { opacity: [0, 1], transform: ["scaleX(0)", "scaleX(0.4)"] }, { duration: 0.25 });
};
onLoadingEnd_fn = async function() {
  await animate2(this, { transform: [null, "scaleX(1)"] }, { duration: 0.25 }).finished;
  animate2(this, { opacity: 0 }, { duration: 0.25 });
};
if (!window.customElements.get("loading-bar")) {
  window.customElements.define("loading-bar", LoadingBar);
}

// js/common/behavior/safe-sticky.js
import { inView as inView2 } from "vendor";
var _resizeObserver, _checkPositionListener, _initialTop, _lastKnownY, _currentTop, _position, _SafeSticky_instances, recalculateStyles_fn, checkPosition_fn;
var SafeSticky = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _SafeSticky_instances);
    __privateAdd(this, _resizeObserver, new ResizeObserver(__privateMethod(this, _SafeSticky_instances, recalculateStyles_fn).bind(this)));
    __privateAdd(this, _checkPositionListener, throttle(__privateMethod(this, _SafeSticky_instances, checkPosition_fn).bind(this)));
    __privateAdd(this, _initialTop, 0);
    __privateAdd(this, _lastKnownY, 0);
    /* we could initialize it to window.scrollY but this avoids a costly reflow */
    __privateAdd(this, _currentTop, 0);
    __privateAdd(this, _position, "relative");
  }
  connectedCallback() {
    inView2(this, () => {
      window.addEventListener("scroll", __privateGet(this, _checkPositionListener));
      __privateGet(this, _resizeObserver).observe(this);
      return () => {
        window.removeEventListener("scroll", __privateGet(this, _checkPositionListener));
        __privateGet(this, _resizeObserver).unobserve(this);
      };
    }, { margin: "500px" });
  }
  disconnectedCallback() {
    window.removeEventListener("scroll", __privateGet(this, _checkPositionListener));
    __privateGet(this, _resizeObserver).unobserve(this);
  }
};
_resizeObserver = new WeakMap();
_checkPositionListener = new WeakMap();
_initialTop = new WeakMap();
_lastKnownY = new WeakMap();
_currentTop = new WeakMap();
_position = new WeakMap();
_SafeSticky_instances = new WeakSet();
recalculateStyles_fn = function() {
  this.style.removeProperty("top");
  const computedStyles = getComputedStyle(this);
  __privateSet(this, _initialTop, parseInt(computedStyles.top));
  __privateSet(this, _position, computedStyles.position);
  __privateMethod(this, _SafeSticky_instances, checkPosition_fn).call(this);
};
checkPosition_fn = function() {
  if (__privateGet(this, _position) !== "sticky") {
    return this.style.removeProperty("top");
  }
  let bounds = this.getBoundingClientRect(), maxTop = bounds.top + window.scrollY - this.offsetTop + __privateGet(this, _initialTop), minTop = this.clientHeight - window.innerHeight + 20;
  if (window.scrollY < __privateGet(this, _lastKnownY)) {
    __privateSet(this, _currentTop, __privateGet(this, _currentTop) - (window.scrollY - __privateGet(this, _lastKnownY)));
  } else {
    __privateSet(this, _currentTop, __privateGet(this, _currentTop) + (__privateGet(this, _lastKnownY) - window.scrollY));
  }
  __privateSet(this, _currentTop, Math.min(Math.max(__privateGet(this, _currentTop), -minTop), maxTop, __privateGet(this, _initialTop)));
  __privateSet(this, _lastKnownY, window.scrollY);
  this.style.top = `${Math.round(__privateGet(this, _currentTop))}px`;
};
if (!window.customElements.get("safe-sticky")) {
  window.customElements.define("safe-sticky", SafeSticky);
}

// node_modules/@splidejs/splide/dist/js/splide.esm.js
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
var MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
var CREATED = 1;
var MOUNTED = 2;
var IDLE = 3;
var MOVING = 4;
var SCROLLING = 5;
var DRAGGING = 6;
var DESTROYED = 7;
var STATES = {
  CREATED,
  MOUNTED,
  IDLE,
  MOVING,
  SCROLLING,
  DRAGGING,
  DESTROYED
};
function empty(array) {
  array.length = 0;
}
function slice(arrayLike, start, end) {
  return Array.prototype.slice.call(arrayLike, start, end);
}
function apply(func) {
  return func.bind.apply(func, [null].concat(slice(arguments, 1)));
}
var nextTick = setTimeout;
var noop = function noop2() {
};
function raf(func) {
  return requestAnimationFrame(func);
}
function typeOf(type, subject) {
  return typeof subject === type;
}
function isObject(subject) {
  return !isNull(subject) && typeOf("object", subject);
}
var isArray = Array.isArray;
var isFunction = apply(typeOf, "function");
var isString = apply(typeOf, "string");
var isUndefined = apply(typeOf, "undefined");
function isNull(subject) {
  return subject === null;
}
function isHTMLElement(subject) {
  try {
    return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
  } catch (e) {
    return false;
  }
}
function toArray(value) {
  return isArray(value) ? value : [value];
}
function forEach(values, iteratee) {
  toArray(values).forEach(iteratee);
}
function includes(array, value) {
  return array.indexOf(value) > -1;
}
function push(array, items) {
  array.push.apply(array, toArray(items));
  return array;
}
function toggleClass(elm, classes, add) {
  if (elm) {
    forEach(classes, function(name) {
      if (name) {
        elm.classList[add ? "add" : "remove"](name);
      }
    });
  }
}
function addClass(elm, classes) {
  toggleClass(elm, isString(classes) ? classes.split(" ") : classes, true);
}
function append(parent, children2) {
  forEach(children2, parent.appendChild.bind(parent));
}
function before(nodes, ref) {
  forEach(nodes, function(node) {
    var parent = (ref || node).parentNode;
    if (parent) {
      parent.insertBefore(node, ref);
    }
  });
}
function matches(elm, selector) {
  return isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}
function children(parent, selector) {
  var children2 = parent ? slice(parent.children) : [];
  return selector ? children2.filter(function(child2) {
    return matches(child2, selector);
  }) : children2;
}
function child(parent, selector) {
  return selector ? children(parent, selector)[0] : parent.firstElementChild;
}
var ownKeys = Object.keys;
function forOwn(object, iteratee, right) {
  if (object) {
    (right ? ownKeys(object).reverse() : ownKeys(object)).forEach(function(key) {
      key !== "__proto__" && iteratee(object[key], key);
    });
  }
  return object;
}
function assign(object) {
  slice(arguments, 1).forEach(function(source) {
    forOwn(source, function(value, key) {
      object[key] = source[key];
    });
  });
  return object;
}
function merge(object) {
  slice(arguments, 1).forEach(function(source) {
    forOwn(source, function(value, key) {
      if (isArray(value)) {
        object[key] = value.slice();
      } else if (isObject(value)) {
        object[key] = merge({}, isObject(object[key]) ? object[key] : {}, value);
      } else {
        object[key] = value;
      }
    });
  });
  return object;
}
function omit(object, keys) {
  forEach(keys || ownKeys(object), function(key) {
    delete object[key];
  });
}
function removeAttribute(elms, attrs) {
  forEach(elms, function(elm) {
    forEach(attrs, function(attr) {
      elm && elm.removeAttribute(attr);
    });
  });
}
function setAttribute(elms, attrs, value) {
  if (isObject(attrs)) {
    forOwn(attrs, function(value2, name) {
      setAttribute(elms, name, value2);
    });
  } else {
    forEach(elms, function(elm) {
      isNull(value) || value === "" ? removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
  }
}
function create(tag, attrs, parent) {
  var elm = document.createElement(tag);
  if (attrs) {
    isString(attrs) ? addClass(elm, attrs) : setAttribute(elm, attrs);
  }
  parent && append(parent, elm);
  return elm;
}
function style(elm, prop, value) {
  if (isUndefined(value)) {
    return getComputedStyle(elm)[prop];
  }
  if (!isNull(value)) {
    elm.style[prop] = "" + value;
  }
}
function display(elm, display2) {
  style(elm, "display", display2);
}
function focus(elm) {
  elm["setActive"] && elm["setActive"]() || elm.focus({
    preventScroll: true
  });
}
function getAttribute(elm, attr) {
  return elm.getAttribute(attr);
}
function hasClass(elm, className) {
  return elm && elm.classList.contains(className);
}
function rect(target) {
  return target.getBoundingClientRect();
}
function remove(nodes) {
  forEach(nodes, function(node) {
    if (node && node.parentNode) {
      node.parentNode.removeChild(node);
    }
  });
}
function parseHtml(html) {
  return child(new DOMParser().parseFromString(html, "text/html").body);
}
function prevent(e, stopPropagation) {
  e.preventDefault();
  if (stopPropagation) {
    e.stopPropagation();
    e.stopImmediatePropagation();
  }
}
function query(parent, selector) {
  return parent && parent.querySelector(selector);
}
function queryAll(parent, selector) {
  return selector ? slice(parent.querySelectorAll(selector)) : [];
}
function removeClass(elm, classes) {
  toggleClass(elm, classes, false);
}
function timeOf(e) {
  return e.timeStamp;
}
function unit(value) {
  return isString(value) ? value : value ? value + "px" : "";
}
var PROJECT_CODE = "splide";
var DATA_ATTRIBUTE = "data-" + PROJECT_CODE;
function assert(condition, message) {
  if (!condition) {
    throw new Error("[" + PROJECT_CODE + "] " + (message || ""));
  }
}
var min = Math.min;
var max = Math.max;
var floor = Math.floor;
var ceil = Math.ceil;
var abs = Math.abs;
function approximatelyEqual(x, y2, epsilon) {
  return abs(x - y2) < epsilon;
}
function between(number, x, y2, exclusive) {
  var minimum = min(x, y2);
  var maximum = max(x, y2);
  return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
}
function clamp(number, x, y2) {
  var minimum = min(x, y2);
  var maximum = max(x, y2);
  return min(max(minimum, number), maximum);
}
function sign(x) {
  return +(x > 0) - +(x < 0);
}
function format(string, replacements) {
  forEach(replacements, function(replacement) {
    string = string.replace("%s", "" + replacement);
  });
  return string;
}
function pad(number) {
  return number < 10 ? "0" + number : "" + number;
}
var ids = {};
function uniqueId(prefix) {
  return "" + prefix + pad(ids[prefix] = (ids[prefix] || 0) + 1);
}
function EventBinder() {
  var listeners = [];
  function bind(targets, events, callback, options) {
    forEachEvent(targets, events, function(target, event, namespace) {
      var isEventTarget = "addEventListener" in target;
      var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
      isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
      listeners.push([target, event, namespace, callback, remover]);
    });
  }
  function unbind(targets, events, callback) {
    forEachEvent(targets, events, function(target, event, namespace) {
      listeners = listeners.filter(function(listener) {
        if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
          listener[4]();
          return false;
        }
        return true;
      });
    });
  }
  function dispatch(target, type, detail) {
    var e;
    var bubbles = true;
    if (typeof CustomEvent === "function") {
      e = new CustomEvent(type, {
        bubbles,
        detail
      });
    } else {
      e = document.createEvent("CustomEvent");
      e.initCustomEvent(type, bubbles, false, detail);
    }
    target.dispatchEvent(e);
    return e;
  }
  function forEachEvent(targets, events, iteratee) {
    forEach(targets, function(target) {
      target && forEach(events, function(events2) {
        events2.split(" ").forEach(function(eventNS) {
          var fragment = eventNS.split(".");
          iteratee(target, fragment[0], fragment[1]);
        });
      });
    });
  }
  function destroy() {
    listeners.forEach(function(data2) {
      data2[4]();
    });
    empty(listeners);
  }
  return {
    bind,
    unbind,
    dispatch,
    destroy
  };
}
var EVENT_MOUNTED = "mounted";
var EVENT_READY = "ready";
var EVENT_MOVE = "move";
var EVENT_MOVED = "moved";
var EVENT_CLICK = "click";
var EVENT_ACTIVE = "active";
var EVENT_INACTIVE = "inactive";
var EVENT_VISIBLE = "visible";
var EVENT_HIDDEN = "hidden";
var EVENT_REFRESH = "refresh";
var EVENT_UPDATED = "updated";
var EVENT_RESIZE = "resize";
var EVENT_RESIZED = "resized";
var EVENT_DRAG = "drag";
var EVENT_DRAGGING = "dragging";
var EVENT_DRAGGED = "dragged";
var EVENT_SCROLL = "scroll";
var EVENT_SCROLLED = "scrolled";
var EVENT_OVERFLOW = "overflow";
var EVENT_DESTROY = "destroy";
var EVENT_ARROWS_MOUNTED = "arrows:mounted";
var EVENT_ARROWS_UPDATED = "arrows:updated";
var EVENT_PAGINATION_MOUNTED = "pagination:mounted";
var EVENT_PAGINATION_UPDATED = "pagination:updated";
var EVENT_NAVIGATION_MOUNTED = "navigation:mounted";
var EVENT_AUTOPLAY_PLAY = "autoplay:play";
var EVENT_AUTOPLAY_PLAYING = "autoplay:playing";
var EVENT_AUTOPLAY_PAUSE = "autoplay:pause";
var EVENT_LAZYLOAD_LOADED = "lazyload:loaded";
var EVENT_SLIDE_KEYDOWN = "sk";
var EVENT_SHIFTED = "sh";
var EVENT_END_INDEX_CHANGED = "ei";
function EventInterface(Splide2) {
  var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
  var binder = EventBinder();
  function on2(events, callback) {
    binder.bind(bus, toArray(events).join(" "), function(e) {
      callback.apply(callback, isArray(e.detail) ? e.detail : []);
    });
  }
  function emit(event) {
    binder.dispatch(bus, event, slice(arguments, 1));
  }
  if (Splide2) {
    Splide2.event.on(EVENT_DESTROY, binder.destroy);
  }
  return assign(binder, {
    bus,
    on: on2,
    off: apply(binder.unbind, bus),
    emit
  });
}
function RequestInterval(interval, onInterval, onUpdate, limit) {
  var now = Date.now;
  var startTime;
  var rate = 0;
  var id;
  var paused = true;
  var count = 0;
  function update() {
    if (!paused) {
      rate = interval ? min((now() - startTime) / interval, 1) : 1;
      onUpdate && onUpdate(rate);
      if (rate >= 1) {
        onInterval();
        startTime = now();
        if (limit && ++count >= limit) {
          return pause();
        }
      }
      id = raf(update);
    }
  }
  function start(resume) {
    resume || cancel();
    startTime = now() - (resume ? rate * interval : 0);
    paused = false;
    id = raf(update);
  }
  function pause() {
    paused = true;
  }
  function rewind() {
    startTime = now();
    rate = 0;
    if (onUpdate) {
      onUpdate(rate);
    }
  }
  function cancel() {
    id && cancelAnimationFrame(id);
    rate = 0;
    id = 0;
    paused = true;
  }
  function set(time2) {
    interval = time2;
  }
  function isPaused() {
    return paused;
  }
  return {
    start,
    rewind,
    pause,
    cancel,
    set,
    isPaused
  };
}
function State(initialState) {
  var state = initialState;
  function set(value) {
    state = value;
  }
  function is(states) {
    return includes(toArray(states), state);
  }
  return {
    set,
    is
  };
}
function Throttle(func, duration) {
  var interval = RequestInterval(duration || 0, func, null, 1);
  return function() {
    interval.isPaused() && interval.start();
  };
}
function Media(Splide2, Components2, options) {
  var state = Splide2.state;
  var breakpoints = options.breakpoints || {};
  var reducedMotion = options.reducedMotion || {};
  var binder = EventBinder();
  var queries = [];
  function setup() {
    var isMin = options.mediaQuery === "min";
    ownKeys(breakpoints).sort(function(n, m) {
      return isMin ? +n - +m : +m - +n;
    }).forEach(function(key) {
      register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
    });
    register(reducedMotion, MEDIA_PREFERS_REDUCED_MOTION);
    update();
  }
  function destroy(completely) {
    if (completely) {
      binder.destroy();
    }
  }
  function register(options2, query2) {
    var queryList = matchMedia(query2);
    binder.bind(queryList, "change", update);
    queries.push([options2, queryList]);
  }
  function update() {
    var destroyed = state.is(DESTROYED);
    var direction = options.direction;
    var merged = queries.reduce(function(merged2, entry) {
      return merge(merged2, entry[1].matches ? entry[0] : {});
    }, {});
    omit(options);
    set(merged);
    if (options.destroy) {
      Splide2.destroy(options.destroy === "completely");
    } else if (destroyed) {
      destroy(true);
      Splide2.mount();
    } else {
      direction !== options.direction && Splide2.refresh();
    }
  }
  function reduce(enable) {
    if (matchMedia(MEDIA_PREFERS_REDUCED_MOTION).matches) {
      enable ? merge(options, reducedMotion) : omit(options, ownKeys(reducedMotion));
    }
  }
  function set(opts, base, notify) {
    merge(options, opts);
    base && merge(Object.getPrototypeOf(options), opts);
    if (notify || !state.is(CREATED)) {
      Splide2.emit(EVENT_UPDATED, options);
    }
  }
  return {
    setup,
    destroy,
    reduce,
    set
  };
}
var ARROW = "Arrow";
var ARROW_LEFT = ARROW + "Left";
var ARROW_RIGHT = ARROW + "Right";
var ARROW_UP = ARROW + "Up";
var ARROW_DOWN = ARROW + "Down";
var RTL = "rtl";
var TTB = "ttb";
var ORIENTATION_MAP = {
  width: ["height"],
  left: ["top", "right"],
  right: ["bottom", "left"],
  x: ["y"],
  X: ["Y"],
  Y: ["X"],
  ArrowLeft: [ARROW_UP, ARROW_RIGHT],
  ArrowRight: [ARROW_DOWN, ARROW_LEFT]
};
function Direction(Splide2, Components2, options) {
  function resolve(prop, axisOnly, direction) {
    direction = direction || options.direction;
    var index = direction === RTL && !axisOnly ? 1 : direction === TTB ? 0 : -1;
    return ORIENTATION_MAP[prop] && ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function(match, offset) {
      var replacement = ORIENTATION_MAP[match.toLowerCase()][index] || match;
      return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
    });
  }
  function orient(value) {
    return value * (options.direction === RTL ? 1 : -1);
  }
  return {
    resolve,
    orient
  };
}
var ROLE = "role";
var TAB_INDEX = "tabindex";
var DISABLED = "disabled";
var ARIA_PREFIX = "aria-";
var ARIA_CONTROLS = ARIA_PREFIX + "controls";
var ARIA_CURRENT = ARIA_PREFIX + "current";
var ARIA_SELECTED = ARIA_PREFIX + "selected";
var ARIA_LABEL = ARIA_PREFIX + "label";
var ARIA_LABELLEDBY = ARIA_PREFIX + "labelledby";
var ARIA_HIDDEN = ARIA_PREFIX + "hidden";
var ARIA_ORIENTATION = ARIA_PREFIX + "orientation";
var ARIA_ROLEDESCRIPTION = ARIA_PREFIX + "roledescription";
var ARIA_LIVE = ARIA_PREFIX + "live";
var ARIA_BUSY = ARIA_PREFIX + "busy";
var ARIA_ATOMIC = ARIA_PREFIX + "atomic";
var ALL_ATTRIBUTES = [ROLE, TAB_INDEX, DISABLED, ARIA_CONTROLS, ARIA_CURRENT, ARIA_LABEL, ARIA_LABELLEDBY, ARIA_HIDDEN, ARIA_ORIENTATION, ARIA_ROLEDESCRIPTION];
var CLASS_PREFIX = PROJECT_CODE + "__";
var STATUS_CLASS_PREFIX = "is-";
var CLASS_ROOT = PROJECT_CODE;
var CLASS_TRACK = CLASS_PREFIX + "track";
var CLASS_LIST = CLASS_PREFIX + "list";
var CLASS_SLIDE = CLASS_PREFIX + "slide";
var CLASS_CLONE = CLASS_SLIDE + "--clone";
var CLASS_CONTAINER = CLASS_SLIDE + "__container";
var CLASS_ARROWS = CLASS_PREFIX + "arrows";
var CLASS_ARROW = CLASS_PREFIX + "arrow";
var CLASS_ARROW_PREV = CLASS_ARROW + "--prev";
var CLASS_ARROW_NEXT = CLASS_ARROW + "--next";
var CLASS_PAGINATION = CLASS_PREFIX + "pagination";
var CLASS_PAGINATION_PAGE = CLASS_PAGINATION + "__page";
var CLASS_PROGRESS = CLASS_PREFIX + "progress";
var CLASS_PROGRESS_BAR = CLASS_PROGRESS + "__bar";
var CLASS_TOGGLE = CLASS_PREFIX + "toggle";
var CLASS_TOGGLE_PLAY = CLASS_TOGGLE + "__play";
var CLASS_TOGGLE_PAUSE = CLASS_TOGGLE + "__pause";
var CLASS_SPINNER = CLASS_PREFIX + "spinner";
var CLASS_SR = CLASS_PREFIX + "sr";
var CLASS_INITIALIZED = STATUS_CLASS_PREFIX + "initialized";
var CLASS_ACTIVE = STATUS_CLASS_PREFIX + "active";
var CLASS_PREV = STATUS_CLASS_PREFIX + "prev";
var CLASS_NEXT = STATUS_CLASS_PREFIX + "next";
var CLASS_VISIBLE = STATUS_CLASS_PREFIX + "visible";
var CLASS_LOADING = STATUS_CLASS_PREFIX + "loading";
var CLASS_FOCUS_IN = STATUS_CLASS_PREFIX + "focus-in";
var CLASS_OVERFLOW = STATUS_CLASS_PREFIX + "overflow";
var STATUS_CLASSES = [CLASS_ACTIVE, CLASS_VISIBLE, CLASS_PREV, CLASS_NEXT, CLASS_LOADING, CLASS_FOCUS_IN, CLASS_OVERFLOW];
var CLASSES = {
  slide: CLASS_SLIDE,
  clone: CLASS_CLONE,
  arrows: CLASS_ARROWS,
  arrow: CLASS_ARROW,
  prev: CLASS_ARROW_PREV,
  next: CLASS_ARROW_NEXT,
  pagination: CLASS_PAGINATION,
  page: CLASS_PAGINATION_PAGE,
  spinner: CLASS_SPINNER
};
function closest(from, selector) {
  if (isFunction(from.closest)) {
    return from.closest(selector);
  }
  var elm = from;
  while (elm && elm.nodeType === 1) {
    if (matches(elm, selector)) {
      break;
    }
    elm = elm.parentElement;
  }
  return elm;
}
var FRICTION = 5;
var LOG_INTERVAL = 200;
var POINTER_DOWN_EVENTS = "touchstart mousedown";
var POINTER_MOVE_EVENTS = "touchmove mousemove";
var POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
function Elements(Splide2, Components2, options) {
  var _EventInterface = EventInterface(Splide2), on2 = _EventInterface.on, bind = _EventInterface.bind;
  var root = Splide2.root;
  var i18n = options.i18n;
  var elements = {};
  var slides = [];
  var rootClasses = [];
  var trackClasses = [];
  var track;
  var list;
  var isUsingKey;
  function setup() {
    collect();
    init();
    update();
  }
  function mount() {
    on2(EVENT_REFRESH, destroy);
    on2(EVENT_REFRESH, setup);
    on2(EVENT_UPDATED, update);
    bind(document, POINTER_DOWN_EVENTS + " keydown", function(e) {
      isUsingKey = e.type === "keydown";
    }, {
      capture: true
    });
    bind(root, "focusin", function() {
      toggleClass(root, CLASS_FOCUS_IN, !!isUsingKey);
    });
  }
  function destroy(completely) {
    var attrs = ALL_ATTRIBUTES.concat("style");
    empty(slides);
    removeClass(root, rootClasses);
    removeClass(track, trackClasses);
    removeAttribute([track, list], attrs);
    removeAttribute(root, completely ? attrs : ["style", ARIA_ROLEDESCRIPTION]);
  }
  function update() {
    removeClass(root, rootClasses);
    removeClass(track, trackClasses);
    rootClasses = getClasses(CLASS_ROOT);
    trackClasses = getClasses(CLASS_TRACK);
    addClass(root, rootClasses);
    addClass(track, trackClasses);
    setAttribute(root, ARIA_LABEL, options.label);
    setAttribute(root, ARIA_LABELLEDBY, options.labelledby);
  }
  function collect() {
    track = find("." + CLASS_TRACK);
    list = child(track, "." + CLASS_LIST);
    assert(track && list, "A track/list element is missing.");
    push(slides, children(list, "." + CLASS_SLIDE + ":not(." + CLASS_CLONE + ")"));
    forOwn({
      arrows: CLASS_ARROWS,
      pagination: CLASS_PAGINATION,
      prev: CLASS_ARROW_PREV,
      next: CLASS_ARROW_NEXT,
      bar: CLASS_PROGRESS_BAR,
      toggle: CLASS_TOGGLE
    }, function(className, key) {
      elements[key] = find("." + className);
    });
    assign(elements, {
      root,
      track,
      list,
      slides
    });
  }
  function init() {
    var id = root.id || uniqueId(PROJECT_CODE);
    var role = options.role;
    root.id = id;
    track.id = track.id || id + "-track";
    list.id = list.id || id + "-list";
    if (!getAttribute(root, ROLE) && root.tagName !== "SECTION" && role) {
      setAttribute(root, ROLE, role);
    }
    setAttribute(root, ARIA_ROLEDESCRIPTION, i18n.carousel);
    setAttribute(list, ROLE, "presentation");
  }
  function find(selector) {
    var elm = query(root, selector);
    return elm && closest(elm, "." + CLASS_ROOT) === root ? elm : void 0;
  }
  function getClasses(base) {
    return [base + "--" + options.type, base + "--" + options.direction, options.drag && base + "--draggable", options.isNavigation && base + "--nav", base === CLASS_ROOT && CLASS_ACTIVE];
  }
  return assign(elements, {
    setup,
    mount,
    destroy
  });
}
var SLIDE = "slide";
var LOOP = "loop";
var FADE = "fade";
function Slide$1(Splide2, index, slideIndex, slide) {
  var event = EventInterface(Splide2);
  var on2 = event.on, emit = event.emit, bind = event.bind;
  var Components = Splide2.Components, root = Splide2.root, options = Splide2.options;
  var isNavigation = options.isNavigation, updateOnMove = options.updateOnMove, i18n = options.i18n, pagination = options.pagination, slideFocus = options.slideFocus;
  var resolve = Components.Direction.resolve;
  var styles = getAttribute(slide, "style");
  var label = getAttribute(slide, ARIA_LABEL);
  var isClone = slideIndex > -1;
  var container = child(slide, "." + CLASS_CONTAINER);
  var destroyed;
  function mount() {
    if (!isClone) {
      slide.id = root.id + "-slide" + pad(index + 1);
      setAttribute(slide, ROLE, pagination ? "tabpanel" : "group");
      setAttribute(slide, ARIA_ROLEDESCRIPTION, i18n.slide);
      setAttribute(slide, ARIA_LABEL, label || format(i18n.slideLabel, [index + 1, Splide2.length]));
    }
    listen();
  }
  function listen() {
    bind(slide, "click", apply(emit, EVENT_CLICK, self2));
    bind(slide, "keydown", apply(emit, EVENT_SLIDE_KEYDOWN, self2));
    on2([EVENT_MOVED, EVENT_SHIFTED, EVENT_SCROLLED], update);
    on2(EVENT_NAVIGATION_MOUNTED, initNavigation);
    if (updateOnMove) {
      on2(EVENT_MOVE, onMove);
    }
  }
  function destroy() {
    destroyed = true;
    event.destroy();
    removeClass(slide, STATUS_CLASSES);
    removeAttribute(slide, ALL_ATTRIBUTES);
    setAttribute(slide, "style", styles);
    setAttribute(slide, ARIA_LABEL, label || "");
  }
  function initNavigation() {
    var controls2 = Splide2.splides.map(function(target) {
      var Slide2 = target.splide.Components.Slides.getAt(index);
      return Slide2 ? Slide2.slide.id : "";
    }).join(" ");
    setAttribute(slide, ARIA_LABEL, format(i18n.slideX, (isClone ? slideIndex : index) + 1));
    setAttribute(slide, ARIA_CONTROLS, controls2);
    setAttribute(slide, ROLE, slideFocus ? "button" : "");
    slideFocus && removeAttribute(slide, ARIA_ROLEDESCRIPTION);
  }
  function onMove() {
    if (!destroyed) {
      update();
    }
  }
  function update() {
    if (!destroyed) {
      var curr = Splide2.index;
      updateActivity();
      updateVisibility();
      toggleClass(slide, CLASS_PREV, index === curr - 1);
      toggleClass(slide, CLASS_NEXT, index === curr + 1);
    }
  }
  function updateActivity() {
    var active = isActive();
    if (active !== hasClass(slide, CLASS_ACTIVE)) {
      toggleClass(slide, CLASS_ACTIVE, active);
      setAttribute(slide, ARIA_CURRENT, isNavigation && active || "");
      emit(active ? EVENT_ACTIVE : EVENT_INACTIVE, self2);
    }
  }
  function updateVisibility() {
    var visible = isVisible();
    var hidden = !visible && (!isActive() || isClone);
    if (!Splide2.state.is([MOVING, SCROLLING])) {
      setAttribute(slide, ARIA_HIDDEN, hidden || "");
    }
    setAttribute(queryAll(slide, options.focusableNodes || ""), TAB_INDEX, hidden ? -1 : "");
    if (slideFocus) {
      setAttribute(slide, TAB_INDEX, hidden ? -1 : 0);
    }
    if (visible !== hasClass(slide, CLASS_VISIBLE)) {
      toggleClass(slide, CLASS_VISIBLE, visible);
      emit(visible ? EVENT_VISIBLE : EVENT_HIDDEN, self2);
    }
    if (!visible && document.activeElement === slide) {
      var Slide2 = Components.Slides.getAt(Splide2.index);
      Slide2 && focus(Slide2.slide);
    }
  }
  function style$1(prop, value, useContainer) {
    style(useContainer && container || slide, prop, value);
  }
  function isActive() {
    var curr = Splide2.index;
    return curr === index || options.cloneStatus && curr === slideIndex;
  }
  function isVisible() {
    if (Splide2.is(FADE)) {
      return isActive();
    }
    var trackRect = rect(Components.Elements.track);
    var slideRect = rect(slide);
    var left = resolve("left", true);
    var right = resolve("right", true);
    return floor(trackRect[left]) <= ceil(slideRect[left]) && floor(slideRect[right]) <= ceil(trackRect[right]);
  }
  function isWithin(from, distance) {
    var diff = abs(from - index);
    if (!isClone && (options.rewind || Splide2.is(LOOP))) {
      diff = min(diff, Splide2.length - diff);
    }
    return diff <= distance;
  }
  var self2 = {
    index,
    slideIndex,
    slide,
    container,
    isClone,
    mount,
    destroy,
    update,
    style: style$1,
    isWithin
  };
  return self2;
}
function Slides(Splide2, Components2, options) {
  var _EventInterface2 = EventInterface(Splide2), on2 = _EventInterface2.on, emit = _EventInterface2.emit, bind = _EventInterface2.bind;
  var _Components2$Elements = Components2.Elements, slides = _Components2$Elements.slides, list = _Components2$Elements.list;
  var Slides2 = [];
  function mount() {
    init();
    on2(EVENT_REFRESH, destroy);
    on2(EVENT_REFRESH, init);
  }
  function init() {
    slides.forEach(function(slide, index) {
      register(slide, index, -1);
    });
  }
  function destroy() {
    forEach$12(function(Slide2) {
      Slide2.destroy();
    });
    empty(Slides2);
  }
  function update() {
    forEach$12(function(Slide2) {
      Slide2.update();
    });
  }
  function register(slide, index, slideIndex) {
    var object = Slide$1(Splide2, index, slideIndex, slide);
    object.mount();
    Slides2.push(object);
    Slides2.sort(function(Slide1, Slide2) {
      return Slide1.index - Slide2.index;
    });
  }
  function get(excludeClones) {
    return excludeClones ? filter(function(Slide2) {
      return !Slide2.isClone;
    }) : Slides2;
  }
  function getIn(page) {
    var Controller2 = Components2.Controller;
    var index = Controller2.toIndex(page);
    var max4 = Controller2.hasFocus() ? 1 : options.perPage;
    return filter(function(Slide2) {
      return between(Slide2.index, index, index + max4 - 1);
    });
  }
  function getAt(index) {
    return filter(index)[0];
  }
  function add(items, index) {
    forEach(items, function(slide) {
      if (isString(slide)) {
        slide = parseHtml(slide);
      }
      if (isHTMLElement(slide)) {
        var ref = slides[index];
        ref ? before(slide, ref) : append(list, slide);
        addClass(slide, options.classes.slide);
        observeImages(slide, apply(emit, EVENT_RESIZE));
      }
    });
    emit(EVENT_REFRESH);
  }
  function remove$1(matcher) {
    remove(filter(matcher).map(function(Slide2) {
      return Slide2.slide;
    }));
    emit(EVENT_REFRESH);
  }
  function forEach$12(iteratee, excludeClones) {
    get(excludeClones).forEach(iteratee);
  }
  function filter(matcher) {
    return Slides2.filter(isFunction(matcher) ? matcher : function(Slide2) {
      return isString(matcher) ? matches(Slide2.slide, matcher) : includes(toArray(matcher), Slide2.index);
    });
  }
  function style3(prop, value, useContainer) {
    forEach$12(function(Slide2) {
      Slide2.style(prop, value, useContainer);
    });
  }
  function observeImages(elm, callback) {
    var images = queryAll(elm, "img");
    var length = images.length;
    if (length) {
      images.forEach(function(img) {
        bind(img, "load error", function() {
          if (!--length) {
            callback();
          }
        });
      });
    } else {
      callback();
    }
  }
  function getLength(excludeClones) {
    return excludeClones ? slides.length : Slides2.length;
  }
  function isEnough() {
    return Slides2.length > options.perPage;
  }
  return {
    mount,
    destroy,
    update,
    register,
    get,
    getIn,
    getAt,
    add,
    remove: remove$1,
    forEach: forEach$12,
    filter,
    style: style3,
    getLength,
    isEnough
  };
}
function Layout(Splide2, Components2, options) {
  var _EventInterface3 = EventInterface(Splide2), on2 = _EventInterface3.on, bind = _EventInterface3.bind, emit = _EventInterface3.emit;
  var Slides2 = Components2.Slides;
  var resolve = Components2.Direction.resolve;
  var _Components2$Elements2 = Components2.Elements, root = _Components2$Elements2.root, track = _Components2$Elements2.track, list = _Components2$Elements2.list;
  var getAt = Slides2.getAt, styleSlides = Slides2.style;
  var vertical;
  var rootRect;
  var overflow;
  function mount() {
    init();
    bind(window, "resize load", Throttle(apply(emit, EVENT_RESIZE)));
    on2([EVENT_UPDATED, EVENT_REFRESH], init);
    on2(EVENT_RESIZE, resize);
  }
  function init() {
    vertical = options.direction === TTB;
    style(root, "maxWidth", unit(options.width));
    style(track, resolve("paddingLeft"), cssPadding(false));
    style(track, resolve("paddingRight"), cssPadding(true));
    resize(true);
  }
  function resize(force) {
    var newRect = rect(root);
    if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
      style(track, "height", cssTrackHeight());
      styleSlides(resolve("marginRight"), unit(options.gap));
      styleSlides("width", cssSlideWidth());
      styleSlides("height", cssSlideHeight(), true);
      rootRect = newRect;
      emit(EVENT_RESIZED);
      if (overflow !== (overflow = isOverflow())) {
        toggleClass(root, CLASS_OVERFLOW, overflow);
        emit(EVENT_OVERFLOW, overflow);
      }
    }
  }
  function cssPadding(right) {
    var padding = options.padding;
    var prop = resolve(right ? "right" : "left");
    return padding && unit(padding[prop] || (isObject(padding) ? 0 : padding)) || "0px";
  }
  function cssTrackHeight() {
    var height = "";
    if (vertical) {
      height = cssHeight();
      assert(height, "height or heightRatio is missing.");
      height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
    }
    return height;
  }
  function cssHeight() {
    return unit(options.height || rect(list).width * options.heightRatio);
  }
  function cssSlideWidth() {
    return options.autoWidth ? null : unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
  }
  function cssSlideHeight() {
    return unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
  }
  function cssSlideSize() {
    var gap = unit(options.gap);
    return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
  }
  function listSize() {
    return rect(list)[resolve("width")];
  }
  function slideSize(index, withoutGap) {
    var Slide2 = getAt(index || 0);
    return Slide2 ? rect(Slide2.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
  }
  function totalSize(index, withoutGap) {
    var Slide2 = getAt(index);
    if (Slide2) {
      var right = rect(Slide2.slide)[resolve("right")];
      var left = rect(list)[resolve("left")];
      return abs(right - left) + (withoutGap ? 0 : getGap());
    }
    return 0;
  }
  function sliderSize(withoutGap) {
    return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
  }
  function getGap() {
    var Slide2 = getAt(0);
    return Slide2 && parseFloat(style(Slide2.slide, resolve("marginRight"))) || 0;
  }
  function getPadding(right) {
    return parseFloat(style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
  }
  function isOverflow() {
    return Splide2.is(FADE) || sliderSize(true) > listSize();
  }
  return {
    mount,
    resize,
    listSize,
    slideSize,
    sliderSize,
    totalSize,
    getPadding,
    isOverflow
  };
}
var MULTIPLIER = 2;
function Clones(Splide2, Components2, options) {
  var event = EventInterface(Splide2);
  var on2 = event.on;
  var Elements2 = Components2.Elements, Slides2 = Components2.Slides;
  var resolve = Components2.Direction.resolve;
  var clones = [];
  var cloneCount;
  function mount() {
    on2(EVENT_REFRESH, remount);
    on2([EVENT_UPDATED, EVENT_RESIZE], observe);
    if (cloneCount = computeCloneCount()) {
      generate(cloneCount);
      Components2.Layout.resize(true);
    }
  }
  function remount() {
    destroy();
    mount();
  }
  function destroy() {
    remove(clones);
    empty(clones);
    event.destroy();
  }
  function observe() {
    var count = computeCloneCount();
    if (cloneCount !== count) {
      if (cloneCount < count || !count) {
        event.emit(EVENT_REFRESH);
      }
    }
  }
  function generate(count) {
    var slides = Slides2.get().slice();
    var length = slides.length;
    if (length) {
      while (slides.length < count) {
        push(slides, slides);
      }
      push(slides.slice(-count), slides.slice(0, count)).forEach(function(Slide2, index) {
        var isHead = index < count;
        var clone = cloneDeep(Slide2.slide, index);
        isHead ? before(clone, slides[0].slide) : append(Elements2.list, clone);
        push(clones, clone);
        Slides2.register(clone, index - count + (isHead ? 0 : length), Slide2.index);
      });
    }
  }
  function cloneDeep(elm, index) {
    var clone = elm.cloneNode(true);
    addClass(clone, options.classes.clone);
    clone.id = Splide2.root.id + "-clone" + pad(index + 1);
    return clone;
  }
  function computeCloneCount() {
    var clones2 = options.clones;
    if (!Splide2.is(LOOP)) {
      clones2 = 0;
    } else if (isUndefined(clones2)) {
      var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
      var fixedCount = fixedSize && ceil(rect(Elements2.track)[resolve("width")] / fixedSize);
      clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * MULTIPLIER;
    }
    return clones2;
  }
  return {
    mount,
    destroy
  };
}
function Move(Splide2, Components2, options) {
  var _EventInterface4 = EventInterface(Splide2), on2 = _EventInterface4.on, emit = _EventInterface4.emit;
  var set = Splide2.state.set;
  var _Components2$Layout = Components2.Layout, slideSize = _Components2$Layout.slideSize, getPadding = _Components2$Layout.getPadding, totalSize = _Components2$Layout.totalSize, listSize = _Components2$Layout.listSize, sliderSize = _Components2$Layout.sliderSize;
  var _Components2$Directio = Components2.Direction, resolve = _Components2$Directio.resolve, orient = _Components2$Directio.orient;
  var _Components2$Elements3 = Components2.Elements, list = _Components2$Elements3.list, track = _Components2$Elements3.track;
  var Transition;
  function mount() {
    Transition = Components2.Transition;
    on2([EVENT_MOUNTED, EVENT_RESIZED, EVENT_UPDATED, EVENT_REFRESH], reposition);
  }
  function reposition() {
    if (!Components2.Controller.isBusy()) {
      Components2.Scroll.cancel();
      jump(Splide2.index);
      Components2.Slides.update();
    }
  }
  function move(dest, index, prev, callback) {
    if (dest !== index && canShift(dest > prev)) {
      cancel();
      translate(shift(getPosition(), dest > prev), true);
    }
    set(MOVING);
    emit(EVENT_MOVE, index, prev, dest);
    Transition.start(index, function() {
      set(IDLE);
      emit(EVENT_MOVED, index, prev, dest);
      callback && callback();
    });
  }
  function jump(index) {
    translate(toPosition(index, true));
  }
  function translate(position, preventLoop) {
    if (!Splide2.is(FADE)) {
      var destination = preventLoop ? position : loop(position);
      style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
      position !== destination && emit(EVENT_SHIFTED);
    }
  }
  function loop(position) {
    if (Splide2.is(LOOP)) {
      var index = toIndex(position);
      var exceededMax = index > Components2.Controller.getEnd();
      var exceededMin = index < 0;
      if (exceededMin || exceededMax) {
        position = shift(position, exceededMax);
      }
    }
    return position;
  }
  function shift(position, backwards) {
    var excess = position - getLimit(backwards);
    var size = sliderSize();
    position -= orient(size * (ceil(abs(excess) / size) || 1)) * (backwards ? 1 : -1);
    return position;
  }
  function cancel() {
    translate(getPosition(), true);
    Transition.cancel();
  }
  function toIndex(position) {
    var Slides2 = Components2.Slides.get();
    var index = 0;
    var minDistance = Infinity;
    for (var i = 0; i < Slides2.length; i++) {
      var slideIndex = Slides2[i].index;
      var distance = abs(toPosition(slideIndex, true) - position);
      if (distance <= minDistance) {
        minDistance = distance;
        index = slideIndex;
      } else {
        break;
      }
    }
    return index;
  }
  function toPosition(index, trimming) {
    var position = orient(totalSize(index - 1) - offset(index));
    return trimming ? trim(position) : position;
  }
  function getPosition() {
    var left = resolve("left");
    return rect(list)[left] - rect(track)[left] + orient(getPadding(false));
  }
  function trim(position) {
    if (options.trimSpace && Splide2.is(SLIDE)) {
      position = clamp(position, 0, orient(sliderSize(true) - listSize()));
    }
    return position;
  }
  function offset(index) {
    var focus2 = options.focus;
    return focus2 === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus2 * slideSize(index) || 0;
  }
  function getLimit(max4) {
    return toPosition(max4 ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
  }
  function canShift(backwards) {
    var shifted = orient(shift(getPosition(), backwards));
    return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - rect(track)[resolve("width")];
  }
  function exceededLimit(max4, position) {
    position = isUndefined(position) ? getPosition() : position;
    var exceededMin = max4 !== true && orient(position) < orient(getLimit(false));
    var exceededMax = max4 !== false && orient(position) > orient(getLimit(true));
    return exceededMin || exceededMax;
  }
  return {
    mount,
    move,
    jump,
    translate,
    shift,
    cancel,
    toIndex,
    toPosition,
    getPosition,
    getLimit,
    exceededLimit,
    reposition
  };
}
function Controller(Splide2, Components2, options) {
  var _EventInterface5 = EventInterface(Splide2), on2 = _EventInterface5.on, emit = _EventInterface5.emit;
  var Move2 = Components2.Move;
  var getPosition = Move2.getPosition, getLimit = Move2.getLimit, toPosition = Move2.toPosition;
  var _Components2$Slides = Components2.Slides, isEnough = _Components2$Slides.isEnough, getLength = _Components2$Slides.getLength;
  var omitEnd = options.omitEnd;
  var isLoop = Splide2.is(LOOP);
  var isSlide = Splide2.is(SLIDE);
  var getNext = apply(getAdjacent, false);
  var getPrev = apply(getAdjacent, true);
  var currIndex = options.start || 0;
  var endIndex;
  var prevIndex = currIndex;
  var slideCount;
  var perMove;
  var perPage;
  function mount() {
    init();
    on2([EVENT_UPDATED, EVENT_REFRESH, EVENT_END_INDEX_CHANGED], init);
    on2(EVENT_RESIZED, onResized);
  }
  function init() {
    slideCount = getLength(true);
    perMove = options.perMove;
    perPage = options.perPage;
    endIndex = getEnd();
    var index = clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
    if (index !== currIndex) {
      currIndex = index;
      Move2.reposition();
    }
  }
  function onResized() {
    if (endIndex !== getEnd()) {
      emit(EVENT_END_INDEX_CHANGED);
    }
  }
  function go(control, allowSameIndex, callback) {
    if (!isBusy()) {
      var dest = parse(control);
      var index = loop(dest);
      if (index > -1 && (allowSameIndex || index !== currIndex)) {
        setIndex(index);
        Move2.move(dest, index, prevIndex, callback);
      }
    }
  }
  function scroll4(destination, duration, snap, callback) {
    Components2.Scroll.scroll(destination, duration, snap, function() {
      var index = loop(Move2.toIndex(getPosition()));
      setIndex(omitEnd ? min(index, endIndex) : index);
      callback && callback();
    });
  }
  function parse(control) {
    var index = currIndex;
    if (isString(control)) {
      var _ref = control.match(/([+\-<>])(\d+)?/) || [], indicator = _ref[1], number = _ref[2];
      if (indicator === "+" || indicator === "-") {
        index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
      } else if (indicator === ">") {
        index = number ? toIndex(+number) : getNext(true);
      } else if (indicator === "<") {
        index = getPrev(true);
      }
    } else {
      index = isLoop ? control : clamp(control, 0, endIndex);
    }
    return index;
  }
  function getAdjacent(prev, destination) {
    var number = perMove || (hasFocus() ? 1 : perPage);
    var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
    if (dest === -1 && isSlide) {
      if (!approximatelyEqual(getPosition(), getLimit(!prev), 1)) {
        return prev ? 0 : endIndex;
      }
    }
    return destination ? dest : loop(dest);
  }
  function computeDestIndex(dest, from, snapPage) {
    if (isEnough() || hasFocus()) {
      var index = computeMovableDestIndex(dest);
      if (index !== dest) {
        from = dest;
        dest = index;
        snapPage = false;
      }
      if (dest < 0 || dest > endIndex) {
        if (!perMove && (between(0, dest, from, true) || between(endIndex, from, dest, true))) {
          dest = toIndex(toPage(dest));
        } else {
          if (isLoop) {
            dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
          } else if (options.rewind) {
            dest = dest < 0 ? endIndex : 0;
          } else {
            dest = -1;
          }
        }
      } else {
        if (snapPage && dest !== from) {
          dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
        }
      }
    } else {
      dest = -1;
    }
    return dest;
  }
  function computeMovableDestIndex(dest) {
    if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
      var position = getPosition();
      while (position === toPosition(dest, true) && between(dest, 0, Splide2.length - 1, !options.rewind)) {
        dest < currIndex ? --dest : ++dest;
      }
    }
    return dest;
  }
  function loop(index) {
    return isLoop ? (index + slideCount) % slideCount || 0 : index;
  }
  function getEnd() {
    var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
    while (omitEnd && end-- > 0) {
      if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
        end++;
        break;
      }
    }
    return clamp(end, 0, slideCount - 1);
  }
  function toIndex(page) {
    return clamp(hasFocus() ? page : perPage * page, 0, endIndex);
  }
  function toPage(index) {
    return hasFocus() ? min(index, endIndex) : floor((index >= endIndex ? slideCount - 1 : index) / perPage);
  }
  function toDest(destination) {
    var closest2 = Move2.toIndex(destination);
    return isSlide ? clamp(closest2, 0, endIndex) : closest2;
  }
  function setIndex(index) {
    if (index !== currIndex) {
      prevIndex = currIndex;
      currIndex = index;
    }
  }
  function getIndex(prev) {
    return prev ? prevIndex : currIndex;
  }
  function hasFocus() {
    return !isUndefined(options.focus) || options.isNavigation;
  }
  function isBusy() {
    return Splide2.state.is([MOVING, SCROLLING]) && !!options.waitForTransition;
  }
  return {
    mount,
    go,
    scroll: scroll4,
    getNext,
    getPrev,
    getAdjacent,
    getEnd,
    setIndex,
    getIndex,
    toIndex,
    toPage,
    toDest,
    hasFocus,
    isBusy
  };
}
var XML_NAME_SPACE = "http://www.w3.org/2000/svg";
var PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
var SIZE = 40;
function Arrows(Splide2, Components2, options) {
  var event = EventInterface(Splide2);
  var on2 = event.on, bind = event.bind, emit = event.emit;
  var classes = options.classes, i18n = options.i18n;
  var Elements2 = Components2.Elements, Controller2 = Components2.Controller;
  var placeholder = Elements2.arrows, track = Elements2.track;
  var wrapper = placeholder;
  var prev = Elements2.prev;
  var next = Elements2.next;
  var created;
  var wrapperClasses;
  var arrows = {};
  function mount() {
    init();
    on2(EVENT_UPDATED, remount);
  }
  function remount() {
    destroy();
    mount();
  }
  function init() {
    var enabled = options.arrows;
    if (enabled && !(prev && next)) {
      createArrows();
    }
    if (prev && next) {
      assign(arrows, {
        prev,
        next
      });
      display(wrapper, enabled ? "" : "none");
      addClass(wrapper, wrapperClasses = CLASS_ARROWS + "--" + options.direction);
      if (enabled) {
        listen();
        update();
        setAttribute([prev, next], ARIA_CONTROLS, track.id);
        emit(EVENT_ARROWS_MOUNTED, prev, next);
      }
    }
  }
  function destroy() {
    event.destroy();
    removeClass(wrapper, wrapperClasses);
    if (created) {
      remove(placeholder ? [prev, next] : wrapper);
      prev = next = null;
    } else {
      removeAttribute([prev, next], ALL_ATTRIBUTES);
    }
  }
  function listen() {
    on2([EVENT_MOUNTED, EVENT_MOVED, EVENT_REFRESH, EVENT_SCROLLED, EVENT_END_INDEX_CHANGED], update);
    bind(next, "click", apply(go, ">"));
    bind(prev, "click", apply(go, "<"));
  }
  function go(control) {
    Controller2.go(control, true);
  }
  function createArrows() {
    wrapper = placeholder || create("div", classes.arrows);
    prev = createArrow(true);
    next = createArrow(false);
    created = true;
    append(wrapper, [prev, next]);
    !placeholder && before(wrapper, track);
  }
  function createArrow(prev2) {
    var arrow = '<button class="' + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + '" type="button"><svg xmlns="' + XML_NAME_SPACE + '" viewBox="0 0 ' + SIZE + " " + SIZE + '" width="' + SIZE + '" height="' + SIZE + '" focusable="false"><path d="' + (options.arrowPath || PATH) + '" />';
    return parseHtml(arrow);
  }
  function update() {
    if (prev && next) {
      var index = Splide2.index;
      var prevIndex = Controller2.getPrev();
      var nextIndex = Controller2.getNext();
      var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
      var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
      prev.disabled = prevIndex < 0;
      next.disabled = nextIndex < 0;
      setAttribute(prev, ARIA_LABEL, prevLabel);
      setAttribute(next, ARIA_LABEL, nextLabel);
      emit(EVENT_ARROWS_UPDATED, prev, next, prevIndex, nextIndex);
    }
  }
  return {
    arrows,
    mount,
    destroy,
    update
  };
}
var INTERVAL_DATA_ATTRIBUTE = DATA_ATTRIBUTE + "-interval";
function Autoplay(Splide2, Components2, options) {
  var _EventInterface6 = EventInterface(Splide2), on2 = _EventInterface6.on, bind = _EventInterface6.bind, emit = _EventInterface6.emit;
  var interval = RequestInterval(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
  var isPaused = interval.isPaused;
  var Elements2 = Components2.Elements, _Components2$Elements4 = Components2.Elements, root = _Components2$Elements4.root, toggle = _Components2$Elements4.toggle;
  var autoplay = options.autoplay;
  var hovered;
  var focused;
  var stopped = autoplay === "pause";
  function mount() {
    if (autoplay) {
      listen();
      toggle && setAttribute(toggle, ARIA_CONTROLS, Elements2.track.id);
      stopped || play();
      update();
    }
  }
  function listen() {
    if (options.pauseOnHover) {
      bind(root, "mouseenter mouseleave", function(e) {
        hovered = e.type === "mouseenter";
        autoToggle();
      });
    }
    if (options.pauseOnFocus) {
      bind(root, "focusin focusout", function(e) {
        focused = e.type === "focusin";
        autoToggle();
      });
    }
    if (toggle) {
      bind(toggle, "click", function() {
        stopped ? play() : pause(true);
      });
    }
    on2([EVENT_MOVE, EVENT_SCROLL, EVENT_REFRESH], interval.rewind);
    on2(EVENT_MOVE, onMove);
  }
  function play() {
    if (isPaused() && Components2.Slides.isEnough()) {
      interval.start(!options.resetProgress);
      focused = hovered = stopped = false;
      update();
      emit(EVENT_AUTOPLAY_PLAY);
    }
  }
  function pause(stop) {
    if (stop === void 0) {
      stop = true;
    }
    stopped = !!stop;
    update();
    if (!isPaused()) {
      interval.pause();
      emit(EVENT_AUTOPLAY_PAUSE);
    }
  }
  function autoToggle() {
    if (!stopped) {
      hovered || focused ? pause(false) : play();
    }
  }
  function update() {
    if (toggle) {
      toggleClass(toggle, CLASS_ACTIVE, !stopped);
      setAttribute(toggle, ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
    }
  }
  function onAnimationFrame(rate) {
    var bar = Elements2.bar;
    bar && style(bar, "width", rate * 100 + "%");
    emit(EVENT_AUTOPLAY_PLAYING, rate);
  }
  function onMove(index) {
    var Slide2 = Components2.Slides.getAt(index);
    interval.set(Slide2 && +getAttribute(Slide2.slide, INTERVAL_DATA_ATTRIBUTE) || options.interval);
  }
  return {
    mount,
    destroy: interval.cancel,
    play,
    pause,
    isPaused
  };
}
function Cover(Splide2, Components2, options) {
  var _EventInterface7 = EventInterface(Splide2), on2 = _EventInterface7.on;
  function mount() {
    if (options.cover) {
      on2(EVENT_LAZYLOAD_LOADED, apply(toggle, true));
      on2([EVENT_MOUNTED, EVENT_UPDATED, EVENT_REFRESH], apply(cover, true));
    }
  }
  function cover(cover2) {
    Components2.Slides.forEach(function(Slide2) {
      var img = child(Slide2.container || Slide2.slide, "img");
      if (img && img.src) {
        toggle(cover2, img, Slide2);
      }
    });
  }
  function toggle(cover2, img, Slide2) {
    Slide2.style("background", cover2 ? 'center/cover no-repeat url("' + img.src + '")' : "", true);
    display(img, cover2 ? "none" : "");
  }
  return {
    mount,
    destroy: apply(cover, false)
  };
}
var BOUNCE_DIFF_THRESHOLD = 10;
var BOUNCE_DURATION = 600;
var FRICTION_FACTOR = 0.6;
var BASE_VELOCITY = 1.5;
var MIN_DURATION = 800;
function Scroll(Splide2, Components2, options) {
  var _EventInterface8 = EventInterface(Splide2), on2 = _EventInterface8.on, emit = _EventInterface8.emit;
  var set = Splide2.state.set;
  var Move2 = Components2.Move;
  var getPosition = Move2.getPosition, getLimit = Move2.getLimit, exceededLimit = Move2.exceededLimit, translate = Move2.translate;
  var isSlide = Splide2.is(SLIDE);
  var interval;
  var callback;
  var friction = 1;
  function mount() {
    on2(EVENT_MOVE, clear);
    on2([EVENT_UPDATED, EVENT_REFRESH], cancel);
  }
  function scroll4(destination, duration, snap, onScrolled, noConstrain) {
    var from = getPosition();
    clear();
    if (snap && (!isSlide || !exceededLimit())) {
      var size = Components2.Layout.sliderSize();
      var offset = sign(destination) * size * floor(abs(destination) / size) || 0;
      destination = Move2.toPosition(Components2.Controller.toDest(destination % size)) + offset;
    }
    var noDistance = approximatelyEqual(from, destination, 1);
    friction = 1;
    duration = noDistance ? 0 : duration || max(abs(destination - from) / BASE_VELOCITY, MIN_DURATION);
    callback = onScrolled;
    interval = RequestInterval(duration, onEnd, apply(update, from, destination, noConstrain), 1);
    set(SCROLLING);
    emit(EVENT_SCROLL);
    interval.start();
  }
  function onEnd() {
    set(IDLE);
    callback && callback();
    emit(EVENT_SCROLLED);
  }
  function update(from, to, noConstrain, rate) {
    var position = getPosition();
    var target = from + (to - from) * easing(rate);
    var diff = (target - position) * friction;
    translate(position + diff);
    if (isSlide && !noConstrain && exceededLimit()) {
      friction *= FRICTION_FACTOR;
      if (abs(diff) < BOUNCE_DIFF_THRESHOLD) {
        scroll4(getLimit(exceededLimit(true)), BOUNCE_DURATION, false, callback, true);
      }
    }
  }
  function clear() {
    if (interval) {
      interval.cancel();
    }
  }
  function cancel() {
    if (interval && !interval.isPaused()) {
      clear();
      onEnd();
    }
  }
  function easing(t) {
    var easingFunc = options.easingFunc;
    return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
  }
  return {
    mount,
    destroy: clear,
    scroll: scroll4,
    cancel
  };
}
var SCROLL_LISTENER_OPTIONS = {
  passive: false,
  capture: true
};
function Drag(Splide2, Components2, options) {
  var _EventInterface9 = EventInterface(Splide2), on2 = _EventInterface9.on, emit = _EventInterface9.emit, bind = _EventInterface9.bind, unbind = _EventInterface9.unbind;
  var state = Splide2.state;
  var Move2 = Components2.Move, Scroll2 = Components2.Scroll, Controller2 = Components2.Controller, track = Components2.Elements.track, reduce = Components2.Media.reduce;
  var _Components2$Directio2 = Components2.Direction, resolve = _Components2$Directio2.resolve, orient = _Components2$Directio2.orient;
  var getPosition = Move2.getPosition, exceededLimit = Move2.exceededLimit;
  var basePosition;
  var baseEvent;
  var prevBaseEvent;
  var isFree;
  var dragging;
  var exceeded = false;
  var clickPrevented;
  var disabled;
  var target;
  function mount() {
    bind(track, POINTER_MOVE_EVENTS, noop, SCROLL_LISTENER_OPTIONS);
    bind(track, POINTER_UP_EVENTS, noop, SCROLL_LISTENER_OPTIONS);
    bind(track, POINTER_DOWN_EVENTS, onPointerDown, SCROLL_LISTENER_OPTIONS);
    bind(track, "click", onClick, {
      capture: true
    });
    bind(track, "dragstart", prevent);
    on2([EVENT_MOUNTED, EVENT_UPDATED], init);
  }
  function init() {
    var drag = options.drag;
    disable(!drag);
    isFree = drag === "free";
  }
  function onPointerDown(e) {
    clickPrevented = false;
    if (!disabled) {
      var isTouch = isTouchEvent(e);
      if (isDraggable(e.target) && (isTouch || !e.button)) {
        if (!Controller2.isBusy()) {
          target = isTouch ? track : window;
          dragging = state.is([MOVING, SCROLLING]);
          prevBaseEvent = null;
          bind(target, POINTER_MOVE_EVENTS, onPointerMove, SCROLL_LISTENER_OPTIONS);
          bind(target, POINTER_UP_EVENTS, onPointerUp, SCROLL_LISTENER_OPTIONS);
          Move2.cancel();
          Scroll2.cancel();
          save(e);
        } else {
          prevent(e, true);
        }
      }
    }
  }
  function onPointerMove(e) {
    if (!state.is(DRAGGING)) {
      state.set(DRAGGING);
      emit(EVENT_DRAG);
    }
    if (e.cancelable) {
      if (dragging) {
        Move2.translate(basePosition + constrain(diffCoord(e)));
        var expired = diffTime(e) > LOG_INTERVAL;
        var hasExceeded = exceeded !== (exceeded = exceededLimit());
        if (expired || hasExceeded) {
          save(e);
        }
        clickPrevented = true;
        emit(EVENT_DRAGGING);
        prevent(e);
      } else if (isSliderDirection(e)) {
        dragging = shouldStart(e);
        prevent(e);
      }
    }
  }
  function onPointerUp(e) {
    if (state.is(DRAGGING)) {
      state.set(IDLE);
      emit(EVENT_DRAGGED);
    }
    if (dragging) {
      move(e);
      prevent(e);
    }
    unbind(target, POINTER_MOVE_EVENTS, onPointerMove);
    unbind(target, POINTER_UP_EVENTS, onPointerUp);
    dragging = false;
  }
  function onClick(e) {
    if (!disabled && clickPrevented) {
      prevent(e, true);
    }
  }
  function save(e) {
    prevBaseEvent = baseEvent;
    baseEvent = e;
    basePosition = getPosition();
  }
  function move(e) {
    var velocity = computeVelocity(e);
    var destination = computeDestination(velocity);
    var rewind = options.rewind && options.rewindByDrag;
    reduce(false);
    if (isFree) {
      Controller2.scroll(destination, 0, options.snap);
    } else if (Splide2.is(FADE)) {
      Controller2.go(orient(sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
    } else if (Splide2.is(SLIDE) && exceeded && rewind) {
      Controller2.go(exceededLimit(true) ? ">" : "<");
    } else {
      Controller2.go(Controller2.toDest(destination), true);
    }
    reduce(true);
  }
  function shouldStart(e) {
    var thresholds2 = options.dragMinThreshold;
    var isObj = isObject(thresholds2);
    var mouse = isObj && thresholds2.mouse || 0;
    var touch = (isObj ? thresholds2.touch : +thresholds2) || 10;
    return abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
  }
  function isSliderDirection(e) {
    return abs(diffCoord(e)) > abs(diffCoord(e, true));
  }
  function computeVelocity(e) {
    if (Splide2.is(LOOP) || !exceeded) {
      var time2 = diffTime(e);
      if (time2 && time2 < LOG_INTERVAL) {
        return diffCoord(e) / time2;
      }
    }
    return 0;
  }
  function computeDestination(velocity) {
    return getPosition() + sign(velocity) * min(abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
  }
  function diffCoord(e, orthogonal) {
    return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
  }
  function diffTime(e) {
    return timeOf(e) - timeOf(getBaseEvent(e));
  }
  function getBaseEvent(e) {
    return baseEvent === e && prevBaseEvent || baseEvent;
  }
  function coordOf(e, orthogonal) {
    return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
  }
  function constrain(diff) {
    return diff / (exceeded && Splide2.is(SLIDE) ? FRICTION : 1);
  }
  function isDraggable(target2) {
    var noDrag = options.noDrag;
    return !matches(target2, "." + CLASS_PAGINATION_PAGE + ", ." + CLASS_ARROW) && (!noDrag || !matches(target2, noDrag));
  }
  function isTouchEvent(e) {
    return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
  }
  function isDragging() {
    return dragging;
  }
  function disable(value) {
    disabled = value;
  }
  return {
    mount,
    disable,
    isDragging
  };
}
var NORMALIZATION_MAP = {
  Spacebar: " ",
  Right: ARROW_RIGHT,
  Left: ARROW_LEFT,
  Up: ARROW_UP,
  Down: ARROW_DOWN
};
function normalizeKey(key) {
  key = isString(key) ? key : key.key;
  return NORMALIZATION_MAP[key] || key;
}
var KEYBOARD_EVENT = "keydown";
function Keyboard(Splide2, Components2, options) {
  var _EventInterface10 = EventInterface(Splide2), on2 = _EventInterface10.on, bind = _EventInterface10.bind, unbind = _EventInterface10.unbind;
  var root = Splide2.root;
  var resolve = Components2.Direction.resolve;
  var target;
  var disabled;
  function mount() {
    init();
    on2(EVENT_UPDATED, destroy);
    on2(EVENT_UPDATED, init);
    on2(EVENT_MOVE, onMove);
  }
  function init() {
    var keyboard = options.keyboard;
    if (keyboard) {
      target = keyboard === "global" ? window : root;
      bind(target, KEYBOARD_EVENT, onKeydown);
    }
  }
  function destroy() {
    unbind(target, KEYBOARD_EVENT);
  }
  function disable(value) {
    disabled = value;
  }
  function onMove() {
    var _disabled = disabled;
    disabled = true;
    nextTick(function() {
      disabled = _disabled;
    });
  }
  function onKeydown(e) {
    if (!disabled) {
      var key = normalizeKey(e);
      if (key === resolve(ARROW_LEFT)) {
        Splide2.go("<");
      } else if (key === resolve(ARROW_RIGHT)) {
        Splide2.go(">");
      }
    }
  }
  return {
    mount,
    destroy,
    disable
  };
}
var SRC_DATA_ATTRIBUTE = DATA_ATTRIBUTE + "-lazy";
var SRCSET_DATA_ATTRIBUTE = SRC_DATA_ATTRIBUTE + "-srcset";
var IMAGE_SELECTOR = "[" + SRC_DATA_ATTRIBUTE + "], [" + SRCSET_DATA_ATTRIBUTE + "]";
function LazyLoad(Splide2, Components2, options) {
  var _EventInterface11 = EventInterface(Splide2), on2 = _EventInterface11.on, off = _EventInterface11.off, bind = _EventInterface11.bind, emit = _EventInterface11.emit;
  var isSequential = options.lazyLoad === "sequential";
  var events = [EVENT_MOVED, EVENT_SCROLLED];
  var entries = [];
  function mount() {
    if (options.lazyLoad) {
      init();
      on2(EVENT_REFRESH, init);
    }
  }
  function init() {
    empty(entries);
    register();
    if (isSequential) {
      loadNext();
    } else {
      off(events);
      on2(events, check);
      check();
    }
  }
  function register() {
    Components2.Slides.forEach(function(Slide2) {
      queryAll(Slide2.slide, IMAGE_SELECTOR).forEach(function(img) {
        var src = getAttribute(img, SRC_DATA_ATTRIBUTE);
        var srcset = getAttribute(img, SRCSET_DATA_ATTRIBUTE);
        if (src !== img.src || srcset !== img.srcset) {
          var className = options.classes.spinner;
          var parent = img.parentElement;
          var spinner = child(parent, "." + className) || create("span", className, parent);
          entries.push([img, Slide2, spinner]);
          img.src || display(img, "none");
        }
      });
    });
  }
  function check() {
    entries = entries.filter(function(data2) {
      var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
      return data2[1].isWithin(Splide2.index, distance) ? load(data2) : true;
    });
    entries.length || off(events);
  }
  function load(data2) {
    var img = data2[0];
    addClass(data2[1].slide, CLASS_LOADING);
    bind(img, "load error", apply(onLoad, data2));
    setAttribute(img, "src", getAttribute(img, SRC_DATA_ATTRIBUTE));
    setAttribute(img, "srcset", getAttribute(img, SRCSET_DATA_ATTRIBUTE));
    removeAttribute(img, SRC_DATA_ATTRIBUTE);
    removeAttribute(img, SRCSET_DATA_ATTRIBUTE);
  }
  function onLoad(data2, e) {
    var img = data2[0], Slide2 = data2[1];
    removeClass(Slide2.slide, CLASS_LOADING);
    if (e.type !== "error") {
      remove(data2[2]);
      display(img, "");
      emit(EVENT_LAZYLOAD_LOADED, img, Slide2);
      emit(EVENT_RESIZE);
    }
    isSequential && loadNext();
  }
  function loadNext() {
    entries.length && load(entries.shift());
  }
  return {
    mount,
    destroy: apply(empty, entries),
    check
  };
}
function Pagination(Splide2, Components2, options) {
  var event = EventInterface(Splide2);
  var on2 = event.on, emit = event.emit, bind = event.bind;
  var Slides2 = Components2.Slides, Elements2 = Components2.Elements, Controller2 = Components2.Controller;
  var hasFocus = Controller2.hasFocus, getIndex = Controller2.getIndex, go = Controller2.go;
  var resolve = Components2.Direction.resolve;
  var placeholder = Elements2.pagination;
  var items = [];
  var list;
  var paginationClasses;
  function mount() {
    destroy();
    on2([EVENT_UPDATED, EVENT_REFRESH, EVENT_END_INDEX_CHANGED], mount);
    var enabled = options.pagination;
    placeholder && display(placeholder, enabled ? "" : "none");
    if (enabled) {
      on2([EVENT_MOVE, EVENT_SCROLL, EVENT_SCROLLED], update);
      createPagination();
      update();
      emit(EVENT_PAGINATION_MOUNTED, {
        list,
        items
      }, getAt(Splide2.index));
    }
  }
  function destroy() {
    if (list) {
      remove(placeholder ? slice(list.children) : list);
      removeClass(list, paginationClasses);
      empty(items);
      list = null;
    }
    event.destroy();
  }
  function createPagination() {
    var length = Splide2.length;
    var classes = options.classes, i18n = options.i18n, perPage = options.perPage;
    var max4 = hasFocus() ? Controller2.getEnd() + 1 : ceil(length / perPage);
    list = placeholder || create("ul", classes.pagination, Elements2.track.parentElement);
    addClass(list, paginationClasses = CLASS_PAGINATION + "--" + getDirection());
    setAttribute(list, ROLE, "tablist");
    setAttribute(list, ARIA_LABEL, i18n.select);
    setAttribute(list, ARIA_ORIENTATION, getDirection() === TTB ? "vertical" : "");
    for (var i = 0; i < max4; i++) {
      var li = create("li", null, list);
      var button = create("button", {
        class: classes.page,
        type: "button"
      }, li);
      var controls2 = Slides2.getIn(i).map(function(Slide2) {
        return Slide2.slide.id;
      });
      var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
      bind(button, "click", apply(onClick, i));
      if (options.paginationKeyboard) {
        bind(button, "keydown", apply(onKeydown, i));
      }
      setAttribute(li, ROLE, "presentation");
      setAttribute(button, ROLE, "tab");
      setAttribute(button, ARIA_CONTROLS, controls2.join(" "));
      setAttribute(button, ARIA_LABEL, format(text, i + 1));
      setAttribute(button, TAB_INDEX, -1);
      items.push({
        li,
        button,
        page: i
      });
    }
  }
  function onClick(page) {
    go(">" + page, true);
  }
  function onKeydown(page, e) {
    var length = items.length;
    var key = normalizeKey(e);
    var dir = getDirection();
    var nextPage = -1;
    if (key === resolve(ARROW_RIGHT, false, dir)) {
      nextPage = ++page % length;
    } else if (key === resolve(ARROW_LEFT, false, dir)) {
      nextPage = (--page + length) % length;
    } else if (key === "Home") {
      nextPage = 0;
    } else if (key === "End") {
      nextPage = length - 1;
    }
    var item = items[nextPage];
    if (item) {
      focus(item.button);
      go(">" + nextPage);
      prevent(e, true);
    }
  }
  function getDirection() {
    return options.paginationDirection || options.direction;
  }
  function getAt(index) {
    return items[Controller2.toPage(index)];
  }
  function update() {
    var prev = getAt(getIndex(true));
    var curr = getAt(getIndex());
    if (prev) {
      var button = prev.button;
      removeClass(button, CLASS_ACTIVE);
      removeAttribute(button, ARIA_SELECTED);
      setAttribute(button, TAB_INDEX, -1);
    }
    if (curr) {
      var _button = curr.button;
      addClass(_button, CLASS_ACTIVE);
      setAttribute(_button, ARIA_SELECTED, true);
      setAttribute(_button, TAB_INDEX, "");
    }
    emit(EVENT_PAGINATION_UPDATED, {
      list,
      items
    }, prev, curr);
  }
  return {
    items,
    mount,
    destroy,
    getAt,
    update
  };
}
var TRIGGER_KEYS = [" ", "Enter"];
function Sync(Splide2, Components2, options) {
  var isNavigation = options.isNavigation, slideFocus = options.slideFocus;
  var events = [];
  function mount() {
    Splide2.splides.forEach(function(target) {
      if (!target.isParent) {
        sync(Splide2, target.splide);
        sync(target.splide, Splide2);
      }
    });
    if (isNavigation) {
      navigate();
    }
  }
  function destroy() {
    events.forEach(function(event) {
      event.destroy();
    });
    empty(events);
  }
  function remount() {
    destroy();
    mount();
  }
  function sync(splide, target) {
    var event = EventInterface(splide);
    event.on(EVENT_MOVE, function(index, prev, dest) {
      target.go(target.is(LOOP) ? dest : index);
    });
    events.push(event);
  }
  function navigate() {
    var event = EventInterface(Splide2);
    var on2 = event.on;
    on2(EVENT_CLICK, onClick);
    on2(EVENT_SLIDE_KEYDOWN, onKeydown);
    on2([EVENT_MOUNTED, EVENT_UPDATED], update);
    events.push(event);
    event.emit(EVENT_NAVIGATION_MOUNTED, Splide2.splides);
  }
  function update() {
    setAttribute(Components2.Elements.list, ARIA_ORIENTATION, options.direction === TTB ? "vertical" : "");
  }
  function onClick(Slide2) {
    Splide2.go(Slide2.index);
  }
  function onKeydown(Slide2, e) {
    if (includes(TRIGGER_KEYS, normalizeKey(e))) {
      onClick(Slide2);
      prevent(e);
    }
  }
  return {
    setup: apply(Components2.Media.set, {
      slideFocus: isUndefined(slideFocus) ? isNavigation : slideFocus
    }, true),
    mount,
    destroy,
    remount
  };
}
function Wheel(Splide2, Components2, options) {
  var _EventInterface12 = EventInterface(Splide2), bind = _EventInterface12.bind;
  var lastTime = 0;
  function mount() {
    if (options.wheel) {
      bind(Components2.Elements.track, "wheel", onWheel, SCROLL_LISTENER_OPTIONS);
    }
  }
  function onWheel(e) {
    if (e.cancelable) {
      var deltaY = e.deltaY;
      var backwards = deltaY < 0;
      var timeStamp = timeOf(e);
      var _min = options.wheelMinThreshold || 0;
      var sleep = options.wheelSleep || 0;
      if (abs(deltaY) > _min && timeStamp - lastTime > sleep) {
        Splide2.go(backwards ? "<" : ">");
        lastTime = timeStamp;
      }
      shouldPrevent(backwards) && prevent(e);
    }
  }
  function shouldPrevent(backwards) {
    return !options.releaseWheel || Splide2.state.is(MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
  }
  return {
    mount
  };
}
var SR_REMOVAL_DELAY = 90;
function Live(Splide2, Components2, options) {
  var _EventInterface13 = EventInterface(Splide2), on2 = _EventInterface13.on;
  var track = Components2.Elements.track;
  var enabled = options.live && !options.isNavigation;
  var sr = create("span", CLASS_SR);
  var interval = RequestInterval(SR_REMOVAL_DELAY, apply(toggle, false));
  function mount() {
    if (enabled) {
      disable(!Components2.Autoplay.isPaused());
      setAttribute(track, ARIA_ATOMIC, true);
      sr.textContent = "\u2026";
      on2(EVENT_AUTOPLAY_PLAY, apply(disable, true));
      on2(EVENT_AUTOPLAY_PAUSE, apply(disable, false));
      on2([EVENT_MOVED, EVENT_SCROLLED], apply(toggle, true));
    }
  }
  function toggle(active) {
    setAttribute(track, ARIA_BUSY, active);
    if (active) {
      append(track, sr);
      interval.start();
    } else {
      remove(sr);
      interval.cancel();
    }
  }
  function destroy() {
    removeAttribute(track, [ARIA_LIVE, ARIA_ATOMIC, ARIA_BUSY]);
    remove(sr);
  }
  function disable(disabled) {
    if (enabled) {
      setAttribute(track, ARIA_LIVE, disabled ? "off" : "polite");
    }
  }
  return {
    mount,
    disable,
    destroy
  };
}
var ComponentConstructors = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Media,
  Direction,
  Elements,
  Slides,
  Layout,
  Clones,
  Move,
  Controller,
  Arrows,
  Autoplay,
  Cover,
  Scroll,
  Drag,
  Keyboard,
  LazyLoad,
  Pagination,
  Sync,
  Wheel,
  Live
});
var I18N = {
  prev: "Previous slide",
  next: "Next slide",
  first: "Go to first slide",
  last: "Go to last slide",
  slideX: "Go to slide %s",
  pageX: "Go to page %s",
  play: "Start autoplay",
  pause: "Pause autoplay",
  carousel: "carousel",
  slide: "slide",
  select: "Select a slide to show",
  slideLabel: "%s of %s"
};
var DEFAULTS = {
  type: "slide",
  role: "region",
  speed: 400,
  perPage: 1,
  cloneStatus: true,
  arrows: true,
  pagination: true,
  paginationKeyboard: true,
  interval: 5e3,
  pauseOnHover: true,
  pauseOnFocus: true,
  resetProgress: true,
  easing: "cubic-bezier(0.25, 1, 0.5, 1)",
  drag: true,
  direction: "ltr",
  trimSpace: true,
  focusableNodes: "a, button, textarea, input, select, iframe",
  live: true,
  classes: CLASSES,
  i18n: I18N,
  reducedMotion: {
    speed: 0,
    rewindSpeed: 0,
    autoplay: "pause"
  }
};
function Fade(Splide2, Components2, options) {
  var Slides2 = Components2.Slides;
  function mount() {
    EventInterface(Splide2).on([EVENT_MOUNTED, EVENT_REFRESH], init);
  }
  function init() {
    Slides2.forEach(function(Slide2) {
      Slide2.style("transform", "translateX(-" + 100 * Slide2.index + "%)");
    });
  }
  function start(index, done) {
    Slides2.style("transition", "opacity " + options.speed + "ms " + options.easing);
    nextTick(done);
  }
  return {
    mount,
    start,
    cancel: noop
  };
}
function Slide(Splide2, Components2, options) {
  var Move2 = Components2.Move, Controller2 = Components2.Controller, Scroll2 = Components2.Scroll;
  var list = Components2.Elements.list;
  var transition = apply(style, list, "transition");
  var endCallback;
  function mount() {
    EventInterface(Splide2).bind(list, "transitionend", function(e) {
      if (e.target === list && endCallback) {
        cancel();
        endCallback();
      }
    });
  }
  function start(index, done) {
    var destination = Move2.toPosition(index, true);
    var position = Move2.getPosition();
    var speed = getSpeed(index);
    if (abs(destination - position) >= 1 && speed >= 1) {
      if (options.useScroll) {
        Scroll2.scroll(destination, speed, false, done);
      } else {
        transition("transform " + speed + "ms " + options.easing);
        Move2.translate(destination, true);
        endCallback = done;
      }
    } else {
      Move2.jump(index);
      done();
    }
  }
  function cancel() {
    transition("");
    Scroll2.cancel();
  }
  function getSpeed(index) {
    var rewindSpeed = options.rewindSpeed;
    if (Splide2.is(SLIDE) && rewindSpeed) {
      var prev = Controller2.getIndex(true);
      var end = Controller2.getEnd();
      if (prev === 0 && index >= end || prev >= end && index === 0) {
        return rewindSpeed;
      }
    }
    return options.speed;
  }
  return {
    mount,
    start,
    cancel
  };
}
var _Splide = /* @__PURE__ */ function() {
  function _Splide2(target, options) {
    this.event = EventInterface();
    this.Components = {};
    this.state = State(CREATED);
    this.splides = [];
    this._o = {};
    this._E = {};
    var root = isString(target) ? query(document, target) : target;
    assert(root, root + " is invalid.");
    this.root = root;
    options = merge({
      label: getAttribute(root, ARIA_LABEL) || "",
      labelledby: getAttribute(root, ARIA_LABELLEDBY) || ""
    }, DEFAULTS, _Splide2.defaults, options || {});
    try {
      merge(options, JSON.parse(getAttribute(root, DATA_ATTRIBUTE)));
    } catch (e) {
      assert(false, "Invalid JSON");
    }
    this._o = Object.create(merge({}, options));
  }
  var _proto = _Splide2.prototype;
  _proto.mount = function mount(Extensions, Transition) {
    var _this = this;
    var state = this.state, Components2 = this.Components;
    assert(state.is([CREATED, DESTROYED]), "Already mounted!");
    state.set(CREATED);
    this._C = Components2;
    this._T = Transition || this._T || (this.is(FADE) ? Fade : Slide);
    this._E = Extensions || this._E;
    var Constructors = assign({}, ComponentConstructors, this._E, {
      Transition: this._T
    });
    forOwn(Constructors, function(Component, key) {
      var component = Component(_this, Components2, _this._o);
      Components2[key] = component;
      component.setup && component.setup();
    });
    forOwn(Components2, function(component) {
      component.mount && component.mount();
    });
    this.emit(EVENT_MOUNTED);
    addClass(this.root, CLASS_INITIALIZED);
    state.set(IDLE);
    this.emit(EVENT_READY);
    return this;
  };
  _proto.sync = function sync(splide) {
    this.splides.push({
      splide
    });
    splide.splides.push({
      splide: this,
      isParent: true
    });
    if (this.state.is(IDLE)) {
      this._C.Sync.remount();
      splide.Components.Sync.remount();
    }
    return this;
  };
  _proto.go = function go(control) {
    this._C.Controller.go(control);
    return this;
  };
  _proto.on = function on2(events, callback) {
    this.event.on(events, callback);
    return this;
  };
  _proto.off = function off(events) {
    this.event.off(events);
    return this;
  };
  _proto.emit = function emit(event) {
    var _this$event;
    (_this$event = this.event).emit.apply(_this$event, [event].concat(slice(arguments, 1)));
    return this;
  };
  _proto.add = function add(slides, index) {
    this._C.Slides.add(slides, index);
    return this;
  };
  _proto.remove = function remove2(matcher) {
    this._C.Slides.remove(matcher);
    return this;
  };
  _proto.is = function is(type) {
    return this._o.type === type;
  };
  _proto.refresh = function refresh() {
    this.emit(EVENT_REFRESH);
    return this;
  };
  _proto.destroy = function destroy(completely) {
    if (completely === void 0) {
      completely = true;
    }
    var event = this.event, state = this.state;
    if (state.is(CREATED)) {
      EventInterface(this).on(EVENT_READY, this.destroy.bind(this, completely));
    } else {
      forOwn(this._C, function(component) {
        component.destroy && component.destroy(completely);
      }, true);
      event.emit(EVENT_DESTROY);
      event.destroy();
      completely && empty(this.splides);
      state.set(DESTROYED);
    }
    return this;
  };
  _createClass(_Splide2, [{
    key: "options",
    get: function get() {
      return this._o;
    },
    set: function set(options) {
      this._C.Media.set(options, true, true);
    }
  }, {
    key: "length",
    get: function get() {
      return this._C.Slides.getLength(true);
    }
  }, {
    key: "index",
    get: function get() {
      return this._C.Controller.getIndex();
    }
  }]);
  return _Splide2;
}();
var Splide = _Splide;
Splide.defaults = {};
Splide.STATES = STATES;

// node_modules/@splidejs/splide-extension-auto-scroll/dist/js/splide-extension-auto-scroll.esm.js
function empty2(array) {
  array.length = 0;
}
function slice$1(arrayLike, start, end) {
  return Array.prototype.slice.call(arrayLike, start, end);
}
function apply$1(func) {
  return func.bind.apply(func, [null].concat(slice$1(arguments, 1)));
}
function raf2(func) {
  return requestAnimationFrame(func);
}
function typeOf$1(type, subject) {
  return typeof subject === type;
}
var isArray$1 = Array.isArray;
apply$1(typeOf$1, "function");
apply$1(typeOf$1, "string");
apply$1(typeOf$1, "undefined");
function toArray$1(value) {
  return isArray$1(value) ? value : [value];
}
function forEach$1(values, iteratee) {
  toArray$1(values).forEach(iteratee);
}
var ownKeys$1 = Object.keys;
function forOwn$1(object, iteratee, right) {
  if (object) {
    var keys = ownKeys$1(object);
    keys = right ? keys.reverse() : keys;
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (key !== "__proto__") {
        if (iteratee(object[key], key) === false) {
          break;
        }
      }
    }
  }
  return object;
}
function assign$1(object) {
  slice$1(arguments, 1).forEach(function(source) {
    forOwn$1(source, function(value, key) {
      object[key] = source[key];
    });
  });
  return object;
}
var min$1 = Math.min;
function EventBinder2() {
  var listeners = [];
  function bind(targets, events, callback, options) {
    forEachEvent(targets, events, function(target, event, namespace) {
      var isEventTarget = "addEventListener" in target;
      var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
      isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
      listeners.push([target, event, namespace, callback, remover]);
    });
  }
  function unbind(targets, events, callback) {
    forEachEvent(targets, events, function(target, event, namespace) {
      listeners = listeners.filter(function(listener) {
        if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
          listener[4]();
          return false;
        }
        return true;
      });
    });
  }
  function dispatch(target, type, detail) {
    var e;
    var bubbles = true;
    if (typeof CustomEvent === "function") {
      e = new CustomEvent(type, {
        bubbles,
        detail
      });
    } else {
      e = document.createEvent("CustomEvent");
      e.initCustomEvent(type, bubbles, false, detail);
    }
    target.dispatchEvent(e);
    return e;
  }
  function forEachEvent(targets, events, iteratee) {
    forEach$1(targets, function(target) {
      target && forEach$1(events, function(events2) {
        events2.split(" ").forEach(function(eventNS) {
          var fragment = eventNS.split(".");
          iteratee(target, fragment[0], fragment[1]);
        });
      });
    });
  }
  function destroy() {
    listeners.forEach(function(data2) {
      data2[4]();
    });
    empty2(listeners);
  }
  return {
    bind,
    unbind,
    dispatch,
    destroy
  };
}
var EVENT_MOVE2 = "move";
var EVENT_MOVED2 = "moved";
var EVENT_UPDATED2 = "updated";
var EVENT_DRAG2 = "drag";
var EVENT_DRAGGED2 = "dragged";
var EVENT_SCROLL2 = "scroll";
var EVENT_SCROLLED2 = "scrolled";
var EVENT_DESTROY2 = "destroy";
function EventInterface2(Splide2) {
  var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
  var binder = EventBinder2();
  function on2(events, callback) {
    binder.bind(bus, toArray$1(events).join(" "), function(e) {
      callback.apply(callback, isArray$1(e.detail) ? e.detail : []);
    });
  }
  function emit(event) {
    binder.dispatch(bus, event, slice$1(arguments, 1));
  }
  if (Splide2) {
    Splide2.event.on(EVENT_DESTROY2, binder.destroy);
  }
  return assign$1(binder, {
    bus,
    on: on2,
    off: apply$1(binder.unbind, bus),
    emit
  });
}
function RequestInterval2(interval, onInterval, onUpdate, limit) {
  var now = Date.now;
  var startTime;
  var rate = 0;
  var id;
  var paused = true;
  var count = 0;
  function update() {
    if (!paused) {
      rate = interval ? min$1((now() - startTime) / interval, 1) : 1;
      onUpdate && onUpdate(rate);
      if (rate >= 1) {
        onInterval();
        startTime = now();
        if (limit && ++count >= limit) {
          return pause();
        }
      }
      raf2(update);
    }
  }
  function start(resume) {
    !resume && cancel();
    startTime = now() - (resume ? rate * interval : 0);
    paused = false;
    raf2(update);
  }
  function pause() {
    paused = true;
  }
  function rewind() {
    startTime = now();
    rate = 0;
    if (onUpdate) {
      onUpdate(rate);
    }
  }
  function cancel() {
    id && cancelAnimationFrame(id);
    rate = 0;
    id = 0;
    paused = true;
  }
  function set(time2) {
    interval = time2;
  }
  function isPaused() {
    return paused;
  }
  return {
    start,
    rewind,
    pause,
    cancel,
    set,
    isPaused
  };
}
function Throttle2(func, duration) {
  var interval;
  function throttled() {
    if (!interval) {
      interval = RequestInterval2(duration || 0, function() {
        func();
        interval = null;
      }, null, 1);
      interval.start();
    }
  }
  return throttled;
}
var CLASS_ACTIVE2 = "is-active";
var SLIDE2 = "slide";
var FADE2 = "fade";
function slice2(arrayLike, start, end) {
  return Array.prototype.slice.call(arrayLike, start, end);
}
function apply2(func) {
  return func.bind(null, ...slice2(arguments, 1));
}
function typeOf2(type, subject) {
  return typeof subject === type;
}
function isObject2(subject) {
  return !isNull2(subject) && typeOf2("object", subject);
}
var isArray2 = Array.isArray;
apply2(typeOf2, "function");
apply2(typeOf2, "string");
var isUndefined2 = apply2(typeOf2, "undefined");
function isNull2(subject) {
  return subject === null;
}
function toArray2(value) {
  return isArray2(value) ? value : [value];
}
function forEach2(values, iteratee) {
  toArray2(values).forEach(iteratee);
}
function toggleClass2(elm, classes, add) {
  if (elm) {
    forEach2(classes, (name) => {
      if (name) {
        elm.classList[add ? "add" : "remove"](name);
      }
    });
  }
}
var ownKeys2 = Object.keys;
function forOwn2(object, iteratee, right) {
  if (object) {
    let keys = ownKeys2(object);
    keys = right ? keys.reverse() : keys;
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (key !== "__proto__") {
        if (iteratee(object[key], key) === false) {
          break;
        }
      }
    }
  }
  return object;
}
function assign2(object) {
  slice2(arguments, 1).forEach((source) => {
    forOwn2(source, (value, key) => {
      object[key] = source[key];
    });
  });
  return object;
}
function removeAttribute2(elms, attrs) {
  forEach2(elms, (elm) => {
    forEach2(attrs, (attr) => {
      elm && elm.removeAttribute(attr);
    });
  });
}
function setAttribute2(elms, attrs, value) {
  if (isObject2(attrs)) {
    forOwn2(attrs, (value2, name) => {
      setAttribute2(elms, name, value2);
    });
  } else {
    forEach2(elms, (elm) => {
      isNull2(value) || value === "" ? removeAttribute2(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
  }
}
var { min: min2, max: max2, floor: floor2, ceil: ceil2, abs: abs2 } = Math;
function clamp2(number, x, y2) {
  const minimum = min2(x, y2);
  const maximum = max2(x, y2);
  return min2(max2(minimum, number), maximum);
}
var DEFAULTS2 = {
  speed: 1,
  autoStart: true,
  pauseOnHover: true,
  pauseOnFocus: true
};
var I18N2 = {
  startScroll: "Start auto scroll",
  pauseScroll: "Pause auto scroll"
};
function AutoScroll(Splide2, Components2, options) {
  const { on: on2, off, bind, unbind } = EventInterface2(Splide2);
  const { translate, getPosition, toIndex, getLimit } = Components2.Move;
  const { setIndex, getIndex } = Components2.Controller;
  const { orient } = Components2.Direction;
  const { toggle } = Components2.Elements;
  const { Live: Live2 } = Components2;
  const { root } = Splide2;
  const throttledUpdateArrows = Throttle2(Components2.Arrows.update, 500);
  let autoScrollOptions = {};
  let interval;
  let stopped;
  let hovered;
  let focused;
  let busy;
  let currPosition;
  function setup() {
    const { autoScroll } = options;
    autoScrollOptions = assign2({}, DEFAULTS2, isObject2(autoScroll) ? autoScroll : {});
  }
  function mount() {
    if (!Splide2.is(FADE2)) {
      if (!interval && options.autoScroll !== false) {
        interval = RequestInterval2(0, move);
        listen();
        autoStart();
      }
    }
  }
  function destroy() {
    if (interval) {
      interval.cancel();
      interval = null;
      currPosition = void 0;
      off([EVENT_MOVE2, EVENT_DRAG2, EVENT_SCROLL2, EVENT_MOVED2, EVENT_SCROLLED2]);
      unbind(root, "mouseenter mouseleave focusin focusout");
      unbind(toggle, "click");
    }
  }
  function listen() {
    if (autoScrollOptions.pauseOnHover) {
      bind(root, "mouseenter mouseleave", (e) => {
        hovered = e.type === "mouseenter";
        autoToggle();
      });
    }
    if (autoScrollOptions.pauseOnFocus) {
      bind(root, "focusin focusout", (e) => {
        focused = e.type === "focusin";
        autoToggle();
      });
    }
    if (autoScrollOptions.useToggleButton) {
      bind(toggle, "click", () => {
        stopped ? play() : pause();
      });
    }
    on2(EVENT_UPDATED2, update);
    on2([EVENT_MOVE2, EVENT_DRAG2, EVENT_SCROLL2], () => {
      busy = true;
      pause(false);
    });
    on2([EVENT_MOVED2, EVENT_DRAGGED2, EVENT_SCROLLED2], () => {
      busy = false;
      autoToggle();
    });
  }
  function update() {
    const { autoScroll } = options;
    if (autoScroll !== false) {
      autoScrollOptions = assign2({}, autoScrollOptions, isObject2(autoScroll) ? autoScroll : {});
      mount();
    } else {
      destroy();
    }
    if (interval && !isUndefined2(currPosition)) {
      translate(currPosition);
    }
  }
  function autoStart() {
    if (autoScrollOptions.autoStart) {
      if (document.readyState === "complete") {
        play();
      } else {
        bind(window, "load", play);
      }
    }
  }
  function play() {
    if (isPaused()) {
      interval.start(true);
      Live2.disable(true);
      focused = hovered = stopped = false;
      updateButton();
    }
  }
  function pause(stop = true) {
    if (!stopped) {
      stopped = stop;
      updateButton();
      if (!isPaused()) {
        interval.pause();
        Live2.disable(false);
      }
    }
  }
  function autoToggle() {
    if (!stopped) {
      hovered || focused || busy ? pause(false) : play();
    }
  }
  function move() {
    const position = getPosition();
    const destination = computeDestination(position);
    if (position !== destination) {
      translate(destination);
      updateIndex(currPosition = getPosition());
    } else {
      pause(false);
      if (autoScrollOptions.rewind) {
        Splide2.go(autoScrollOptions.speed > 0 ? 0 : Components2.Controller.getEnd());
      }
    }
    throttledUpdateArrows();
  }
  function computeDestination(position) {
    const speed = autoScrollOptions.speed || 1;
    position += orient(speed);
    if (Splide2.is(SLIDE2)) {
      position = clamp2(position, getLimit(false), getLimit(true));
    }
    return position;
  }
  function updateIndex(position) {
    const { length } = Splide2;
    const index = (toIndex(position) + length) % length;
    if (index !== getIndex()) {
      setIndex(index);
      Components2.Slides.update();
      Components2.Pagination.update();
      options.lazyLoad === "nearby" && Components2.LazyLoad.check();
    }
  }
  function updateButton() {
    if (toggle) {
      const key = stopped ? "startScroll" : "pauseScroll";
      toggleClass2(toggle, CLASS_ACTIVE2, !stopped);
      setAttribute2(toggle, "aria-label", options.i18n[key] || I18N2[key]);
    }
  }
  function isPaused() {
    return !interval || interval.isPaused();
  }
  return {
    setup,
    mount,
    destroy,
    play,
    pause,
    isPaused
  };
}

// js/common/behavior/scrolling-content.js
var ScrollingContent = class extends HTMLElement {
  constructor() {
    super();
    this._initScrollableContent();
  }
  _initScrollableContent() {
    let sliderOptions = {
      type: "loop",
      drag: "free",
      arrows: false,
      pagination: false,
      autoWidth: true,
      snap: false
    };
    let playDelay = this.getAttribute("auto-scroll") || 0;
    if (this.hasAttribute("auto-scroll")) {
      sliderOptions["autoScroll"] = {
        pauseOnHover: false,
        autoStart: false,
        speed: parseFloat(this.getAttribute("scroll-speed")) || 1
      };
    }
    if (this.getAttribute("disable") === "md-max") {
      sliderOptions["mediaQuery"] = "max";
      sliderOptions["breakpoints"] = {
        999: {
          destroy: true
        }
      };
    }
    this.scrollableContent = new Splide(this, sliderOptions);
    if (this.hasAttribute("auto-scroll")) {
      this.scrollableContent.mount({ AutoScroll });
      setTimeout(() => {
        this.scrollableContent.Components.AutoScroll.play();
      }, playDelay);
    }
  }
};
if (!window.customElements.get("scrolling-content")) {
  window.customElements.define("scrolling-content", ScrollingContent);
}

// js/common/carousel/scroll-carousel.js
import { inView as inView3, scroll, computeScrollIntoView } from "vendor";
var ScrollCarousel = class extends HTMLElement {
  constructor() {
    super();
    __publicField(this, "hasPendingProgrammaticScroll", false);
    //onMouseDownListener = this.onMouseDown.bind(this);
    __publicField(this, "onMouseMoveListener", this.onMouseMove.bind(this));
    __publicField(this, "onMouseClickListener", this.onMouseClick.bind(this));
    __publicField(this, "onMouseUpListener", this.onMouseUp.bind(this));
    __publicField(this, "targetIndex", 0);
    // The cell index to which we are currently going to
    __publicField(this, "forceChangeEvent", false);
    __publicField(this, "dragPosition", {});
    __publicField(this, "isDragging", false);
    __publicField(this, "latestScrollProgress");
    __publicField(this, "scrollTimeout");
    __publicField(this, "hasTabChanged", false);
    this.setupListeners();
    new ResizeObserver(this.onResize.bind(this)).observe(this);
    new MutationObserver(this.onMutate.bind(this)).observe(this, { subtree: true, attributes: true, attributeFilter: ["hidden"] });
    scroll(this.onScroll.bind(this), { container: this, axis: "x" });
  }
  connectedCallback() {
    this.targetIndex = Math.max(0, this.cells.findIndex((item) => item.classList.contains("is-initial")));
    if (this.targetIndex > 0) {
      this.select(this.targetIndex, { instant: true });
    }
    if (this.adaptiveHeight) {
      this.adaptHeight();
    }
    inView3(this, () => this.preloadImages());
    if (this.closest("x-tabs")) {
      this.closest("x-tabs").addEventListener("tab:changed", () => {
        if (this.scrollLeft === 0) {
          this.hasTabChanged = true;
        }
      });
    }
    this.fetchProductColors();
  }
  disconnectedCallback() {
    this.removeEventListener("mousemove", this.onMouseMoveListener);
    document.removeEventListener("mouseup", this.onMouseUpListener);
  }
  /**
   * -------------------------------------------------------------------------------------------------------------------
   * PUBLIC API (PROPERTIES)
   * -------------------------------------------------------------------------------------------------------------------
   */
  get cellSelector() {
    return this.hasAttribute("cell-selector") ? this.getAttribute("cell-selector") : null;
  }
  get allCells() {
    return this.cellSelector ? Array.from(this.querySelectorAll(this.cellSelector)) : Array.from(this.children);
  }
  get cells() {
    return this.allCells.filter((cell) => !cell.hasAttribute("hidden"));
  }
  get selectedCell() {
    return this.cells[this.selectedIndex];
  }
  get selectedIndex() {
    return this.targetIndex;
  }
  get cellAlign() {
    const scrollSnapAlign = this.cells.length > 0 ? getComputedStyle(this.cells[0]).scrollSnapAlign : "";
    return scrollSnapAlign === "none" ? "center" : scrollSnapAlign;
  }
  get groupCells() {
    if (this.hasAttribute("group-cells")) {
      const number = parseInt(this.getAttribute("group-cells"));
      return isNaN(number) ? Math.floor(this.clientWidth / this.cells[0].clientWidth) : number;
    } else {
      return 1;
    }
  }
  get adaptiveHeight() {
    return this.hasAttribute("adaptive-height");
  }
  get isScrollable() {
    return this.scrollWidth !== this.clientWidth || this.scrollHeight !== this.clientHeight;
  }
  /**
   * -------------------------------------------------------------------------------------------------------------------
   * PUBLIC API (METHODS)
   * -------------------------------------------------------------------------------------------------------------------
   */
  previous({ instant = false } = {}) {
    this.select(Math.max(this.targetIndex - this.groupCells, 0), { instant });
  }
  next({ instant = false } = {}) {
    this.select(Math.min(this.targetIndex + this.groupCells, this.cells.length - 1), { instant });
  }
  select(index, { instant = false } = {}) {
    if (!(index in this.cells)) {
      return;
    }
    this.dispatchEvent(new CustomEvent("carousel:select", { detail: { index, cell: this.cells[index] } }));
    if ("checkVisibility" in this && this.checkVisibility() || this.offsetWidth > 0 && this.offsetHeight > 0) {
      const targetScrollLeft = this.calculateLeftScroll(this.cells[index]);
      if (this.scrollLeft !== targetScrollLeft) {
        this.updateTargetIndex(index);
        this.hasPendingProgrammaticScroll = true;
        this.scrollTo({ left: targetScrollLeft, behavior: instant ? "auto" : "smooth" });
      } else {
        this.updateTargetIndex(this.calculateClosestIndexToAlignment());
      }
      this.updateTargetIndex(index);
      this.hasPendingProgrammaticScroll = true;
      this.scrollToCell(this.cells[index], instant);
    } else {
      this.targetIndex = index;
      this.forceChangeEvent = true;
    }
  }
  /**
   * Filter cells by indexes. This will automatically add the "hidden" attribute to cells whose index belong to this
   * list. It will also take care of properly adjusting the controls. As a reaction, a "carousel:filter" with the
   * filtered indexes will be emitted.
   */
  filter(indexes = []) {
    this.allCells.forEach((cell, index) => {
      cell.toggleAttribute("hidden", indexes.includes(index));
    });
    this.dispatchEvent(new CustomEvent("carousel:filter", { detail: { filteredIndexes: indexes } }));
  }
  /**
   * -------------------------------------------------------------------------------------------------------------------
   * PRIVATE METHODS
   * -------------------------------------------------------------------------------------------------------------------
   */
  /**
   * Setup all the listeners needed for the carousel to work properly
   */
  setupListeners() {
    if (this.allCells.length > 1) {
      this.addEventListener("carousel:change", this.preloadImages);
      this.addEventListener("scrollend", this.onScrollEnd);
      if (this.adaptiveHeight) {
        this.addEventListener("carousel:settle", this.adaptHeight);
      }
      if (Shopify.designMode) {
        this.addEventListener("shopify:block:select", (event) => this.select(this.cells.indexOf(event.target), { instant: event.detail.load }));
      }
    }
  }
  updateTargetIndex(newValue) {
    if (newValue === this.targetIndex && !this.forceChangeEvent) {
      return;
    }
    this.targetIndex = newValue;
    this.forceChangeEvent = false;
    this.dispatchEvent(new CustomEvent("carousel:change", { detail: { index: newValue, cell: this.cells[newValue] } }));
  }
  /**
   * -------------------------------------------------------------------------------------------------------------------
   * SCROLL MANAGEMENT
   * -------------------------------------------------------------------------------------------------------------------
   */
  onScroll(info) {
    const xProgress = this.hasTabChanged ? 0 : Math.abs(info.x.progress);
    const lastXProgress = this.hasTabChanged ? 0.05 : this.latestScrollProgress || 0;
    if (xProgress < 0.05 && lastXProgress >= 0.05) {
      this.dispatchEvent(new CustomEvent("scroll:edge-nearing", { detail: { position: "start" } }));
    }
    if (xProgress >= 0.05 && lastXProgress < 0.05) {
      this.dispatchEvent(new CustomEvent("scroll:edge-leaving", { detail: { position: "start" } }));
    }
    if (xProgress > 0.95 && lastXProgress <= 0.95) {
      this.dispatchEvent(new CustomEvent("scroll:edge-nearing", { detail: { position: "end" } }));
    }
    if (xProgress <= 0.95 && lastXProgress > 0.95) {
      this.dispatchEvent(new CustomEvent("scroll:edge-leaving", { detail: { position: "end" } }));
    }
    this.latestScrollProgress = xProgress;
    this.hasTabChanged = false;
    if (!("onscrollend" in window)) {
      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(() => {
        this.dispatchEvent(new CustomEvent("scrollend", { bubbles: true }));
      }, 75);
    }
    if (this.hasPendingProgrammaticScroll) {
      return;
    }
    this.updateTargetIndex(this.calculateClosestIndexToAlignment());
  }
  onScrollEnd() {
    this.hasPendingProgrammaticScroll = false;
    this.updateTargetIndex(this.calculateClosestIndexToAlignment());
    this.dispatchEvent(new CustomEvent("carousel:settle", { detail: { index: this.selectedIndex, cell: this.selectedCell } }));
  }
  /**
   * Calculate the amount to scroll to align the cell with the "cell-align" rule
   */
  calculateLeftScroll(cell) {
    let scrollLeft;
    switch (this.cellAlign) {
      case "start":
        scrollLeft = cell.offsetLeft - (parseInt(getComputedStyle(this).scrollPaddingInlineStart) || 0);
        break;
      case "center":
        scrollLeft = Math.round(cell.offsetLeft - this.clientWidth / 2 + cell.clientWidth / 2);
        break;
      case "end":
        scrollLeft = cell.offsetLeft + cell.offsetWidth - this.clientWidth + (parseInt(getComputedStyle(this).scrollPaddingInlineEnd) || 0);
        break;
    }
    return Math.min(Math.max(scrollLeft, 0), this.scrollWidth - this.clientWidth);
  }
  scrollToCell(cell, instant = false) {
    const actions = computeScrollIntoView(cell, {
      boundary: this,
      inline: "start"
    });
    actions.forEach(({ el, top, left }) => {
      el.scrollTo({ top, left, behavior: instant ? "auto" : "smooth" });
    });
  }
  calculateClosestIndexToAlignment() {
    let cellAlign = this.cellAlign, offsetAccumulators, targetPoint;
    if (this.cellAlign.length === 0) return;
    if (this.tagName === "SIZE-COMPARE-CAROUSEL") {
      offsetAccumulators = this.cells.map((cell) => Math.round(cell.offsetLeft));
      targetPoint = Math.round(this.scrollLeft * 2.6);
      return offsetAccumulators.indexOf(offsetAccumulators.reduce((prev, curr) => Math.abs(curr - targetPoint) < Math.abs(prev - targetPoint) ? curr : prev));
    }
    if (this.tagName === "BOUTIQUE-CAROUSEL" && matchesMediaQuery("md-max")) {
      offsetAccumulators = this.cells.map((cell) => Math.round(cell.offsetTop));
      targetPoint = Math.round(this.scrollTop);
      return offsetAccumulators.indexOf(offsetAccumulators.reduce((prev, curr) => Math.abs(curr - targetPoint) < Math.abs(prev - targetPoint) ? curr : prev));
    }
    if (cellAlign === "center") {
      offsetAccumulators = this.cells.map((cell) => Math.round(cell.offsetLeft + cell.clientWidth / 2));
      targetPoint = Math.round(this.scrollLeft + this.clientWidth / 2);
    } else if (cellAlign === "start" && document.dir === "ltr" || cellAlign === "end" && document.dir === "rtl") {
      offsetAccumulators = this.cells.map((cell) => cell.offsetLeft);
      targetPoint = this.scrollLeft;
    } else {
      offsetAccumulators = this.cells.map((cell) => cell.offsetLeft + cell.clientWidth);
      targetPoint = this.scrollLeft + this.clientWidth;
    }
    return offsetAccumulators.indexOf(offsetAccumulators.reduce((prev, curr) => Math.abs(curr - targetPoint) < Math.abs(prev - targetPoint) ? curr : prev));
  }
  /**
   * -------------------------------------------------------------------------------------------------------------------
   * DRAG FEATURE
   * -------------------------------------------------------------------------------------------------------------------
   */
  onMouseDown(event) {
    this.dragPosition = {
      // The current scroll
      left: this.scrollLeft,
      top: this.scrollTop,
      // Get the current mouse position
      x: event.clientX,
      y: event.clientY
    };
    this.isDragging = true;
    this.style.setProperty("scroll-snap-type", "none");
    this.addEventListener("mousemove", this.onMouseMoveListener);
    this.addEventListener("click", this.onMouseClickListener, { once: true });
    document.addEventListener("mouseup", this.onMouseUpListener);
  }
  onMouseMove(event) {
    event.preventDefault();
    const [dx, dy] = [event.clientX - this.dragPosition.x, event.clientY - this.dragPosition.y];
    this.scrollTop = this.dragPosition.top - dy;
    this.scrollLeft = this.dragPosition.left - dx;
  }
  onMouseClick(event) {
    if (event.clientX - this.dragPosition.x !== 0) {
      event.preventDefault();
    }
  }
  onMouseUp(event) {
    this.isDragging = false;
    if (event.clientX - this.dragPosition.x === 0) {
      this.style.removeProperty("scroll-snap-type");
    } else if (!this.hasPendingProgrammaticScroll) {
      this.scrollToCell(this.selectedCell);
    }
    this.removeEventListener("mousemove", this.onMouseMoveListener);
    document.removeEventListener("mouseup", this.onMouseUpListener);
  }
  /**
   * -------------------------------------------------------------------------------------------------------------------
   * OTHER
   * -------------------------------------------------------------------------------------------------------------------
   */
  onResize() {
    if (this.selectedIndex !== this.calculateClosestIndexToAlignment()) {
      this.select(this.selectedIndex, { instant: true });
    }
    if (this.adaptiveHeight) {
      this.adaptHeight();
    }
    this.classList.toggle("is-scrollable", this.scrollWidth > this.clientWidth);
  }
  onMutate() {
    this.forceChangeEvent = true;
  }
  adaptHeight() {
    this.style.maxHeight = null;
    if (this.isScrollable) {
      this.style.maxHeight = `${this.selectedCell.clientHeight}px`;
    }
  }
  preloadImages() {
    if (!this.selectedIndex) return;
    const previousSlide = this.cells[Math.max(this.selectedIndex - 1, 0)], nextSlide = this.cells[Math.min(this.selectedIndex + 1, this.cells.length - 1)];
    [previousSlide, this.selectedCell, nextSlide].filter((item) => item !== null).forEach((item) => {
      if (item.tagName === "IMG") {
        item.setAttribute("loading", "eager");
      } else {
        Array.from(item.querySelectorAll('img[loading="lazy"]')).forEach((img) => img.setAttribute("loading", "eager"));
      }
      Array.from(item.querySelectorAll('video[preload="none"]')).forEach((video) => video.setAttribute("preload", "metadata"));
    });
  }
  // get product card related colors
  async fetchProductColors() {
    let typesSearchTermsList = [];
    let vendorSearchTermsList = [];
    Array.from(this.scrollCarouselItems).forEach((product) => {
      let type = product.getAttribute("type") ? product.getAttribute("type") : null;
      let vendor = product.getAttribute("vendor") ? product.getAttribute("vendor") : null;
      let typesSearchItem = `product_type:"${type}"`;
      let vendorSearchItem = `vendor:"${vendor}"`;
      if (typesSearchTermsList.indexOf(typesSearchItem) < 0) {
        typesSearchTermsList.push(typesSearchItem);
      }
      if (vendorSearchTermsList.indexOf(vendorSearchItem) < 0) {
        vendorSearchTermsList.push(vendorSearchItem);
      }
    });
    if (typesSearchTermsList.length === 0 || vendorSearchTermsList.length === 0) return;
    const query2 = encodeURIComponent(`${typesSearchTermsList.join(" OR ")} AND ${vendorSearchTermsList.join(" OR ")}`);
    const url = `${Shopify.routes.root}search?resources[type]=product&section_id=product-card-colors&q=${query2}`;
    const response = await fetch(url);
    const responseText = await response.text();
    if (response.ok) {
      let div = document.createElement("div");
      div.innerHTML = responseText;
      let object = JSON.parse(div.querySelector(".shopify-section").innerHTML);
      Array.from(this.scrollCarouselItems).forEach((product) => {
        let productColorId = product.getAttribute("color-id");
        product.dispatchEvent(new CustomEvent("product-card:infos", {
          bubbles: true,
          detail: {
            colorListHTML: object.hasOwnProperty(productColorId) ? object[productColorId]["colors"] : null,
            variantId: object.hasOwnProperty(productColorId) ? object[productColorId]["variant_id"] : null
          }
        }));
      });
    }
  }
  get scrollCarouselItems() {
    return this.querySelectorAll("product-card");
  }
};
if (!window.customElements.get("scroll-carousel")) {
  window.customElements.define("scroll-carousel", ScrollCarousel);
}

// js/common/carousel/boutique-carousel.js
var BoutiqueCarousel = class extends ScrollCarousel {
};
if (!window.customElements.get("boutique-carousel")) {
  window.customElements.define("boutique-carousel", BoutiqueCarousel);
}

// js/common/carousel/carousel-navigation.js
var _abortController, _allItems, _CarouselNavigation_instances, onCarouselFilter_fn;
var CarouselNavigation = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _CarouselNavigation_instances);
    __privateAdd(this, _abortController);
    __privateAdd(this, _allItems, []);
  }
  connectedCallback() {
    if (!this.carousel) {
      throw "Carousel navigation component requires an aria-controls attribute that refers to the controlled carousel.";
    }
    __privateSet(this, _abortController, new AbortController());
    __privateSet(this, _allItems, Array.from(this.querySelectorAll("button")));
    __privateGet(this, _allItems).forEach((button) => button.addEventListener("click", () => this.onButtonClicked(this.items.indexOf(button)), { signal: __privateGet(this, _abortController).signal }));
    this.carousel.addEventListener("carousel:change", (event) => this.onNavigationChange(event.detail.index), { signal: __privateGet(this, _abortController).signal });
    this.carousel.addEventListener("carousel:filter", __privateMethod(this, _CarouselNavigation_instances, onCarouselFilter_fn).bind(this), { signal: __privateGet(this, _abortController).signal });
  }
  disconnectedCallback() {
    __privateGet(this, _abortController).abort();
  }
  get items() {
    return __privateGet(this, _allItems).filter((item) => !item.hasAttribute("hidden"));
  }
  get carousel() {
    return document.getElementById(this.getAttribute("aria-controls"));
  }
  get selectedIndex() {
    return __privateGet(this, _allItems).findIndex((button) => button.getAttribute("aria-current") === "true");
  }
  onButtonClicked(newIndex) {
    this.carousel.select(newIndex);
    this.onNavigationChange(newIndex);
  }
  onNavigationChange(newIndex) {
    this.items.forEach((button, index) => button.setAttribute("aria-current", newIndex === index ? "true" : "false"));
    if (this.hasAttribute("align-selected") && (this.scrollWidth !== this.clientWidth || this.scrollHeight !== this.clientHeight)) {
      this.scrollTo({
        left: this.items[newIndex].offsetLeft - this.clientWidth / 2 + this.items[newIndex].clientWidth / 2,
        top: this.items[newIndex].offsetTop - this.clientHeight / 2 + this.items[newIndex].clientHeight / 2,
        behavior: matchesMediaQuery("motion-safe") ? "smooth" : "auto"
      });
    }
  }
};
_abortController = new WeakMap();
_allItems = new WeakMap();
_CarouselNavigation_instances = new WeakSet();
onCarouselFilter_fn = function(event) {
  __privateGet(this, _allItems).forEach((item, index) => {
    item.toggleAttribute("hidden", (event.detail.filteredIndexes || []).includes(index));
  });
};
var _abortController2;
var CarouselPrevButton = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _abortController2);
  }
  connectedCallback() {
    if (!this.carousel) {
      throw "Carousel prev button component requires an aria-controls attribute that refers to the controlled carousel.";
    }
    __privateSet(this, _abortController2, new AbortController());
    this.addEventListener("click", () => this.carousel.previous(), { signal: __privateGet(this, _abortController2).signal });
    this.carousel.addEventListener("scroll:edge-nearing", (event) => this.buttonController.disabled = event.detail.position === "start", { signal: __privateGet(this, _abortController2).signal });
    this.carousel.addEventListener("scroll:edge-leaving", (event) => this.buttonController.disabled = event.detail.position === "start" ? false : this.disabled, { signal: __privateGet(this, _abortController2).signal });
  }
  disconnectedCallback() {
    __privateGet(this, _abortController2).abort();
  }
  get buttonController() {
    return this.querySelector("button");
  }
  get carousel() {
    return document.getElementById(this.firstElementChild.getAttribute("aria-controls"));
  }
};
_abortController2 = new WeakMap();
var _abortController3;
var CarouselNextButton = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _abortController3);
  }
  connectedCallback() {
    if (!this.carousel) {
      throw "Carousel next button component requires an aria-controls attribute that refers to the controlled carousel.";
    }
    __privateSet(this, _abortController3, new AbortController());
    this.addEventListener("click", () => this.carousel.next(), { signal: __privateGet(this, _abortController3).signal });
    this.carousel.addEventListener("scroll:edge-nearing", (event) => this.buttonController.disabled = event.detail.position === "end", { signal: __privateGet(this, _abortController3).signal });
    this.carousel.addEventListener("scroll:edge-leaving", (event) => this.buttonController.disabled = event.detail.position === "end" ? false : this.disabled, { signal: __privateGet(this, _abortController3).signal });
  }
  disconnectedCallback() {
    __privateGet(this, _abortController3).abort();
  }
  get buttonController() {
    return this.querySelector("button");
  }
  get carousel() {
    return document.getElementById(this.firstElementChild.getAttribute("aria-controls"));
  }
};
_abortController3 = new WeakMap();
var CarouselContainer = class extends HTMLElement {
  connectedCallback() {
    this.calcProductCarouselHeight();
    window.addEventListener("resize", this.calcProductCarouselHeight.bind(this));
  }
  get imageToObserve() {
    return this.querySelectorAll(this.getAttribute("image-selector"))[0];
  }
  calcProductCarouselHeight() {
    if (this.imageToObserve) {
      Array.from(this.querySelectorAll(".carousel-controls-centered")).forEach((item) => {
        item.style.height = this.imageToObserve.offsetHeight + "px";
      });
    }
  }
};
if (!window.customElements.get("carousel-prev-button")) {
  window.customElements.define("carousel-prev-button", CarouselPrevButton);
}
if (!window.customElements.get("carousel-next-button")) {
  window.customElements.define("carousel-next-button", CarouselNextButton);
}
if (!window.customElements.get("carousel-navigation")) {
  window.customElements.define("carousel-navigation", CarouselNavigation);
}
if (!window.customElements.get("carousel-container")) {
  window.customElements.define("carousel-container", CarouselContainer);
}

// js/common/carousel/effect-carousel.js
import { animate as animate3, timeline as timeline2, inView as inView4 } from "vendor";
var _listenersAbortController, _gestureArea, _player, _targetIndex, _preventInitialTransition, _EffectCarousel_instances, setupListeners_fn, onKeyboardNavigation_fn, preloadImages_fn;
var EffectCarousel = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _EffectCarousel_instances);
    __privateAdd(this, _listenersAbortController);
    __privateAdd(this, _gestureArea);
    __privateAdd(this, _player);
    __privateAdd(this, _targetIndex, 0);
    __privateAdd(this, _preventInitialTransition, false);
    __privateMethod(this, _EffectCarousel_instances, setupListeners_fn).call(this);
    inView4(this, () => this.onBecameVisible());
    this.addEventListener("carousel:settle", (event) => {
      this.allCells.forEach((cell) => cell.classList.toggle("is-selected", cell === event.detail.cell));
    });
  }
  connectedCallback() {
    __privateSet(this, _targetIndex, Math.max(0, this.cells.findIndex((item) => item.classList.contains("is-selected"))));
    __privateMethod(this, _EffectCarousel_instances, preloadImages_fn).call(this);
  }
  /**
   * -------------------------------------------------------------------------------------------------------------------
   * PUBLIC API (PROPERTIES)
   * -------------------------------------------------------------------------------------------------------------------
   */
  get allowSwipe() {
    return this.hasAttribute("allow-swipe");
  }
  get cellSelector() {
    return this.hasAttribute("cell-selector") ? this.getAttribute("cell-selector") : null;
  }
  get allCells() {
    return this.cellSelector ? Array.from(this.querySelectorAll(this.cellSelector)) : Array.from(this.children);
  }
  get cells() {
    return this.allCells.filter((cell) => !cell.hasAttribute("hidden"));
  }
  get selectedCell() {
    return this.cells[this.selectedIndex];
  }
  get selectedIndex() {
    return __privateGet(this, _targetIndex);
  }
  get player() {
    return __privateGet(this, _player);
  }
  /**
   * -------------------------------------------------------------------------------------------------------------------
   * PUBLIC API (METHODS)
   * -------------------------------------------------------------------------------------------------------------------
   */
  previous({ instant = false } = {}) {
    return this.select((this.selectedIndex - 1 + this.cells.length) % this.cells.length, { instant, direction: "previous" });
  }
  next({ instant = false } = {}) {
    return this.select((this.selectedIndex + 1 + this.cells.length) % this.cells.length, { instant, direction: "next" });
  }
  async select(index, { instant = false, direction = null } = {}) {
    var _a, _b, _c;
    if (!(index in this.cells)) {
      return Promise.resolve();
    }
    this.dispatchEvent(new CustomEvent("carousel:select", { detail: { index, cell: this.cells[index] } }));
    if (index === this.selectedIndex) {
      return Promise.resolve();
    }
    (_a = __privateGet(this, _player)) == null ? void 0 : _a.pause();
    const [fromSlide, toSlide] = [this.selectedCell, this.cells[index]];
    direction != null ? direction : direction = index > this.selectedIndex ? "next" : "previous";
    __privateSet(this, _targetIndex, index);
    this.dispatchEvent(new CustomEvent("carousel:change", { detail: { index, cell: this.cells[index] } }));
    const animationControls = this.createOnChangeAnimationControls(fromSlide, toSlide, { direction });
    if ("leaveControls" in animationControls && "enterControls" in animationControls) {
      const leaveAnimationControls = animationControls.leaveControls();
      if (instant) {
        leaveAnimationControls.finish();
      }
      await leaveAnimationControls.finished;
      (_b = __privateGet(this, _player)) == null ? void 0 : _b.resume(true);
      fromSlide.classList.remove("is-selected");
      toSlide.classList.add("is-selected");
      const enterAnimationControls = animationControls.enterControls();
      if (instant) {
        enterAnimationControls.finish();
      }
      await enterAnimationControls.finished;
    } else {
      if (instant) {
        animationControls.finish();
      }
      (_c = __privateGet(this, _player)) == null ? void 0 : _c.resume(true);
      toSlide.classList.add("is-selected");
      await animationControls.finished;
      fromSlide.classList.remove("is-selected");
    }
    this.dispatchEvent(new CustomEvent("carousel:settle", { detail: { index, cell: this.cells[index] } }));
  }
  /**
   * Filter cells by indexes. This will automatically add the "hidden" attribute to cells whose index belong to this
   * list. It will also take care of properly adjusting the controls. As a reaction, a "carousel:filter" with the
   * filtered indexes will be emitted.
   */
  filter(indexes = []) {
    this.allCells.forEach((cell, index) => {
      cell.toggleAttribute("hidden", indexes.includes(index));
    });
    this.dispatchEvent(new CustomEvent("carousel:filter", { detail: { filteredIndexes: indexes } }));
  }
  async onBecameVisible() {
    const animationControls = await this.createOnBecameVisibleAnimationControls(this.selectedCell);
    [this.selectedCell, ...this.selectedCell.querySelectorAll("[reveal-on-scroll]")].forEach((element) => {
      element.removeAttribute("reveal-on-scroll");
    });
    if (__privateGet(this, _preventInitialTransition) && typeof animationControls.finish === "function") {
      animationControls.finish();
    }
    return animationControls.finished.then(() => {
      var _a;
      (_a = __privateGet(this, _player)) == null ? void 0 : _a.resume(true);
      this.dispatchEvent(new CustomEvent("carousel:settle", { detail: { index: this.selectedIndex, cell: this.selectedCell } }));
    });
  }
  /**
   * The animation controls when the carousel enter into the view for the first time (by default, none)
   */
  createOnBecameVisibleAnimationControls(toSlide) {
    return animate3(toSlide, {}, { duration: 0 });
  }
  /**
   * Define the transition when the slide changes
   */
  createOnChangeAnimationControls(fromSlide, toSlide, { direction } = {}) {
    return timeline2([
      [fromSlide, { opacity: [1, 0] }, { duration: 0.3 }],
      [toSlide, { opacity: [0, 1] }, { duration: 0.3, at: "<" }]
    ]);
  }
  /**
   * When the breakpoint changes (for instance from mobile to desktop), we may have to clean up the existing
   * attributes leave by Motion
   */
  cleanUpAnimations() {
    this.allCells.forEach((cell) => {
      cell.style.removeProperty("opacity");
      cell.style.removeProperty("visibility");
    });
  }
  checkAutoplayResize() {
    if (matchesMediaQuery("md")) {
      __privateGet(this, _player).stop();
    } else {
      __privateGet(this, _player).start();
    }
  }
};
_listenersAbortController = new WeakMap();
_gestureArea = new WeakMap();
_player = new WeakMap();
_targetIndex = new WeakMap();
_preventInitialTransition = new WeakMap();
_EffectCarousel_instances = new WeakSet();
/**
 * -------------------------------------------------------------------------------------------------------------------
 * PRIVATE
 * -------------------------------------------------------------------------------------------------------------------
 */
setupListeners_fn = function() {
  var _a, _b;
  if (this.hasAttribute("disabled-on")) {
    mediaQueryListener(this.getAttribute("disabled-on"), (event) => {
      var _a2;
      if (event.matches) {
        (_a2 = __privateGet(this, _listenersAbortController)) == null ? void 0 : _a2.abort();
        this.cleanUpAnimations();
      } else {
        __privateMethod(this, _EffectCarousel_instances, setupListeners_fn).call(this);
      }
    });
    if (matchesMediaQuery(this.getAttribute("disabled-on"))) {
      return;
    }
  }
  __privateSet(this, _listenersAbortController, new AbortController());
  const listenerOptions = { signal: __privateGet(this, _listenersAbortController).signal };
  if (Shopify.designMode) {
    this.closest(".shopify-section").addEventListener("shopify:section:select", (event) => __privateSet(this, _preventInitialTransition, event.detail.load), listenerOptions);
  }
  if (this.allCells.length > 1) {
    this.addEventListener("carousel:change", __privateMethod(this, _EffectCarousel_instances, preloadImages_fn));
    if (this.allowSwipe) {
      __privateSet(this, _gestureArea, new GestureArea(this, { signal: __privateGet(this, _listenersAbortController).signal }));
      this.addEventListener("swipeleft", this.next, listenerOptions);
      this.addEventListener("swiperight", this.previous, listenerOptions);
    }
    if (!this.hasAttribute("disable-keyboard-navigation")) {
      this.tabIndex = 0;
      this.addEventListener("keydown", __privateMethod(this, _EffectCarousel_instances, onKeyboardNavigation_fn), listenerOptions);
    }
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => this.select(this.cells.indexOf(event.target), { instant: event.detail.load }), listenerOptions);
    }
    if (this.hasAttribute("autoplay")) {
      (_b = __privateGet(this, _player)) != null ? _b : __privateSet(this, _player, new Player((_a = this.getAttribute("autoplay")) != null ? _a : 5));
      __privateGet(this, _player).addEventListener("player:end", this.next.bind(this), listenerOptions);
      if (Shopify.designMode) {
        this.addEventListener("shopify:block:select", () => __privateGet(this, _player).stop(), listenerOptions);
        this.addEventListener("shopify:block:deselect", () => __privateGet(this, _player).start(), listenerOptions);
      }
    }
    if (this.hasAttribute("autoplay-mobile-only")) {
      window.addEventListener("resize", debounce(this.checkAutoplayResize.bind(this), 100));
      if (matchesMediaQuery("md")) {
        __privateGet(this, _player).stop();
      }
    }
  }
};
/**
 * -------------------------------------------------------------------------------------------------------------------
 * OTHER
 * -------------------------------------------------------------------------------------------------------------------
 */
onKeyboardNavigation_fn = function(event) {
  if (event.target !== this) {
    return;
  }
  if (event.code === "ArrowLeft") {
    this.previous();
  } else if (event.code === "ArrowRight") {
    this.next();
  }
};
preloadImages_fn = function() {
  const previousSlide = this.cells[(this.selectedIndex - 1 + this.cells.length) % this.cells.length], nextSlide = this.cells[(this.selectedIndex + 1 + this.cells.length) % this.cells.length];
  [previousSlide, this.selectedCell, nextSlide].forEach((item) => {
    Array.from(item.querySelectorAll('img[loading="lazy"]')).forEach((img) => img.setAttribute("loading", "eager"));
    Array.from(item.querySelectorAll('video[preload="none"]')).forEach((video) => video.setAttribute("preload", "metadata"));
  });
};
if (!window.customElements.get("effect-carousel")) {
  window.customElements.define("effect-carousel", EffectCarousel);
}

// js/common/carousel/hotspots-carousel.js
var HotspotsCarousel = class extends ScrollCarousel {
  constructor() {
    super();
    this.addEventListener("carousel:change", (event) => this.onNavigationChange(event.detail.index));
  }
  onNavigationChange(index) {
    Array.from(this.children).forEach((item, currentIndex) => {
      item.setAttribute("aria-current", index === currentIndex ? "true" : "false");
    });
  }
};
if (!window.customElements.get("hotspots-carousel")) {
  window.customElements.define("hotspots-carousel", HotspotsCarousel);
}

// js/common/carousel/ksp-carousel.js
import { animate as animate4 } from "vendor";
var KspCarousel = class extends EffectCarousel {
  createOnChangeAnimationControls(fromSlide, toSlide) {
    return {
      leaveControls: () => animate4(fromSlide, { opacity: [1, 0], visibility: ["visible", "hidden"] }),
      enterControls: () => animate4(toSlide, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { at: "<" })
    };
  }
};
var _stockValue, _stockValueLabel, _KspStockManager_instances, onVariantChangedListener_fn;
var KspStockManager = class extends HTMLElement {
  constructor() {
    var _a;
    super();
    __privateAdd(this, _KspStockManager_instances);
    __privateAdd(this, _stockValue);
    __privateAdd(this, _stockValueLabel);
    __privateSet(this, _stockValue, this.querySelector("[data-stock]"));
    __privateSet(this, _stockValueLabel, this.querySelector("[data-stock-label]"));
    (_a = document.forms[this.getAttribute("form")]) == null ? void 0 : _a.addEventListener("variant:change", __privateMethod(this, _KspStockManager_instances, onVariantChangedListener_fn).bind(this));
  }
};
_stockValue = new WeakMap();
_stockValueLabel = new WeakMap();
_KspStockManager_instances = new WeakSet();
onVariantChangedListener_fn = function(event) {
  const currentStock = event.detail.variantStock;
  let currentStockKey = "available";
  if (currentStock < 8) currentStockKey = "low_stock";
  if (currentStock <= 0) currentStockKey = "unavailable";
  __privateGet(this, _stockValue).setAttribute("data-stock", currentStockKey);
  __privateGet(this, _stockValueLabel).innerHTML = window.themeVariables.product.ksp.stock[currentStockKey];
};
if (!window.customElements.get("ksp-carousel")) {
  window.customElements.define("ksp-carousel", KspCarousel);
}
if (!window.customElements.get("ksp-stock-manager")) {
  window.customElements.define("ksp-stock-manager", KspStockManager);
}

// js/common/carousel/press-review-carousel.js
import { animate as animate5, timeline as timeline3 } from "vendor";
var PressReviewCarousel = class extends EffectCarousel {
  createOnChangeAnimationControls(fromSlide, toSlide) {
    return {
      leaveControls: () => {
        return animate5(fromSlide, { opacity: [1, 0], visibility: ["visible", "hidden"] });
      },
      enterControls: () => {
        return timeline3([
          [toSlide, { opacity: [0, 1], visibility: ["hidden", "visible"] }],
          [toSlide.querySelector(".quote-icon-color"), { transform: ["translateY(16px)", "translateY(0)"], opacity: [0, 1] }, { at: 0.1 }],
          [toSlide.querySelector(".press-review-carousel__stars"), { transform: ["translateY(16px)", "translateY(0)"], opacity: [0, 1] }, { at: 0.1 }],
          [toSlide.querySelector(".trustpilot-stars"), { transform: ["translateY(16px)", "translateY(0)"], opacity: [0, 1] }, { at: 0.1 }],
          [toSlide.querySelector(".press-review__slide-title"), { transform: ["translateY(16px)", "translateY(0)"], opacity: [0, 1] }, { at: 0.2 }],
          [toSlide.querySelector(".quote-carousel__author"), { transform: ["translateY(16px)", "translateY(0)"], opacity: [0, 1] }, { at: 0.3 }],
          [toSlide.querySelector(".icon-trustpilot-rating"), { transform: ["translateY(16px)", "translateY(0)"], opacity: [0, 1] }, { at: 0.3 }]
        ]);
      }
    };
  }
};
if (!window.customElements.get("press-review-carousel")) {
  window.customElements.define("press-review-carousel", PressReviewCarousel);
}

// js/common/carousel/product-scroll-carousel.js
import { scroll as scroll2, computeScrollIntoView as computeScrollIntoView2 } from "vendor";
var _hasPendingProgrammaticScroll, _targetIndex2, _forceChangeEvent, _scrollTimeout, _ProductScrollCarousel_instances, setupListeners_fn2, updateTargetIndex_fn, onScroll_fn, onScrollEnd_fn, scrollToCell_fn, calculateClosestIndexToAlignment_fn, preloadImages_fn2;
var ProductScrollCarousel = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _ProductScrollCarousel_instances);
    __privateAdd(this, _hasPendingProgrammaticScroll, false);
    __privateAdd(this, _targetIndex2, 0);
    // The cell index to which we are currently going to
    __privateAdd(this, _forceChangeEvent, false);
    __privateAdd(this, _scrollTimeout);
    __privateMethod(this, _ProductScrollCarousel_instances, setupListeners_fn2).call(this);
    scroll2(__privateMethod(this, _ProductScrollCarousel_instances, onScroll_fn).bind(this), { container: this, axis: "y" });
  }
  connectedCallback() {
    __privateSet(this, _targetIndex2, Math.max(0, this.cells.findIndex((item) => item.classList.contains("is-initial"))));
    if (__privateGet(this, _targetIndex2) > 0) {
      this.select(__privateGet(this, _targetIndex2), { instant: true });
    }
  }
  /**
   * -------------------------------------------------------------------------------------------------------------------
   * PUBLIC API (PROPERTIES)
   * -------------------------------------------------------------------------------------------------------------------
   */
  get cellSelector() {
    return this.hasAttribute("cell-selector") ? this.getAttribute("cell-selector") : null;
  }
  get allCells() {
    return this.cellSelector ? Array.from(this.querySelectorAll(this.cellSelector)) : Array.from(this.children);
  }
  get cells() {
    return this.allCells.filter((cell) => !cell.hasAttribute("hidden"));
  }
  get selectedCell() {
    return this.cells[this.selectedIndex];
  }
  get selectedIndex() {
    return __privateGet(this, _targetIndex2);
  }
  get cellAlign() {
    const scrollSnapAlign = getComputedStyle(this.cells[0]).scrollSnapAlign;
    return scrollSnapAlign === "none" ? "center" : scrollSnapAlign;
  }
  /**
   * -------------------------------------------------------------------------------------------------------------------
   * PUBLIC API (METHODS)
   * -------------------------------------------------------------------------------------------------------------------
   */
  select(index, { instant = false } = {}) {
    if (!(index in this.cells)) {
      return;
    }
    this.dispatchEvent(new CustomEvent("carousel:select", { detail: { index, cell: this.cells[index] } }));
    if ("checkVisibility" in this && this.checkVisibility() || this.offsetWidth > 0 && this.offsetHeight > 0) {
      __privateMethod(this, _ProductScrollCarousel_instances, updateTargetIndex_fn).call(this, index);
      __privateSet(this, _hasPendingProgrammaticScroll, true);
      __privateMethod(this, _ProductScrollCarousel_instances, scrollToCell_fn).call(this, this.cells[index], instant);
    }
  }
};
_hasPendingProgrammaticScroll = new WeakMap();
_targetIndex2 = new WeakMap();
_forceChangeEvent = new WeakMap();
_scrollTimeout = new WeakMap();
_ProductScrollCarousel_instances = new WeakSet();
/**
 * -------------------------------------------------------------------------------------------------------------------
 * PRIVATE METHODS
 * -------------------------------------------------------------------------------------------------------------------
 */
/**
 * Setup all the listeners needed for the carousel to work properly
 */
setupListeners_fn2 = function() {
  if (this.allCells.length > 1) {
    this.addEventListener("carousel:change", __privateMethod(this, _ProductScrollCarousel_instances, preloadImages_fn2));
    this.addEventListener("scrollend", __privateMethod(this, _ProductScrollCarousel_instances, onScrollEnd_fn));
  }
};
updateTargetIndex_fn = function(newValue) {
  if (newValue === __privateGet(this, _targetIndex2) && !__privateGet(this, _forceChangeEvent)) {
    return;
  }
  __privateSet(this, _targetIndex2, newValue);
  __privateSet(this, _forceChangeEvent, false);
  this.dispatchEvent(new CustomEvent("carousel:change", { detail: { index: newValue, cell: this.cells[newValue] } }));
};
/**
 * -------------------------------------------------------------------------------------------------------------------
 * SCROLL MANAGEMENT
 * -------------------------------------------------------------------------------------------------------------------
 */
onScroll_fn = function() {
  if (!("onscrollend" in window)) {
    clearTimeout(__privateGet(this, _scrollTimeout));
    __privateSet(this, _scrollTimeout, setTimeout(() => {
      this.dispatchEvent(new CustomEvent("scrollend", { bubbles: true }));
    }, 75));
  }
  if (__privateGet(this, _hasPendingProgrammaticScroll)) {
    return;
  }
  __privateMethod(this, _ProductScrollCarousel_instances, updateTargetIndex_fn).call(this, __privateMethod(this, _ProductScrollCarousel_instances, calculateClosestIndexToAlignment_fn).call(this));
};
onScrollEnd_fn = function() {
  __privateSet(this, _hasPendingProgrammaticScroll, false);
  __privateMethod(this, _ProductScrollCarousel_instances, updateTargetIndex_fn).call(this, __privateMethod(this, _ProductScrollCarousel_instances, calculateClosestIndexToAlignment_fn).call(this));
  this.dispatchEvent(new CustomEvent("carousel:settle", { detail: { index: this.selectedIndex, cell: this.selectedCell } }));
};
scrollToCell_fn = function(cell, instant = false) {
  const actions = computeScrollIntoView2(cell, {
    boundary: this,
    inline: "start"
  });
  actions.forEach(({ el, top, left }) => {
    el.scrollTo({ top, left, behavior: instant ? "auto" : "smooth" });
  });
};
calculateClosestIndexToAlignment_fn = function() {
  let cellAlign = this.cellAlign, offsetAccumulators, targetPoint;
  if (cellAlign === "center") {
    offsetAccumulators = this.cells.map((cell) => Math.round(cell.offsetTop + cell.clientWidth / 2));
    targetPoint = Math.round(this.scrollTop + this.clientWidth / 2);
  }
  return offsetAccumulators.indexOf(offsetAccumulators.reduce((prev, curr) => Math.abs(curr - targetPoint) < Math.abs(prev - targetPoint) ? curr : prev));
};
/**
 * -------------------------------------------------------------------------------------------------------------------
 * OTHER
 * -------------------------------------------------------------------------------------------------------------------
 */
preloadImages_fn2 = function() {
  const previousSlide = this.cells[Math.max(this.selectedIndex - 1, 0)], nextSlide = this.cells[Math.min(this.selectedIndex + 1, this.cells.length - 1)];
  [previousSlide, this.selectedCell, nextSlide].filter((item) => item !== null).forEach((item) => {
    Array.from(item.querySelectorAll('img[loading="lazy"]')).forEach((img) => img.setAttribute("loading", "eager"));
  });
};
if (!window.customElements.get("product-scroll-carousel")) {
  window.customElements.define("product-scroll-carousel", ProductScrollCarousel);
}

// js/common/carousel/size-compare-carousel.js
var SizeCompareCarousel = class extends ScrollCarousel {
};
if (!window.customElements.get("size-compare-carousel")) {
  window.customElements.define("size-compare-carousel", SizeCompareCarousel);
}

// js/common/cart/fetch-cart.js
var createCartPromise = () => {
  return new Promise(async (resolve) => {
    resolve(await (await fetch(`${Shopify.routes.root}cart.js`)).json());
  });
};
var fetchCart = createCartPromise();
document.addEventListener("cart:change", (event) => {
  fetchCart = event.detail["cart"];
});
window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    fetchCart = createCartPromise();
  }
});
document.addEventListener("cart:refresh", () => {
  fetchCart = createCartPromise();
});

// js/common/cart/cart-count.js
var _abortController4, _CartCount_instances, updateFromServer_fn;
var CartCount = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _CartCount_instances);
    __privateAdd(this, _abortController4);
  }
  connectedCallback() {
    __privateSet(this, _abortController4, new AbortController());
    document.addEventListener("cart:change", (event) => this.itemCount = event.detail["cart"]["item_count"], { signal: __privateGet(this, _abortController4).signal });
    document.addEventListener("cart:refresh", __privateMethod(this, _CartCount_instances, updateFromServer_fn).bind(this), { signal: __privateGet(this, _abortController4).signal });
    window.addEventListener("pageshow", __privateMethod(this, _CartCount_instances, updateFromServer_fn).bind(this), { signal: __privateGet(this, _abortController4).signal });
  }
  disconnectedCallback() {
    __privateGet(this, _abortController4).abort();
  }
  set itemCount(count) {
    this.innerText = count;
  }
};
_abortController4 = new WeakMap();
_CartCount_instances = new WeakSet();
updateFromServer_fn = async function() {
  this.itemCount = (await fetchCart)["item_count"];
};
if (!window.customElements.get("cart-count")) {
  window.customElements.define("cart-count", CartCount);
}

// js/common/cart/cart-cross-sell.js
import { animate as animate6 } from "vendor";
var _CartCrossSellRecommendation_instances, loadRecommendations_fn;
var CartCrossSellRecommendation = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _CartCrossSellRecommendation_instances);
  }
  connectedCallback() {
    this.isLoaded = false;
    __privateMethod(this, _CartCrossSellRecommendation_instances, loadRecommendations_fn).call(this);
  }
};
_CartCrossSellRecommendation_instances = new WeakSet();
loadRecommendations_fn = async function() {
  if (this.isLoaded) {
    return;
  }
  this.isLoaded = true;
  const section = this.closest(".shopify-section"), intent = this.getAttribute("intent") || "related", url = `${Shopify.routes.root}recommendations/products?product_id=${this.getAttribute("product")}&limit=${this.getAttribute("limit") || 4}&section_id=${extractSectionId(section)}&intent=${intent}`, response = await fetch(url, { priority: intent === "related" ? "low" : "auto" });
  const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html"), productRecommendationsElement = tempDiv.querySelector("cart-cross-sell");
  if (productRecommendationsElement.childElementCount > 0) {
    this.replaceWith(...document.importNode(productRecommendationsElement, true).childNodes);
    animate6(section, { opacity: [0, 1] }, { duration: 0.3 });
  } else {
    this.remove();
  }
};
if (!window.customElements.get("cart-cross-sell")) {
  window.customElements.define("cart-cross-sell", CartCrossSellRecommendation);
}

// js/common/cart/cart-note.js
var _CartNote_instances, onNoteChanged_fn;
var CartNote = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _CartNote_instances);
    this.addEventListener("change", __privateMethod(this, _CartNote_instances, onNoteChanged_fn));
  }
};
_CartNote_instances = new WeakSet();
onNoteChanged_fn = function(event) {
  if (event.target.getAttribute("name") !== "note") {
    return;
  }
  fetch(`${Shopify.routes.root}cart/update.js`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ note: event.target.value }),
    keepalive: true
    // Allows to make sure the request is fired even when submitting the form
  });
};
if (!window.customElements.get("cart-note")) {
  window.customElements.define("cart-note", CartNote);
}

// js/common/cart/checkout-button.js
var CheckoutButton = class extends HTMLElement {
  constructor() {
    var _a;
    super();
    (_a = document.forms[this.getAttribute("form")]) == null ? void 0 : _a.addEventListener("submit", this.onFormSubmit.bind(this));
  }
  onFormSubmit() {
    this.querySelector('button[type="submit"]').classList.add("is-loading");
  }
};
if (!window.customElements.get("checkout-button")) {
  window.customElements.define("checkout-button", CheckoutButton);
}

// js/common/cart/gwp-currencies-exchange-rates.json
var gwp_currencies_exchange_rates_default = {
  "FR_EUR": 1,
	"US_USD": 1,
	"AD_EUR": 1,
	"AE_AED": 4.833333333333333,
	"AG_XCD": 3.566666666666667,
	"AM_AMD": 480,
	"AL_ALL": 105.55555555555556,
	"AI_XCD": 3.566666666666667,
	"AT_EUR": 1,
	"AU_AUD": 2,
	"AO_AOA": 1201.111111111111,
	"AR_ARS": 1985.0666666666666,
	"AZ_AZN": 2.2444444444444445,
	"AW_AWG": 2.3777777777777778,
	"BA_BAM": 2.2222222222222223,
	"BE_EUR": 1,
	"BB_BBD": 2.6333333333333333,
	"BG_EUR": 1,
	"BF_XOF": 743.3333333333334,
	"BD_BDT": 162.22222222222223,
	"BJ_XOF": 743.3333333333334,
	"BH_USD": 1.3111111111111111,
	"BL_EUR": 1.1,
	"BI_BIF": 3944.4444444444443,
	"BM_USD": 1.3111111111111111,
	"BN_BND": 1.6777777777777778,
	"BO_BOB": 15.6,
	"BR_BRL": 6.822222222222222,
	"BS_BSD": 1.3222222222222222,
	"BT_USD": 1.3111111111111111,
	"BW_BWP": 17.711111111111112,
	"BZ_BZD": 2.6555555555555554,
	"CA_CAD": 1.8333333333333333,
	"CI_XOF": 743.3333333333334,
	"CG_XAF": 743.3333333333334,
	"CH_CHF": 1.01,
	"CK_NZD": 2.2222222222222223,
	"CL_CLP": 1453.3333333333333,
	"CM_XAF": 743.3333333333334,
	"CN_CNY": 8.88888888888889,
	"CO_COP": 4155.555555555556,
	"CR_CRC": 592.2222222222222,
	"CV_CVE": 125.55555555555556,
	"CW_USD": 1.3111111111111111,
	"CY_EUR": 1,
	"CZ_CZK": 25.555555555555557,
	"DE_EUR": 1,
	"DJ_DJF": 234.44444444444446,
	"DK_DKK": 7.988888888888889,
	"DM_XCD": 3.566666666666667,
	"DO_DOP": 77.77777777777777,
	"DZ_DZD": 175.55555555555554,
	"EC_USD": 1.3111111111111111,
	"EE_EUR": 1,
	"ES_EUR": 1,
	"EG_EGP": 66.87777777777778,
	"FI_EUR": 1,
	"ET_ETB": 214.85555555555555,
	"FJ_FJD": 2.9,
	"FK_FKP": 0.9777777777777777,
	"FO_DKK": 8.433333333333334,
	"GB_GBP": 0.9888888888888889,
	"GA_USD": 1.3111111111111111,
	"GD_XCD": 3.566666666666667,
	"GF_EUR": 1.1,
	"GE_GEL": 3.422222222222222,
	"GG_GBP": 0.8111111111111111,
	"GH_USD": 1.3111111111111111,
	"GI_GBP": 0.9666666666666667,
	"GL_DKK": 8.433333333333334,
	"GM_GMD": 97.36666666666666,
	"GP_EUR": 1.1,
	"GN_GNF": 11622.222222222223,
	"GQ_XAF": 743.3333333333334,
	"GR_EUR": 1,
	"GW_XOF": 743.3333333333334,
	"GT_GTQ": 10.066666666666666,
	"HR_EUR": 1,
	"HK_HKD": 10.277777777777779,
	"GY_GYD": 275.55555555555554,
	"HN_HNL": 35.36666666666667,
	"IE_EUR": 1,
	"HU_HUF": 396.6666666666667,
	"IL_ILS": 3.9444444444444446,
	"HT_HTG": 172.22222222222223,
	"ID_IDR": 23288.88888888889,
	"IM_GBP": 0.8111111111111111,
	"IS_ISK": 160,
	"IT_EUR": 1,
	"IN_INR": 125.55555555555556,
	"JE_GBP": 0.8111111111111111,
	"JM_JMD": 208.88888888888889,
	"JO_USD": 1.3111111111111111,
	"JP_JPY": 224.95555555555555,
	"KE_KES": 171.11111111111111,
	"KG_KGS": 115.55555555555556,
	"KH_KHR": 5344.444444444444,
	"KI_USD": 1.3111111111111111,
	"KM_KMF": 560,
	"KN_XCD": 3.566666666666667,
	"KR_KRW": 1793.3333333333333,
	"KW_USD": 1.3111111111111111,
	"KY_KYD": 1.1,
	"KZ_KZT": 607.7777777777778,
	"LA_LAK": 29477.777777777777,
	"LB_LBP": 117800,
	"LC_XCD": 3.566666666666667,
	"LI_CHF": 1.0666666666666667,
	"LK_LKR": 432.22222222222223,
	"LR_LRD": 238.88888888888889,
	"LS_LSL": 21.233333333333334,
	"LU_EUR": 1,
	"LT_EUR": 1,
	"LV_EUR": 1,
	"MC_EUR": 1,
	"MA_MAD": 12.222222222222221,
	"ME_EUR": 1.1,
	"MF_EUR": 1.1,
	"MD_MDL": 22.544444444444444,
	"MG_USD": 1.3111111111111111,
	"MK_MKD": 70,
	"MN_MNT": 4744.444444444444,
	"MQ_EUR": 1.1,
	"MO_MOP": 10.622222222222222,
	"MR_USD": 1.3111111111111111,
	"MT_EUR": 1,
	"MS_XCD": 3.566666666666667,
	"MU_MUR": 61.98888888888889,
	"MX_MXN": 24.444444444444443,
	"MY_MYR": 5.333333333333333,
	"MV_MVR": 20.344444444444445,
	"MW_MWK": 2281.1111111111113,
	"MZ_MZN": 84.44444444444444,
	"NL_EUR": 1,
	"NC_XPF": 135.55555555555554,
	"NA_NAD": 21.233333333333334,
	"NG_NGN": 1762.2222222222222,
	"NI_NIO": 48.666666666666664,
	"NO_NOK": 12.777777777777779,
	"NR_AUD": 1.8333333333333333,
	"NP_NPR": 201.11111111111111,
	"NZ_NZD": 2.2777777777777777,
	"NU_NZD": 2.2222222222222223,
	"OM_USD": 1.3111111111111111,
	"PA_USD": 1.3111111111111111,
	"PF_XPF": 135.55555555555554,
	"PE_PEN": 4.433333333333334,
	"PL_PLN": 4.555555555555555,
	"PH_PHP": 97.77777777777777,
	"PG_PGK": 5.844444444444444,
	"PK_PKR": 365.55555555555554,
	"PT_EUR": 1,
	"QA_QAR": 4.833333333333333,
	"RE_EUR": 1.1,
	"RO_RON": 5.555555555555555,
	"PY_PYG": 7788.888888888889,
	"RS_RSD": 133.33333333333334,
	"SA_SAR": 5.222222222222222,
	"SE_SEK": 12.222222222222221,
	"RW_RWF": 1940,
	"SG_SGD": 1.6666666666666667,
	"SB_SBD": 10.533333333333333,
	"SC_SCR": 18.155555555555555,
	"SK_EUR": 1,
	"SH_SHP": 0.9777777777777777,
	"SI_EUR": 1,
	"SM_EUR": 1,
	"SN_XOF": 743.3333333333334,
	"SL_SLL": 27600,
	"SV_USD": 1.3111111111111111,
	"SR_SRD": 49.72222222222222,
	"ST_STD": 29322.222222222223,
	"SX_USD": 1.3111111111111111,
	"SZ_SZL": 21.22222222222222,
	"TC_USD": 1.3111111111111111,
	"TD_XAF": 743.3333333333334,
	"TG_XOF": 743.3333333333334,
	"TH_THB": 43.644444444444446,
	"TL_USD": 1.3111111111111111,
	"TN_USD": 1.3111111111111111,
	"TM_USD": 1.3111111111111111,
	"TO_TOP": 3.1777777777777776,
	"TT_TTD": 8.855555555555556,
	"TV_AUD": 1.8333333333333333,
	"TW_TWD": 41.48888888888889,
	"UG_UGX": 4988.888888888889,
	"TZ_TZS": 3488.8888888888887,
	"VA_EUR": 1,
	"UY_UYU": 53.03333333333333,
	"UZ_UZS": 15555.555555555555,
	"VC_XCD": 3.566666666666667,
	"VE_USD": 1.3111111111111111,
	"VG_USD": 1.3111111111111111,
	"VU_VUV": 156.66666666666666,
	"WF_XPF": 135.55555555555554,
	"VN_VND": 34311.11111111111,
	"YT_EUR": 1.1,
	"WS_WST": 3.6,
	"ZA_ZAR": 21.666666666666668,
	"ZW_USD": 1.3111111111111111,
	"ZM_ZMW": 24.966666666666665
};

// js/common/cart/gwp-bar.js
var _onCartChangedListener, _threshold, _GWPBar_instances, updateMessage_fn, onCartChanged_fn;
var GWPBar = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _GWPBar_instances);
    __privateAdd(this, _onCartChangedListener, __privateMethod(this, _GWPBar_instances, onCartChanged_fn).bind(this));
    __privateAdd(this, _threshold);
    const currency = window.Shopify.currency.active;
    const country = window.Shopify.country;
    this.exchangeRate = gwp_currencies_exchange_rates_default[`${country}_${currency}`];
    if (!this.exchangeRate) {
      this.exchangeRate = 1;
    }
    let thresholdBaseCurrency = this.getAttribute("threshold-base-currency");
    if (!thresholdBaseCurrency) {
      thresholdBaseCurrency = 9999999999999;
    }
    thresholdBaseCurrency = parseFloat(thresholdBaseCurrency.replace(/[^0-9.]/g, ""));
    __privateSet(this, _threshold, thresholdBaseCurrency * this.exchangeRate);
    this.setAttribute("threshold", __privateGet(this, _threshold));
    this.progressBarElement.valueMax = __privateGet(this, _threshold);
    this.getCartContent();
  }
  static get observedAttributes() {
    return ["threshold", "total-price"];
  }
  connectedCallback() {
    document.addEventListener("cart:change", __privateGet(this, _onCartChangedListener));
    this.getCartContent();
  }
  disconnectedCallback() {
    document.removeEventListener("cart:change", __privateGet(this, _onCartChangedListener));
  }
  get totalPrice() {
    return parseFloat(this.getAttribute("total-price"));
  }
  set totalPrice(value) {
    this.setAttribute("total-price", value);
  }
  get progressBarElement() {
    return this.querySelector("progress-bar");
  }
  get gwpProductId() {
    return parseInt(this.getAttribute("gwp-product-id"));
  }
  async attributeChangedCallback(attribute, oldValue, newValue) {
    await window.customElements.whenDefined("progress-bar");
    switch (attribute) {
      case "threshold":
        this.progressBarElement.valueMax = newValue;
        break;
      case "total-price":
        this.progressBarElement.valueNow = newValue;
        break;
    }
    __privateMethod(this, _GWPBar_instances, updateMessage_fn).call(this);
  }
  async getCartContent() {
    this.cartContent = await fetchCart;
    this.checkForGwp(this.cartContent);
  }
  checkForGwp(cart) {
    const priceForItems = cart["items"].filter((item) => item && item["id"] !== this.gwpProductId).reduce((sum, item) => sum + item["final_line_price"], 0), cartDiscount = cart["cart_level_discount_applications"].reduce((sum, discountAllocation) => sum + discountAllocation["total_allocated_amount"], 0);
    const totalPriceInCurrency = priceForItems - cartDiscount;
    this.totalPrice = totalPriceInCurrency;
    const isGWPinCart = cart["items"].some((item) => item["id"] === this.gwpProductId);
    const hasBeenRemoved = sessionStorage.getItem("lt-gwp-removed") === "true";
    if (hasBeenRemoved) this.hidden = true;
    if (this.totalPrice >= __privateGet(this, _threshold)) {
      if (!isGWPinCart && !hasBeenRemoved) this.manageGWPProduct("add");
    } else {
      if (isGWPinCart) this.manageGWPProduct("remove");
    }
  }
  async manageGWPProduct(action) {
    let isCartPage = window.location.pathname === "/cart";
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    let updates = {
      [this.gwpProductId]: action === "add" ? 1 : 0
    };
    await fetch(`${Shopify.routes.root}cart/update.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates }),
      keepalive: true
      // Allows to make sure the request is fired even when submitting the form
    });
    sessionStorage.removeItem("lt-gwp-removed");
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    if (!isCartPage) {
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true
      }));
    } else {
      window.location.reload();
    }
  }
};
_onCartChangedListener = new WeakMap();
_threshold = new WeakMap();
_GWPBar_instances = new WeakSet();
updateMessage_fn = function() {
  let message = "";
  if (this.totalPrice >= __privateGet(this, _threshold)) {
    message = this.getAttribute("reached-message");
  } else {
    const remaining = __privateGet(this, _threshold) - this.totalPrice;
    const replacement = `${formatMoney(remaining).replace(/\$/g, "$$$$")}`;
    message = this.getAttribute("unreached-message").replace(new RegExp("({{.*}})", "g"), replacement);
  }
  this.querySelector("span[data-text]").innerHTML = message;
};
onCartChanged_fn = function(event) {
  this.checkForGwp(event.detail["cart"]);
};
if (!window.customElements.get("gwp-bar")) {
  window.customElements.define("gwp-bar", GWPBar);
}

// js/common/cart/gift-package.js
var _GiftPackage_instances, onPackageSelected_fn;
var GiftPackage = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _GiftPackage_instances);
    this.querySelector('input[type="checkbox"]').addEventListener("change", __privateMethod(this, _GiftPackage_instances, onPackageSelected_fn).bind(this));
  }
  get productId() {
    return this.getAttribute("product-id");
  }
};
_GiftPackage_instances = new WeakSet();
onPackageSelected_fn = async function(event) {
  let isCartPage = window.location.pathname === "/cart";
  document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
  let updates = {
    [this.productId]: event.target.checked ? 1 : 0
  };
  await fetch(`${Shopify.routes.root}cart/update.js`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ updates, attributes: { "packaging": event.target.checked } }),
    keepalive: true
    // Allows to make sure the request is fired even when submitting the form
  });
  document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
  if (!isCartPage) {
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
      bubbles: true
    }));
  } else {
    window.location.reload();
  }
};
if (!window.customElements.get("gift-package")) {
  window.customElements.define("gift-package", GiftPackage);
}

// js/common/cart/line-item-quantity.js
import { Delegate } from "vendor";
var LineItemQuantity = class extends HTMLElement {
  constructor() {
    super();
    this.delegate = new Delegate(this);
    this.delegate.on("change", "[data-line-key]", this.onQuantityChanged.bind(this));
    this.delegate.on("click", '[href*="/cart/change"]', this.onChangeLinkClicked.bind(this));
  }
  onQuantityChanged(event, target) {
    this.changeLineItemQuantity(target.getAttribute("data-line-key"), parseInt(target.value));
  }
  onChangeLinkClicked(event, target) {
    event.preventDefault();
    target.setAttribute("aria-busy", "true");
    if (target.classList.contains("line-item-remove--gwp")) {
      sessionStorage.setItem("lt-gwp-removed", "true");
    }
    const url = new URL(target.href);
    this.changeLineItemQuantity(url.searchParams.get("id"), parseInt(url.searchParams.get("quantity")));
  }
  async changeLineItemQuantity(lineKey, targetQuantity) {
    if (window.themeVariables.settings.pageType === "cart") {
      window.location.href = `${Shopify.routes.root}cart/change?id=${lineKey}&quantity=${targetQuantity}`;
    } else {
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
      const lineItem = this.closest("line-item");
      lineItem == null ? void 0 : lineItem.dispatchEvent(new CustomEvent("line-item:will-change", { bubbles: true, detail: { targetQuantity } }));
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
      const cartContent = await (await fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: targetQuantity,
          sections: sectionsToBundle.join(",")
        })
      })).json();
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
      const lineItemAfterChange = cartContent["items"].filter((lineItem2) => lineItem2["key"] === lineKey);
      lineItem == null ? void 0 : lineItem.dispatchEvent(new CustomEvent("line-item:change", {
        bubbles: true,
        detail: {
          quantity: lineItemAfterChange.length === 0 ? 0 : lineItemAfterChange[0]["quantity"],
          cart: cartContent
        }
      }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "line-item:change",
          cart: cartContent
        }
      }));
      if (cartContent.items_removed.length > 0) {
        const removed_item = {
          title: cartContent.items_removed[0].title.split("-")[1].trim(),
          sku: cartContent.items_removed[0].sku,
          quantity: cartContent.items_removed[0].quantity,
          product: {
            title: cartContent.items_removed[0].title.split("-")[0].trim(),
            type: cartContent.items_removed[0].product_type
          },
          price: {
            amount: cartContent.items_removed[0].presentment_price,
            currencyCode: cartContent.currency
          }
        };
        Shopify.analytics.publish("product_remove_from_cart", {
          cartLine: {
            merchandise: removed_item,
            quantity: cartContent.items_removed[0].quantity,
            cost: {
              totalAmount: {
                amount: cartContent.items_removed[0].presentment_price * cartContent.items_removed[0].quantity,
                currencyCode: cartContent.currency
              }
            }
          }
        });
      }
    }
  }
};
if (!window.customElements.get("line-item-quantity")) {
  window.customElements.define("line-item-quantity", LineItemQuantity);
}

// js/common/facets/facets-banner.js
var _allQuickFacetButtons, _FacetsBanner_instances, forceOpenFacetAccordion_fn;
var FacetsBanner = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _FacetsBanner_instances);
    __privateAdd(this, _allQuickFacetButtons);
    __privateSet(this, _allQuickFacetButtons, this.querySelectorAll("[data-opens]"));
    Array.from(__privateGet(this, _allQuickFacetButtons)).forEach((button) => button.addEventListener("click", __privateMethod(this, _FacetsBanner_instances, forceOpenFacetAccordion_fn).bind(this)));
  }
};
_allQuickFacetButtons = new WeakMap();
_FacetsBanner_instances = new WeakSet();
forceOpenFacetAccordion_fn = function(event) {
  let id = event.currentTarget.getAttribute("data-opens");
  if (!id) return;
  this.facetDrawer = document.querySelector("facets-drawer");
  this.facetDrawer.show();
  if (id) {
    if (!this.facetDrawer.querySelector(`#${id} details`).classList.contains("is-open")) {
      this.facetDrawer.querySelector(`#${id}`).onSummaryClick();
    }
  }
};
if (!window.customElements.get("facets-banner")) {
  window.customElements.define("facets-banner", FacetsBanner);
}

// js/common/overlay/dialog-element.js
import { animate as animate7, FocusTrap, Delegate as Delegate2 } from "vendor";
var lockLayerCount = 0;
var _isLocked, _delegate, _abortController5, _focusTrap, _originalParentBeforeAppend, _DialogElement_instances, allowOutsideClick_fn, allowOutsideClickTouch_fn, allowOutsideClickMouse_fn, onToggleClicked_fn, updateSlotVisibility_fn;
var DialogElement = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _DialogElement_instances);
    __privateAdd(this, _isLocked, false);
    __privateAdd(this, _delegate, new Delegate2(document.body));
    __privateAdd(this, _abortController5);
    __privateAdd(this, _focusTrap);
    __privateAdd(this, _originalParentBeforeAppend);
    if (this.shadowDomTemplate) {
      this.attachShadow({ mode: "open" }).appendChild(document.getElementById(this.shadowDomTemplate).content.cloneNode(true));
      this.shadowRoot.addEventListener("slotchange", (event) => __privateMethod(this, _DialogElement_instances, updateSlotVisibility_fn).call(this, event.target));
    }
    this.addEventListener("dialog:force-close", (event) => {
      this.hide();
      event.stopPropagation();
    });
  }
  static get observedAttributes() {
    return ["id", "open"];
  }
  connectedCallback() {
    var _a;
    if (this.id) {
      __privateGet(this, _delegate).off().on("click", `[aria-controls="${this.id}"]`, __privateMethod(this, _DialogElement_instances, onToggleClicked_fn).bind(this));
    }
    __privateSet(this, _abortController5, new AbortController());
    this.setAttribute("role", "dialog");
    if (this.shadowDomTemplate) {
      (_a = this.getShadowPartByName("overlay")) == null ? void 0 : _a.addEventListener("click", this.hide.bind(this), { signal: this.abortController.signal });
      Array.from(this.shadowRoot.querySelectorAll("slot")).forEach((slot) => __privateMethod(this, _DialogElement_instances, updateSlotVisibility_fn).call(this, slot));
    }
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => this.show(!event.detail.load), { signal: this.abortController.signal });
      this.addEventListener("shopify:block:deselect", this.hide, { signal: this.abortController.signal });
      this._shopifySection = this._shopifySection || this.closest(".shopify-section");
      if (this._shopifySection) {
        if (this.hasAttribute("handle-editor-events")) {
          this._shopifySection.addEventListener("shopify:section:select", (event) => this.show(!event.detail.load), { signal: this.abortController.signal });
          this._shopifySection.addEventListener("shopify:section:deselect", this.hide.bind(this), { signal: this.abortController.signal });
        }
        this._shopifySection.addEventListener("shopify:section:unload", () => this.remove(), { signal: this.abortController.signal });
      }
    }
  }
  disconnectedCallback() {
    var _a;
    __privateGet(this, _delegate).off();
    this.abortController.abort();
    (_a = this.focusTrap) == null ? void 0 : _a.deactivate({ onDeactivate: () => {
    } });
    if (__privateGet(this, _isLocked)) {
      __privateSet(this, _isLocked, false);
      document.documentElement.classList.toggle("lock", --lockLayerCount > 0);
    }
  }
  /**
   * Open the dialog element (the animation can be disabled by passing false as an argument). This function should
   * normally not be directly overriden on children classes
   */
  show(animate23 = true) {
    if (this.open) {
      return Promise.resolve();
    }
    this.setAttribute("open", animate23 ? "" : "immediate");
    return waitForEvent(this, "dialog:after-show");
  }
  /**
   * Hide the dialog element. This function should normally not be directly overriden on children classes
   */
  hide() {
    if (!this.open) {
      return Promise.resolve();
    }
    this.removeAttribute("open");
    return waitForEvent(this, "dialog:after-hide");
  }
  /**
   * Get the abort controller used to clean listeners. You can retrieve it in children classes to add your own listeners
   * that will be cleaned when the element is removed or re-rendered
   */
  get abortController() {
    return __privateGet(this, _abortController5);
  }
  /**
   * Get all the elements controlling this dialog (typically, button). An element controls this dialog if it has an
   * aria-controls attribute matching the ID of this dialog element
   */
  get controls() {
    return Array.from(this.getRootNode().querySelectorAll(`[aria-controls="${this.id}"]`));
  }
  /**
   * Returns if the dialog is open or closed
   */
  get open() {
    return this.hasAttribute("open");
  }
  /**
   * If true is returned, then FocusTrap will activate and manage all the focus management. This is required for good
   * accessibility (such as keyboard management) and should normally not be set to false in children classes unless
   * there is a very good reason to do so
   */
  get shouldTrapFocus() {
    return true;
  }
  /**
   * When the dialog focus is trapped, define if the page is lock (not scrollable). This is usually desirable on
   * full screen modals
   */
  get shouldLock() {
    return false;
  }
  /**
   * By default, when the focus is trapped on an element, a click outside the trapped element close it. Sometimes, it
   * may be desirable to turn off all interactions so that all clicks outside don't do anything
   */
  get clickOutsideDeactivates() {
    return true;
  }
  /**
   * Sometimes (especially for drawer) we need to ensure that an element is on top of everything else. To do that,
   * we need to move the element to the body. We are doing that on open, and then restore the initial position on
   * close
   */
  get shouldAppendToBody() {
    return false;
  }
  /**
   * Decide which element to focus first when the dialog focus is trapped. By default, the first focusable element
   * will be focused, but this can be overridden by passing a selector in the "initial-focus" attribute
   */
  get initialFocus() {
    return this.hasAttribute("initial-focus") ? this.getAttribute("initial-focus") === "false" ? false : this.querySelector(this.getAttribute("initial-focus")) : this.hasAttribute("tabindex") ? this : this.querySelector('input:not([type="hidden"])') || false;
  }
  /**
   * If set to true, then focus trap will not automatically scroll to the first focused element, which can cause
   * annoying experience.
   */
  get preventScrollWhenTrapped() {
    return true;
  }
  /**
   * Get the focus trap element configured with all the other attributes
   */
  get focusTrap() {
    return __privateSet(this, _focusTrap, __privateGet(this, _focusTrap) || new FocusTrap.createFocusTrap([this, this.shadowRoot], {
      onDeactivate: this.hide.bind(this),
      allowOutsideClick: this.clickOutsideDeactivates ? __privateMethod(this, _DialogElement_instances, allowOutsideClick_fn).bind(this) : false,
      initialFocus: matchesMediaQuery("supports-hover") ? this.initialFocus : false,
      fallbackFocus: this,
      preventScroll: this.preventScrollWhenTrapped
    }));
  }
  /**
   * Get the ShadowDOM template (if any). If there is one defined, the dialog automatically constructs it with the
   * shadow DOM
   */
  get shadowDomTemplate() {
    return this.getAttribute("template");
  }
  /**
   * For dialog that use Shadow DOM, this allows a quick retrieval of parts by name
   */
  getShadowPartByName(name) {
    var _a;
    return (_a = this.shadowRoot) == null ? void 0 : _a.querySelector(`[part="${name}"]`);
  }
  /**
   * Callback called when attributes changes. This is the part that glues everything
   */
  attributeChangedCallback(name, oldValue, newValue) {
    var _a;
    switch (name) {
      case "id":
        if (newValue) {
          __privateGet(this, _delegate).off().on("click", `[aria-controls="${this.id}"]`, __privateMethod(this, _DialogElement_instances, onToggleClicked_fn).bind(this));
        }
        break;
      case "open":
        this.controls.forEach((toggle) => toggle.setAttribute("aria-expanded", newValue === null ? "false" : "true"));
        if (oldValue === null && (newValue === "" || newValue === "immediate")) {
          __privateSet(this, _originalParentBeforeAppend, null);
          this.style.setProperty("display", "block");
          this.dispatchEvent(new CustomEvent("dialog:before-show"));
          if (this.shouldAppendToBody && this.parentElement !== document.body) {
            __privateSet(this, _originalParentBeforeAppend, this.parentElement);
            document.body.append(this);
          }
          const animationControls = this.createEnterAnimationControls();
          if (newValue === "immediate") {
            animationControls.finish();
          }
          animationControls.finished.then(() => {
            this.dispatchEvent(new CustomEvent("dialog:after-show"));
          });
          if (this.shouldTrapFocus) {
            this.focusTrap.activate({
              checkCanFocusTrap: () => animationControls.finished
            });
          }
          if (this.shouldLock) {
            lockLayerCount += 1;
            __privateSet(this, _isLocked, true);
            document.documentElement.classList.add("lock");
          }
        } else if (oldValue !== null && newValue === null) {
          this.dispatchEvent(new CustomEvent("dialog:before-hide"));
          const hideTransitionPromise = this.createLeaveAnimationControls().finished;
          hideTransitionPromise.then(() => {
            if (this.parentElement === document.body && __privateGet(this, _originalParentBeforeAppend)) {
              __privateGet(this, _originalParentBeforeAppend).appendChild(this);
              __privateSet(this, _originalParentBeforeAppend, null);
            }
            this.style.setProperty("display", "none");
            this.dispatchEvent(new CustomEvent("dialog:after-hide"));
          });
          (_a = this.focusTrap) == null ? void 0 : _a.deactivate({
            checkCanReturnFocus: () => hideTransitionPromise
          });
          if (this.shouldLock) {
            __privateSet(this, _isLocked, false);
            document.documentElement.classList.toggle("lock", --lockLayerCount > 0);
          }
        }
        this.dispatchEvent(new CustomEvent("toggle", { bubbles: true }));
        break;
    }
  }
  /**
   * Create the animation controls for the enter animation
   */
  createEnterAnimationControls() {
    return animate7(this, {}, { duration: 0 });
  }
  /**
   * Create the animation controls for the leave animation
   */
  createLeaveAnimationControls() {
    return animate7(this, {}, { duration: 0 });
  }
  /**
   * When "clickOutsideDeactivates" is true, this method is called on the final click destination. If this method
   * returns true, then the dialog closes (if false, the dialog remains in its current state). By default, this
   * will close the dialog if a click is done outside the dialog. However, this may be overridden in children classes
   * to provide custom behavior (for instance, to only allow some elements to close the dialog)
   */
  hideForOutsideClickTarget(target) {
    return !this.contains(target);
  }
  /**
   * When "clickOutsideDeactivates" is set to true, this method allows to control which element, when clicked, allows
   * to pass-through and have its behavior being executed
   */
  allowOutsideClickForTarget(target) {
    return false;
  }
};
_isLocked = new WeakMap();
_delegate = new WeakMap();
_abortController5 = new WeakMap();
_focusTrap = new WeakMap();
_originalParentBeforeAppend = new WeakMap();
_DialogElement_instances = new WeakSet();
/**
 * If "clickOutsideDeactivates" is true, then this listener will be called on every click outside the element. This
 * allows function separates touch and non-touch events
 */
allowOutsideClick_fn = function(event) {
  if ("TouchEvent" in window && event instanceof TouchEvent) {
    return __privateMethod(this, _DialogElement_instances, allowOutsideClickTouch_fn).call(this, event);
  } else {
    return __privateMethod(this, _DialogElement_instances, allowOutsideClickMouse_fn).call(this, event);
  }
};
/**
 * If "clickOutsideDeactivates" is true, this listener will be called on every touch click outside the trapped
 * element. By default, this will allow any click outside to cause the dialog to close
 */
allowOutsideClickTouch_fn = function(event) {
  event.target.addEventListener("touchend", (subEvent) => {
    const endTarget = document.elementFromPoint(subEvent.changedTouches.item(0).clientX, subEvent.changedTouches.item(0).clientY);
    if (this.hideForOutsideClickTarget(endTarget)) {
      this.hide();
    }
  }, { once: true, signal: this.abortController.signal });
  return this.allowOutsideClickForTarget(event.target);
};
/**
 * If "clickOutsideDeactivates" is true, this listener will be called on every mouse click outside the trapped
 * element. By default, this will allow any click outside to cause the dialog to close.
 */
allowOutsideClickMouse_fn = function(event) {
  if (event.type !== "click") {
    return false;
  }
  if (this.hideForOutsideClickTarget(event.target)) {
    this.hide();
  }
  if (this.allowOutsideClickForTarget(event.target)) {
    return true;
  }
  let target = event.target, closestControl = event.target.closest("[aria-controls]");
  if (closestControl && closestControl.getAttribute("aria-controls") === this.id) {
    target = closestControl;
  }
  return this.id !== target.getAttribute("aria-controls");
};
/**
 * This function is called whenever a toggle (an element controlling this dialog) is called. This simply open
 * the dialog if closed, or close it if open
 */
onToggleClicked_fn = function(event) {
  event == null ? void 0 : event.preventDefault();
  this.open ? this.hide() : this.show();
};
/**
 * Hide the slots that do not have any children
 */
updateSlotVisibility_fn = function(slot) {
  if (!["header", "footer"].includes(slot.name)) {
    return;
  }
  slot.parentElement.hidden = slot.assignedElements({ flatten: true }).length === 0;
};
var DialogCloseButton = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", () => this.dispatchEvent(new CustomEvent("dialog:force-close", { bubbles: true, cancelable: true, composed: true })));
  }
};
if (!window.customElements.get("dialog-element")) {
  window.customElements.define("dialog-element", DialogElement);
}
if (!window.customElements.get("dialog-close-button")) {
  window.customElements.define("dialog-close-button", DialogCloseButton);
}

// js/common/overlay/drawer.js
import { timeline as timeline4 } from "vendor";
var _initialPosition;
var Drawer = class extends DialogElement {
  constructor() {
    super(...arguments);
    __publicField(this, "transform", null);
    __privateAdd(this, _initialPosition, null);
  }
  connectedCallback() {
    super.connectedCallback();
    this.setAttribute("aria-modal", "true");
  }
  get shadowDomTemplate() {
    return this.getAttribute("template") || "drawer-default-template";
  }
  get shouldLock() {
    return true;
  }
  get shouldAppendToBody() {
    return true;
  }
  get openFrom() {
    return this.getAttribute("open-from") || "right";
  }
  getStyleProperties(direction) {
    switch (direction) {
      case "right":
        this.transform = ["translateX(100%)", "translateX(0)"];
        this.style.setProperty("--drawer-base-align-items", "stretch");
        this.style.setProperty("--drawer-base-justify-items", "end");
        break;
      case "left":
        this.transform = ["translateX(-100%)", "translateX(0)"];
        this.style.setProperty("--drawer-base-align-items", "stretch");
        this.style.setProperty("--drawer-base-justify-items", "start");
        break;
      case "bottom":
        this.transform = ["translateY(100%)", "translateY(0)"];
        this.style.setProperty("--drawer-base-align-items", "end");
        this.style.setProperty("--drawer-base-justify-items", "stretch");
        break;
      case "top":
        this.transform = ["translateY(-100%)", "translateY(0)"];
        this.style.setProperty("--drawer-base-align-items", "start");
        this.style.setProperty("--drawer-base-justify-items", "stretch");
    }
  }
  setStyleProperties() {
    this.getStyleProperties(this.openFrom);
    if (this.openFrom.split(",").length === 1) {
      return;
    }
    Array.from(this.openFrom.split(",")).forEach((item) => {
      let direction = item.split(":")[item.split(":").length - 1].trim();
      let mediaQuery = item.split(":")[0].trim();
      if (matchesMediaQuery(mediaQuery)) {
        this.getStyleProperties(direction);
      }
    });
  }
  createEnterAnimationControls() {
    this.setStyleProperties();
    return timeline4([
      [this.getShadowPartByName("overlay"), { opacity: [0, 1] }, { duration: 0.3, easing: [0.645, 0.045, 0.355, 1] }],
      [this.getShadowPartByName("content"), { transform: this.transform }, { duration: 0.3, at: "<", easing: [0.5, 0.5, 0.5, 1] }]
    ]);
  }
  createLeaveAnimationControls() {
    return timeline4([
      [this.getShadowPartByName("overlay"), { opacity: [1, 0] }, { duration: 0.3, easing: [0.645, 0.045, 0.355, 1] }],
      [this.getShadowPartByName("content"), { transform: this.transform.reverse() }, { duration: 0.3, at: "<", easing: [0.5, 0.5, 0.5, 1] }]
    ]);
  }
};
_initialPosition = new WeakMap();
if (!window.customElements.get("x-drawer")) {
  window.customElements.define("x-drawer", Drawer);
}

// js/common/overlay/modal.js
import { timeline as timeline5 } from "vendor";
var Modal = class extends DialogElement {
  connectedCallback() {
    super.connectedCallback();
    this.setAttribute("aria-modal", "true");
  }
  get shadowDomTemplate() {
    return this.getAttribute("template") || "modal-default-template";
  }
  get shouldLock() {
    return true;
  }
  get shouldAppendToBody() {
    return this.getAttribute("should-append-to-body") ? matchesMediaQuery(this.getAttribute("should-append-to-body")) : true;
  }
  createEnterAnimationControls() {
    return timeline5([
      [this.getShadowPartByName("overlay"), { opacity: [0, 1] }, { duration: 0.15 }],
      [this.getShadowPartByName("content"), { opacity: [0, 1], transform: ["translateY(32px)", "translateY(0)"] }, { duration: 0.15, at: "-0.1" }]
    ]);
  }
  createLeaveAnimationControls() {
    return timeline5([
      [this.getShadowPartByName("overlay"), { opacity: [1, 0] }, { duration: 0.15 }],
      [this.getShadowPartByName("content"), { opacity: [1, 0], transform: ["translateY(0)", "translateY(32px)"] }, { duration: 0.15, at: "<" }]
    ]);
  }
};
if (!window.customElements.get("x-modal")) {
  window.customElements.define("x-modal", Modal);
}

// js/common/overlay/popover.js
import { timeline as timeline6 } from "vendor";
var Popover = class extends DialogElement {
  connectedCallback() {
    super.connectedCallback();
    this.controls.forEach((control) => control.setAttribute("aria-haspopup", "dialog"));
    if (this.hasAttribute("close-on-listbox-select")) {
      this.addEventListener("listbox:select", this.hide, { signal: this.abortController.signal });
    }
  }
  get shadowDomTemplate() {
    return this.getAttribute("template") || "popover-default-template";
  }
  get shouldLock() {
    return matchesMediaQuery("md-max");
  }
  get shouldAppendToBody() {
    return matchesMediaQuery("md-max");
  }
  get preventScrollWhenTrapped() {
    return true;
  }
  createEnterAnimationControls() {
    return timeline6([
      [this.getShadowPartByName("overlay"), { opacity: [0, 1] }, { duration: 0.15 }],
      [this.getShadowPartByName("content"), { opacity: [0, 1], transform: ["translateY(10px)", "translateY(0)"] }, { duration: 0.15, at: "-0.1" }]
    ]);
  }
  createLeaveAnimationControls() {
    return timeline6([
      [this.getShadowPartByName("overlay"), { opacity: [1, 0] }, { duration: 0.15 }],
      [this.getShadowPartByName("content"), { opacity: [1, 0], transform: ["translateY(0)", "translateY(10px)"] }, { duration: 0.15, at: "<" }]
    ]);
  }
};
if (!window.customElements.get("x-popover")) {
  window.customElements.define("x-popover", Popover);
}

// js/common/facets/facets-drawer.js
var _FacetsDrawer_instances, updateFacets_fn;
var FacetsDrawer = class extends Drawer {
  constructor() {
    super();
    __privateAdd(this, _FacetsDrawer_instances);
    this.addEventListener("dialog:after-hide", __privateMethod(this, _FacetsDrawer_instances, updateFacets_fn));
  }
  get shouldAppendToBody() {
    return false;
  }
};
_FacetsDrawer_instances = new WeakSet();
updateFacets_fn = function() {
  var _a;
  (_a = this.querySelector("facets-form form")) == null ? void 0 : _a.dispatchEvent(new Event("submit", { bubbles: true }));
};
if (!window.customElements.get("facets-drawer")) {
  window.customElements.define("facets-drawer", FacetsDrawer);
}

// js/common/facets/facets-form.js
var _isDirty, _FacetsForm_instances, form_get, buildUrl_fn, onFormChanged_fn, onFormSubmitted_fn;
var FacetsForm = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _FacetsForm_instances);
    __privateAdd(this, _isDirty, false);
    this.addEventListener("change", __privateMethod(this, _FacetsForm_instances, onFormChanged_fn));
    this.addEventListener("submit", __privateMethod(this, _FacetsForm_instances, onFormSubmitted_fn), { capture: true });
  }
};
_isDirty = new WeakMap();
_FacetsForm_instances = new WeakSet();
form_get = function() {
  return this.querySelector("form");
};
buildUrl_fn = function() {
  const searchParams = new URLSearchParams(new FormData(__privateGet(this, _FacetsForm_instances, form_get))), url = new URL(__privateGet(this, _FacetsForm_instances, form_get).action);
  url.search = "";
  searchParams.forEach((value, key) => url.searchParams.append(key, value));
  ["page", "filter.v.price.gte", "filter.v.price.lte"].forEach((optionToClear) => {
    if (url.searchParams.get(optionToClear) === "") {
      url.searchParams.delete(optionToClear);
    }
  });
  url.searchParams.set("section_id", this.getAttribute("section-id"));
  return url;
};
onFormChanged_fn = function() {
  __privateSet(this, _isDirty, true);
  if (this.hasAttribute("update-on-change")) {
    __privateGet(this, _FacetsForm_instances, form_get).dispatchEvent(new Event("submit", { cancelable: true }));
  } else {
    cachedFetch(__privateMethod(this, _FacetsForm_instances, buildUrl_fn).call(this).toString());
  }
};
onFormSubmitted_fn = function(event) {
  event.preventDefault();
  if (!__privateGet(this, _isDirty)) {
    return;
  }
  this.dispatchEvent(new CustomEvent("facet:update", {
    bubbles: true,
    detail: {
      url: __privateMethod(this, _FacetsForm_instances, buildUrl_fn).call(this)
    }
  }));
  __privateSet(this, _isDirty, false);
};
if (!window.customElements.get("facets-form")) {
  window.customElements.define("facets-form", FacetsForm);
}

// js/common/facets/facet-link.js
var _FacetLink_instances, onFacetUpdate_fn;
var FacetLink = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _FacetLink_instances);
    this.addEventListener("click", __privateMethod(this, _FacetLink_instances, onFacetUpdate_fn).bind(this));
  }
  get hideGender() {
    return this.hasAttribute("hide-gender");
  }
};
_FacetLink_instances = new WeakSet();
onFacetUpdate_fn = function(event) {
  event.preventDefault();
  const sectionId = extractSectionId(event.target);
  let url = new URL(this.firstElementChild.href);
  if (this.hideGender) {
    url = new URL(this.firstElementChild.href + `?filter.p.m.custom.gender_web=${localStorage.getItem("letanneur:currentGender")}`);
  }
  url.searchParams.set("section_id", sectionId);
  this.dispatchEvent(new CustomEvent("facet:update", {
    bubbles: true,
    detail: {
      url
    }
  }));
};
if (!window.customElements.get("facet-link")) {
  window.customElements.define("facet-link", FacetLink);
}

// js/common/facets/facets-sort-popover.js
var _FacetsSortPopover_instances, onSortChange_fn;
var FacetsSortPopover = class extends Popover {
  constructor() {
    super();
    __privateAdd(this, _FacetsSortPopover_instances);
    this.addEventListener("listbox:change", __privateMethod(this, _FacetsSortPopover_instances, onSortChange_fn));
  }
};
_FacetsSortPopover_instances = new WeakSet();
onSortChange_fn = function(event) {
  const url = new URL(window.location.href);
  url.searchParams.set("sort_by", event.detail.value);
  url.searchParams.delete("page");
  url.searchParams.set("section_id", this.getAttribute("section-id"));
  this.dispatchEvent(new CustomEvent("facet:update", {
    bubbles: true,
    detail: {
      url
    }
  }));
};
if (!window.customElements.get("facets-sort-popover")) {
  window.customElements.define("facets-sort-popover", FacetsSortPopover);
}

// js/common/facets/facets-listeners.js
import { Delegate as Delegate3 } from "vendor";
var abortController = null;
var delegate = new Delegate3(document.body);
var openDetailsValues = new Set(Array.from(document.querySelectorAll('facets-form details[open] input[name*="filter."]'), (item) => item.name));
delegate.on("toggle", "facets-form details", (event, detailsElement) => {
  const inputNames = [...new Set(Array.from(detailsElement.querySelectorAll('input[name*="filter."]'), (item) => item.name))];
  inputNames.forEach((inputName) => {
    detailsElement.open ? openDetailsValues.add(inputName) : openDetailsValues.delete(inputName);
  });
}, true);
document.addEventListener("facet:update", async (event) => {
  if (abortController) {
    abortController.abort();
  }
  abortController = new AbortController();
  const url = event.detail.url, shopifySection = document.getElementById(`shopify-section-${url.searchParams.get("section_id")}`);
  const clonedUrl = new URL(url);
  clonedUrl.searchParams.delete("section_id");
  history.replaceState({}, "", clonedUrl.toString());
  try {
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    const tempContent = new DOMParser().parseFromString(await (await cachedFetch(url.toString(), { signal: abortController.signal })).text(), "text/html");
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
    const newShopifySection = tempContent.querySelector(".shopify-section");
    newShopifySection.querySelectorAll("facets-form details").forEach((detailsElement) => {
      const inputNames = [...new Set(Array.from(detailsElement.querySelectorAll('input[name*="filter."]'), (item) => item.name))];
      inputNames.forEach((inputName) => {
        detailsElement.toggleAttribute("open", openDetailsValues.has(inputName));
      });
    });
    if (event.detail.loadMore) {
      let currentIndex = event.detail.previousButton ? 0 : document.querySelectorAll(".collection__product-list").length - 1;
      let currentProductList = document.querySelectorAll(".collection__product-list")[currentIndex];
      if (event.detail.previousButton) {
        currentProductList.before(...document.importNode(tempContent.querySelector(".shopify-section"), true).childNodes);
      } else {
        currentProductList.after(...document.importNode(tempContent.querySelector(".shopify-section"), true).childNodes);
      }
    } else {
      shopifySection.replaceChildren(...document.importNode(tempContent.querySelector(".shopify-section"), true).childNodes);
      const scrollToProductList = () => shopifySection.querySelector(".collection").scrollIntoView({ block: "start", behavior: "smooth" });
      if ("requestIdleCallback" in window) {
        requestIdleCallback(scrollToProductList, { timeout: 500 });
      } else {
        requestAnimationFrame(scrollToProductList);
      }
    }
  } catch (e) {
  }
});

// js/common/feedback/progress-bar.js
import { inView as inView5 } from "vendor";
var _allowUpdatingProgress, _ProgressBar_instances, calculateProgressBar_fn;
var ProgressBar = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _ProgressBar_instances);
    __privateAdd(this, _allowUpdatingProgress, !this.hasAttribute("animate-on-scroll"));
  }
  static get observedAttributes() {
    return ["aria-valuenow", "aria-valuemax"];
  }
  connectedCallback() {
    if (this.hasAttribute("animate-on-scroll")) {
      inView5(this, () => {
        __privateSet(this, _allowUpdatingProgress, true);
        __privateMethod(this, _ProgressBar_instances, calculateProgressBar_fn).call(this);
      }, { margin: "-50px 0px" });
    }
  }
  get progress() {
    return Math.min(1, this.valueNow / this.valueMax);
  }
  get valueNow() {
    return parseFloat(this.getAttribute("aria-valuenow"));
  }
  get valueMax() {
    return parseFloat(this.getAttribute("aria-valuemax")) * 100;
  }
  set valueMax(value) {
    this.setAttribute("aria-valuemax", value);
  }
  set valueNow(value) {
    this.setAttribute("aria-valuenow", value);
  }
  attributeChangedCallback() {
    if (__privateGet(this, _allowUpdatingProgress)) {
      __privateMethod(this, _ProgressBar_instances, calculateProgressBar_fn).call(this);
    }
  }
};
_allowUpdatingProgress = new WeakMap();
_ProgressBar_instances = new WeakSet();
calculateProgressBar_fn = function() {
  this.style.setProperty("--progress", `${this.progress}`);
};
if (!window.customElements.get("progress-bar")) {
  window.customElements.define("progress-bar", ProgressBar);
}

// js/common/form/custom-form.js
var CustomForm = class extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    this.formElement.addEventListener("submit", this._submitForm.bind(this));
  }
  get formElement() {
    return this.querySelector("form");
  }
  get formType() {
    return this.getAttribute("data-form-type");
  }
  get formName() {
    return this.getAttribute("data-form-name");
  }
  get formSubmit() {
    return this.querySelector('button[type="submit"]');
  }
  get formSuccess() {
    return this.querySelector(".message_success");
  }
  get formError() {
    return this.querySelector(".message_error");
  }
  get formErrorMessage() {
    return this.querySelector(".message_error .banner");
  }
  async _submitForm(event) {
    var _a, _b;
    event == null ? void 0 : event.preventDefault();
    this.formSuccess.classList.add("hidden");
    this.formError.classList.add("hidden");
    this.formSubmit.classList.add("is-loading");
    let formData = new FormData(this.formElement);
    const formResponse = await (await ltRequest(formData, this.formType, this.formName)).json();
    if (((_a = formResponse.response) == null ? void 0 : _a.length) > 0 || ((_b = formResponse.errors) == null ? void 0 : _b.length) > 0) {
      const error = formResponse.response || formResponse.errors;
      this.formErrorMessage.textContent = window.themeVariables.form.errors[error[0]];
      this.formError.classList.remove("hidden");
    } else {
      this.formSuccess.classList.remove("hidden");
      this.formElement.reset();
    }
    this.formSubmit.classList.remove("is-loading");
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
};
if (!window.customElements.get("custom-form")) {
  window.customElements.define("custom-form", CustomForm);
}

// js/common/form/customer-fields-handler.js
var CustomerFieldsHandler = class extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.CFformID = this.getAttribute("data-form-id");
    this.errorFormMessage = this.form.querySelector(".banner--error");
    CF.customerReady(() => {
      this.form.addEventListener("submit", this.onFormSubmitted.bind(this));
    });
  }
  onFormSubmitted(event) {
    event.preventDefault();
    this.form.querySelector('button[type="submit"]:not(.link)').classList.add("is-loading");
    let data2 = new FormData(this.form);
    let formData = {};
    for (const [key, value] of data2) {
      formData[key] = value;
    }
    CF.customer.set(formData);
    let customerSaveOptions = {
      redirect: false,
      formId: this.CFformID
    };
    CF.customer.save(customerSaveOptions).then((errorObj) => {
      console.log("save customer", errorObj);
      if (!errorObj) {
        this.querySelector('button[type="submit"]:not(.link)').classList.remove("is-loading");
      }
      if (errorObj) {
        if (errorObj.email && this.errorFormMessage) {
          this.errorFormMessage.innerText = window.themeVariables.strings.customer.register.email_error;
        }
        if (errorObj && this.errorFormMessage) {
          this.errorFormMessage.removeAttribute("hidden");
        }
      }
    }).catch(function(error) {
      alert("Failed to save customer! :(");
      console.error(error);
    });
    return false;
  }
};
if (!window.customElements.get("custom-form")) {
  window.customElements.define("custom-form", CustomerFieldsHandler);
}

// js/common/form/localization-form.js
var LocalizationForm = class extends HTMLElement {
  constructor() {
    super();
    this.languageInput = this.querySelector('input[name="language_code"]');
    this.countryInput = this.querySelector('input[name="country_code"]');
    this.form = this.querySelector("form");
    this.form.addEventListener("submit", this.onSubmit.bind(this));
  }
  onSubmit(event) {
    var _a;
    event.preventDefault();
    let marketsLanguages = ["de", "es", "fr", "us"];
    const selectedCountryCode = (_a = event.submitter) == null ? void 0 : _a.getAttribute("data-country-code");
    this.countryInput.value = selectedCountryCode;
    this.languageInput.value = marketsLanguages.indexOf(selectedCountryCode) > -1 ? selectedCountryCode : "en";
    if (this.form) this.form.submit();
  }
};
if (!window.customElements.get("localization-form")) {
  window.customElements.define("localization-form", LocalizationForm);
}

// js/common/form/price-range.js
var _abortController6;
var PriceRange = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _abortController6);
  }
  connectedCallback() {
    __privateSet(this, _abortController6, new AbortController());
    const rangeLowerBound = this.querySelector('input[type="range"]#price-gte'), rangeHigherBound = this.querySelector('input[type="range"]#price-lte'), textInputLowerBound = this.querySelector('input[name="filter.v.price.gte"]'), textInputHigherBound = this.querySelector('input[name="filter.v.price.lte"]');
    textInputLowerBound.addEventListener("focus", () => textInputLowerBound.select(), { signal: __privateGet(this, _abortController6).signal });
    textInputHigherBound.addEventListener("focus", () => textInputHigherBound.select(), { signal: __privateGet(this, _abortController6).signal });
    textInputLowerBound.addEventListener("change", (event) => {
      event.preventDefault();
      event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(textInputHigherBound.value || event.target.max) - 1), event.target.min);
      rangeLowerBound.value = event.target.value;
      let newVal = (parseInt(rangeLowerBound.value) - parseInt(rangeLowerBound.min)) * 100 / (parseInt(rangeLowerBound.max) - parseInt(rangeLowerBound.min));
      rangeLowerBound.closest(".range-group").style.setProperty("--range-min", `calc(${newVal}% + (${12 - newVal * 0.24}px))`);
    }, { signal: __privateGet(this, _abortController6).signal });
    textInputHigherBound.addEventListener("change", (event) => {
      event.preventDefault();
      event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(textInputLowerBound.value || event.target.min) + 1), event.target.max);
      rangeHigherBound.value = event.target.value;
      let newVal = (parseInt(rangeHigherBound.value) - parseInt(rangeHigherBound.min)) * 100 / (parseInt(rangeHigherBound.max) - parseInt(rangeHigherBound.min));
      rangeHigherBound.closest(".range-group").style.setProperty("--range-max", `calc(${newVal}% + (${12 - newVal * 0.24}px))`);
    }, { signal: __privateGet(this, _abortController6).signal });
    rangeLowerBound.addEventListener("change", (event) => {
      event.stopPropagation();
      textInputLowerBound.value = event.target.value;
      textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
    }, { signal: __privateGet(this, _abortController6).signal });
    rangeHigherBound.addEventListener("change", (event) => {
      event.stopPropagation();
      textInputHigherBound.value = event.target.value;
      textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
    }, { signal: __privateGet(this, _abortController6).signal });
    rangeLowerBound.addEventListener("input", (event) => {
      event.target.value = Math.min(parseInt(event.target.value), parseInt(textInputHigherBound.value || event.target.max) - 1);
      let newVal = (parseInt(rangeLowerBound.value) - parseInt(rangeLowerBound.min)) * 100 / (parseInt(rangeLowerBound.max) - parseInt(rangeLowerBound.min));
      event.target.closest(".range-group").style.setProperty("--range-min", `calc(${newVal}% + (${12 - newVal * 0.24}px))`);
      textInputLowerBound.value = event.target.value;
      event.target.closest(".range-container").querySelector("span[data-value]").innerText = event.target.value;
    }, { signal: __privateGet(this, _abortController6).signal });
    rangeHigherBound.addEventListener("input", (event) => {
      event.target.value = Math.max(parseInt(event.target.value), parseInt(textInputLowerBound.value || event.target.min) + 1);
      let newVal = (parseInt(rangeHigherBound.value) - parseInt(rangeHigherBound.min)) * 100 / (parseInt(rangeHigherBound.max) - parseInt(rangeHigherBound.min));
      event.target.closest(".range-group").style.setProperty("--range-max", `calc(${newVal}% + (${12 - newVal * 0.24}px))`);
      textInputHigherBound.value = event.target.value;
      event.target.closest(".range-container").querySelector("span[data-value]").innerText = event.target.value;
    }, { signal: __privateGet(this, _abortController6).signal });
  }
  disconnectedCallback() {
    __privateGet(this, _abortController6).abort();
  }
};
_abortController6 = new WeakMap();
if (!window.customElements.get("price-range")) {
  window.customElements.define("price-range", PriceRange);
}

// node_modules/cleave.js/dist/cleave-esm.js
var commonjsGlobal = typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var NumeralFormatter = function(numeralDecimalMark, numeralIntegerScale, numeralDecimalScale, numeralThousandsGroupStyle, numeralPositiveOnly, stripLeadingZeroes, prefix, signBeforePrefix, tailPrefix, delimiter) {
  var owner = this;
  owner.numeralDecimalMark = numeralDecimalMark || ".";
  owner.numeralIntegerScale = numeralIntegerScale > 0 ? numeralIntegerScale : 0;
  owner.numeralDecimalScale = numeralDecimalScale >= 0 ? numeralDecimalScale : 2;
  owner.numeralThousandsGroupStyle = numeralThousandsGroupStyle || NumeralFormatter.groupStyle.thousand;
  owner.numeralPositiveOnly = !!numeralPositiveOnly;
  owner.stripLeadingZeroes = stripLeadingZeroes !== false;
  owner.prefix = prefix || prefix === "" ? prefix : "";
  owner.signBeforePrefix = !!signBeforePrefix;
  owner.tailPrefix = !!tailPrefix;
  owner.delimiter = delimiter || delimiter === "" ? delimiter : ",";
  owner.delimiterRE = delimiter ? new RegExp("\\" + delimiter, "g") : "";
};
NumeralFormatter.groupStyle = {
  thousand: "thousand",
  lakh: "lakh",
  wan: "wan",
  none: "none"
};
NumeralFormatter.prototype = {
  getRawValue: function(value) {
    return value.replace(this.delimiterRE, "").replace(this.numeralDecimalMark, ".");
  },
  format: function(value) {
    var owner = this, parts, partSign, partSignAndPrefix, partInteger, partDecimal = "";
    value = value.replace(/[A-Za-z]/g, "").replace(owner.numeralDecimalMark, "M").replace(/[^\dM-]/g, "").replace(/^\-/, "N").replace(/\-/g, "").replace("N", owner.numeralPositiveOnly ? "" : "-").replace("M", owner.numeralDecimalMark);
    if (owner.stripLeadingZeroes) {
      value = value.replace(/^(-)?0+(?=\d)/, "$1");
    }
    partSign = value.slice(0, 1) === "-" ? "-" : "";
    if (typeof owner.prefix != "undefined") {
      if (owner.signBeforePrefix) {
        partSignAndPrefix = partSign + owner.prefix;
      } else {
        partSignAndPrefix = owner.prefix + partSign;
      }
    } else {
      partSignAndPrefix = partSign;
    }
    partInteger = value;
    if (value.indexOf(owner.numeralDecimalMark) >= 0) {
      parts = value.split(owner.numeralDecimalMark);
      partInteger = parts[0];
      partDecimal = owner.numeralDecimalMark + parts[1].slice(0, owner.numeralDecimalScale);
    }
    if (partSign === "-") {
      partInteger = partInteger.slice(1);
    }
    if (owner.numeralIntegerScale > 0) {
      partInteger = partInteger.slice(0, owner.numeralIntegerScale);
    }
    switch (owner.numeralThousandsGroupStyle) {
      case NumeralFormatter.groupStyle.lakh:
        partInteger = partInteger.replace(/(\d)(?=(\d\d)+\d$)/g, "$1" + owner.delimiter);
        break;
      case NumeralFormatter.groupStyle.wan:
        partInteger = partInteger.replace(/(\d)(?=(\d{4})+$)/g, "$1" + owner.delimiter);
        break;
      case NumeralFormatter.groupStyle.thousand:
        partInteger = partInteger.replace(/(\d)(?=(\d{3})+$)/g, "$1" + owner.delimiter);
        break;
    }
    if (owner.tailPrefix) {
      return partSign + partInteger.toString() + (owner.numeralDecimalScale > 0 ? partDecimal.toString() : "") + owner.prefix;
    }
    return partSignAndPrefix + partInteger.toString() + (owner.numeralDecimalScale > 0 ? partDecimal.toString() : "");
  }
};
var NumeralFormatter_1 = NumeralFormatter;
var DateFormatter = function(datePattern, dateMin, dateMax) {
  var owner = this;
  owner.date = [];
  owner.blocks = [];
  owner.datePattern = datePattern;
  owner.dateMin = dateMin.split("-").reverse().map(function(x) {
    return parseInt(x, 10);
  });
  if (owner.dateMin.length === 2) owner.dateMin.unshift(0);
  owner.dateMax = dateMax.split("-").reverse().map(function(x) {
    return parseInt(x, 10);
  });
  if (owner.dateMax.length === 2) owner.dateMax.unshift(0);
  owner.initBlocks();
};
DateFormatter.prototype = {
  initBlocks: function() {
    var owner = this;
    owner.datePattern.forEach(function(value) {
      if (value === "Y") {
        owner.blocks.push(4);
      } else {
        owner.blocks.push(2);
      }
    });
  },
  getISOFormatDate: function() {
    var owner = this, date = owner.date;
    return date[2] ? date[2] + "-" + owner.addLeadingZero(date[1]) + "-" + owner.addLeadingZero(date[0]) : "";
  },
  getBlocks: function() {
    return this.blocks;
  },
  getValidatedDate: function(value) {
    var owner = this, result = "";
    value = value.replace(/[^\d]/g, "");
    owner.blocks.forEach(function(length, index) {
      if (value.length > 0) {
        var sub = value.slice(0, length), sub0 = sub.slice(0, 1), rest = value.slice(length);
        switch (owner.datePattern[index]) {
          case "d":
            if (sub === "00") {
              sub = "01";
            } else if (parseInt(sub0, 10) > 3) {
              sub = "0" + sub0;
            } else if (parseInt(sub, 10) > 31) {
              sub = "31";
            }
            break;
          case "m":
            if (sub === "00") {
              sub = "01";
            } else if (parseInt(sub0, 10) > 1) {
              sub = "0" + sub0;
            } else if (parseInt(sub, 10) > 12) {
              sub = "12";
            }
            break;
        }
        result += sub;
        value = rest;
      }
    });
    return this.getFixedDateString(result);
  },
  getFixedDateString: function(value) {
    var owner = this, datePattern = owner.datePattern, date = [], dayIndex = 0, monthIndex = 0, yearIndex = 0, dayStartIndex = 0, monthStartIndex = 0, yearStartIndex = 0, day, month, year, fullYearDone = false;
    if (value.length === 4 && datePattern[0].toLowerCase() !== "y" && datePattern[1].toLowerCase() !== "y") {
      dayStartIndex = datePattern[0] === "d" ? 0 : 2;
      monthStartIndex = 2 - dayStartIndex;
      day = parseInt(value.slice(dayStartIndex, dayStartIndex + 2), 10);
      month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
      date = this.getFixedDate(day, month, 0);
    }
    if (value.length === 8) {
      datePattern.forEach(function(type, index) {
        switch (type) {
          case "d":
            dayIndex = index;
            break;
          case "m":
            monthIndex = index;
            break;
          default:
            yearIndex = index;
            break;
        }
      });
      yearStartIndex = yearIndex * 2;
      dayStartIndex = dayIndex <= yearIndex ? dayIndex * 2 : dayIndex * 2 + 2;
      monthStartIndex = monthIndex <= yearIndex ? monthIndex * 2 : monthIndex * 2 + 2;
      day = parseInt(value.slice(dayStartIndex, dayStartIndex + 2), 10);
      month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
      year = parseInt(value.slice(yearStartIndex, yearStartIndex + 4), 10);
      fullYearDone = value.slice(yearStartIndex, yearStartIndex + 4).length === 4;
      date = this.getFixedDate(day, month, year);
    }
    if (value.length === 4 && (datePattern[0] === "y" || datePattern[1] === "y")) {
      monthStartIndex = datePattern[0] === "m" ? 0 : 2;
      yearStartIndex = 2 - monthStartIndex;
      month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
      year = parseInt(value.slice(yearStartIndex, yearStartIndex + 2), 10);
      fullYearDone = value.slice(yearStartIndex, yearStartIndex + 2).length === 2;
      date = [0, month, year];
    }
    if (value.length === 6 && (datePattern[0] === "Y" || datePattern[1] === "Y")) {
      monthStartIndex = datePattern[0] === "m" ? 0 : 4;
      yearStartIndex = 2 - 0.5 * monthStartIndex;
      month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
      year = parseInt(value.slice(yearStartIndex, yearStartIndex + 4), 10);
      fullYearDone = value.slice(yearStartIndex, yearStartIndex + 4).length === 4;
      date = [0, month, year];
    }
    date = owner.getRangeFixedDate(date);
    owner.date = date;
    var result = date.length === 0 ? value : datePattern.reduce(function(previous, current) {
      switch (current) {
        case "d":
          return previous + (date[0] === 0 ? "" : owner.addLeadingZero(date[0]));
        case "m":
          return previous + (date[1] === 0 ? "" : owner.addLeadingZero(date[1]));
        case "y":
          return previous + (fullYearDone ? owner.addLeadingZeroForYear(date[2], false) : "");
        case "Y":
          return previous + (fullYearDone ? owner.addLeadingZeroForYear(date[2], true) : "");
      }
    }, "");
    return result;
  },
  getRangeFixedDate: function(date) {
    var owner = this, datePattern = owner.datePattern, dateMin = owner.dateMin || [], dateMax = owner.dateMax || [];
    if (!date.length || dateMin.length < 3 && dateMax.length < 3) return date;
    if (datePattern.find(function(x) {
      return x.toLowerCase() === "y";
    }) && date[2] === 0) return date;
    if (dateMax.length && (dateMax[2] < date[2] || dateMax[2] === date[2] && (dateMax[1] < date[1] || dateMax[1] === date[1] && dateMax[0] < date[0]))) return dateMax;
    if (dateMin.length && (dateMin[2] > date[2] || dateMin[2] === date[2] && (dateMin[1] > date[1] || dateMin[1] === date[1] && dateMin[0] > date[0]))) return dateMin;
    return date;
  },
  getFixedDate: function(day, month, year) {
    day = Math.min(day, 31);
    month = Math.min(month, 12);
    year = parseInt(year || 0, 10);
    if (month < 7 && month % 2 === 0 || month > 8 && month % 2 === 1) {
      day = Math.min(day, month === 2 ? this.isLeapYear(year) ? 29 : 28 : 30);
    }
    return [day, month, year];
  },
  isLeapYear: function(year) {
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
  },
  addLeadingZero: function(number) {
    return (number < 10 ? "0" : "") + number;
  },
  addLeadingZeroForYear: function(number, fullYearMode) {
    if (fullYearMode) {
      return (number < 10 ? "000" : number < 100 ? "00" : number < 1e3 ? "0" : "") + number;
    }
    return (number < 10 ? "0" : "") + number;
  }
};
var DateFormatter_1 = DateFormatter;
var TimeFormatter = function(timePattern, timeFormat) {
  var owner = this;
  owner.time = [];
  owner.blocks = [];
  owner.timePattern = timePattern;
  owner.timeFormat = timeFormat;
  owner.initBlocks();
};
TimeFormatter.prototype = {
  initBlocks: function() {
    var owner = this;
    owner.timePattern.forEach(function() {
      owner.blocks.push(2);
    });
  },
  getISOFormatTime: function() {
    var owner = this, time2 = owner.time;
    return time2[2] ? owner.addLeadingZero(time2[0]) + ":" + owner.addLeadingZero(time2[1]) + ":" + owner.addLeadingZero(time2[2]) : "";
  },
  getBlocks: function() {
    return this.blocks;
  },
  getTimeFormatOptions: function() {
    var owner = this;
    if (String(owner.timeFormat) === "12") {
      return {
        maxHourFirstDigit: 1,
        maxHours: 12,
        maxMinutesFirstDigit: 5,
        maxMinutes: 60
      };
    }
    return {
      maxHourFirstDigit: 2,
      maxHours: 23,
      maxMinutesFirstDigit: 5,
      maxMinutes: 60
    };
  },
  getValidatedTime: function(value) {
    var owner = this, result = "";
    value = value.replace(/[^\d]/g, "");
    var timeFormatOptions = owner.getTimeFormatOptions();
    owner.blocks.forEach(function(length, index) {
      if (value.length > 0) {
        var sub = value.slice(0, length), sub0 = sub.slice(0, 1), rest = value.slice(length);
        switch (owner.timePattern[index]) {
          case "h":
            if (parseInt(sub0, 10) > timeFormatOptions.maxHourFirstDigit) {
              sub = "0" + sub0;
            } else if (parseInt(sub, 10) > timeFormatOptions.maxHours) {
              sub = timeFormatOptions.maxHours + "";
            }
            break;
          case "m":
          case "s":
            if (parseInt(sub0, 10) > timeFormatOptions.maxMinutesFirstDigit) {
              sub = "0" + sub0;
            } else if (parseInt(sub, 10) > timeFormatOptions.maxMinutes) {
              sub = timeFormatOptions.maxMinutes + "";
            }
            break;
        }
        result += sub;
        value = rest;
      }
    });
    return this.getFixedTimeString(result);
  },
  getFixedTimeString: function(value) {
    var owner = this, timePattern = owner.timePattern, time2 = [], secondIndex = 0, minuteIndex = 0, hourIndex = 0, secondStartIndex = 0, minuteStartIndex = 0, hourStartIndex = 0, second, minute, hour;
    if (value.length === 6) {
      timePattern.forEach(function(type, index) {
        switch (type) {
          case "s":
            secondIndex = index * 2;
            break;
          case "m":
            minuteIndex = index * 2;
            break;
          case "h":
            hourIndex = index * 2;
            break;
        }
      });
      hourStartIndex = hourIndex;
      minuteStartIndex = minuteIndex;
      secondStartIndex = secondIndex;
      second = parseInt(value.slice(secondStartIndex, secondStartIndex + 2), 10);
      minute = parseInt(value.slice(minuteStartIndex, minuteStartIndex + 2), 10);
      hour = parseInt(value.slice(hourStartIndex, hourStartIndex + 2), 10);
      time2 = this.getFixedTime(hour, minute, second);
    }
    if (value.length === 4 && owner.timePattern.indexOf("s") < 0) {
      timePattern.forEach(function(type, index) {
        switch (type) {
          case "m":
            minuteIndex = index * 2;
            break;
          case "h":
            hourIndex = index * 2;
            break;
        }
      });
      hourStartIndex = hourIndex;
      minuteStartIndex = minuteIndex;
      second = 0;
      minute = parseInt(value.slice(minuteStartIndex, minuteStartIndex + 2), 10);
      hour = parseInt(value.slice(hourStartIndex, hourStartIndex + 2), 10);
      time2 = this.getFixedTime(hour, minute, second);
    }
    owner.time = time2;
    return time2.length === 0 ? value : timePattern.reduce(function(previous, current) {
      switch (current) {
        case "s":
          return previous + owner.addLeadingZero(time2[2]);
        case "m":
          return previous + owner.addLeadingZero(time2[1]);
        case "h":
          return previous + owner.addLeadingZero(time2[0]);
      }
    }, "");
  },
  getFixedTime: function(hour, minute, second) {
    second = Math.min(parseInt(second || 0, 10), 60);
    minute = Math.min(minute, 60);
    hour = Math.min(hour, 60);
    return [hour, minute, second];
  },
  addLeadingZero: function(number) {
    return (number < 10 ? "0" : "") + number;
  }
};
var TimeFormatter_1 = TimeFormatter;
var PhoneFormatter = function(formatter, delimiter) {
  var owner = this;
  owner.delimiter = delimiter || delimiter === "" ? delimiter : " ";
  owner.delimiterRE = delimiter ? new RegExp("\\" + delimiter, "g") : "";
  owner.formatter = formatter;
};
PhoneFormatter.prototype = {
  setFormatter: function(formatter) {
    this.formatter = formatter;
  },
  format: function(phoneNumber) {
    var owner = this;
    owner.formatter.clear();
    phoneNumber = phoneNumber.replace(/[^\d+]/g, "");
    phoneNumber = phoneNumber.replace(/^\+/, "B").replace(/\+/g, "").replace("B", "+");
    phoneNumber = phoneNumber.replace(owner.delimiterRE, "");
    var result = "", current, validated = false;
    for (var i = 0, iMax = phoneNumber.length; i < iMax; i++) {
      current = owner.formatter.inputDigit(phoneNumber.charAt(i));
      if (/[\s()-]/g.test(current)) {
        result = current;
        validated = true;
      } else {
        if (!validated) {
          result = current;
        }
      }
    }
    result = result.replace(/[()]/g, "");
    result = result.replace(/[\s-]/g, owner.delimiter);
    return result;
  }
};
var PhoneFormatter_1 = PhoneFormatter;
var CreditCardDetector = {
  blocks: {
    uatp: [4, 5, 6],
    amex: [4, 6, 5],
    diners: [4, 6, 4],
    discover: [4, 4, 4, 4],
    mastercard: [4, 4, 4, 4],
    dankort: [4, 4, 4, 4],
    instapayment: [4, 4, 4, 4],
    jcb15: [4, 6, 5],
    jcb: [4, 4, 4, 4],
    maestro: [4, 4, 4, 4],
    visa: [4, 4, 4, 4],
    mir: [4, 4, 4, 4],
    unionPay: [4, 4, 4, 4],
    general: [4, 4, 4, 4]
  },
  re: {
    // starts with 1; 15 digits, not starts with 1800 (jcb card)
    uatp: /^(?!1800)1\d{0,14}/,
    // starts with 34/37; 15 digits
    amex: /^3[47]\d{0,13}/,
    // starts with 6011/65/644-649; 16 digits
    discover: /^(?:6011|65\d{0,2}|64[4-9]\d?)\d{0,12}/,
    // starts with 300-305/309 or 36/38/39; 14 digits
    diners: /^3(?:0([0-5]|9)|[689]\d?)\d{0,11}/,
    // starts with 51-55/2221–2720; 16 digits
    mastercard: /^(5[1-5]\d{0,2}|22[2-9]\d{0,1}|2[3-7]\d{0,2})\d{0,12}/,
    // starts with 5019/4175/4571; 16 digits
    dankort: /^(5019|4175|4571)\d{0,12}/,
    // starts with 637-639; 16 digits
    instapayment: /^63[7-9]\d{0,13}/,
    // starts with 2131/1800; 15 digits
    jcb15: /^(?:2131|1800)\d{0,11}/,
    // starts with 2131/1800/35; 16 digits
    jcb: /^(?:35\d{0,2})\d{0,12}/,
    // starts with 50/56-58/6304/67; 16 digits
    maestro: /^(?:5[0678]\d{0,2}|6304|67\d{0,2})\d{0,12}/,
    // starts with 22; 16 digits
    mir: /^220[0-4]\d{0,12}/,
    // starts with 4; 16 digits
    visa: /^4\d{0,15}/,
    // starts with 62/81; 16 digits
    unionPay: /^(62|81)\d{0,14}/
  },
  getStrictBlocks: function(block) {
    var total = block.reduce(function(prev, current) {
      return prev + current;
    }, 0);
    return block.concat(19 - total);
  },
  getInfo: function(value, strictMode) {
    var blocks = CreditCardDetector.blocks, re2 = CreditCardDetector.re;
    strictMode = !!strictMode;
    for (var key in re2) {
      if (re2[key].test(value)) {
        var matchedBlocks = blocks[key];
        return {
          type: key,
          blocks: strictMode ? this.getStrictBlocks(matchedBlocks) : matchedBlocks
        };
      }
    }
    return {
      type: "unknown",
      blocks: strictMode ? this.getStrictBlocks(blocks.general) : blocks.general
    };
  }
};
var CreditCardDetector_1 = CreditCardDetector;
var Util = {
  noop: function() {
  },
  strip: function(value, re2) {
    return value.replace(re2, "");
  },
  getPostDelimiter: function(value, delimiter, delimiters) {
    if (delimiters.length === 0) {
      return value.slice(-delimiter.length) === delimiter ? delimiter : "";
    }
    var matchedDelimiter = "";
    delimiters.forEach(function(current) {
      if (value.slice(-current.length) === current) {
        matchedDelimiter = current;
      }
    });
    return matchedDelimiter;
  },
  getDelimiterREByDelimiter: function(delimiter) {
    return new RegExp(delimiter.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1"), "g");
  },
  getNextCursorPosition: function(prevPos, oldValue, newValue, delimiter, delimiters) {
    if (oldValue.length === prevPos) {
      return newValue.length;
    }
    return prevPos + this.getPositionOffset(prevPos, oldValue, newValue, delimiter, delimiters);
  },
  getPositionOffset: function(prevPos, oldValue, newValue, delimiter, delimiters) {
    var oldRawValue, newRawValue, lengthOffset;
    oldRawValue = this.stripDelimiters(oldValue.slice(0, prevPos), delimiter, delimiters);
    newRawValue = this.stripDelimiters(newValue.slice(0, prevPos), delimiter, delimiters);
    lengthOffset = oldRawValue.length - newRawValue.length;
    return lengthOffset !== 0 ? lengthOffset / Math.abs(lengthOffset) : 0;
  },
  stripDelimiters: function(value, delimiter, delimiters) {
    var owner = this;
    if (delimiters.length === 0) {
      var delimiterRE = delimiter ? owner.getDelimiterREByDelimiter(delimiter) : "";
      return value.replace(delimiterRE, "");
    }
    delimiters.forEach(function(current) {
      current.split("").forEach(function(letter) {
        value = value.replace(owner.getDelimiterREByDelimiter(letter), "");
      });
    });
    return value;
  },
  headStr: function(str, length) {
    return str.slice(0, length);
  },
  getMaxLength: function(blocks) {
    return blocks.reduce(function(previous, current) {
      return previous + current;
    }, 0);
  },
  // strip prefix
  // Before type  |   After type    |     Return value
  // PEFIX-...    |   PEFIX-...     |     ''
  // PREFIX-123   |   PEFIX-123     |     123
  // PREFIX-123   |   PREFIX-23     |     23
  // PREFIX-123   |   PREFIX-1234   |     1234
  getPrefixStrippedValue: function(value, prefix, prefixLength, prevResult, delimiter, delimiters, noImmediatePrefix, tailPrefix, signBeforePrefix) {
    if (prefixLength === 0) {
      return value;
    }
    if (value === prefix && value !== "") {
      return "";
    }
    if (signBeforePrefix && value.slice(0, 1) == "-") {
      var prev = prevResult.slice(0, 1) == "-" ? prevResult.slice(1) : prevResult;
      return "-" + this.getPrefixStrippedValue(value.slice(1), prefix, prefixLength, prev, delimiter, delimiters, noImmediatePrefix, tailPrefix, signBeforePrefix);
    }
    if (prevResult.slice(0, prefixLength) !== prefix && !tailPrefix) {
      if (noImmediatePrefix && !prevResult && value) return value;
      return "";
    } else if (prevResult.slice(-prefixLength) !== prefix && tailPrefix) {
      if (noImmediatePrefix && !prevResult && value) return value;
      return "";
    }
    var prevValue = this.stripDelimiters(prevResult, delimiter, delimiters);
    if (value.slice(0, prefixLength) !== prefix && !tailPrefix) {
      return prevValue.slice(prefixLength);
    } else if (value.slice(-prefixLength) !== prefix && tailPrefix) {
      return prevValue.slice(0, -prefixLength - 1);
    }
    return tailPrefix ? value.slice(0, -prefixLength) : value.slice(prefixLength);
  },
  getFirstDiffIndex: function(prev, current) {
    var index = 0;
    while (prev.charAt(index) === current.charAt(index)) {
      if (prev.charAt(index++) === "") {
        return -1;
      }
    }
    return index;
  },
  getFormattedValue: function(value, blocks, blocksLength, delimiter, delimiters, delimiterLazyShow) {
    var result = "", multipleDelimiters = delimiters.length > 0, currentDelimiter = "";
    if (blocksLength === 0) {
      return value;
    }
    blocks.forEach(function(length, index) {
      if (value.length > 0) {
        var sub = value.slice(0, length), rest = value.slice(length);
        if (multipleDelimiters) {
          currentDelimiter = delimiters[delimiterLazyShow ? index - 1 : index] || currentDelimiter;
        } else {
          currentDelimiter = delimiter;
        }
        if (delimiterLazyShow) {
          if (index > 0) {
            result += currentDelimiter;
          }
          result += sub;
        } else {
          result += sub;
          if (sub.length === length && index < blocksLength - 1) {
            result += currentDelimiter;
          }
        }
        value = rest;
      }
    });
    return result;
  },
  // move cursor to the end
  // the first time user focuses on an input with prefix
  fixPrefixCursor: function(el, prefix, delimiter, delimiters) {
    if (!el) {
      return;
    }
    var val = el.value, appendix = delimiter || (delimiters[0] || " ");
    if (!el.setSelectionRange || !prefix || prefix.length + appendix.length <= val.length) {
      return;
    }
    var len = val.length * 2;
    setTimeout(function() {
      el.setSelectionRange(len, len);
    }, 1);
  },
  // Check if input field is fully selected
  checkFullSelection: function(value) {
    try {
      var selection = window.getSelection() || document.getSelection() || {};
      return selection.toString().length === value.length;
    } catch (ex) {
    }
    return false;
  },
  setSelection: function(element, position, doc) {
    if (element !== this.getActiveElement(doc)) {
      return;
    }
    if (element && element.value.length <= position) {
      return;
    }
    if (element.createTextRange) {
      var range = element.createTextRange();
      range.move("character", position);
      range.select();
    } else {
      try {
        element.setSelectionRange(position, position);
      } catch (e) {
        console.warn("The input element type does not support selection");
      }
    }
  },
  getActiveElement: function(parent) {
    var activeElement = parent.activeElement;
    if (activeElement && activeElement.shadowRoot) {
      return this.getActiveElement(activeElement.shadowRoot);
    }
    return activeElement;
  },
  isAndroid: function() {
    return navigator && /android/i.test(navigator.userAgent);
  },
  // On Android chrome, the keyup and keydown events
  // always return key code 229 as a composition that
  // buffers the user’s keystrokes
  // see https://github.com/nosir/cleave.js/issues/147
  isAndroidBackspaceKeydown: function(lastInputValue, currentInputValue) {
    if (!this.isAndroid() || !lastInputValue || !currentInputValue) {
      return false;
    }
    return currentInputValue === lastInputValue.slice(0, -1);
  }
};
var Util_1 = Util;
var DefaultProperties = {
  // Maybe change to object-assign
  // for now just keep it as simple
  assign: function(target, opts) {
    target = target || {};
    opts = opts || {};
    target.creditCard = !!opts.creditCard;
    target.creditCardStrictMode = !!opts.creditCardStrictMode;
    target.creditCardType = "";
    target.onCreditCardTypeChanged = opts.onCreditCardTypeChanged || function() {
    };
    target.phone = !!opts.phone;
    target.phoneRegionCode = opts.phoneRegionCode || "AU";
    target.phoneFormatter = {};
    target.time = !!opts.time;
    target.timePattern = opts.timePattern || ["h", "m", "s"];
    target.timeFormat = opts.timeFormat || "24";
    target.timeFormatter = {};
    target.date = !!opts.date;
    target.datePattern = opts.datePattern || ["d", "m", "Y"];
    target.dateMin = opts.dateMin || "";
    target.dateMax = opts.dateMax || "";
    target.dateFormatter = {};
    target.numeral = !!opts.numeral;
    target.numeralIntegerScale = opts.numeralIntegerScale > 0 ? opts.numeralIntegerScale : 0;
    target.numeralDecimalScale = opts.numeralDecimalScale >= 0 ? opts.numeralDecimalScale : 2;
    target.numeralDecimalMark = opts.numeralDecimalMark || ".";
    target.numeralThousandsGroupStyle = opts.numeralThousandsGroupStyle || "thousand";
    target.numeralPositiveOnly = !!opts.numeralPositiveOnly;
    target.stripLeadingZeroes = opts.stripLeadingZeroes !== false;
    target.signBeforePrefix = !!opts.signBeforePrefix;
    target.tailPrefix = !!opts.tailPrefix;
    target.swapHiddenInput = !!opts.swapHiddenInput;
    target.numericOnly = target.creditCard || target.date || !!opts.numericOnly;
    target.uppercase = !!opts.uppercase;
    target.lowercase = !!opts.lowercase;
    target.prefix = target.creditCard || target.date ? "" : opts.prefix || "";
    target.noImmediatePrefix = !!opts.noImmediatePrefix;
    target.prefixLength = target.prefix.length;
    target.rawValueTrimPrefix = !!opts.rawValueTrimPrefix;
    target.copyDelimiter = !!opts.copyDelimiter;
    target.initValue = opts.initValue !== void 0 && opts.initValue !== null ? opts.initValue.toString() : "";
    target.delimiter = opts.delimiter || opts.delimiter === "" ? opts.delimiter : opts.date ? "/" : opts.time ? ":" : opts.numeral ? "," : opts.phone ? " " : " ";
    target.delimiterLength = target.delimiter.length;
    target.delimiterLazyShow = !!opts.delimiterLazyShow;
    target.delimiters = opts.delimiters || [];
    target.blocks = opts.blocks || [];
    target.blocksLength = target.blocks.length;
    target.root = typeof commonjsGlobal === "object" && commonjsGlobal ? commonjsGlobal : window;
    target.document = opts.document || target.root.document;
    target.maxLength = 0;
    target.backspace = false;
    target.result = "";
    target.onValueChanged = opts.onValueChanged || function() {
    };
    return target;
  }
};
var DefaultProperties_1 = DefaultProperties;
var Cleave = function(element, opts) {
  var owner = this;
  var hasMultipleElements = false;
  if (typeof element === "string") {
    owner.element = document.querySelector(element);
    hasMultipleElements = document.querySelectorAll(element).length > 1;
  } else {
    if (typeof element.length !== "undefined" && element.length > 0) {
      owner.element = element[0];
      hasMultipleElements = element.length > 1;
    } else {
      owner.element = element;
    }
  }
  if (!owner.element) {
    throw new Error("[cleave.js] Please check the element");
  }
  if (hasMultipleElements) {
    try {
      console.warn("[cleave.js] Multiple input fields matched, cleave.js will only take the first one.");
    } catch (e) {
    }
  }
  opts.initValue = owner.element.value;
  owner.properties = Cleave.DefaultProperties.assign({}, opts);
  owner.init();
};
Cleave.prototype = {
  init: function() {
    var owner = this, pps = owner.properties;
    if (!pps.numeral && !pps.phone && !pps.creditCard && !pps.time && !pps.date && (pps.blocksLength === 0 && !pps.prefix)) {
      owner.onInput(pps.initValue);
      return;
    }
    pps.maxLength = Cleave.Util.getMaxLength(pps.blocks);
    owner.isAndroid = Cleave.Util.isAndroid();
    owner.lastInputValue = "";
    owner.isBackward = "";
    owner.onChangeListener = owner.onChange.bind(owner);
    owner.onKeyDownListener = owner.onKeyDown.bind(owner);
    owner.onFocusListener = owner.onFocus.bind(owner);
    owner.onCutListener = owner.onCut.bind(owner);
    owner.onCopyListener = owner.onCopy.bind(owner);
    owner.initSwapHiddenInput();
    owner.element.addEventListener("input", owner.onChangeListener);
    owner.element.addEventListener("keydown", owner.onKeyDownListener);
    owner.element.addEventListener("focus", owner.onFocusListener);
    owner.element.addEventListener("cut", owner.onCutListener);
    owner.element.addEventListener("copy", owner.onCopyListener);
    owner.initPhoneFormatter();
    owner.initDateFormatter();
    owner.initTimeFormatter();
    owner.initNumeralFormatter();
    if (pps.initValue || pps.prefix && !pps.noImmediatePrefix) {
      owner.onInput(pps.initValue);
    }
  },
  initSwapHiddenInput: function() {
    var owner = this, pps = owner.properties;
    if (!pps.swapHiddenInput) return;
    var inputFormatter = owner.element.cloneNode(true);
    owner.element.parentNode.insertBefore(inputFormatter, owner.element);
    owner.elementSwapHidden = owner.element;
    owner.elementSwapHidden.type = "hidden";
    owner.element = inputFormatter;
    owner.element.id = "";
  },
  initNumeralFormatter: function() {
    var owner = this, pps = owner.properties;
    if (!pps.numeral) {
      return;
    }
    pps.numeralFormatter = new Cleave.NumeralFormatter(
      pps.numeralDecimalMark,
      pps.numeralIntegerScale,
      pps.numeralDecimalScale,
      pps.numeralThousandsGroupStyle,
      pps.numeralPositiveOnly,
      pps.stripLeadingZeroes,
      pps.prefix,
      pps.signBeforePrefix,
      pps.tailPrefix,
      pps.delimiter
    );
  },
  initTimeFormatter: function() {
    var owner = this, pps = owner.properties;
    if (!pps.time) {
      return;
    }
    pps.timeFormatter = new Cleave.TimeFormatter(pps.timePattern, pps.timeFormat);
    pps.blocks = pps.timeFormatter.getBlocks();
    pps.blocksLength = pps.blocks.length;
    pps.maxLength = Cleave.Util.getMaxLength(pps.blocks);
  },
  initDateFormatter: function() {
    var owner = this, pps = owner.properties;
    if (!pps.date) {
      return;
    }
    pps.dateFormatter = new Cleave.DateFormatter(pps.datePattern, pps.dateMin, pps.dateMax);
    pps.blocks = pps.dateFormatter.getBlocks();
    pps.blocksLength = pps.blocks.length;
    pps.maxLength = Cleave.Util.getMaxLength(pps.blocks);
  },
  initPhoneFormatter: function() {
    var owner = this, pps = owner.properties;
    if (!pps.phone) {
      return;
    }
    try {
      pps.phoneFormatter = new Cleave.PhoneFormatter(
        new pps.root.Cleave.AsYouTypeFormatter(pps.phoneRegionCode),
        pps.delimiter
      );
    } catch (ex) {
      throw new Error("[cleave.js] Please include phone-type-formatter.{country}.js lib");
    }
  },
  onKeyDown: function(event) {
    var owner = this, charCode = event.which || event.keyCode;
    owner.lastInputValue = owner.element.value;
    owner.isBackward = charCode === 8;
  },
  onChange: function(event) {
    var owner = this, pps = owner.properties, Util2 = Cleave.Util;
    owner.isBackward = owner.isBackward || event.inputType === "deleteContentBackward";
    var postDelimiter = Util2.getPostDelimiter(owner.lastInputValue, pps.delimiter, pps.delimiters);
    if (owner.isBackward && postDelimiter) {
      pps.postDelimiterBackspace = postDelimiter;
    } else {
      pps.postDelimiterBackspace = false;
    }
    this.onInput(this.element.value);
  },
  onFocus: function() {
    var owner = this, pps = owner.properties;
    owner.lastInputValue = owner.element.value;
    if (pps.prefix && pps.noImmediatePrefix && !owner.element.value) {
      this.onInput(pps.prefix);
    }
    Cleave.Util.fixPrefixCursor(owner.element, pps.prefix, pps.delimiter, pps.delimiters);
  },
  onCut: function(e) {
    if (!Cleave.Util.checkFullSelection(this.element.value)) return;
    this.copyClipboardData(e);
    this.onInput("");
  },
  onCopy: function(e) {
    if (!Cleave.Util.checkFullSelection(this.element.value)) return;
    this.copyClipboardData(e);
  },
  copyClipboardData: function(e) {
    var owner = this, pps = owner.properties, Util2 = Cleave.Util, inputValue = owner.element.value, textToCopy = "";
    if (!pps.copyDelimiter) {
      textToCopy = Util2.stripDelimiters(inputValue, pps.delimiter, pps.delimiters);
    } else {
      textToCopy = inputValue;
    }
    try {
      if (e.clipboardData) {
        e.clipboardData.setData("Text", textToCopy);
      } else {
        window.clipboardData.setData("Text", textToCopy);
      }
      e.preventDefault();
    } catch (ex) {
    }
  },
  onInput: function(value) {
    var owner = this, pps = owner.properties, Util2 = Cleave.Util;
    var postDelimiterAfter = Util2.getPostDelimiter(value, pps.delimiter, pps.delimiters);
    if (!pps.numeral && pps.postDelimiterBackspace && !postDelimiterAfter) {
      value = Util2.headStr(value, value.length - pps.postDelimiterBackspace.length);
    }
    if (pps.phone) {
      if (pps.prefix && (!pps.noImmediatePrefix || value.length)) {
        pps.result = pps.prefix + pps.phoneFormatter.format(value).slice(pps.prefix.length);
      } else {
        pps.result = pps.phoneFormatter.format(value);
      }
      owner.updateValueState();
      return;
    }
    if (pps.numeral) {
      if (pps.prefix && pps.noImmediatePrefix && value.length === 0) {
        pps.result = "";
      } else {
        pps.result = pps.numeralFormatter.format(value);
      }
      owner.updateValueState();
      return;
    }
    if (pps.date) {
      value = pps.dateFormatter.getValidatedDate(value);
    }
    if (pps.time) {
      value = pps.timeFormatter.getValidatedTime(value);
    }
    value = Util2.stripDelimiters(value, pps.delimiter, pps.delimiters);
    value = Util2.getPrefixStrippedValue(value, pps.prefix, pps.prefixLength, pps.result, pps.delimiter, pps.delimiters, pps.noImmediatePrefix, pps.tailPrefix, pps.signBeforePrefix);
    value = pps.numericOnly ? Util2.strip(value, /[^\d]/g) : value;
    value = pps.uppercase ? value.toUpperCase() : value;
    value = pps.lowercase ? value.toLowerCase() : value;
    if (pps.prefix) {
      if (pps.tailPrefix) {
        value = value + pps.prefix;
      } else {
        value = pps.prefix + value;
      }
      if (pps.blocksLength === 0) {
        pps.result = value;
        owner.updateValueState();
        return;
      }
    }
    if (pps.creditCard) {
      owner.updateCreditCardPropsByValue(value);
    }
    value = Util2.headStr(value, pps.maxLength);
    pps.result = Util2.getFormattedValue(
      value,
      pps.blocks,
      pps.blocksLength,
      pps.delimiter,
      pps.delimiters,
      pps.delimiterLazyShow
    );
    owner.updateValueState();
  },
  updateCreditCardPropsByValue: function(value) {
    var owner = this, pps = owner.properties, Util2 = Cleave.Util, creditCardInfo;
    if (Util2.headStr(pps.result, 4) === Util2.headStr(value, 4)) {
      return;
    }
    creditCardInfo = Cleave.CreditCardDetector.getInfo(value, pps.creditCardStrictMode);
    pps.blocks = creditCardInfo.blocks;
    pps.blocksLength = pps.blocks.length;
    pps.maxLength = Util2.getMaxLength(pps.blocks);
    if (pps.creditCardType !== creditCardInfo.type) {
      pps.creditCardType = creditCardInfo.type;
      pps.onCreditCardTypeChanged.call(owner, pps.creditCardType);
    }
  },
  updateValueState: function() {
    var owner = this, Util2 = Cleave.Util, pps = owner.properties;
    if (!owner.element) {
      return;
    }
    var endPos = owner.element.selectionEnd;
    var oldValue = owner.element.value;
    var newValue = pps.result;
    endPos = Util2.getNextCursorPosition(endPos, oldValue, newValue, pps.delimiter, pps.delimiters);
    if (owner.isAndroid) {
      window.setTimeout(function() {
        owner.element.value = newValue;
        Util2.setSelection(owner.element, endPos, pps.document, false);
        owner.callOnValueChanged();
      }, 1);
      return;
    }
    owner.element.value = newValue;
    if (pps.swapHiddenInput) owner.elementSwapHidden.value = owner.getRawValue();
    Util2.setSelection(owner.element, endPos, pps.document, false);
    owner.callOnValueChanged();
  },
  callOnValueChanged: function() {
    var owner = this, pps = owner.properties;
    pps.onValueChanged.call(owner, {
      target: {
        name: owner.element.name,
        value: pps.result,
        rawValue: owner.getRawValue()
      }
    });
  },
  setPhoneRegionCode: function(phoneRegionCode) {
    var owner = this, pps = owner.properties;
    pps.phoneRegionCode = phoneRegionCode;
    owner.initPhoneFormatter();
    owner.onChange();
  },
  setRawValue: function(value) {
    var owner = this, pps = owner.properties;
    value = value !== void 0 && value !== null ? value.toString() : "";
    if (pps.numeral) {
      value = value.replace(".", pps.numeralDecimalMark);
    }
    pps.postDelimiterBackspace = false;
    owner.element.value = value;
    owner.onInput(value);
  },
  getRawValue: function() {
    var owner = this, pps = owner.properties, Util2 = Cleave.Util, rawValue = owner.element.value;
    if (pps.rawValueTrimPrefix) {
      rawValue = Util2.getPrefixStrippedValue(rawValue, pps.prefix, pps.prefixLength, pps.result, pps.delimiter, pps.delimiters, pps.noImmediatePrefix, pps.tailPrefix, pps.signBeforePrefix);
    }
    if (pps.numeral) {
      rawValue = pps.numeralFormatter.getRawValue(rawValue);
    } else {
      rawValue = Util2.stripDelimiters(rawValue, pps.delimiter, pps.delimiters);
    }
    return rawValue;
  },
  getISOFormatDate: function() {
    var owner = this, pps = owner.properties;
    return pps.date ? pps.dateFormatter.getISOFormatDate() : "";
  },
  getISOFormatTime: function() {
    var owner = this, pps = owner.properties;
    return pps.time ? pps.timeFormatter.getISOFormatTime() : "";
  },
  getFormattedValue: function() {
    return this.element.value;
  },
  destroy: function() {
    var owner = this;
    owner.element.removeEventListener("input", owner.onChangeListener);
    owner.element.removeEventListener("keydown", owner.onKeyDownListener);
    owner.element.removeEventListener("focus", owner.onFocusListener);
    owner.element.removeEventListener("cut", owner.onCutListener);
    owner.element.removeEventListener("copy", owner.onCopyListener);
  },
  toString: function() {
    return "[Cleave Object]";
  }
};
Cleave.NumeralFormatter = NumeralFormatter_1;
Cleave.DateFormatter = DateFormatter_1;
Cleave.TimeFormatter = TimeFormatter_1;
Cleave.PhoneFormatter = PhoneFormatter_1;
Cleave.CreditCardDetector = CreditCardDetector_1;
Cleave.Util = Util_1;
Cleave.DefaultProperties = DefaultProperties_1;
(typeof commonjsGlobal === "object" && commonjsGlobal ? commonjsGlobal : window)["Cleave"] = Cleave;
var Cleave_1 = Cleave;
var cleave_esm_default = Cleave_1;

// js/common/form/date-input.js
var _inputName, _input;
var DateInput = class extends HTMLElement {
  constructor() {
    var _a;
    super();
    __privateAdd(this, _inputName);
    __privateAdd(this, _input);
    __privateSet(this, _input, this.querySelector("input"));
    __privateSet(this, _inputName, (_a = __privateGet(this, _input)) == null ? void 0 : _a.getAttribute("name"));
    setTimeout(() => {
      let cleave = new cleave_esm_default(`[name="${__privateGet(this, _inputName)}"]`, {
        date: true,
        dateMin: "1900-01-01",
        dateMax: window.themeVariables.settings.today,
        datePattern: ["d", "m", "Y"]
      });
    }, 1e3);
  }
};
_inputName = new WeakMap();
_input = new WeakMap();
if (!window.customElements.get("date-input")) {
  window.customElements.define("date-input", DateInput);
}

// js/common/form/quantity-selector.js
var _abortController7, _decreaseButton, _increaseButton, _quantityInputElement, _QuantitySelector_instances, onDecreaseQuantity_fn, onIncreaseQuantity_fn, onVariantChangedListener_fn2, updateUI_fn;
var QuantitySelector = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _QuantitySelector_instances);
    __privateAdd(this, _abortController7);
    __privateAdd(this, _decreaseButton);
    __privateAdd(this, _increaseButton);
    __privateAdd(this, _quantityInputElement);
  }
  connectedCallback() {
    var _a, _b, _c;
    __privateSet(this, _abortController7, new AbortController());
    __privateSet(this, _decreaseButton, this.querySelector("button:first-of-type"));
    __privateSet(this, _increaseButton, this.querySelector("button:last-of-type"));
    __privateSet(this, _quantityInputElement, this.querySelector("quantity-input"));
    (_a = __privateGet(this, _decreaseButton)) == null ? void 0 : _a.addEventListener("click", __privateMethod(this, _QuantitySelector_instances, onDecreaseQuantity_fn).bind(this), { signal: __privateGet(this, _abortController7).signal });
    (_b = __privateGet(this, _increaseButton)) == null ? void 0 : _b.addEventListener("click", __privateMethod(this, _QuantitySelector_instances, onIncreaseQuantity_fn).bind(this), { signal: __privateGet(this, _abortController7).signal });
    (_c = document.forms[this.getAttribute("form")]) == null ? void 0 : _c.addEventListener("variant:change", __privateMethod(this, _QuantitySelector_instances, onVariantChangedListener_fn2).bind(this), { signal: __privateGet(this, _abortController7).signal });
  }
  disconnectedCallback() {
    __privateGet(this, _abortController7).abort();
  }
};
_abortController7 = new WeakMap();
_decreaseButton = new WeakMap();
_increaseButton = new WeakMap();
_quantityInputElement = new WeakMap();
_QuantitySelector_instances = new WeakSet();
onDecreaseQuantity_fn = function() {
  __privateGet(this, _quantityInputElement).stepDown();
  __privateMethod(this, _QuantitySelector_instances, updateUI_fn).call(this);
};
onIncreaseQuantity_fn = function() {
  __privateGet(this, _quantityInputElement).stepUp();
  __privateMethod(this, _QuantitySelector_instances, updateUI_fn).call(this);
};
onVariantChangedListener_fn2 = function(event) {
  __privateGet(this, _quantityInputElement).updateVariantRule(event.detail.variant);
};
updateUI_fn = function() {
  __privateGet(this, _decreaseButton).disabled = __privateGet(this, _quantityInputElement).quantity <= 1;
};
var _QuantityInput_instances, inputElement_get, onValueInput_fn;
var QuantityInput = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _QuantityInput_instances);
    __privateGet(this, _QuantityInput_instances, inputElement_get).addEventListener("input", __privateMethod(this, _QuantityInput_instances, onValueInput_fn).bind(this));
  }
  connectedCallback() {
  }
  get quantity() {
    return parseInt(__privateGet(this, _QuantityInput_instances, inputElement_get).value);
  }
  updateVariantRule(variant) {
  }
  stepDown() {
    __privateGet(this, _QuantityInput_instances, inputElement_get).stepDown();
  }
  stepUp() {
    __privateGet(this, _QuantityInput_instances, inputElement_get).stepUp();
  }
};
_QuantityInput_instances = new WeakSet();
inputElement_get = function() {
  return this.firstElementChild;
};
onValueInput_fn = function() {
  if (__privateGet(this, _QuantityInput_instances, inputElement_get).value === "") {
    __privateGet(this, _QuantityInput_instances, inputElement_get).value = __privateGet(this, _QuantityInput_instances, inputElement_get).min || 1;
  }
};
if (!window.customElements.get("quantity-selector")) {
  window.customElements.define("quantity-selector", QuantitySelector);
}
if (!window.customElements.get("quantity-input")) {
  window.customElements.define("quantity-input", QuantityInput);
}

// js/common/list/listbox.js
var _accessibilityInitialized, _hiddenInput, _Listbox_instances, setupAccessibility_fn, onOptionClicked_fn, onInputChanged_fn, onKeyDown_fn;
var Listbox = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _Listbox_instances);
    __privateAdd(this, _accessibilityInitialized, false);
    __privateAdd(this, _hiddenInput);
    this.addEventListener("keydown", __privateMethod(this, _Listbox_instances, onKeyDown_fn));
  }
  static get observedAttributes() {
    return ["aria-activedescendant"];
  }
  connectedCallback() {
    var _a;
    __privateSet(this, _hiddenInput, this.querySelector('input[type="hidden"]'));
    (_a = __privateGet(this, _hiddenInput)) == null ? void 0 : _a.addEventListener("change", __privateMethod(this, _Listbox_instances, onInputChanged_fn).bind(this));
    if (!__privateGet(this, _accessibilityInitialized)) {
      requestAnimationFrame(__privateMethod(this, _Listbox_instances, setupAccessibility_fn).bind(this));
    }
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "aria-activedescendant" && oldValue !== null && newValue !== oldValue) {
      Array.from(this.querySelectorAll('[role="option"]')).forEach((option) => {
        if (option.id === newValue) {
          option.setAttribute("aria-selected", "true");
          if (__privateGet(this, _hiddenInput) && __privateGet(this, _hiddenInput).value !== option.value) {
            __privateGet(this, _hiddenInput).value = option.value;
            __privateGet(this, _hiddenInput).dispatchEvent(new Event("change", { bubbles: true }));
          }
          if (this.hasAttribute("aria-owns")) {
            this.getAttribute("aria-owns").split(" ").forEach((boundId) => {
              document.getElementById(boundId).textContent = option.getAttribute("title") || option.innerText || option.value;
            });
          }
          option.dispatchEvent(new CustomEvent("listbox:change", {
            bubbles: true,
            detail: {
              value: option.value
            }
          }));
        } else {
          option.setAttribute("aria-selected", "false");
        }
      });
    }
  }
};
_accessibilityInitialized = new WeakMap();
_hiddenInput = new WeakMap();
_Listbox_instances = new WeakSet();
setupAccessibility_fn = function() {
  this.setAttribute("role", "listbox");
  Array.from(this.querySelectorAll('[role="option"]')).forEach((option) => {
    option.addEventListener("click", __privateMethod(this, _Listbox_instances, onOptionClicked_fn).bind(this));
    option.id = "option-" + (crypto.randomUUID ? crypto.randomUUID() : Math.floor(Math.random() * 1e4));
    if (option.getAttribute("aria-selected") === "true") {
      this.setAttribute("aria-activedescendant", option.id);
    }
  });
  __privateSet(this, _accessibilityInitialized, true);
};
onOptionClicked_fn = function(event) {
  if (event.currentTarget.getAttribute("type") === "submit") {
    return;
  }
  this.setAttribute("aria-activedescendant", event.currentTarget.id);
  event.currentTarget.dispatchEvent(new CustomEvent("listbox:select", {
    bubbles: true,
    detail: {
      value: event.currentTarget.value
    }
  }));
};
onInputChanged_fn = function(event) {
  this.setAttribute("aria-activedescendant", this.querySelector(`[role="option"][value="${CSS.escape(event.target.value)}"]`).id);
};
onKeyDown_fn = function(event) {
  var _a, _b;
  if (event.key === "ArrowUp") {
    (_a = event.target.previousElementSibling) == null ? void 0 : _a.focus();
    event.preventDefault();
  } else if (event.key === "ArrowDown") {
    (_b = event.target.nextElementSibling) == null ? void 0 : _b.focus();
    event.preventDefault();
  }
};
if (!window.customElements.get("x-listbox")) {
  window.customElements.define("x-listbox", Listbox);
}

// js/common/product/dimension-converter.js
var DimensionConverter = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __publicField(this, "allButtons");
    __publicField(this, "allValuesElements");
    __publicField(this, "allUnitElements");
  }
  connectedCallback() {
    this.allButtons = this.querySelectorAll("[data-convert]");
    this.allValuesElements = this.querySelectorAll("[data-value]");
    this.allUnitElements = this.querySelectorAll("[data-unit]");
    this.switchElements = this.querySelectorAll(".switch-values");
    Array.from(this.allButtons).forEach((button) => {
      button.addEventListener("click", this.convertValues.bind(this));
    });
    const defaultButton = Array.from(this.allButtons).find((btn) => btn.getAttribute("aria-selected") === "true");
    if (defaultButton) {
      this.convertValues({ target: defaultButton });
    }
  }
  convertValues(event) {
    let selectedUnit = event.target.getAttribute("data-convert");
    Array.from(this.allValuesElements).forEach((item) => {
      let defaultValue = parseFloat(item.getAttribute("data-value"));
      item.innerHTML = selectedUnit === "cm" ? defaultValue : (defaultValue * 0.393701).toFixed(1);
    });
    Array.from(this.allUnitElements).forEach((item) => {
      item.innerHTML = selectedUnit;
    });
    Array.from(this.allButtons).forEach((item) => {
      item.setAttribute("aria-selected", item.getAttribute("data-convert") === selectedUnit ? "true" : "false");
    });
    Array.from(this.switchElements).forEach((el) => {
      el.setAttribute("initial-item", `${selectedUnit === "cm"}`);
    });
    this.setSwitchItemWidth(event.target);
  }
  setSwitchItemWidth(item) {
    item.style.setProperty("--switch-item-width", `${item.clientWidth}px`);
  }
};
if (!window.customElements.get("dimension-converter")) {
  window.customElements.define("dimension-converter", DimensionConverter);
}

// js/common/product/gift-card-custom-select.js
var _GiftCardCustomSelect_instances, onVariantChange_fn;
var GiftCardCustomSelect = class extends Popover {
  constructor() {
    super();
    __privateAdd(this, _GiftCardCustomSelect_instances);
    this.addEventListener("listbox:change", __privateMethod(this, _GiftCardCustomSelect_instances, onVariantChange_fn).bind(this));
  }
};
_GiftCardCustomSelect_instances = new WeakSet();
onVariantChange_fn = function(event) {
  this.controls.forEach((el) => {
    el.querySelector("[custom-select-value]").innerHTML = event.detail.value;
  });
};
if (!window.customElements.get("gift-card-custom-select")) {
  window.customElements.define("gift-card-custom-select", GiftCardCustomSelect);
}

// js/common/product/material-focus-image.js
var MaterialFocusImage = class extends HTMLElement {
  constructor() {
    super();
    let imageWithZeroHeightFound = false;
    const images = Array.from(this.querySelectorAll("img"));
    images.forEach((img) => {
      if (img.naturalHeight === 0) {
        imageWithZeroHeightFound = true;
      }
    });
    if (imageWithZeroHeightFound) {
      images.forEach((img) => {
        img.style.display = "none";
        img.style.opacity = "0";
      });
      Array.from(this.querySelectorAll("svg")).forEach((svg) => {
        svg.style.display = "block";
      });
    } else {
      images.forEach((img) => {
        img.style.display = "block";
        img.style.opacity = "1";
      });
      Array.from(this.querySelectorAll("svg")).forEach((svg) => {
        svg.style.display = "none";
      });
    }
  }
};
if (!window.customElements.get("material-focus-image")) {
  window.customElements.define("material-focus-image", MaterialFocusImage);
}

// js/common/product/product-back-in-stock.js
var _listenersAbortController2, _drawer, _form, _formId, _variantIdInput, _emailInput, _submitButton, _initialElements, _successElements, _errorElements, _ProductBackInStock_instances, onFormSubmitted_fn2, onVariantChangedListener_fn3, onDrawerClose_fn, onEmailInputChanged_fn;
var ProductBackInStock = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _ProductBackInStock_instances);
    __privateAdd(this, _listenersAbortController2);
    __privateAdd(this, _drawer);
    __privateAdd(this, _form);
    __privateAdd(this, _formId);
    __privateAdd(this, _variantIdInput);
    __privateAdd(this, _emailInput);
    __privateAdd(this, _submitButton);
    __privateAdd(this, _initialElements);
    __privateAdd(this, _successElements);
    __privateAdd(this, _errorElements);
    __privateSet(this, _drawer, this.closest(".drawer"));
    __privateSet(this, _form, this.firstElementChild);
    __privateSet(this, _formId, this.querySelector('input[type="hidden"][form]'));
    __privateSet(this, _variantIdInput, this.querySelector('[name="variant_id"]'));
    __privateSet(this, _emailInput, this.querySelector('[name="email"]'));
    __privateSet(this, _submitButton, this.querySelector('[type="submit"]'));
    const initialAvailable = __privateGet(this, _variantIdInput).dataset.available !== "false";
    __privateGet(this, _submitButton).disabled = initialAvailable;
    __privateGet(this, _submitButton).setAttribute("aria-disabled", String(initialAvailable));
    __privateSet(this, _initialElements, Array.from(__privateGet(this, _drawer).querySelectorAll('[data-step="initial"]')));
    __privateSet(this, _successElements, Array.from(__privateGet(this, _drawer).querySelectorAll('[data-step="success"]')));
    __privateSet(this, _errorElements, Array.from(__privateGet(this, _drawer).querySelectorAll('[data-step="error"]')));
    this.addEventListener("submit", __privateMethod(this, _ProductBackInStock_instances, onFormSubmitted_fn2));
    __privateGet(this, _drawer).addEventListener("dialog:force-close", __privateMethod(this, _ProductBackInStock_instances, onDrawerClose_fn).bind(this));
    __privateGet(this, _emailInput).addEventListener("input", __privateMethod(this, _ProductBackInStock_instances, onEmailInputChanged_fn).bind(this));
  }
  connectedCallback() {
    var _a;
    __privateSet(this, _listenersAbortController2, new AbortController());
    (_a = document.forms[__privateGet(this, _formId).getAttribute("form")]) == null ? void 0 : _a.addEventListener("variant:change", __privateMethod(this, _ProductBackInStock_instances, onVariantChangedListener_fn3).bind(this), { signal: __privateGet(this, _listenersAbortController2).signal });
  }
  disconnectedCallback() {
    __privateGet(this, _listenersAbortController2).abort();
  }
};
_listenersAbortController2 = new WeakMap();
_drawer = new WeakMap();
_form = new WeakMap();
_formId = new WeakMap();
_variantIdInput = new WeakMap();
_emailInput = new WeakMap();
_submitButton = new WeakMap();
_initialElements = new WeakMap();
_successElements = new WeakMap();
_errorElements = new WeakMap();
_ProductBackInStock_instances = new WeakSet();
onFormSubmitted_fn2 = function(event) {
  event.preventDefault();
  let submitButton = event.submitter;
  submitButton.setAttribute("aria-busy", "true");
  let that = this;
  const formData = new FormData(__privateGet(this, _form));
  BIS.create(formData.get("email"), formData.get("variant_id"), formData.get("product_id")).then(function(resp) {
    if (resp.status === "OK") {
      __privateGet(that, _initialElements).forEach((el) => el.classList.add("hidden"));
      __privateGet(that, _successElements).forEach((el) => el.classList.remove("hidden"));
    } else if (resp.status === "Error") {
      __privateGet(that, _emailInput).classList.add("error");
      __privateGet(that, _errorElements).forEach((el) => el.classList.remove("hidden"));
    }
    submitButton.removeAttribute("aria-busy");
  });
};
onVariantChangedListener_fn3 = function(event) {
  const variant = event.detail.variant;
  __privateGet(this, _variantIdInput).value = variant.id;
  __privateGet(this, _submitButton).disabled = variant.available;
  __privateGet(this, _submitButton).setAttribute("aria-disabled", String(variant.available));
};
onDrawerClose_fn = function() {
  __privateGet(this, _initialElements).forEach((el) => el.classList.remove("hidden"));
  __privateGet(this, _successElements).forEach((el) => el.classList.add("hidden"));
  __privateGet(this, _errorElements).forEach((el) => el.classList.add("hidden"));
  __privateGet(this, _emailInput).classList.remove("error");
  __privateGet(this, _emailInput).value = "";
};
onEmailInputChanged_fn = function(event) {
  if (event.target.value === "") {
    __privateGet(this, _errorElements).forEach((el) => el.classList.add("hidden"));
    __privateGet(this, _emailInput).classList.remove("error");
  }
};
if (!window.customElements.get("product-back-in-stock")) {
  window.customElements.define("product-back-in-stock", ProductBackInStock);
}

// js/common/product/product-card.js
var ProductCard = class extends HTMLElement {
  constructor() {
    super();
    if (this.hasAttribute("show-swatches")) {
      this.addEventListener("product-card:infos", this.setProductColors.bind(this));
    }
    if (this.hasAttribute("show-form")) {
      this.addEventListener("product-card:infos", this.setVariantId.bind(this));
    }
  }
  setProductColors(event) {
    if (this.querySelector(".color-list")) {
      this.querySelector(".color-list").innerHTML = event.detail.colorListHTML;
    }
  }
  setVariantId(event) {
    if (event.detail.variantId) {
      const productForm = this.querySelector(".product-card__form");
      const productSku = this.getAttribute("sku");
      if (productForm && productSku) {
        let currentVariantId = event.detail.variantId.filter((el) => el.includes(productSku));
        if (currentVariantId.length === 1) {
          productForm.querySelector('input[name="id"]').value = currentVariantId[0].split(":")[1];
          productForm.style.display = "block";
        }
      }
    }
  }
};
if (!window.customElements.get("product-card")) {
  window.customElements.define("product-card", ProductCard);
}

// js/common/product/product-form.js
var _ProductForm_instances, onSubmit_fn;
var ProductForm = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _ProductForm_instances);
    this.addEventListener("submit", __privateMethod(this, _ProductForm_instances, onSubmit_fn), { capture: true });
  }
  connectedCallback() {
    if (this.form) {
      this.form.id.disabled = false;
    }
  }
  get form() {
    return this.firstElementChild;
  }
};
_ProductForm_instances = new WeakSet();
onSubmit_fn = async function(event) {
  event.preventDefault();
  if (!this.form.checkValidity()) {
    this.form.reportValidity();
    return;
  }
  const submitButtons = Array.from(this.form.elements).filter((button) => button.type === "submit");
  submitButtons.forEach((submitButton) => {
    submitButton.setAttribute("disabled", "disabled");
    submitButton.setAttribute("aria-busy", "true");
  });
  let sectionsToBundle = [];
  document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
  const formData = new FormData(this.form);
  formData.set("sections", sectionsToBundle.join(","));
  formData.set("sections_url", `${Shopify.routes.root}variants/${this.form.id.value}`);
  const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
    body: formData,
    method: "POST",
    headers: {
      "X-Requested-With": "XMLHttpRequest"
      // Needed for Shopify to check inventory
    }
  });
  submitButtons.forEach((submitButton) => {
    submitButton.removeAttribute("disabled");
    submitButton.removeAttribute("aria-busy");
  });
  const responseJson = await response.json();
  if (response.ok) {
    if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
      return window.location.href = `${Shopify.routes.root}cart`;
    }
    const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    cartContent["sections"] = responseJson["sections"];
    this.dispatchEvent(new CustomEvent("variant:add", {
      bubbles: true,
      detail: {
        items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
        cart: cartContent
      }
    }));
    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
      bubbles: true,
      detail: {
        baseEvent: "variant:add",
        cart: cartContent
      }
    }));
  } else {
    this.dispatchEvent(new CustomEvent("cart:error", {
      bubbles: true,
      detail: {
        error: responseJson["description"]
      }
    }));
  }
};
if (!window.customElements.get("product-form")) {
  window.customElements.define("product-form", ProductForm);
}

// js/common/product/product-form-listeners.js
var _onVariantChangedListener, _onCartErrorListener, _BuyButtons_instances, onVariantChanged_fn, onCartError_fn;
var BuyButtons = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _BuyButtons_instances);
    __privateAdd(this, _onVariantChangedListener, __privateMethod(this, _BuyButtons_instances, onVariantChanged_fn).bind(this));
    __privateAdd(this, _onCartErrorListener, __privateMethod(this, _BuyButtons_instances, onCartError_fn).bind(this));
  }
  connectedCallback() {
    var _a, _b;
    (_a = document.forms[this.getAttribute("form")]) == null ? void 0 : _a.addEventListener("variant:change", __privateGet(this, _onVariantChangedListener));
    (_b = document.forms[this.getAttribute("form")]) == null ? void 0 : _b.addEventListener("cart:error", __privateGet(this, _onCartErrorListener));
  }
  disconnectedCallback() {
    var _a, _b;
    (_a = document.forms[this.getAttribute("form")]) == null ? void 0 : _a.removeEventListener("variant:change", __privateGet(this, _onVariantChangedListener));
    (_b = document.forms[this.getAttribute("form")]) == null ? void 0 : _b.removeEventListener("cart:error", __privateGet(this, _onCartErrorListener));
  }
};
_onVariantChangedListener = new WeakMap();
_onCartErrorListener = new WeakMap();
_BuyButtons_instances = new WeakSet();
onVariantChanged_fn = function(event) {
  const addToCartButton = this.querySelector('button[type="submit"]');
  if (!event.detail.variant) {
  } else {
    if (!event.detail.variant["available"]) {
    }
  }
  const showWhenUnavailable = Array.from(document.querySelectorAll("[show-when-unavailable]"));
  const showWhenAvailable = Array.from(document.querySelectorAll("[show-when-available]"));
  if (!event.detail.variant["available"]) {
    showWhenUnavailable.forEach((item) => item.removeAttribute("hidden"));
    showWhenAvailable.forEach((item) => item.setAttribute("hidden", ""));
  } else {
    showWhenUnavailable.forEach((item) => item.setAttribute("hidden", ""));
    showWhenAvailable.forEach((item) => item.removeAttribute("hidden"));
  }
};
onCartError_fn = function(event) {
  const bannerElement = document.createRange().createContextualFragment(`
      <div class="banner banner--error" role="alert">
        ${event.detail.error}
      </div>
    `).firstElementChild;
  this.prepend(bannerElement);
  setTimeout(() => {
    bannerElement.remove();
  }, 2500);
};
if (!window.customElements.get("buy-buttons")) {
  window.customElements.define("buy-buttons", BuyButtons);
}
var _onVariantChangedListener2, _sizesAttribute, _classAttribute, _VariantMedia_instances, widths_get, onVariantChanged_fn2;
var VariantMedia = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _VariantMedia_instances);
    __privateAdd(this, _onVariantChangedListener2, __privateMethod(this, _VariantMedia_instances, onVariantChanged_fn2).bind(this));
    __privateAdd(this, _sizesAttribute);
    __privateAdd(this, _classAttribute);
  }
  connectedCallback() {
    var _a;
    __privateSet(this, _sizesAttribute, this.querySelector("img").sizes);
    __privateSet(this, _classAttribute, this.querySelector("img").className);
    (_a = document.forms[this.getAttribute("form")]) == null ? void 0 : _a.addEventListener("variant:change", __privateGet(this, _onVariantChangedListener2));
  }
  disconnectedCallback() {
    var _a;
    (_a = document.forms[this.getAttribute("form")]) == null ? void 0 : _a.removeEventListener("variant:change", __privateGet(this, _onVariantChangedListener2));
  }
};
_onVariantChangedListener2 = new WeakMap();
_sizesAttribute = new WeakMap();
_classAttribute = new WeakMap();
_VariantMedia_instances = new WeakSet();
widths_get = function() {
  return this.getAttribute("widths").split(",").map((width) => parseInt(width));
};
onVariantChanged_fn2 = function(event) {
  if (!event.detail.variant || !event.detail.variant["featured_media"]) {
    return;
  }
  this.replaceChildren(createMediaImg(event.detail.variant["featured_media"], __privateGet(this, _VariantMedia_instances, widths_get), { "class": __privateGet(this, _classAttribute), "sizes": __privateGet(this, _sizesAttribute) }));
};
if (!window.customElements.get("variant-media")) {
  window.customElements.define("variant-media", VariantMedia);
}
var _onVariantChangedListener3, _PaymentTerms_instances, onVariantChanged_fn3;
var PaymentTerms = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _PaymentTerms_instances);
    __privateAdd(this, _onVariantChangedListener3, __privateMethod(this, _PaymentTerms_instances, onVariantChanged_fn3).bind(this));
  }
  connectedCallback() {
    var _a;
    (_a = document.forms[this.getAttribute("form")]) == null ? void 0 : _a.addEventListener("variant:change", __privateGet(this, _onVariantChangedListener3));
  }
  disconnectedCallback() {
    var _a;
    (_a = document.forms[this.getAttribute("form")]) == null ? void 0 : _a.removeEventListener("variant:change", __privateGet(this, _onVariantChangedListener3));
  }
};
_onVariantChangedListener3 = new WeakMap();
_PaymentTerms_instances = new WeakSet();
onVariantChanged_fn3 = function(event) {
  if (event.detail.variant) {
    const element = this.querySelector('[name="id"]');
    element.value = event.detail.variant["id"];
    element.dispatchEvent(new Event("change", { bubbles: true }));
  }
};
if (!window.customElements.get("payment-terms")) {
  window.customElements.define("payment-terms", PaymentTerms);
}
var _onVariantChangedListener4, _PickupAvailability_instances, onVariantChanged_fn4;
var PickupAvailability = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _PickupAvailability_instances);
    __privateAdd(this, _onVariantChangedListener4, __privateMethod(this, _PickupAvailability_instances, onVariantChanged_fn4).bind(this));
  }
  connectedCallback() {
    var _a;
    (_a = document.forms[this.getAttribute("form")]) == null ? void 0 : _a.addEventListener("variant:change", __privateGet(this, _onVariantChangedListener4));
  }
  disconnectedCallback() {
    var _a;
    (_a = document.forms[this.getAttribute("form")]) == null ? void 0 : _a.removeEventListener("variant:change", __privateGet(this, _onVariantChangedListener4));
  }
};
_onVariantChangedListener4 = new WeakMap();
_PickupAvailability_instances = new WeakSet();
onVariantChanged_fn4 = async function(event) {
  if (!event.detail.variant) {
    this.innerHTML = "";
  } else {
    const element = document.createElement("div");
    element.innerHTML = await (await fetch(`${Shopify.routes.root}variants/${event.detail.variant["id"]}?section_id=pickup-availability`)).text();
    this.replaceChildren(...element.querySelector("pickup-availability").childNodes);
  }
};
if (!window.customElements.get("pickup-availability")) {
  window.customElements.define("pickup-availability", PickupAvailability);
}
var currencyFormat = window.themeVariables.settings.moneyFormat;
var _onVariantChangedListener5, _SalePrice_instances, onVariantChanged_fn5;
var SalePrice = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _SalePrice_instances);
    __privateAdd(this, _onVariantChangedListener5, __privateMethod(this, _SalePrice_instances, onVariantChanged_fn5).bind(this));
  }
  connectedCallback() {
    var _a;
    (_a = document.forms[this.getAttribute("form")]) == null ? void 0 : _a.addEventListener("variant:change", __privateGet(this, _onVariantChangedListener5));
  }
  disconnectedCallback() {
    var _a;
    (_a = document.forms[this.getAttribute("form")]) == null ? void 0 : _a.removeEventListener("variant:change", __privateGet(this, _onVariantChangedListener5));
  }
};
_onVariantChangedListener5 = new WeakMap();
_SalePrice_instances = new WeakSet();
onVariantChanged_fn5 = function(event) {
  const variant = event.detail.variant;
  this.lastChild.replaceWith(document.createRange().createContextualFragment(formatMoney(variant["price"], currencyFormat)));
  this.classList.toggle("text-on-sale", variant["compare_at_price"] > variant["price"]);
};
var _onVariantChangedListener6, _CompareAtPrice_instances, onVariantChanged_fn6;
var CompareAtPrice = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _CompareAtPrice_instances);
    __privateAdd(this, _onVariantChangedListener6, __privateMethod(this, _CompareAtPrice_instances, onVariantChanged_fn6).bind(this));
  }
  connectedCallback() {
    var _a;
    (_a = document.forms[this.getAttribute("form")]) == null ? void 0 : _a.addEventListener("variant:change", __privateGet(this, _onVariantChangedListener6));
  }
  disconnectedCallback() {
    var _a;
    (_a = document.forms[this.getAttribute("form")]) == null ? void 0 : _a.removeEventListener("variant:change", __privateGet(this, _onVariantChangedListener6));
  }
};
_onVariantChangedListener6 = new WeakMap();
_CompareAtPrice_instances = new WeakSet();
onVariantChanged_fn6 = function(event) {
  const variant = event.detail.variant;
  this.lastChild.replaceWith(document.createRange().createContextualFragment(formatMoney(variant["compare_at_price"], currencyFormat)));
  this.hidden = !(variant["compare_at_price"] > variant["price"]);
};
var _onVariantChangedListener7, _UnitPrice_instances, onVariantChanged_fn7;
var UnitPrice = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _UnitPrice_instances);
    __privateAdd(this, _onVariantChangedListener7, __privateMethod(this, _UnitPrice_instances, onVariantChanged_fn7).bind(this));
  }
  connectedCallback() {
    var _a;
    (_a = document.forms[this.getAttribute("form")]) == null ? void 0 : _a.addEventListener("variant:change", __privateGet(this, _onVariantChangedListener7));
  }
  disconnectedCallback() {
    var _a;
    (_a = document.forms[this.getAttribute("form")]) == null ? void 0 : _a.removeEventListener("variant:change", __privateGet(this, _onVariantChangedListener7));
  }
};
_onVariantChangedListener7 = new WeakMap();
_UnitPrice_instances = new WeakSet();
onVariantChanged_fn7 = function(event) {
  const variant = event.detail.variant;
  if (!variant["unit_price"]) {
    return this.hidden = true;
  }
  const referenceValue = variant["unit_price_measurement"]["reference_value"] !== 1 ? variant["unit_price_measurement"]["reference_value"] : "";
  const node = document.createRange().createContextualFragment(
    `${formatMoney(variant["unit_price"])}/${referenceValue}${variant["unit_price_measurement"]["reference_unit"]}`
  );
  this.lastChild.replaceWith(node);
  this.hidden = false;
};
if (!window.customElements.get("sale-price")) {
  window.customElements.define("sale-price", SalePrice);
}
if (!window.customElements.get("compare-at-price")) {
  window.customElements.define("compare-at-price", CompareAtPrice);
}
if (!window.customElements.get("unit-price")) {
  window.customElements.define("unit-price", UnitPrice);
}
var _onVariantChangedListener8, _SoldOutBadge_instances, onVariantChanged_fn8;
var SoldOutBadge = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _SoldOutBadge_instances);
    __privateAdd(this, _onVariantChangedListener8, __privateMethod(this, _SoldOutBadge_instances, onVariantChanged_fn8).bind(this));
  }
  connectedCallback() {
    var _a;
    (_a = document.forms[this.getAttribute("form")]) == null ? void 0 : _a.addEventListener("variant:change", __privateGet(this, _onVariantChangedListener8));
  }
  disconnectedCallback() {
    var _a;
    (_a = document.forms[this.getAttribute("form")]) == null ? void 0 : _a.removeEventListener("variant:change", __privateGet(this, _onVariantChangedListener8));
  }
};
_onVariantChangedListener8 = new WeakMap();
_SoldOutBadge_instances = new WeakSet();
onVariantChanged_fn8 = function(event) {
  this.hidden = event.detail.variant["available"];
};
var _onVariantChangedListener9, _OnSaleBadge_instances, onVariantChanged_fn9;
var OnSaleBadge = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _OnSaleBadge_instances);
    __privateAdd(this, _onVariantChangedListener9, __privateMethod(this, _OnSaleBadge_instances, onVariantChanged_fn9).bind(this));
  }
  connectedCallback() {
    var _a;
    (_a = document.forms[this.getAttribute("form")]) == null ? void 0 : _a.addEventListener("variant:change", __privateGet(this, _onVariantChangedListener9));
  }
  disconnectedCallback() {
    var _a;
    (_a = document.forms[this.getAttribute("form")]) == null ? void 0 : _a.removeEventListener("variant:change", __privateGet(this, _onVariantChangedListener9));
  }
};
_onVariantChangedListener9 = new WeakMap();
_OnSaleBadge_instances = new WeakSet();
onVariantChanged_fn9 = function(event) {
  const variant = event.detail.variant;
  if (variant["compare_at_price"] > variant["price"]) {
    this.hidden = false;
    if (this.hasAttribute("discount-mode")) {
      const savings = this.getAttribute("discount-mode") === "percentage" ? `${Math.round((variant["compare_at_price"] - variant["price"]) * 100 / variant["compare_at_price"])}%` : formatMoney(variant["compare_at_price"] - variant["price"]);
      this.innerHTML = `${window.themeVariables.strings.discountBadge.replace("@@", savings)}`;
    }
  } else {
    this.hidden = true;
  }
};
var _BadgeList_instances, onBadgeChange_fn;
var BadgeList = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _BadgeList_instances);
    const mutationObserver = new MutationObserver(__privateMethod(this, _BadgeList_instances, onBadgeChange_fn).bind(this));
    Array.from(this.children).forEach((badge) => {
      mutationObserver.observe(badge, { attributes: true, attributeFilter: ["hidden"] });
    });
  }
};
_BadgeList_instances = new WeakSet();
onBadgeChange_fn = function() {
  this.hidden = Array.from(this.children).every((badge) => badge.hasAttribute("hidden"));
};
if (!window.customElements.get("sold-out-badge")) {
  window.customElements.define("sold-out-badge", SoldOutBadge);
}
if (!window.customElements.get("on-sale-badge")) {
  window.customElements.define("on-sale-badge", OnSaleBadge);
}
if (!window.customElements.get("badge-list")) {
  window.customElements.define("badge-list", BadgeList);
}
var _onVariantChangedListener10, _inventoryElements, _progressBarElement, _VariantInventory_instances, onVariantChanged_fn10;
var VariantInventory = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _VariantInventory_instances);
    __privateAdd(this, _onVariantChangedListener10, __privateMethod(this, _VariantInventory_instances, onVariantChanged_fn10).bind(this));
    __privateAdd(this, _inventoryElements);
    __privateAdd(this, _progressBarElement);
  }
  connectedCallback() {
    var _a;
    (_a = document.forms[this.getAttribute("form")]) == null ? void 0 : _a.addEventListener("variant:change", __privateGet(this, _onVariantChangedListener10));
    __privateSet(this, _inventoryElements, Array.from(this.querySelectorAll("[data-variant-id]")));
    __privateSet(this, _progressBarElement, this.querySelector("progress-bar"));
  }
  disconnectedCallback() {
    var _a;
    (_a = document.forms[this.getAttribute("form")]) == null ? void 0 : _a.removeEventListener("variant:change", __privateGet(this, _onVariantChangedListener10));
  }
};
_onVariantChangedListener10 = new WeakMap();
_inventoryElements = new WeakMap();
_progressBarElement = new WeakMap();
_VariantInventory_instances = new WeakSet();
onVariantChanged_fn10 = function(event) {
  this.hidden = !event.detail.variant;
  if (event.detail.variant) {
    __privateGet(this, _inventoryElements).forEach((item) => {
      const isItemHidden = item.toggleAttribute("hidden", event.detail.variant["id"] !== parseInt(item.getAttribute("data-variant-id")));
      if (!isItemHidden) {
        this.className = `inventory text-${item.getAttribute("data-status")}`;
        if (__privateGet(this, _progressBarElement)) {
          __privateGet(this, _progressBarElement).valueNow = item.getAttribute("data-quantity");
        }
      }
    });
  }
};
if (!window.customElements.get("variant-inventory")) {
  window.customElements.define("variant-inventory", VariantInventory);
}
var _onVariantChangedListener11, _VariantSku_instances, onVariantChanged_fn11;
var VariantSku = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _VariantSku_instances);
    __privateAdd(this, _onVariantChangedListener11, __privateMethod(this, _VariantSku_instances, onVariantChanged_fn11).bind(this));
  }
  connectedCallback() {
    var _a;
    (_a = document.forms[this.getAttribute("form")]) == null ? void 0 : _a.addEventListener("variant:change", __privateGet(this, _onVariantChangedListener11));
  }
  disconnectedCallback() {
    var _a;
    (_a = document.forms[this.getAttribute("form")]) == null ? void 0 : _a.removeEventListener("variant:change", __privateGet(this, _onVariantChangedListener11));
  }
};
_onVariantChangedListener11 = new WeakMap();
_VariantSku_instances = new WeakSet();
onVariantChanged_fn11 = function(event) {
  if (!event.detail.variant) {
    this.hidden = true;
  } else {
    this.innerText = `${window.themeVariables.strings.sku} ${event.detail.variant["sku"]}`;
    this.hidden = !event.detail.variant["sku"];
  }
};
if (!window.customElements.get("variant-sku")) {
  window.customElements.define("variant-sku", VariantSku);
}

// js/common/product/product-gallery.js
var _abortController8;
var ProductGallery = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _abortController8);
  }
  connectedCallback() {
    __privateSet(this, _abortController8, new AbortController());
    if (!this.carousel) {
      return;
    }
  }
  disconnectedCallback() {
    __privateGet(this, _abortController8).abort();
  }
  get carousel() {
    return this.querySelector(".product-gallery__carousel");
  }
};
_abortController8 = new WeakMap();
if (!window.customElements.get("product-gallery")) {
  window.customElements.define("product-gallery", ProductGallery);
}

// js/common/product/product-list.js
import { inView as inView6, animate as animate8, stagger } from "vendor";
var ProductList = class extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("product-list:refresh", this.fetchProductColors);
  }
  connectedCallback() {
    if (matchesMediaQuery("motion-safe") && this.querySelectorAll('product-card[reveal-on-scroll="true"]').length > 0) {
      inView6(this, this.reveal.bind(this));
    }
    this.fetchProductColors();
  }
  // animation for product card reveal
  reveal() {
    animate8(this.querySelectorAll('product-card[reveal-on-scroll="true"], collection-merch[reveal-on-scroll="true"]'), {
      opacity: [0, 1],
      transform: ["translateY(20px)", "translateY(0)"]
    }, {
      duration: 0.2,
      easing: "ease-in",
      delay: stagger(0.05, { start: 0.2, easing: "ease-out" })
    });
  }
  // get product card related colors
  async fetchProductColors() {
    let typesSearchTermsList = [];
    let vendorSearchTermsList = [];
    Array.from(this.productListItems).forEach((product) => {
      let type = product.getAttribute("type") ? product.getAttribute("type") : null;
      let vendor = product.getAttribute("vendor") ? product.getAttribute("vendor") : null;
      let typesSearchItem = `product_type:"${type}"`;
      let vendorSearchItem = `vendor:"${vendor}"`;
      if (typesSearchTermsList.indexOf(typesSearchItem) < 0) {
        typesSearchTermsList.push(typesSearchItem);
      }
      if (vendorSearchTermsList.indexOf(vendorSearchItem) < 0) {
        vendorSearchTermsList.push(vendorSearchItem);
      }
    });
    if (typesSearchTermsList.length === 0 || vendorSearchTermsList.length === 0) return;
    const query2 = encodeURIComponent(`${typesSearchTermsList.join(" OR ")} AND ${vendorSearchTermsList.join(" OR ")}`);
    const url = `${Shopify.routes.root}search?resources[type]=product&section_id=product-card-colors&q=${query2}`;
    const response = await fetch(url);
    const responseText = await response.text();
    if (response.ok) {
      let div = document.createElement("div");
      div.innerHTML = responseText;
      let object = JSON.parse(div.querySelector(".shopify-section").innerHTML);
      Array.from(this.productListItems).forEach((product) => {
        let productColorId = product.getAttribute("color-id");
        product.dispatchEvent(new CustomEvent("product-card:infos", {
          bubbles: true,
          detail: {
            colorListHTML: object.hasOwnProperty(productColorId) ? object[productColorId]["colors"] : null,
            variantId: object.hasOwnProperty(productColorId) ? object[productColorId]["variant_id"] : null
          }
        }));
      });
    }
  }
  get productListItems() {
    return this.querySelectorAll("product-card");
  }
};
if (!window.customElements.get("product-list")) {
  window.customElements.define("product-list", ProductList);
}

// js/common/product/product-list-load-more.js
import { animate as animate9 } from "vendor";
var _currentPage, _ProductLoadMore_instances, onLoadMore_fn, onProductsLoaded_fn;
var ProductLoadMore = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _ProductLoadMore_instances);
    __privateAdd(this, _currentPage);
    this.anchorElement = this.querySelector("a");
    this.anchorElement.addEventListener("click", __privateMethod(this, _ProductLoadMore_instances, onLoadMore_fn).bind(this));
    document.documentElement.addEventListener("theme:loading:end", __privateMethod(this, _ProductLoadMore_instances, onProductsLoaded_fn).bind(this));
  }
  get controlledList() {
    return document.getElementById(this.getAttribute("aria-controls"));
  }
  get maxPage() {
    return parseInt(this.getAttribute("max"));
  }
  get minPage() {
    return parseInt(this.getAttribute("min"));
  }
  get nextPage() {
    return this.getAttribute("direction") === "next";
  }
  get previousPage() {
    return this.getAttribute("direction") === "previous";
  }
  set hrefPage(newUrl) {
    this.anchorElement.setAttribute("href", newUrl);
  }
};
_currentPage = new WeakMap();
_ProductLoadMore_instances = new WeakSet();
onLoadMore_fn = async function(event) {
  event.preventDefault();
  this.querySelector(".button").setAttribute("aria-busy", "true");
  const sectionId = extractSectionId(event.target), url = new URL(this.anchorElement.href);
  url.searchParams.set("section_id", "collection-load-more-products");
  __privateSet(this, _currentPage, url.searchParams.get("page"));
  let response = await fetch(`${this.anchorElement.href}&section_id=${sectionId}`);
  let contentHtml = new DOMParser().parseFromString(await response.text(), "text/html");
  let mainCollectionJson = contentHtml.getElementById("main-collection-json");
  Shopify.analytics.publish("more_products_collection_viewed", {
    collection: {
      productVariants: JSON.parse(mainCollectionJson == null ? void 0 : mainCollectionJson.textContent),
      id: window.themeVariables.collection.id,
      title: window.themeVariables.collection.title
    }
  });
  let productCardList = contentHtml.getElementById(`product-list-${sectionId}`).querySelectorAll(".product-card");
  if (this.nextPage) {
    productCardList = Array.from(productCardList);
  } else if (this.previousPage) {
    productCardList = Array.from(productCardList).reverse();
  }
  productCardList.forEach((item, index) => {
    if (item.classList.contains("product-card-horizontal") == false) {
      if (this.nextPage) {
        this.controlledList.append(item);
        animate9(
          item,
          {
            opacity: [0, 1],
            transform: ["translateY(20px)", "translateY(0)"]
          },
          {
            duration: 0.2,
            easing: "ease-in",
            delay: 0.075 * index
          }
        );
      } else if (this.previousPage) {
        this.controlledList.prepend(item);
      }
    }
  });
  if (this.previousPage) {
    this.controlledList.reveal();
  }
  document.getElementById(`product-list-${sectionId}`).dispatchEvent(new CustomEvent("product-list:refresh"));
  const clonedUrl = new URL(url);
  clonedUrl.searchParams.delete("section_id");
  history.replaceState({}, "", clonedUrl.toString());
  let newUrl = new URL(this.anchorElement.href);
  newUrl.searchParams.set("page", (parseInt(url.searchParams.get("page")) + (this.maxPage ? 1 : -1)).toString());
  this.hrefPage = newUrl.pathname + newUrl.search;
  __privateMethod(this, _ProductLoadMore_instances, onProductsLoaded_fn).call(this);
  this.querySelector(".button").removeAttribute("aria-busy");
};
onProductsLoaded_fn = function() {
  if (parseInt(__privateGet(this, _currentPage)) === this.maxPage) {
    this.remove();
  }
  if (parseInt(__privateGet(this, _currentPage)) === this.minPage) {
    this.remove();
  }
};
if (!window.customElements.get("product-load-more")) {
  window.customElements.define("product-load-more", ProductLoadMore);
}

// js/common/product/product-list-columns.js
var _allVueButtons, _ProductListColumns_instances, changeColumnVue_fn;
var ProductListColumns = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _ProductListColumns_instances);
    __privateAdd(this, _allVueButtons);
  }
  connectedCallback() {
    __privateSet(this, _allVueButtons, this.querySelectorAll("button"));
    Array.from(__privateGet(this, _allVueButtons)).forEach((button) => button.addEventListener("click", __privateMethod(this, _ProductListColumns_instances, changeColumnVue_fn).bind(this)));
  }
  get controlledElement() {
    return document.getElementById(this.getAttribute("aria-controls"));
  }
};
_allVueButtons = new WeakMap();
_ProductListColumns_instances = new WeakSet();
changeColumnVue_fn = function(event) {
  var _a, _b;
  Array.from(__privateGet(this, _allVueButtons)).forEach((button) => button.setAttribute("aria-selected", button === event.currentTarget ? "true" : "false"));
  this.controlledElement.style.setProperty(`--product-list-items-per-row`, `${event.currentTarget.getAttribute("data-columns")}`);
  (_b = (_a = this.closest(".shopify-section")) == null ? void 0 : _a.querySelector(".product-list")) == null ? void 0 : _b.classList.toggle("product-list--more-items-per-row");
};
if (!window.customElements.get("product-list-columns")) {
  window.customElements.define("product-list-columns", ProductListColumns);
}

// js/common/product/product-loader.js
var loadedProducts = {};
var ProductLoader = class {
  static load(productHandle) {
    if (!productHandle) {
      return;
    }
    if (loadedProducts[productHandle]) {
      return loadedProducts[productHandle];
    }
    loadedProducts[productHandle] = new Promise(async (resolve, reject) => {
      const response = await fetch(`${Shopify.routes.root}products/${productHandle}.js`);
      if (response.ok) {
        const responseAsJson = await response.json();
        resolve(responseAsJson);
      } else {
        reject(`
          Attempted to load information for product with handle ${productHandle}, but this product is in "draft" mode. You won't be able to
          switch between variants or access to per-variant information. To fully preview this product, change temporarily its status
          to "active".
        `);
      }
    });
    return loadedProducts[productHandle];
  }
};

// js/common/product/product-material-info.js
import { animate as animate10, timeline as timeline7 } from "vendor";
var ProductMaterialInfo = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __publicField(this, "allButtons");
    __publicField(this, "panelExterior");
    __publicField(this, "panelInterior");
  }
  connectedCallback() {
    this.animationDuration = 0;
    this.allButtons = this.querySelectorAll("[data-panel]");
    this.panelExterior = this.querySelector("[panel-exterior]");
    this.panelInterior = this.querySelector("[panel-interior]");
    this.switchElements = this.querySelectorAll(".switch-values");
    Array.from(this.allButtons).forEach((button) => {
      let panel = button.closest(".product-material-info");
      if (matchesMediaQuery(button.closest("[mq]").getAttribute("mq")) && !panel.hidden && button.getAttribute("aria-selected") === "true") {
        this.setSwitchItemWidth(button);
      }
      button.addEventListener("click", this.togglePanel.bind(this));
    });
  }
  togglePanel(event) {
    let activePanel = parseInt(event.target.getAttribute("data-panel")) === 1 ? this.panelInterior : this.panelExterior;
    let targetPanel = parseInt(event.target.getAttribute("data-panel")) === 1 ? this.panelExterior : this.panelInterior;
    Array.from(this.allButtons).forEach((button) => {
      let isCurrentPanel = button.getAttribute("data-panel") === event.target.getAttribute("data-panel");
      button.setAttribute("aria-selected", isCurrentPanel ? "true" : "false");
    });
    this.transition(activePanel, targetPanel);
  }
  async transition(fromPanel, toPanel) {
    await animate10(fromPanel, { opacity: [1, 0] }, { duration: this.animationDuration }).finished;
    fromPanel.hidden = true;
    toPanel.hidden = false;
    await animate10(toPanel, { opacity: [0, 1] }, { duration: this.animationDuration }).finished;
    timeline7([
      [toPanel.querySelector(".product-material-info__material-image"), { transform: ["translateY(32px)", "translateY(0)"], opacity: [0, 1] }],
      [toPanel.querySelector(".marquee-content"), { opacity: [0, 1] }, { at: "-0.2" }],
      [toPanel.querySelector(".product-material-info__material-label"), { transform: ["translateY(16px)", "translateY(0)"], opacity: [0, 1] }, { at: "-0.2" }],
      [toPanel.querySelector(".product-material-info__info-title"), { transform: ["translateY(16px)", "translateY(0)"], opacity: [0, 1] }, { at: "-0.2" }],
      [toPanel.querySelector(".product-material-info__info-description"), { transform: ["translateY(16px)", "translateY(0)"], opacity: [0, 1] }, { at: "-0.2" }]
    ]);
    Array.from(toPanel.querySelectorAll("[mq]")).forEach((values) => {
      let button = values.querySelector('[data-panel][aria-selected="true"]');
      if (matchesMediaQuery(values.getAttribute("mq")) && button.getAttribute("aria-selected") === "true") {
        this.setSwitchItemWidth(button);
      }
    });
    setTimeout(() => {
      Array.from(this.switchElements).forEach((el) => {
        el.setAttribute("initial-item", `${fromPanel === this.panelInterior}`);
      });
    }, 10);
  }
  setSwitchItemWidth(item) {
    Array.from(this.switchElements).forEach((el) => {
      el.style.setProperty("--switch-item-width", `${item.clientWidth}px`);
    });
  }
};
if (!window.customElements.get("product-material-info")) {
  window.customElements.define("product-material-info", ProductMaterialInfo);
}

// js/common/product/product-sticky.js
var _onVariantChangedListener12, _ProductSticky_instances, onVariantChanged_fn12;
var ProductSticky = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _ProductSticky_instances);
    __privateAdd(this, _onVariantChangedListener12, __privateMethod(this, _ProductSticky_instances, onVariantChanged_fn12).bind(this));
  }
  connectedCallback() {
    var _a;
    (_a = document.forms[this.getAttribute("form")]) == null ? void 0 : _a.addEventListener("variant:change", __privateGet(this, _onVariantChangedListener12));
    let productInfoElement = this.parentElement.querySelector(".product-info");
    let footer = document.querySelector(".shopify-section-group-footer-group");
    let elementsToObserve = [productInfoElement, footer];
    this.options = {
      root: null,
      rootMargin: "-150px",
      threshold: 0
    };
    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        this.setAttribute("aria-hidden", entry.isIntersecting || window.scrollY < productInfoElement.offsetTop + productInfoElement.clientHeight - 150 ? "true" : "false");
      });
    }, this.options);
    elementsToObserve.forEach((el) => {
      this.observer.observe(el);
    });
  }
  disconnectedCallback() {
    var _a;
    (_a = document.forms[this.getAttribute("form")]) == null ? void 0 : _a.removeEventListener("variant:change", __privateGet(this, _onVariantChangedListener12));
  }
};
_onVariantChangedListener12 = new WeakMap();
_ProductSticky_instances = new WeakSet();
onVariantChanged_fn12 = function(event) {
  const currentVariant = this.querySelector("[data-current-variant]");
  currentVariant.innerHTML = event.detail.variant["title"];
  event.detail.variant["available"] ? currentVariant.removeAttribute("is-disabled") : currentVariant.setAttribute("is-disabled", "");
};
if (!window.customElements.get("product-sticky")) {
  window.customElements.define("product-sticky", ProductSticky);
}

// js/common/product/size-compare-drawer.js
import { timeline as timeline8 } from "vendor";
var SizeCompareDrawer = class extends Drawer {
  createEnterAnimationControls() {
    this.setStyleProperties();
    return timeline8([
      [this.getShadowPartByName("overlay"), { opacity: [0, 1] }, { duration: 0.3, easing: [0.645, 0.045, 0.355, 1] }],
      [this.getShadowPartByName("content"), { transform: this.transform }, { duration: 0.3, easing: [0.5, 0.5, 0.5, 1], at: "<" }],
      [this.querySelector(".size-compare-drawer__title"), { opacity: [0, 1], transform: ["translateY(10px)", "translateY(0)"] }, { duration: 0.15 }],
      [this.querySelectorAll(".size-compare-drawer__item"), { opacity: [0, 1], transform: ["translateY(10px)", "translateY(0)"] }, { duration: 0.15 }]
    ]);
  }
};
if (!window.customElements.get("size-compare-drawer")) {
  window.customElements.define("size-compare-drawer", SizeCompareDrawer);
}

// js/common/product/variant-picker.js
var _abortController9, _VariantPicker_instances, onOptionChanged_fn, onMasterSelectorChanged_fn, getVariantById_fn, getVariantFromOptions_fn, isVariantSelectable_fn, getFirstMatchingAvailableOrSelectableVariant_fn, getSelectedOptionValues_fn, updateDisableSelectors_fn;
var VariantPicker = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _VariantPicker_instances);
    __privateAdd(this, _abortController9);
  }
  async connectedCallback() {
    __privateSet(this, _abortController9, new AbortController());
    this.masterSelector = document.forms[this.getAttribute("form")].id;
    this.optionSelectors = Array.from(this.querySelectorAll("[data-option-selector]"));
    if (!this.masterSelector) {
      console.warn(`The variant selector for product with handle ${this.productHandle} is not linked to any product form.`);
      return;
    }
    this.product = await ProductLoader.load(this.productHandle);
    this.optionSelectors.forEach((optionSelector) => {
      optionSelector.addEventListener("change", __privateMethod(this, _VariantPicker_instances, onOptionChanged_fn).bind(this), { signal: __privateGet(this, _abortController9).signal });
    });
    this.masterSelector.addEventListener("change", __privateMethod(this, _VariantPicker_instances, onMasterSelectorChanged_fn).bind(this), { signal: __privateGet(this, _abortController9).signal });
    __privateMethod(this, _VariantPicker_instances, updateDisableSelectors_fn).call(this);
    this.selectVariant(this.selectedVariant["id"]);
  }
  disconnectedCallback() {
    __privateGet(this, _abortController9).abort();
  }
  get selectedVariant() {
    return __privateMethod(this, _VariantPicker_instances, getVariantById_fn).call(this, parseInt(this.masterSelector.value));
  }
  get productHandle() {
    return this.getAttribute("handle");
  }
  get hideSoldOutVariants() {
    return this.hasAttribute("hide-sold-out-variants");
  }
  get updateUrl() {
    return this.hasAttribute("update-url");
  }
  set variantStock(stock) {
    this.currentVariantStock = parseInt(stock);
  }
  get variantStock() {
    return this.currentVariantStock;
  }
  /**
   * Select a new variant by its ID
   */
  selectVariant(id) {
    if (!__privateMethod(this, _VariantPicker_instances, isVariantSelectable_fn).call(this, __privateMethod(this, _VariantPicker_instances, getVariantById_fn).call(this, id))) {
      id = __privateMethod(this, _VariantPicker_instances, getFirstMatchingAvailableOrSelectableVariant_fn).call(this)["id"];
    }
    const previousVariant = this.selectedVariant;
    if (previousVariant && previousVariant.id === id) {
      return;
    }
    this.masterSelector.value = id;
    this.masterSelector.dispatchEvent(new Event("change", { bubbles: true }));
    if (this.updateUrl && history.replaceState) {
      const newUrl = new URL(window.location.href);
      if (id) {
        newUrl.searchParams.set("variant", id);
      } else {
        newUrl.searchParams.delete("variant");
      }
      window.history.replaceState({ path: newUrl.toString() }, "", newUrl.toString());
    }
    __privateMethod(this, _VariantPicker_instances, updateDisableSelectors_fn).call(this);
    this.masterSelector.form.dispatchEvent(new CustomEvent("variant:change", {
      bubbles: true,
      detail: {
        product: this.product,
        variant: this.selectedVariant,
        previousVariant,
        variantStock: this.variantStock
      }
    }));
  }
};
_abortController9 = new WeakMap();
_VariantPicker_instances = new WeakSet();
onOptionChanged_fn = function(event) {
  var _a;
  if (!event.target.name.startsWith("option")) {
    return;
  }
  this.selectVariant((_a = __privateMethod(this, _VariantPicker_instances, getVariantFromOptions_fn).call(this)) == null ? void 0 : _a.id);
};
onMasterSelectorChanged_fn = function() {
  var _a;
  const options = ((_a = this.selectedVariant) == null ? void 0 : _a.options) || [];
  options.forEach((value, index) => {
    let input = this.optionSelectors[index].querySelector(`input[type="radio"][name="option${index + 1}"][value="${CSS.escape(value)}"], input[type="hidden"][name="option${index + 1}"], select[name="option${index + 1}"]`), triggerChangeEvent = false;
    if (input.tagName === "SELECT" || input.tagName === "INPUT" && input.type === "hidden") {
      triggerChangeEvent = input.value !== value;
      input.value = value;
    } else if (input.tagName === "INPUT" && input.type === "radio") {
      triggerChangeEvent = !input.checked && input.value === value;
      input.checked = input.value === value;
    }
    if (triggerChangeEvent) {
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }
    this.variantStock = input.getAttribute("data-stock");
  });
};
/**
 * Get the product variant by its ID
 */
getVariantById_fn = function(id) {
  return this.product["variants"].find((variant) => variant["id"] === id);
};
/**
 * Get the variant based on the options
 */
getVariantFromOptions_fn = function() {
  const options = __privateMethod(this, _VariantPicker_instances, getSelectedOptionValues_fn).call(this);
  return this.product["variants"].find((variant) => {
    return variant["options"].every((value, index) => value === options[index]);
  });
};
/**
 * Detect if a specific variant is selectable. This is used when the "hide sold out variant" option is enabled, to allow
 * returning true only if the variant is actually available
 */
isVariantSelectable_fn = function(variant) {
  if (!variant) {
    return false;
  } else {
    return variant["available"] || !this.hideSoldOutVariants && !variant["available"];
  }
};
/**
 * This method is used internally to select an available or selectable variant, when the current choice does not
 * match the requirements. For instance, if sold out variants are configured to be hidden, but that the choices end
 * up being a non-valid variant, the theme automatically changes the variant to match the requirements. In the case
 * the customer end up on variant combinations that do not exist, it also switches to a valid combination.
 *
 * The algorithm is as follows: if we have for instance three options "Color", "Size" and "Material", we pop the last
 * option (Material) and try to find the first available variant for the given Color and Size. If none is found we
 * remove the second option (Size) and try to find the first available variant for the selected color. Finally, if none
 * is found we return the first available variant independently of any choice.
 */
getFirstMatchingAvailableOrSelectableVariant_fn = function() {
  let options = __privateMethod(this, _VariantPicker_instances, getSelectedOptionValues_fn).call(this), matchedVariant = null, slicedCount = 0;
  do {
    options.pop();
    slicedCount += 1;
    matchedVariant = this.product["variants"].find((variant) => {
      if (this.hideSoldOutVariants) {
        return variant["available"] && variant["options"].slice(0, variant["options"].length - slicedCount).every((value, index) => value === options[index]);
      } else {
        return variant["options"].slice(0, variant["options"].length - slicedCount).every((value, index) => value === options[index]);
      }
    });
  } while (!matchedVariant && options.length > 0);
  return matchedVariant;
};
getSelectedOptionValues_fn = function() {
  return this.optionSelectors.map((optionSelector) => {
    return optionSelector.querySelector('input[name^="option"][type="hidden"], input[name^="option"]:checked, select[name^="option"]').value;
  });
};
/**
 * We add specific class to sold out variants based on the selectors
 */
updateDisableSelectors_fn = function() {
  const selectedVariant = this.selectedVariant;
  if (!selectedVariant) {
    return;
  }
  const applyClassToSelector = (selector, valueIndex, available, hasAtLeastOneCombination) => {
    const optionValue = Array.from(selector.querySelectorAll("[data-option-value]"))[valueIndex];
    optionValue.toggleAttribute("hidden", !hasAtLeastOneCombination);
    if (this.hideSoldOutVariants) {
      optionValue.toggleAttribute("hidden", !available);
    } else {
      optionValue.classList.toggle("is-disabled", !available);
    }
  };
  if (this.optionSelectors && this.optionSelectors[0]) {
    this.product["options"][0]["values"].forEach((value, valueIndex) => {
      const hasAtLeastOneCombination = this.product["variants"].some((variant) => variant["option1"] === value && variant), hasAvailableVariant = this.product["variants"].some((variant) => variant["option1"] === value && variant["available"]);
      applyClassToSelector(this.optionSelectors[0], valueIndex, hasAvailableVariant, hasAtLeastOneCombination);
      if (this.optionSelectors[1]) {
        this.product["options"][1]["values"].forEach((value2, valueIndex2) => {
          const hasAtLeastOneCombination2 = this.product["variants"].some((variant) => variant["option2"] === value2 && variant["option1"] === selectedVariant["option1"] && variant), hasAvailableVariant2 = this.product["variants"].some((variant) => variant["option2"] === value2 && variant["option1"] === selectedVariant["option1"] && variant["available"]);
          applyClassToSelector(this.optionSelectors[1], valueIndex2, hasAvailableVariant2, hasAtLeastOneCombination2);
          if (this.optionSelectors[2]) {
            this.product["options"][2]["values"].forEach((value3, valueIndex3) => {
              const hasAtLeastOneCombination3 = this.product["variants"].some((variant) => variant["option3"] === value3 && variant["option1"] === selectedVariant["option1"] && variant["option2"] === selectedVariant["option2"] && variant), hasAvailableVariant3 = this.product["variants"].some((variant) => variant["option3"] === value3 && variant["option1"] === selectedVariant["option1"] && variant["option2"] === selectedVariant["option2"] && variant["available"]);
              applyClassToSelector(this.optionSelectors[2], valueIndex3, hasAvailableVariant3, hasAtLeastOneCombination3);
            });
          }
        });
      }
    });
  }
};
var _onVariantChangedListener13, _VariantOptionValue_instances, onVariantChanged_fn13;
var VariantOptionValue = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _VariantOptionValue_instances);
    __privateAdd(this, _onVariantChangedListener13, __privateMethod(this, _VariantOptionValue_instances, onVariantChanged_fn13).bind(this));
  }
  connectedCallback() {
    var _a;
    (_a = document.forms[this.getAttribute("form")]) == null ? void 0 : _a.addEventListener("variant:change", __privateGet(this, _onVariantChangedListener13));
  }
  disconnectedCallback() {
    var _a;
    (_a = document.forms[this.getAttribute("form")]) == null ? void 0 : _a.removeEventListener("variant:change", __privateGet(this, _onVariantChangedListener13));
  }
};
_onVariantChangedListener13 = new WeakMap();
_VariantOptionValue_instances = new WeakSet();
onVariantChanged_fn13 = function(event) {
  this.innerHTML = event.detail.variant[this.getAttribute("for")];
};
if (!window.customElements.get("variant-picker")) {
  window.customElements.define("variant-picker", VariantPicker);
}
if (!window.customElements.get("variant-option-value")) {
  window.customElements.define("variant-option-value", VariantOptionValue);
}

// js/common/media/base-media.js
import { inView as inView7 } from "vendor";
var BaseMedia = class extends HTMLElement {
  static get observedAttributes() {
    return ["playing"];
  }
  connectedCallback() {
    this._abortController = new AbortController();
    if (this.hasAttribute("autoplay")) {
      inView7(this, this.play.bind(this), { margin: "0px 0px 0px 0px" });
    }
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get playing() {
    return this.hasAttribute("playing");
  }
  get player() {
    return this._playerProxy = this._playerProxy || new Proxy(this._playerTarget(), {
      get: (target, prop) => {
        return async () => {
          target = await target;
          this._playerHandler(target, prop);
        };
      }
    });
  }
  play(event) {
    if (event.target.matches(".video-controls")) return;
    if (!this.playing) {
      this.player.play();
    } else {
      this.player.pause();
    }
  }
  pause() {
    if (this.playing) {
      this.player.pause();
    }
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "playing") {
      if (oldValue === null && newValue === "") {
        this.dispatchEvent(new CustomEvent("media:play", { bubbles: true }));
        if (this.hasAttribute("group")) {
          Array.from(document.querySelectorAll(`[group="${this.getAttribute("group")}"]`)).filter((item) => item !== this).forEach((itemToPause) => {
            itemToPause.pause();
          });
        }
      } else if (newValue === null) {
        this.dispatchEvent(new CustomEvent("media:pause", { bubbles: true }));
      }
    }
  }
};

// js/common/media/model.js
var ModelMedia = class extends BaseMedia {
  connectedCallback() {
    super.connectedCallback();
    this.player;
  }
  _playerTarget() {
    return new Promise((resolve) => {
      this.setAttribute("loaded", "");
      window.Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: this._setupShopifyXr.bind(this)
        },
        {
          name: "model-viewer-ui",
          version: "1.0",
          onLoad: () => {
            const modelViewer = this.querySelector("model-viewer");
            modelViewer.addEventListener("shopify_model_viewer_ui_toggle_play", () => this.setAttribute("playing", ""));
            modelViewer.addEventListener("shopify_model_viewer_ui_toggle_pause", () => this.removeAttribute("playing"));
            resolve(new window.Shopify.ModelViewerUI(modelViewer, { focusOnPlay: true }));
          }
        }
      ]);
    });
  }
  _playerHandler(target, prop) {
    target[prop]();
  }
  async _setupShopifyXr() {
    if (!window.ShopifyXR) {
      document.addEventListener("shopify_xr_initialized", this._setupShopifyXr.bind(this));
    } else {
      const models = (await ProductLoader.load(this.getAttribute("handle")))["media"].filter((media) => media["media_type"] === "model");
      window.ShopifyXR.addModels(models);
      window.ShopifyXR.setupXRElements();
    }
  }
};
if (!window.customElements.get("model-media")) {
  window.customElements.define("model-media", ModelMedia);
}

// js/common/media/video.js
import { inView as inView8 } from "vendor";
var _mustRemoveControlsAfterSuspend;
var VideoMedia = class extends BaseMedia {
  constructor() {
    super(...arguments);
    __privateAdd(this, _mustRemoveControlsAfterSuspend, false);
  }
  connectedCallback() {
    var _a;
    super.connectedCallback();
    if (!this.hasAttribute("autoplay")) {
      this.addEventListener("click", this.play, { signal: this._abortController.signal });
    }
    (_a = this.querySelector(".video-controls")) == null ? void 0 : _a.addEventListener("click", this.mute.bind(this), { signal: this._abortController.signal });
    if (this.getAttribute("type") === "video") {
      inView8(this, () => {
        var _a2;
        (_a2 = this.querySelector("video")) == null ? void 0 : _a2.setAttribute("preload", "metadata");
      }, { margin: "800px" });
    }
  }
  _playerTarget() {
    const videoElement = this.querySelector("video");
    this.setAttribute("loaded", "");
    videoElement.addEventListener("play", () => {
      this.setAttribute("playing", "");
      this.removeAttribute("suspended");
      if (__privateGet(this, _mustRemoveControlsAfterSuspend)) {
        videoElement.controls = false;
      }
    });
    videoElement.addEventListener("pause", () => {
      if (!videoElement.seeking && videoElement.paused) {
        this.removeAttribute("playing");
      }
    });
    return videoElement;
  }
  mute() {
    const videoElement = this.querySelector("video");
    videoElement.muted = !videoElement.muted;
    this.setAttribute("mute", videoElement.muted.toString());
  }
  _playerHandler(target, prop) {
    if (prop === "play" && !this.hasAttribute("host")) {
      target.play().catch((error) => {
        if (error.name === "NotAllowedError") {
          this.setAttribute("suspended", "");
          if (!this.hasAttribute("controls")) {
            __privateSet(this, _mustRemoveControlsAfterSuspend, true);
            target.controls = true;
          }
        }
      });
    } else {
      target[prop]();
    }
  }
};
_mustRemoveControlsAfterSuspend = new WeakMap();
if (!window.customElements.get("video-media")) {
  window.customElements.define("video-media", VideoMedia);
}

// js/common/navigation/accordion-disclosure.js
import { timeline as timeline9 } from "vendor";
var _detailsElement, _summaryElement, _contentElement, _AccordionDisclosure_instances, open_fn, close_fn;
var AccordionDisclosure = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _AccordionDisclosure_instances);
    __privateAdd(this, _detailsElement, this.querySelector("details"));
    __privateAdd(this, _summaryElement, __privateGet(this, _detailsElement).firstElementChild);
    __privateAdd(this, _contentElement, __privateGet(this, _detailsElement).lastElementChild);
    if (!(window.innerWidth > 1e3 && this.closest(".footer__accordion-container"))) {
      __privateGet(this, _summaryElement).addEventListener("click", this.onSummaryClick.bind(this));
      __privateGet(this, _detailsElement).classList.toggle("is-open", __privateGet(this, _detailsElement).open);
    }
  }
  connectedCallback() {
    if (window.innerWidth > 1e3 && this.closest(".footer__accordion-container")) {
      document.querySelectorAll(".footer__accordion-container .accordion__summary").forEach((summaryElement) => {
        summaryElement.addEventListener("click", (event) => {
          event.preventDefault();
        });
      });
      __privateGet(this, _summaryElement).removeEventListener("click", this.onSummaryClick.bind(this));
      this.forceOpen();
    }
  }
  forceOpen() {
    __privateGet(this, _detailsElement).open = true;
    __privateGet(this, _detailsElement).classList.add("is-open");
  }
  createOpenAnimationControls() {
    return timeline9([
      [__privateGet(this, _detailsElement), { height: [`${__privateGet(this, _summaryElement).clientHeight}px`, `${__privateGet(this, _detailsElement).clientHeight}px`] }, { duration: 0.25, easing: "ease" }],
      [__privateGet(this, _contentElement), { opacity: [0, 1] }, { duration: 0.15, at: "-0.1" }]
    ]);
  }
  createCloseAnimationControls() {
    return timeline9([
      [__privateGet(this, _contentElement), { opacity: 0 }, { duration: 0.15 }],
      [__privateGet(this, _detailsElement), { height: [`${__privateGet(this, _detailsElement).clientHeight}px`, `${__privateGet(this, _summaryElement).clientHeight}px`] }, { duration: 0.25, at: "<", easing: "ease" }]
    ]);
  }
  onSummaryClick(event) {
    if (event) event.preventDefault();
    __privateGet(this, _detailsElement).classList.toggle("is-open");
    if (__privateGet(this, _detailsElement).classList.contains("is-open")) {
      __privateMethod(this, _AccordionDisclosure_instances, open_fn).call(this);
    } else {
      __privateMethod(this, _AccordionDisclosure_instances, close_fn).call(this);
    }
  }
};
_detailsElement = new WeakMap();
_summaryElement = new WeakMap();
_contentElement = new WeakMap();
_AccordionDisclosure_instances = new WeakSet();
open_fn = async function() {
  __privateGet(this, _detailsElement).open = true;
  __privateGet(this, _detailsElement).style.overflow = "hidden";
  const animationControls = this.createOpenAnimationControls();
  await animationControls.finished;
  __privateGet(this, _detailsElement).style.height = null;
  __privateGet(this, _detailsElement).style.overflow = null;
};
close_fn = async function() {
  const animationControls = this.createCloseAnimationControls();
  await animationControls.finished;
  if (!__privateGet(this, _detailsElement).classList.contains("is-open")) {
    __privateGet(this, _detailsElement).style.height = null;
    __privateGet(this, _detailsElement).open = false;
  }
};
if (!window.customElements.get("accordion-disclosure")) {
  window.customElements.define("accordion-disclosure", AccordionDisclosure);
}

// js/common/navigation/custom-details.js
var _onSummaryClickedListener, _CustomDetails_instances, onSummaryClicked_fn;
var CustomDetails = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _CustomDetails_instances);
    __privateAdd(this, _onSummaryClickedListener, __privateMethod(this, _CustomDetails_instances, onSummaryClicked_fn).bind(this));
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => this.toggle(true, !event.detail.load));
      this.addEventListener("shopify:block:deselect", (event) => this.toggle(false, !event.detail.load));
    }
  }
  static get observedAttributes() {
    return ["open", "aria-expanded"];
  }
  connectedCallback() {
    this.setAttribute("aria-expanded", this.open ? "true" : "false");
    this.summaryElement.addEventListener("click", __privateGet(this, _onSummaryClickedListener));
  }
  disconnectedCallback() {
    this.summaryElement.removeEventListener("click", __privateGet(this, _onSummaryClickedListener));
  }
  get summaryElement() {
    return this.tagName === "DETAILS" ? this.firstElementChild : this.querySelector("details").firstElementChild;
  }
  get contentElement() {
    return this.tagName === "DETAILS" ? this.lastElementChild : this.querySelector("details").lastElementChild;
  }
  toggle(force = void 0, animate23 = true) {
    const newValue = typeof force === "boolean" ? force : !(this.getAttribute("aria-expanded") === "true");
    if (newValue) {
      this.setAttribute("open", animate23 ? "" : "immediate");
    }
    this.setAttribute("aria-expanded", newValue ? "true" : "false");
  }
  /**
   * Sync the "open" attribute with the is-expanded class. We also track the "internal-open" attribute to run
   * the various animation
   */
  attributeChangedCallback(name, oldValue, newValue) {
    var _a;
    switch (name) {
      case "open":
        this.setAttribute("aria-expanded", newValue !== null ? "true" : "false");
        break;
      case "aria-expanded":
        if (oldValue === newValue || !this.isConnected) {
          return;
        }
        if (newValue === "false" && this.open) {
          (_a = this.createHideAnimationControls()) == null ? void 0 : _a.finished.then((event) => {
            if (event !== void 0) {
              this.removeAttribute("open");
            }
          });
        } else if (newValue === "true") {
          const controls2 = this.createShowAnimationControls();
          if (this.getAttribute("open") === "immediate") {
            controls2.finish();
          }
        }
    }
  }
  createShowAnimationControls() {
  }
  createHideAnimationControls() {
  }
};
_onSummaryClickedListener = new WeakMap();
_CustomDetails_instances = new WeakSet();
/**
 * By default, when clicking on the summary, the browser directly toggle the "open" attribute, which prevent to
 * perform animation. We therefore block that to allow doing an animation
 */
onSummaryClicked_fn = function(event) {
  if (this.open && this.summaryElement.hasAttribute("data-follow-link")) {
    return window.location.href = this.summaryElement.getAttribute("data-follow-link");
  }
  event.preventDefault();
  this.toggle();
};

// js/common/navigation/menu-disclosure.js
var _hoverTimer, _detectClickOutsideListener, _detectEscKeyboardListener, _detectFocusOutListener, _detectHoverOutsideListener, _detectHoverListener, _MenuDisclosure_instances, detectClickOutside_fn, detectHover_fn, detectHoverOutside_fn, detectEscKeyboard_fn, detectFocusOut_fn;
var _MenuDisclosure = class _MenuDisclosure extends CustomDetails {
  constructor() {
    super();
    __privateAdd(this, _MenuDisclosure_instances);
    __privateAdd(this, _hoverTimer);
    __privateAdd(this, _detectClickOutsideListener, __privateMethod(this, _MenuDisclosure_instances, detectClickOutside_fn).bind(this));
    __privateAdd(this, _detectEscKeyboardListener, __privateMethod(this, _MenuDisclosure_instances, detectEscKeyboard_fn).bind(this));
    __privateAdd(this, _detectFocusOutListener, __privateMethod(this, _MenuDisclosure_instances, detectFocusOut_fn).bind(this));
    __privateAdd(this, _detectHoverOutsideListener, __privateMethod(this, _MenuDisclosure_instances, detectHoverOutside_fn).bind(this));
    __privateAdd(this, _detectHoverListener, __privateMethod(this, _MenuDisclosure_instances, detectHover_fn).bind(this));
    this.querySelector("details").addEventListener("mouseover", __privateGet(this, _detectHoverListener));
    this.querySelector("details").addEventListener("mouseout", __privateGet(this, _detectHoverListener));
  }
  /**
   * Get the trigger mode (can be "click" or "hover"). However, for touch devices, it is always forced to click
   * to provide a better user experience
   */
  get trigger() {
    return !window.matchMedia("screen and (pointer: fine)").matches ? "click" : this.getAttribute("trigger");
  }
  /**
   * In ms, describe the delay before which we close the menu
   */
  get mouseOverDelayTolerance() {
    return 200;
  }
  /**
   * -------------------------------------------------------------------------------------------------------------------
   * PRIVATE API
   * -------------------------------------------------------------------------------------------------------------------
   */
  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    if (name === "aria-expanded") {
      if (oldValue === newValue) {
        return;
      }
      if (newValue === "false") {
        document.removeEventListener("click", __privateGet(this, _detectClickOutsideListener));
        document.removeEventListener("keydown", __privateGet(this, _detectEscKeyboardListener));
        document.removeEventListener("focusout", __privateGet(this, _detectFocusOutListener));
        document.removeEventListener("mouseover", __privateGet(this, _detectHoverOutsideListener));
      } else {
        document.addEventListener("click", __privateGet(this, _detectClickOutsideListener));
        document.addEventListener("keydown", __privateGet(this, _detectEscKeyboardListener));
        document.addEventListener("focusout", __privateGet(this, _detectFocusOutListener));
        document.addEventListener("mouseover", __privateGet(this, _detectHoverOutsideListener));
      }
    }
  }
};
_hoverTimer = new WeakMap();
_detectClickOutsideListener = new WeakMap();
_detectEscKeyboardListener = new WeakMap();
_detectFocusOutListener = new WeakMap();
_detectHoverOutsideListener = new WeakMap();
_detectHoverListener = new WeakMap();
_MenuDisclosure_instances = new WeakSet();
/**
 * When dropdown menu is configured to open on click, we add a listener to detect click outside and automatically
 * close the navigation.
 */
detectClickOutside_fn = function(event) {
  if (this.trigger !== "click") {
    return;
  }
  if (!this.contains(event.target) && !(event.target.closest("details") instanceof _MenuDisclosure)) {
    this.toggle(false);
  }
};
/**
 * On desktop device, if the mode is set to hover, we open/close the dropdown on hover
 */
detectHover_fn = function(event) {
  if (this.trigger !== "hover") {
    return;
  }
  if (event.type === "mouseover") {
    clearTimeout(__privateGet(this, _hoverTimer));
    this.toggle(true);
  } else if (event.type === "mouseout") {
    __privateSet(this, _hoverTimer, setTimeout(() => this.toggle(false), this.mouseOverDelayTolerance));
  }
};
/**
 * Try to detect when the user hover a different link, to immediately close the item without extra delay
 */
detectHoverOutside_fn = function(event) {
  if (this.trigger !== "hover") {
    return;
  }
  const closestDetails = event.target.closest("details");
  if (closestDetails instanceof _MenuDisclosure && closestDetails !== this && !closestDetails.contains(this) && !this.contains(closestDetails)) {
    clearTimeout(__privateGet(this, _hoverTimer));
    this.toggle(false);
  }
};
/**
 * Detect if we hit the "Escape" key to automatically close the dropdown
 */
detectEscKeyboard_fn = function(event) {
  if (event.code === "Escape") {
    const targetMenu = event.target.closest("details[open]");
    if (targetMenu && targetMenu instanceof _MenuDisclosure) {
      targetMenu.toggle(false);
      event.stopPropagation();
    }
  }
};
/**
 * Close the dropdown automatically when the dropdown is focused out
 */
detectFocusOut_fn = function(event) {
  if (event.relatedTarget && !this.contains(event.relatedTarget)) {
    this.toggle(false);
  }
};
var MenuDisclosure = _MenuDisclosure;

// js/common/navigation/page-anchors.js
var PageAnchors = class extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    this.elementsToObserve = [];
    this.allItems = Array.from(this.querySelectorAll("[data-section-index]"));
    this.allItems.forEach((button) => {
      this.elementsToObserve.push(this.getIndexedSection(button.getAttribute("data-section-index")));
      button.addEventListener("click", (event) => this.onAnchorClicked(event), { signal: this.abortController.signal });
    });
    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          let index = Array.from(entry.target.parentNode.children).indexOf(entry.target);
          this.setAnchorItemWidth(index);
        }
      });
    }, {
      root: null,
      rootMargin: "10%",
      threshold: 0
    });
    this.elementsToObserve.forEach((el) => {
      this.observer.observe(el);
    });
  }
  disconnectedCallback() {
    this.abortController.abort();
  }
  onAnchorClicked(event) {
    event.preventDefault();
    if (event.target.getAttribute("data-section-index")) {
      let targetSection = this.getIndexedSection(event.target.getAttribute("data-section-index"));
      document.documentElement.scrollTo({
        top: targetSection.offsetTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-height")),
        behavior: window.matchMedia("(prefers-reduced-motion: no-preference)").matches ? "smooth" : "auto"
      });
    }
  }
  setAnchorItemWidth(index) {
    Array.from(this.allItems).forEach((el) => {
      if (parseInt(el.getAttribute("data-section-index")) === index) {
        this.style.setProperty("--anchor-item-width", `${el.clientWidth}px`);
        this.style.setProperty("--anchor-item-left-position", `${el.offsetLeft}px`);
      }
      el.setAttribute("aria-selected", parseInt(el.getAttribute("data-section-index")) === index ? "true" : "false");
    });
  }
  getIndexedSection(index) {
    return document.querySelectorAll("#main .shopify-section")[index];
  }
};
if (!window.customElements.get("page-anchors")) {
  window.customElements.define("page-anchors", PageAnchors);
}

// js/common/navigation/scrolling-nav.js
var _ScrollingNav_instances, scrollToLinkActive_fn;
var ScrollingNav = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _ScrollingNav_instances);
  }
  connectedCallback() {
    __privateMethod(this, _ScrollingNav_instances, scrollToLinkActive_fn).call(this);
  }
  get scrollingElement() {
    return this.querySelector(this.getAttribute("scrolling-element"));
  }
};
_ScrollingNav_instances = new WeakSet();
scrollToLinkActive_fn = function() {
  if (this.querySelector(".button-tag.active")) {
    let currentItem = this.querySelector(".button-tag.active");
    let offsetLeft = currentItem.offsetLeft - (this.offsetWidth / 2 - currentItem.offsetWidth / 2);
    this.scrollingElement.scrollTo({
      top: 0,
      left: offsetLeft
    });
  }
};
if (!window.customElements.get("scrolling-nav")) {
  window.customElements.define("scrolling-nav", ScrollingNav);
}

// js/common/navigation/tabs.js
import { Delegate as Delegate4, animate as animate11 } from "vendor";
var Tabs = class extends HTMLElement {
  constructor() {
    super();
    __publicField(this, "componentID", crypto.randomUUID ? crypto.randomUUID() : Math.floor(Math.random() * 1e4));
    __publicField(this, "buttons", []);
    __publicField(this, "panels", []);
    __publicField(this, "delegate", new Delegate4(this));
    if (!this.shadowRoot) {
      this.attachShadow({ mode: "open" }).appendChild(this.querySelector("template").content.cloneNode(true));
    }
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => this.selectedIndex = this.buttons.indexOf(event.target));
    }
    this.delegate.on("click", 'button[role="tab"]', this.onButtonClicked.bind(this));
    this.shadowRoot.addEventListener("slotchange", this.onSlotChange.bind(this));
    this.addEventListener("keydown", this.handleKeyboard);
  }
  static get observedAttributes() {
    return ["selected-index"];
  }
  connectedCallback() {
    this.setupComponent();
    this.selectedIndex = this.selectedIndex;
  }
  disconnectedCallback() {
    this.delegate.destroy();
  }
  /**
   * --------------------------------------------------------------------------
   * GETTERS AND SETTERS
   * --------------------------------------------------------------------------
   */
  get animationDuration() {
    return this.hasAttribute("animation-duration") ? parseFloat(this.getAttribute("animation-duration")) : 0.15;
  }
  get selectedIndex() {
    return parseInt(this.getAttribute("selected-index")) || 0;
  }
  set selectedIndex(index) {
    this.setAttribute("selected-index", Math.min(Math.max(index, 0), this.buttons.length - 1).toString());
    this.style.setProperty("--selected-index", this.selectedIndex.toString());
  }
  /**
   * --------------------------------------------------------------------------
   * METHODS
   * --------------------------------------------------------------------------
   */
  attributeChangedCallback(name, oldValue, newValue) {
    this.buttons.forEach((button, index) => button.setAttribute("aria-selected", index === parseInt(newValue) ? "true" : "false"));
    if (name === "selected-index" && oldValue !== null && oldValue !== newValue) {
      this.transition(this.panels[parseInt(oldValue)], this.panels[parseInt(newValue)]);
    }
  }
  /**
   * Perform a custom transition (can be overridden in subclasses). To "from" and "to" are hash representing the panel
   */
  async transition(fromPanel, toPanel) {
    if (fromPanel) {
      await animate11(fromPanel, { opacity: [1, 0] }, { duration: this.animationDuration }).finished;
      fromPanel.hidden = true;
    }
    if (toPanel) {
      toPanel.hidden = false;
      this.dispatchEvent(new CustomEvent("tab:changed"));
      await animate11(toPanel, { opacity: [0, 1], transform: ["translateY(6px)", "translateY(0)"] }, { duration: this.animationDuration }).finished;
    }
  }
  setupComponent() {
    this.buttons = Array.from(this.shadowRoot.querySelector('slot[name="title"]').assignedNodes(), (item) => item.matches("button") && item || item.querySelector("button"));
    this.panels = Array.from(this.shadowRoot.querySelector('slot[name="content"]').assignedNodes());
    this.buttons.forEach((button, index) => {
      button.setAttribute("role", "tab");
      button.setAttribute("aria-controls", `tab-panel-${this.componentID}-${index}`);
      button.id = `tab-${this.componentID}-${index}`;
    });
    this.panels.forEach((panel, index) => {
      panel.setAttribute("role", "tabpanel");
      panel.setAttribute("aria-labelledby", `tab-${this.componentID}-${index}`);
      panel.id = `tab-panel-${this.componentID}-${index}`;
      panel.hidden = index !== this.selectedIndex;
    });
    this.style.setProperty("--item-count", this.buttons.length.toString());
  }
  onButtonClicked(event, button) {
    this.selectedIndex = this.buttons.indexOf(button);
  }
  onSlotChange() {
    this.setupComponent();
  }
  /**
   * As per https://www.w3.org/WAI/ARIA/apg/example-index/tabs/tabs-automatic.html, when a tab is currently focused,
   * left and right arrow should switch the tab
   */
  handleKeyboard(event) {
    const index = this.buttons.indexOf(document.activeElement);
    if (index === -1 || !["ArrowLeft", "ArrowRight"].includes(event.key)) {
      return;
    }
    if (event.key === "ArrowLeft") {
      this.selectedIndex = (this.selectedIndex - 1 + this.buttons.length) % this.buttons.length;
    } else {
      this.selectedIndex = (this.selectedIndex + 1 + this.buttons.length) % this.buttons.length;
    }
    this.buttons[this.selectedIndex].focus();
  }
};
if (!window.customElements.get("x-tabs")) {
  window.customElements.define("x-tabs", Tabs);
}

// js/common/search/algolia-recommend.js
var import_recommend = __toESM(require_recommend_umd());

// node_modules/petite-vue/dist/petite-vue.es.js
var tt = Object.defineProperty;
var nt = (e, t, n) => t in e ? tt(e, t, { enumerable: true, configurable: true, writable: true, value: n }) : e[t] = n;
var $ = (e, t, n) => (nt(e, typeof t != "symbol" ? t + "" : t, n), n);
function st(e, t) {
  const n = /* @__PURE__ */ Object.create(null), s = e.split(",");
  for (let r = 0; r < s.length; r++) n[s[r]] = true;
  return t ? (r) => !!n[r.toLowerCase()] : (r) => !!n[r];
}
function de(e) {
  if (y(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++) {
      const s = e[n], r = N(s) ? it(s) : de(s);
      if (r) for (const i in r) t[i] = r[i];
    }
    return t;
  } else {
    if (N(e)) return e;
    if (S(e)) return e;
  }
}
var rt = /;(?![^(]*\))/g;
var ot = /:(.+)/;
function it(e) {
  const t = {};
  return e.split(rt).forEach((n) => {
    if (n) {
      const s = n.split(ot);
      s.length > 1 && (t[s[0].trim()] = s[1].trim());
    }
  }), t;
}
function me(e) {
  let t = "";
  if (N(e)) t = e;
  else if (y(e)) for (let n = 0; n < e.length; n++) {
    const s = me(e[n]);
    s && (t += s + " ");
  }
  else if (S(e)) for (const n in e) e[n] && (t += n + " ");
  return t.trim();
}
function ct(e, t) {
  if (e.length !== t.length) return false;
  let n = true;
  for (let s = 0; n && s < e.length; s++) n = I(e[s], t[s]);
  return n;
}
function I(e, t) {
  if (e === t) return true;
  let n = ge(e), s = ge(t);
  if (n || s) return n && s ? e.getTime() === t.getTime() : false;
  if (n = y(e), s = y(t), n || s) return n && s ? ct(e, t) : false;
  if (n = S(e), s = S(t), n || s) {
    if (!n || !s) return false;
    const r = Object.keys(e).length, i = Object.keys(t).length;
    if (r !== i) return false;
    for (const c in e) {
      const o = e.hasOwnProperty(c), l = t.hasOwnProperty(c);
      if (o && !l || !o && l || !I(e[c], t[c])) return false;
    }
  }
  return String(e) === String(t);
}
function G(e, t) {
  return e.findIndex((n) => I(n, t));
}
var lt = Object.assign;
var ft = (e, t) => {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
};
var at = Object.prototype.hasOwnProperty;
var U = (e, t) => at.call(e, t);
var y = Array.isArray;
var Y = (e) => ye(e) === "[object Map]";
var ge = (e) => e instanceof Date;
var N = (e) => typeof e == "string";
var Q = (e) => typeof e == "symbol";
var S = (e) => e !== null && typeof e == "object";
var ut = Object.prototype.toString;
var ye = (e) => ut.call(e);
var pt = (e) => ye(e).slice(8, -1);
var X = (e) => N(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e;
var be = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  return (n) => t[n] || (t[n] = e(n));
};
var ht = /-(\w)/g;
var dt = be((e) => e.replace(ht, (t, n) => n ? n.toUpperCase() : ""));
var mt = /\B([A-Z])/g;
var xe = be((e) => e.replace(mt, "-$1").toLowerCase());
var gt = (e, t) => !Object.is(e, t);
var ve = (e) => {
  const t = parseFloat(e);
  return isNaN(t) ? e : t;
};
var yt;
function we(e, t) {
  t = t || yt, t && t.active && t.effects.push(e);
}
var _e = (e) => {
  const t = new Set(e);
  return t.w = 0, t.n = 0, t;
};
var Ee = (e) => (e.w & O) > 0;
var $e = (e) => (e.n & O) > 0;
var bt = ({ deps: e }) => {
  if (e.length) for (let t = 0; t < e.length; t++) e[t].w |= O;
};
var xt = (e) => {
  const { deps: t } = e;
  if (t.length) {
    let n = 0;
    for (let s = 0; s < t.length; s++) {
      const r = t[s];
      Ee(r) && !$e(r) ? r.delete(e) : t[n++] = r, r.w &= ~O, r.n &= ~O;
    }
    t.length = n;
  }
};
var ee = /* @__PURE__ */ new WeakMap();
var B = 0;
var O = 1;
var te = 30;
var z = [];
var C;
var W = Symbol("");
var Se = Symbol("");
var vt = class {
  constructor(t, n = null, s) {
    this.fn = t, this.scheduler = n, this.active = true, this.deps = [], we(this, s);
  }
  run() {
    if (!this.active) return this.fn();
    if (!z.includes(this)) try {
      return z.push(C = this), $t(), O = 1 << ++B, B <= te ? bt(this) : Oe(this), this.fn();
    } finally {
      B <= te && xt(this), O = 1 << --B, ke(), z.pop();
      const t = z.length;
      C = t > 0 ? z[t - 1] : void 0;
    }
  }
  stop() {
    this.active && (Oe(this), this.onStop && this.onStop(), this.active = false);
  }
};
function Oe(e) {
  const { deps: t } = e;
  if (t.length) {
    for (let n = 0; n < t.length; n++) t[n].delete(e);
    t.length = 0;
  }
}
function wt(e, t) {
  e.effect && (e = e.effect.fn);
  const n = new vt(e);
  t && (lt(n, t), t.scope && we(n, t.scope)), (!t || !t.lazy) && n.run();
  const s = n.run.bind(n);
  return s.effect = n, s;
}
function _t(e) {
  e.effect.stop();
}
var K = true;
var ne = [];
function Et() {
  ne.push(K), K = false;
}
function $t() {
  ne.push(K), K = true;
}
function ke() {
  const e = ne.pop();
  K = e === void 0 ? true : e;
}
function F(e, t, n) {
  if (!St()) return;
  let s = ee.get(e);
  s || ee.set(e, s = /* @__PURE__ */ new Map());
  let r = s.get(n);
  r || s.set(n, r = _e()), Ot(r);
}
function St() {
  return K && C !== void 0;
}
function Ot(e, t) {
  let n = false;
  B <= te ? $e(e) || (e.n |= O, n = !Ee(e)) : n = !e.has(C), n && (e.add(C), C.deps.push(e));
}
function se(e, t, n, s, r, i) {
  const c = ee.get(e);
  if (!c) return;
  let o = [];
  if (t === "clear") o = [...c.values()];
  else if (n === "length" && y(e)) c.forEach((l, f) => {
    (f === "length" || f >= s) && o.push(l);
  });
  else switch (n !== void 0 && o.push(c.get(n)), t) {
    case "add":
      y(e) ? X(n) && o.push(c.get("length")) : (o.push(c.get(W)), Y(e) && o.push(c.get(Se)));
      break;
    case "delete":
      y(e) || (o.push(c.get(W)), Y(e) && o.push(c.get(Se)));
      break;
    case "set":
      Y(e) && o.push(c.get(W));
      break;
  }
  if (o.length === 1) o[0] && Te(o[0]);
  else {
    const l = [];
    for (const f of o) f && l.push(...f);
    Te(_e(l));
  }
}
function Te(e, t) {
  for (const n of y(e) ? e : [...e]) (n !== C || n.allowRecurse) && (n.scheduler ? n.scheduler() : n.run());
}
var kt = st("__proto__,__v_isRef,__isVue");
var Ae = new Set(Object.getOwnPropertyNames(Symbol).map((e) => Symbol[e]).filter(Q));
var Tt = Me();
var At = Me(true);
var Re = Rt();
function Rt() {
  const e = {};
  return ["includes", "indexOf", "lastIndexOf"].forEach((t) => {
    e[t] = function(...n) {
      const s = j(this);
      for (let i = 0, c = this.length; i < c; i++) F(s, "get", i + "");
      const r = s[t](...n);
      return r === -1 || r === false ? s[t](...n.map(j)) : r;
    };
  }), ["push", "pop", "shift", "unshift", "splice"].forEach((t) => {
    e[t] = function(...n) {
      Et();
      const s = j(this)[t].apply(this, n);
      return ke(), s;
    };
  }), e;
}
function Me(e = false, t = false) {
  return function(s, r, i) {
    if (r === "__v_isReactive") return !e;
    if (r === "__v_isReadonly") return e;
    if (r === "__v_raw" && i === (e ? t ? zt : je : t ? Bt : Ce).get(s)) return s;
    const c = y(s);
    if (!e && c && U(Re, r)) return Reflect.get(Re, r, i);
    const o = Reflect.get(s, r, i);
    return (Q(r) ? Ae.has(r) : kt(r)) || (e || F(s, "get", r), t) ? o : re(o) ? !c || !X(r) ? o.value : o : S(o) ? e ? Ht(o) : D(o) : o;
  };
}
var Mt = Ct();
function Ct(e = false) {
  return function(n, s, r, i) {
    let c = n[s];
    if (!e && !Lt(r) && (r = j(r), c = j(c), !y(n) && re(c) && !re(r))) return c.value = r, true;
    const o = y(n) && X(s) ? Number(s) < n.length : U(n, s), l = Reflect.set(n, s, r, i);
    return n === j(i) && (o ? gt(r, c) && se(n, "set", s, r) : se(n, "add", s, r)), l;
  };
}
function jt(e, t) {
  const n = U(e, t);
  e[t];
  const s = Reflect.deleteProperty(e, t);
  return s && n && se(e, "delete", t, void 0), s;
}
function Pt(e, t) {
  const n = Reflect.has(e, t);
  return (!Q(t) || !Ae.has(t)) && F(e, "has", t), n;
}
function It(e) {
  return F(e, "iterate", y(e) ? "length" : W), Reflect.ownKeys(e);
}
var Nt = { get: Tt, set: Mt, deleteProperty: jt, has: Pt, ownKeys: It };
var Kt = { get: At, set(e, t) {
  return true;
}, deleteProperty(e, t) {
  return true;
} };
var Ce = /* @__PURE__ */ new WeakMap();
var Bt = /* @__PURE__ */ new WeakMap();
var je = /* @__PURE__ */ new WeakMap();
var zt = /* @__PURE__ */ new WeakMap();
function Dt(e) {
  switch (e) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function Vt(e) {
  return e.__v_skip || !Object.isExtensible(e) ? 0 : Dt(pt(e));
}
function D(e) {
  return e && e.__v_isReadonly ? e : Pe(e, false, Nt, null, Ce);
}
function Ht(e) {
  return Pe(e, true, Kt, null, je);
}
function Pe(e, t, n, s, r) {
  if (!S(e) || e.__v_raw && !(t && e.__v_isReactive)) return e;
  const i = r.get(e);
  if (i) return i;
  const c = Vt(e);
  if (c === 0) return e;
  const o = new Proxy(e, c === 2 ? s : n);
  return r.set(e, o), o;
}
function Lt(e) {
  return !!(e && e.__v_isReadonly);
}
function j(e) {
  const t = e && e.__v_raw;
  return t ? j(t) : e;
}
function re(e) {
  return Boolean(e && e.__v_isRef === true);
}
Promise.resolve();
var oe = false;
var q = [];
var Wt = Promise.resolve();
var V = (e) => Wt.then(e);
var Ie = (e) => {
  q.includes(e) || q.push(e), oe || (oe = true, V(Ft));
};
var Ft = () => {
  for (const e of q) e();
  q.length = 0, oe = false;
};
var qt = /^(spellcheck|draggable|form|list|type)$/;
var ie = ({ el: e, get: t, effect: n, arg: s, modifiers: r }) => {
  let i;
  s === "class" && (e._class = e.className), n(() => {
    let c = t();
    if (s) (r == null ? void 0 : r.camel) && (s = dt(s)), ce(e, s, c, i);
    else {
      for (const o in c) ce(e, o, c[o], i && i[o]);
      for (const o in i) (!c || !(o in c)) && ce(e, o, null);
    }
    i = c;
  });
};
var ce = (e, t, n, s) => {
  if (t === "class") e.setAttribute("class", me(e._class ? [e._class, n] : n) || "");
  else if (t === "style") {
    n = de(n);
    const { style: r } = e;
    if (!n) e.removeAttribute("style");
    else if (N(n)) n !== s && (r.cssText = n);
    else {
      for (const i in n) le(r, i, n[i]);
      if (s && !N(s)) for (const i in s) n[i] == null && le(r, i, "");
    }
  } else !(e instanceof SVGElement) && t in e && !qt.test(t) ? (e[t] = n, t === "value" && (e._value = n)) : t === "true-value" ? e._trueValue = n : t === "false-value" ? e._falseValue = n : n != null ? e.setAttribute(t, n) : e.removeAttribute(t);
};
var Ne = /\s*!important$/;
var le = (e, t, n) => {
  y(n) ? n.forEach((s) => le(e, t, s)) : t.startsWith("--") ? e.setProperty(t, n) : Ne.test(n) ? e.setProperty(xe(t), n.replace(Ne, ""), "important") : e[t] = n;
};
var k = (e, t) => {
  const n = e.getAttribute(t);
  return n != null && e.removeAttribute(t), n;
};
var T = (e, t, n, s) => {
  e.addEventListener(t, n, s);
};
var Jt = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;
var Zt = ["ctrl", "shift", "alt", "meta"];
var Gt = { stop: (e) => e.stopPropagation(), prevent: (e) => e.preventDefault(), self: (e) => e.target !== e.currentTarget, ctrl: (e) => !e.ctrlKey, shift: (e) => !e.shiftKey, alt: (e) => !e.altKey, meta: (e) => !e.metaKey, left: (e) => "button" in e && e.button !== 0, middle: (e) => "button" in e && e.button !== 1, right: (e) => "button" in e && e.button !== 2, exact: (e, t) => Zt.some((n) => e[`${n}Key`] && !t[n]) };
var Ke = ({ el: e, get: t, exp: n, arg: s, modifiers: r }) => {
  if (!s) return;
  let i = Jt.test(n) ? t(`(e => ${n}(e))`) : t(`($event => { ${n} })`);
  if (s === "vue:mounted") {
    V(i);
    return;
  } else if (s === "vue:unmounted") return () => i();
  if (r) {
    s === "click" && (r.right && (s = "contextmenu"), r.middle && (s = "mouseup"));
    const c = i;
    i = (o) => {
      if (!("key" in o && !(xe(o.key) in r))) {
        for (const l in r) {
          const f = Gt[l];
          if (f && f(o, r)) return;
        }
        return c(o);
      }
    };
  }
  T(e, s, i, r);
};
var Ut = ({ el: e, get: t, effect: n }) => {
  const s = e.style.display;
  n(() => {
    e.style.display = t() ? s : "none";
  });
};
var Be = ({ el: e, get: t, effect: n }) => {
  n(() => {
    e.textContent = ze(t());
  });
};
var ze = (e) => e == null ? "" : S(e) ? JSON.stringify(e, null, 2) : String(e);
var Yt = ({ el: e, get: t, effect: n }) => {
  n(() => {
    e.innerHTML = t();
  });
};
var Qt = ({ el: e, exp: t, get: n, effect: s, modifiers: r }) => {
  const i = e.type, c = n(`(val) => { ${t} = val }`), { trim: o, number: l = i === "number" } = r || {};
  if (e.tagName === "SELECT") {
    const f = e;
    T(e, "change", () => {
      const a = Array.prototype.filter.call(f.options, (u) => u.selected).map((u) => l ? ve(A(u)) : A(u));
      c(f.multiple ? a : a[0]);
    }), s(() => {
      const a = n(), u = f.multiple;
      for (let p = 0, x = f.options.length; p < x; p++) {
        const b = f.options[p], v = A(b);
        if (u) y(a) ? b.selected = G(a, v) > -1 : b.selected = a.has(v);
        else if (I(A(b), a)) {
          f.selectedIndex !== p && (f.selectedIndex = p);
          return;
        }
      }
      !u && f.selectedIndex !== -1 && (f.selectedIndex = -1);
    });
  } else if (i === "checkbox") {
    T(e, "change", () => {
      const a = n(), u = e.checked;
      if (y(a)) {
        const p = A(e), x = G(a, p), b = x !== -1;
        if (u && !b) c(a.concat(p));
        else if (!u && b) {
          const v = [...a];
          v.splice(x, 1), c(v);
        }
      } else c(De(e, u));
    });
    let f;
    s(() => {
      const a = n();
      y(a) ? e.checked = G(a, A(e)) > -1 : a !== f && (e.checked = I(a, De(e, true))), f = a;
    });
  } else if (i === "radio") {
    T(e, "change", () => {
      c(A(e));
    });
    let f;
    s(() => {
      const a = n();
      a !== f && (e.checked = I(a, A(e)));
    });
  } else {
    const f = (a) => o ? a.trim() : l ? ve(a) : a;
    T(e, "compositionstart", Xt), T(e, "compositionend", en), T(e, (r == null ? void 0 : r.lazy) ? "change" : "input", () => {
      e.composing || c(f(e.value));
    }), o && T(e, "change", () => {
      e.value = e.value.trim();
    }), s(() => {
      if (e.composing) return;
      const a = e.value, u = n();
      document.activeElement === e && f(a) === u || a !== u && (e.value = u);
    });
  }
};
var A = (e) => "_value" in e ? e._value : e.value;
var De = (e, t) => {
  const n = t ? "_trueValue" : "_falseValue";
  return n in e ? e[n] : t;
};
var Xt = (e) => {
  e.target.composing = true;
};
var en = (e) => {
  const t = e.target;
  t.composing && (t.composing = false, tn(t, "input"));
};
var tn = (e, t) => {
  const n = document.createEvent("HTMLEvents");
  n.initEvent(t, true, true), e.dispatchEvent(n);
};
var Ve = /* @__PURE__ */ Object.create(null);
var H = (e, t, n) => He(e, `return(${t})`, n);
var He = (e, t, n) => {
  const s = Ve[t] || (Ve[t] = nn(t));
  try {
    return s(e, n);
  } catch (r) {
    console.error(r);
  }
};
var nn = (e) => {
  try {
    return new Function("$data", "$el", `with($data){${e}}`);
  } catch (t) {
    return console.error(`${t.message} in expression: ${e}`), () => {
    };
  }
};
var sn = ({ el: e, ctx: t, exp: n, effect: s }) => {
  V(() => s(() => He(t.scope, n, e)));
};
var rn = { bind: ie, on: Ke, show: Ut, text: Be, html: Yt, model: Qt, effect: sn };
var on = (e, t, n) => {
  const s = e.parentElement, r = new Comment("v-if");
  s.insertBefore(r, e);
  const i = [{ exp: t, el: e }];
  let c, o;
  for (; (c = e.nextElementSibling) && (o = null, k(c, "v-else") === "" || (o = k(c, "v-else-if"))); ) s.removeChild(c), i.push({ exp: o, el: c });
  const l = e.nextSibling;
  s.removeChild(e);
  let f, a = -1;
  const u = () => {
    f && (s.insertBefore(r, f.el), f.remove(), f = void 0);
  };
  return n.effect(() => {
    for (let p = 0; p < i.length; p++) {
      const { exp: x, el: b } = i[p];
      if (!x || H(n.scope, x)) {
        p !== a && (u(), f = new ue(b, n), f.insert(s, r), s.removeChild(r), a = p);
        return;
      }
    }
    a = -1, u();
  }), l;
};
var cn = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var Le = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var ln = /^\(|\)$/g;
var fn = /^[{[]\s*((?:[\w_$]+\s*,?\s*)+)[\]}]$/;
var an = (e, t, n) => {
  const s = t.match(cn);
  if (!s) return;
  const r = e.nextSibling, i = e.parentElement, c = new Text("");
  i.insertBefore(c, e), i.removeChild(e);
  const o = s[2].trim();
  let l = s[1].trim().replace(ln, "").trim(), f, a = false, u, p, x = "key", b = e.getAttribute(x) || e.getAttribute(x = ":key") || e.getAttribute(x = "v-bind:key");
  b && (e.removeAttribute(x), x === "key" && (b = JSON.stringify(b)));
  let v;
  (v = l.match(Le)) && (l = l.replace(Le, "").trim(), u = v[1].trim(), v[2] && (p = v[2].trim())), (v = l.match(fn)) && (f = v[1].split(",").map((m) => m.trim()), a = l[0] === "[");
  let pe = false, R, L, J;
  const et = (m) => {
    const w = /* @__PURE__ */ new Map(), h = [];
    if (y(m)) for (let d = 0; d < m.length; d++) h.push(Z(w, m[d], d));
    else if (typeof m == "number") for (let d = 0; d < m; d++) h.push(Z(w, d + 1, d));
    else if (S(m)) {
      let d = 0;
      for (const g in m) h.push(Z(w, m[g], d++, g));
    }
    return [h, w];
  }, Z = (m, w, h, d) => {
    const g = {};
    f ? f.forEach((M, E) => g[M] = w[a ? E : M]) : g[l] = w, d ? (u && (g[u] = d), p && (g[p] = h)) : u && (g[u] = h);
    const P = Ge(n, g), _ = b ? H(P.scope, b) : h;
    return m.set(_, h), P.key = _, P;
  }, he = (m, w) => {
    const h = new ue(e, m);
    return h.key = m.key, h.insert(i, w), h;
  };
  return n.effect(() => {
    const m = H(n.scope, o), w = J;
    if ([L, J] = et(m), !pe) R = L.map((h) => he(h, c)), pe = true;
    else {
      for (let _ = 0; _ < R.length; _++) J.has(R[_].key) || R[_].remove();
      const h = [];
      let d = L.length, g, P;
      for (; d--; ) {
        const _ = L[d], M = w.get(_.key);
        let E;
        M == null ? E = he(_, g ? g.el : c) : (E = R[M], Object.assign(E.ctx.scope, _.scope), M !== d && (R[M + 1] !== g || P === g) && (P = E, E.insert(i, g ? g.el : c))), h.unshift(g = E);
      }
      R = h;
    }
  }), r;
};
var We = ({ el: e, ctx: { scope: { $refs: t } }, get: n, effect: s }) => {
  let r;
  return s(() => {
    const i = n();
    t[i] = e, r && i !== r && delete t[r], r = i;
  }), () => {
    r && delete t[r];
  };
};
var un = /^(?:v-|:|@)/;
var pn = /\.([\w-]+)/g;
var fe = false;
var Fe = (e, t) => {
  const n = e.nodeType;
  if (n === 1) {
    const s = e;
    if (s.hasAttribute("v-pre")) return;
    k(s, "v-cloak");
    let r;
    if (r = k(s, "v-if")) return on(s, r, t);
    if (r = k(s, "v-for")) return an(s, r, t);
    if ((r = k(s, "v-scope")) || r === "") {
      const o = r ? H(t.scope, r) : {};
      t = Ge(t, o), o.$template && hn(s, o.$template);
    }
    const i = k(s, "v-once") != null;
    i && (fe = true), (r = k(s, "ref")) && ae(s, We, `"${r}"`, t), qe(s, t);
    const c = [];
    for (const { name: o, value: l } of [...s.attributes]) un.test(o) && o !== "v-cloak" && (o === "v-model" ? c.unshift([o, l]) : o[0] === "@" || /^v-on\b/.test(o) ? c.push([o, l]) : Je(s, o, l, t));
    for (const [o, l] of c) Je(s, o, l, t);
    i && (fe = false);
  } else if (n === 3) {
    const s = e.data;
    if (s.includes(t.delimiters[0])) {
      let r = [], i = 0, c;
      for (; c = t.delimitersRE.exec(s); ) {
        const o = s.slice(i, c.index);
        o && r.push(JSON.stringify(o)), r.push(`$s(${c[1]})`), i = c.index + c[0].length;
      }
      i < s.length && r.push(JSON.stringify(s.slice(i))), ae(e, Be, r.join("+"), t);
    }
  } else n === 11 && qe(e, t);
};
var qe = (e, t) => {
  let n = e.firstChild;
  for (; n; ) n = Fe(n, t) || n.nextSibling;
};
var Je = (e, t, n, s) => {
  let r, i, c;
  if (t = t.replace(pn, (o, l) => ((c || (c = {}))[l] = true, "")), t[0] === ":") r = ie, i = t.slice(1);
  else if (t[0] === "@") r = Ke, i = t.slice(1);
  else {
    const o = t.indexOf(":"), l = o > 0 ? t.slice(2, o) : t.slice(2);
    r = rn[l] || s.dirs[l], i = o > 0 ? t.slice(o + 1) : void 0;
  }
  r && (r === ie && i === "ref" && (r = We), ae(e, r, n, s, i, c), e.removeAttribute(t));
};
var ae = (e, t, n, s, r, i) => {
  const c = t({ el: e, get: (o = n) => H(s.scope, o, e), effect: s.effect, ctx: s, exp: n, arg: r, modifiers: i });
  c && s.cleanups.push(c);
};
var hn = (e, t) => {
  if (t[0] === "#") {
    const n = document.querySelector(t);
    e.appendChild(n.content.cloneNode(true));
    return;
  }
  e.innerHTML = t;
};
var Ze = (e) => {
  const t = { delimiters: ["{{", "}}"], delimitersRE: /\{\{([^]+?)\}\}/g, ...e, scope: e ? e.scope : D({}), dirs: e ? e.dirs : {}, effects: [], blocks: [], cleanups: [], effect: (n) => {
    if (fe) return Ie(n), n;
    const s = wt(n, { scheduler: () => Ie(s) });
    return t.effects.push(s), s;
  } };
  return t;
};
var Ge = (e, t = {}) => {
  const n = e.scope, s = Object.create(n);
  Object.defineProperties(s, Object.getOwnPropertyDescriptors(t)), s.$refs = Object.create(n.$refs);
  const r = D(new Proxy(s, { set(i, c, o, l) {
    return l === r && !i.hasOwnProperty(c) ? Reflect.set(n, c, o) : Reflect.set(i, c, o, l);
  } }));
  return Ue(r), { ...e, scope: r };
};
var Ue = (e) => {
  for (const t of Object.keys(e)) typeof e[t] == "function" && (e[t] = e[t].bind(e));
};
var ue = class {
  constructor(t, n, s = false) {
    $(this, "template");
    $(this, "ctx");
    $(this, "key");
    $(this, "parentCtx");
    $(this, "isFragment");
    $(this, "start");
    $(this, "end");
    this.isFragment = t instanceof HTMLTemplateElement, s ? this.template = t : this.isFragment ? this.template = t.content.cloneNode(true) : this.template = t.cloneNode(true), s ? this.ctx = n : (this.parentCtx = n, n.blocks.push(this), this.ctx = Ze(n)), Fe(this.template, this.ctx);
  }
  get el() {
    return this.start || this.template;
  }
  insert(t, n = null) {
    if (this.isFragment) if (this.start) {
      let s = this.start, r;
      for (; s && (r = s.nextSibling, t.insertBefore(s, n), s !== this.end); ) s = r;
    } else this.start = new Text(""), this.end = new Text(""), t.insertBefore(this.end, n), t.insertBefore(this.start, this.end), t.insertBefore(this.template, this.end);
    else t.insertBefore(this.template, n);
  }
  remove() {
    if (this.parentCtx && ft(this.parentCtx.blocks, this), this.start) {
      const t = this.start.parentNode;
      let n = this.start, s;
      for (; n && (s = n.nextSibling, t.removeChild(n), n !== this.end); ) n = s;
    } else this.template.parentNode.removeChild(this.template);
    this.teardown();
  }
  teardown() {
    this.ctx.blocks.forEach((t) => {
      t.teardown();
    }), this.ctx.effects.forEach(_t), this.ctx.cleanups.forEach((t) => t());
  }
};
var Ye = (e) => e.replace(/[-.*+?^${}()|[\]\/\\]/g, "\\$&");
var Qe = (e) => {
  const t = Ze();
  if (e && (t.scope = D(e), Ue(t.scope), e.$delimiters)) {
    const [s, r] = t.delimiters = e.$delimiters;
    t.delimitersRE = new RegExp(Ye(s) + "([^]+?)" + Ye(r), "g");
  }
  t.scope.$s = ze, t.scope.$nextTick = V, t.scope.$refs = /* @__PURE__ */ Object.create(null);
  let n;
  return { directive(s, r) {
    return r ? (t.dirs[s] = r, this) : t.dirs[s];
  }, mount(s) {
    if (typeof s == "string" && (s = document.querySelector(s), !s)) return;
    s = s || document.documentElement;
    let r;
    return s.hasAttribute("v-scope") ? r = [s] : r = [...s.querySelectorAll("[v-scope]")].filter((i) => !i.matches("[v-scope] [v-scope]")), r.length || (r = [s]), n = r.map((i) => new ue(i, t, true)), this;
  }, unmount() {
    n.forEach((s) => s.teardown());
  } };
};
var Xe = document.currentScript;
Xe && Xe.hasAttribute("init") && Qe().mount();

// node_modules/@motionone/utils/dist/array.es.js
function addUniqueItem(array, item) {
  array.indexOf(item) === -1 && array.push(item);
}
function removeItem(arr, item) {
  const index = arr.indexOf(item);
  index > -1 && arr.splice(index, 1);
}

// node_modules/@motionone/utils/dist/clamp.es.js
var clamp3 = (min4, max4, v) => Math.min(Math.max(v, min4), max4);

// node_modules/@motionone/utils/dist/defaults.es.js
var defaults = {
  duration: 0.3,
  delay: 0,
  endDelay: 0,
  repeat: 0,
  easing: "ease"
};

// node_modules/@motionone/utils/dist/is-number.es.js
var isNumber = (value) => typeof value === "number";

// node_modules/@motionone/utils/dist/is-easing-list.es.js
var isEasingList = (easing) => Array.isArray(easing) && !isNumber(easing[0]);

// node_modules/@motionone/utils/dist/wrap.es.js
var wrap = (min4, max4, v) => {
  const rangeSize = max4 - min4;
  return ((v - min4) % rangeSize + rangeSize) % rangeSize + min4;
};

// node_modules/@motionone/utils/dist/easing.es.js
function getEasingForSegment(easing, i) {
  return isEasingList(easing) ? easing[wrap(0, easing.length, i)] : easing;
}

// node_modules/@motionone/utils/dist/mix.es.js
var mix = (min4, max4, progress2) => -progress2 * min4 + progress2 * max4 + min4;

// node_modules/@motionone/utils/dist/noop.es.js
var noop3 = () => {
};
var noopReturn = (v) => v;

// node_modules/@motionone/utils/dist/progress.es.js
var progress = (min4, max4, value) => max4 - min4 === 0 ? 1 : (value - min4) / (max4 - min4);

// node_modules/@motionone/utils/dist/offset.es.js
function fillOffset(offset, remaining) {
  const min4 = offset[offset.length - 1];
  for (let i = 1; i <= remaining; i++) {
    const offsetProgress = progress(0, remaining, i);
    offset.push(mix(min4, 1, offsetProgress));
  }
}
function defaultOffset(length) {
  const offset = [0];
  fillOffset(offset, length - 1);
  return offset;
}

// node_modules/@motionone/utils/dist/interpolate.es.js
function interpolate(output, input = defaultOffset(output.length), easing = noopReturn) {
  const length = output.length;
  const remainder = length - input.length;
  remainder > 0 && fillOffset(input, remainder);
  return (t) => {
    let i = 0;
    for (; i < length - 2; i++) {
      if (t < input[i + 1])
        break;
    }
    let progressInRange = clamp3(0, 1, progress(input[i], input[i + 1], t));
    const segmentEasing = getEasingForSegment(easing, i);
    progressInRange = segmentEasing(progressInRange);
    return mix(output[i], output[i + 1], progressInRange);
  };
}

// node_modules/@motionone/utils/dist/is-cubic-bezier.es.js
var isCubicBezier = (easing) => Array.isArray(easing) && isNumber(easing[0]);

// node_modules/@motionone/utils/dist/is-easing-generator.es.js
var isEasingGenerator = (easing) => typeof easing === "object" && Boolean(easing.createAnimation);

// node_modules/@motionone/utils/dist/is-function.es.js
var isFunction2 = (value) => typeof value === "function";

// node_modules/@motionone/utils/dist/is-string.es.js
var isString2 = (value) => typeof value === "string";

// node_modules/@motionone/utils/dist/time.es.js
var time = {
  ms: (seconds) => seconds * 1e3,
  s: (milliseconds) => milliseconds / 1e3
};

// node_modules/@motionone/easing/dist/cubic-bezier.es.js
var calcBezier = (t, a1, a2) => (((1 - 3 * a2 + 3 * a1) * t + (3 * a2 - 6 * a1)) * t + 3 * a1) * t;
var subdivisionPrecision = 1e-7;
var subdivisionMaxIterations = 12;
function binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
  let currentX;
  let currentT;
  let i = 0;
  do {
    currentT = lowerBound + (upperBound - lowerBound) / 2;
    currentX = calcBezier(currentT, mX1, mX2) - x;
    if (currentX > 0) {
      upperBound = currentT;
    } else {
      lowerBound = currentT;
    }
  } while (Math.abs(currentX) > subdivisionPrecision && ++i < subdivisionMaxIterations);
  return currentT;
}
function cubicBezier(mX1, mY1, mX2, mY2) {
  if (mX1 === mY1 && mX2 === mY2)
    return noopReturn;
  const getTForX = (aX) => binarySubdivide(aX, 0, 1, mX1, mX2);
  return (t) => t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2);
}

// node_modules/@motionone/easing/dist/steps.es.js
var steps = (steps2, direction = "end") => (progress2) => {
  progress2 = direction === "end" ? Math.min(progress2, 0.999) : Math.max(progress2, 1e-3);
  const expanded = progress2 * steps2;
  const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
  return clamp3(0, 1, rounded / steps2);
};

// node_modules/@motionone/animation/dist/utils/easing.es.js
var namedEasings = {
  ease: cubicBezier(0.25, 0.1, 0.25, 1),
  "ease-in": cubicBezier(0.42, 0, 1, 1),
  "ease-in-out": cubicBezier(0.42, 0, 0.58, 1),
  "ease-out": cubicBezier(0, 0, 0.58, 1)
};
var functionArgsRegex = /\((.*?)\)/;
function getEasingFunction(definition) {
  if (isFunction2(definition))
    return definition;
  if (isCubicBezier(definition))
    return cubicBezier(...definition);
  const namedEasing = namedEasings[definition];
  if (namedEasing)
    return namedEasing;
  if (definition.startsWith("steps")) {
    const args = functionArgsRegex.exec(definition);
    if (args) {
      const argsArray = args[1].split(",");
      return steps(parseFloat(argsArray[0]), argsArray[1].trim());
    }
  }
  return noopReturn;
}

// node_modules/@motionone/animation/dist/Animation.es.js
var Animation = class {
  constructor(output, keyframes = [0, 1], { easing, duration: initialDuration = defaults.duration, delay = defaults.delay, endDelay = defaults.endDelay, repeat = defaults.repeat, offset, direction = "normal", autoplay = true } = {}) {
    this.startTime = null;
    this.rate = 1;
    this.t = 0;
    this.cancelTimestamp = null;
    this.easing = noopReturn;
    this.duration = 0;
    this.totalDuration = 0;
    this.repeat = 0;
    this.playState = "idle";
    this.finished = new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
    easing = easing || defaults.easing;
    if (isEasingGenerator(easing)) {
      const custom = easing.createAnimation(keyframes);
      easing = custom.easing;
      keyframes = custom.keyframes || keyframes;
      initialDuration = custom.duration || initialDuration;
    }
    this.repeat = repeat;
    this.easing = isEasingList(easing) ? noopReturn : getEasingFunction(easing);
    this.updateDuration(initialDuration);
    const interpolate$1 = interpolate(keyframes, offset, isEasingList(easing) ? easing.map(getEasingFunction) : noopReturn);
    this.tick = (timestamp) => {
      var _a;
      delay = delay;
      let t = 0;
      if (this.pauseTime !== void 0) {
        t = this.pauseTime;
      } else {
        t = (timestamp - this.startTime) * this.rate;
      }
      this.t = t;
      t /= 1e3;
      t = Math.max(t - delay, 0);
      if (this.playState === "finished" && this.pauseTime === void 0) {
        t = this.totalDuration;
      }
      const progress2 = t / this.duration;
      let currentIteration = Math.floor(progress2);
      let iterationProgress = progress2 % 1;
      if (!iterationProgress && progress2 >= 1) {
        iterationProgress = 1;
      }
      iterationProgress === 1 && currentIteration--;
      const iterationIsOdd = currentIteration % 2;
      if (direction === "reverse" || direction === "alternate" && iterationIsOdd || direction === "alternate-reverse" && !iterationIsOdd) {
        iterationProgress = 1 - iterationProgress;
      }
      const p = t >= this.totalDuration ? 1 : Math.min(iterationProgress, 1);
      const latest = interpolate$1(this.easing(p));
      output(latest);
      const isAnimationFinished = this.pauseTime === void 0 && (this.playState === "finished" || t >= this.totalDuration + endDelay);
      if (isAnimationFinished) {
        this.playState = "finished";
        (_a = this.resolve) === null || _a === void 0 ? void 0 : _a.call(this, latest);
      } else if (this.playState !== "idle") {
        this.frameRequestId = requestAnimationFrame(this.tick);
      }
    };
    if (autoplay)
      this.play();
  }
  play() {
    const now = performance.now();
    this.playState = "running";
    if (this.pauseTime !== void 0) {
      this.startTime = now - this.pauseTime;
    } else if (!this.startTime) {
      this.startTime = now;
    }
    this.cancelTimestamp = this.startTime;
    this.pauseTime = void 0;
    this.frameRequestId = requestAnimationFrame(this.tick);
  }
  pause() {
    this.playState = "paused";
    this.pauseTime = this.t;
  }
  finish() {
    this.playState = "finished";
    this.tick(0);
  }
  stop() {
    var _a;
    this.playState = "idle";
    if (this.frameRequestId !== void 0) {
      cancelAnimationFrame(this.frameRequestId);
    }
    (_a = this.reject) === null || _a === void 0 ? void 0 : _a.call(this, false);
  }
  cancel() {
    this.stop();
    this.tick(this.cancelTimestamp);
  }
  reverse() {
    this.rate *= -1;
  }
  commitStyles() {
  }
  updateDuration(duration) {
    this.duration = duration;
    this.totalDuration = duration * (this.repeat + 1);
  }
  get currentTime() {
    return this.t;
  }
  set currentTime(t) {
    if (this.pauseTime !== void 0 || this.rate === 0) {
      this.pauseTime = t;
    } else {
      this.startTime = performance.now() - t / this.rate;
    }
  }
  get playbackRate() {
    return this.rate;
  }
  set playbackRate(rate) {
    this.rate = rate;
  }
};

// node_modules/hey-listen/dist/hey-listen.es.js
var warning = function() {
};
var invariant = function() {
};
if (true) {
  warning = function(check, message) {
    if (!check && typeof console !== "undefined") {
      console.warn(message);
    }
  };
  invariant = function(check, message) {
    if (!check) {
      throw new Error(message);
    }
  };
}

// node_modules/@motionone/types/dist/MotionValue.es.js
var MotionValue = class {
  setAnimation(animation) {
    this.animation = animation;
    animation === null || animation === void 0 ? void 0 : animation.finished.then(() => this.clearAnimation()).catch(() => {
    });
  }
  clearAnimation() {
    this.animation = this.generator = void 0;
  }
};

// node_modules/@motionone/dom/dist/animate/data.es.js
var data = /* @__PURE__ */ new WeakMap();
function getAnimationData(element) {
  if (!data.has(element)) {
    data.set(element, {
      transforms: [],
      values: /* @__PURE__ */ new Map()
    });
  }
  return data.get(element);
}
function getMotionValue(motionValues, name) {
  if (!motionValues.has(name)) {
    motionValues.set(name, new MotionValue());
  }
  return motionValues.get(name);
}

// node_modules/@motionone/dom/dist/animate/utils/transforms.es.js
var axes = ["", "X", "Y", "Z"];
var order = ["translate", "scale", "rotate", "skew"];
var transformAlias = {
  x: "translateX",
  y: "translateY",
  z: "translateZ"
};
var rotation = {
  syntax: "<angle>",
  initialValue: "0deg",
  toDefaultUnit: (v) => v + "deg"
};
var baseTransformProperties = {
  translate: {
    syntax: "<length-percentage>",
    initialValue: "0px",
    toDefaultUnit: (v) => v + "px"
  },
  rotate: rotation,
  scale: {
    syntax: "<number>",
    initialValue: 1,
    toDefaultUnit: noopReturn
  },
  skew: rotation
};
var transformDefinitions = /* @__PURE__ */ new Map();
var asTransformCssVar = (name) => `--motion-${name}`;
var transforms = ["x", "y", "z"];
order.forEach((name) => {
  axes.forEach((axis) => {
    transforms.push(name + axis);
    transformDefinitions.set(asTransformCssVar(name + axis), baseTransformProperties[name]);
  });
});
var compareTransformOrder = (a, b) => transforms.indexOf(a) - transforms.indexOf(b);
var transformLookup = new Set(transforms);
var isTransform = (name) => transformLookup.has(name);
var addTransformToElement = (element, name) => {
  if (transformAlias[name])
    name = transformAlias[name];
  const { transforms: transforms2 } = getAnimationData(element);
  addUniqueItem(transforms2, name);
  element.style.transform = buildTransformTemplate(transforms2);
};
var buildTransformTemplate = (transforms2) => transforms2.sort(compareTransformOrder).reduce(transformListToString, "").trim();
var transformListToString = (template, name) => `${template} ${name}(var(${asTransformCssVar(name)}))`;

// node_modules/@motionone/dom/dist/animate/utils/css-var.es.js
var isCssVar = (name) => name.startsWith("--");
var registeredProperties = /* @__PURE__ */ new Set();
function registerCssVariable(name) {
  if (registeredProperties.has(name))
    return;
  registeredProperties.add(name);
  try {
    const { syntax, initialValue } = transformDefinitions.has(name) ? transformDefinitions.get(name) : {};
    CSS.registerProperty({
      name,
      inherits: false,
      syntax,
      initialValue
    });
  } catch (e) {
  }
}

// node_modules/@motionone/dom/dist/animate/utils/feature-detection.es.js
var testAnimation = (keyframes, options) => document.createElement("div").animate(keyframes, options);
var featureTests = {
  cssRegisterProperty: () => typeof CSS !== "undefined" && Object.hasOwnProperty.call(CSS, "registerProperty"),
  waapi: () => Object.hasOwnProperty.call(Element.prototype, "animate"),
  partialKeyframes: () => {
    try {
      testAnimation({ opacity: [1] });
    } catch (e) {
      return false;
    }
    return true;
  },
  finished: () => Boolean(testAnimation({ opacity: [0, 1] }, { duration: 1e-3 }).finished),
  linearEasing: () => {
    try {
      testAnimation({ opacity: 0 }, { easing: "linear(0, 1)" });
    } catch (e) {
      return false;
    }
    return true;
  }
};
var results = {};
var supports = {};
for (const key in featureTests) {
  supports[key] = () => {
    if (results[key] === void 0)
      results[key] = featureTests[key]();
    return results[key];
  };
}

// node_modules/@motionone/dom/dist/animate/utils/easing.es.js
var resolution = 0.015;
var generateLinearEasingPoints = (easing, duration) => {
  let points = "";
  const numPoints = Math.round(duration / resolution);
  for (let i = 0; i < numPoints; i++) {
    points += easing(progress(0, numPoints - 1, i)) + ", ";
  }
  return points.substring(0, points.length - 2);
};
var convertEasing = (easing, duration) => {
  if (isFunction2(easing)) {
    return supports.linearEasing() ? `linear(${generateLinearEasingPoints(easing, duration)})` : defaults.easing;
  } else {
    return isCubicBezier(easing) ? cubicBezierAsString(easing) : easing;
  }
};
var cubicBezierAsString = ([a, b, c, d]) => `cubic-bezier(${a}, ${b}, ${c}, ${d})`;

// node_modules/@motionone/dom/dist/animate/utils/keyframes.es.js
function hydrateKeyframes(keyframes, readInitialValue) {
  for (let i = 0; i < keyframes.length; i++) {
    if (keyframes[i] === null) {
      keyframes[i] = i ? keyframes[i - 1] : readInitialValue();
    }
  }
  return keyframes;
}
var keyframesList = (keyframes) => Array.isArray(keyframes) ? keyframes : [keyframes];

// node_modules/@motionone/dom/dist/animate/utils/get-style-name.es.js
function getStyleName(key) {
  if (transformAlias[key])
    key = transformAlias[key];
  return isTransform(key) ? asTransformCssVar(key) : key;
}

// node_modules/@motionone/dom/dist/animate/style.es.js
var style2 = {
  get: (element, name) => {
    name = getStyleName(name);
    let value = isCssVar(name) ? element.style.getPropertyValue(name) : getComputedStyle(element)[name];
    if (!value && value !== 0) {
      const definition = transformDefinitions.get(name);
      if (definition)
        value = definition.initialValue;
    }
    return value;
  },
  set: (element, name, value) => {
    name = getStyleName(name);
    if (isCssVar(name)) {
      element.style.setProperty(name, value);
    } else {
      element.style[name] = value;
    }
  }
};

// node_modules/@motionone/dom/dist/animate/utils/stop-animation.es.js
function stopAnimation(animation, needsCommit = true) {
  if (!animation || animation.playState === "finished")
    return;
  try {
    if (animation.stop) {
      animation.stop();
    } else {
      needsCommit && animation.commitStyles();
      animation.cancel();
    }
  } catch (e) {
  }
}

// node_modules/@motionone/dom/dist/animate/utils/get-unit.es.js
function getUnitConverter(keyframes, definition) {
  var _a;
  let toUnit = (definition === null || definition === void 0 ? void 0 : definition.toDefaultUnit) || noopReturn;
  const finalKeyframe = keyframes[keyframes.length - 1];
  if (isString2(finalKeyframe)) {
    const unit2 = ((_a = finalKeyframe.match(/(-?[\d.]+)([a-z%]*)/)) === null || _a === void 0 ? void 0 : _a[2]) || "";
    if (unit2)
      toUnit = (value) => value + unit2;
  }
  return toUnit;
}

// node_modules/@motionone/dom/dist/animate/animate-style.es.js
function getDevToolsRecord() {
  return window.__MOTION_DEV_TOOLS_RECORD;
}
function animateStyle(element, key, keyframesDefinition, options = {}, AnimationPolyfill) {
  const record = getDevToolsRecord();
  const isRecording = options.record !== false && record;
  let animation;
  let { duration = defaults.duration, delay = defaults.delay, endDelay = defaults.endDelay, repeat = defaults.repeat, easing = defaults.easing, persist = false, direction, offset, allowWebkitAcceleration = false, autoplay = true } = options;
  const data2 = getAnimationData(element);
  const valueIsTransform = isTransform(key);
  let canAnimateNatively = supports.waapi();
  valueIsTransform && addTransformToElement(element, key);
  const name = getStyleName(key);
  const motionValue = getMotionValue(data2.values, name);
  const definition = transformDefinitions.get(name);
  stopAnimation(motionValue.animation, !(isEasingGenerator(easing) && motionValue.generator) && options.record !== false);
  return () => {
    const readInitialValue = () => {
      var _a, _b;
      return (_b = (_a = style2.get(element, name)) !== null && _a !== void 0 ? _a : definition === null || definition === void 0 ? void 0 : definition.initialValue) !== null && _b !== void 0 ? _b : 0;
    };
    let keyframes = hydrateKeyframes(keyframesList(keyframesDefinition), readInitialValue);
    const toUnit = getUnitConverter(keyframes, definition);
    if (isEasingGenerator(easing)) {
      const custom = easing.createAnimation(keyframes, key !== "opacity", readInitialValue, name, motionValue);
      easing = custom.easing;
      keyframes = custom.keyframes || keyframes;
      duration = custom.duration || duration;
    }
    if (isCssVar(name)) {
      if (supports.cssRegisterProperty()) {
        registerCssVariable(name);
      } else {
        canAnimateNatively = false;
      }
    }
    if (valueIsTransform && !supports.linearEasing() && (isFunction2(easing) || isEasingList(easing) && easing.some(isFunction2))) {
      canAnimateNatively = false;
    }
    if (canAnimateNatively) {
      if (definition) {
        keyframes = keyframes.map((value) => isNumber(value) ? definition.toDefaultUnit(value) : value);
      }
      if (keyframes.length === 1 && (!supports.partialKeyframes() || isRecording)) {
        keyframes.unshift(readInitialValue());
      }
      const animationOptions = {
        delay: time.ms(delay),
        duration: time.ms(duration),
        endDelay: time.ms(endDelay),
        easing: !isEasingList(easing) ? convertEasing(easing, duration) : void 0,
        direction,
        iterations: repeat + 1,
        fill: "both"
      };
      animation = element.animate({
        [name]: keyframes,
        offset,
        easing: isEasingList(easing) ? easing.map((thisEasing) => convertEasing(thisEasing, duration)) : void 0
      }, animationOptions);
      if (!animation.finished) {
        animation.finished = new Promise((resolve, reject) => {
          animation.onfinish = resolve;
          animation.oncancel = reject;
        });
      }
      const target = keyframes[keyframes.length - 1];
      animation.finished.then(() => {
        if (persist)
          return;
        style2.set(element, name, target);
        animation.cancel();
      }).catch(noop3);
      if (!allowWebkitAcceleration)
        animation.playbackRate = 1.000001;
    } else if (AnimationPolyfill && valueIsTransform) {
      keyframes = keyframes.map((value) => typeof value === "string" ? parseFloat(value) : value);
      if (keyframes.length === 1) {
        keyframes.unshift(parseFloat(readInitialValue()));
      }
      animation = new AnimationPolyfill((latest) => {
        style2.set(element, name, toUnit ? toUnit(latest) : latest);
      }, keyframes, Object.assign(Object.assign({}, options), {
        duration,
        easing
      }));
    } else {
      const target = keyframes[keyframes.length - 1];
      style2.set(element, name, definition && isNumber(target) ? definition.toDefaultUnit(target) : target);
    }
    if (isRecording) {
      record(element, key, keyframes, {
        duration,
        delay,
        easing,
        repeat,
        offset
      }, "motion-one");
    }
    motionValue.setAnimation(animation);
    if (animation && !autoplay)
      animation.pause();
    return animation;
  };
}

// node_modules/@motionone/dom/dist/animate/utils/options.es.js
var getOptions = (options, key) => (
  /**
   * TODO: Make test for this
   * Always return a new object otherwise delay is overwritten by results of stagger
   * and this results in no stagger
   */
  options[key] ? Object.assign(Object.assign({}, options), options[key]) : Object.assign({}, options)
);

// node_modules/@motionone/dom/dist/utils/resolve-elements.es.js
function resolveElements(elements, selectorCache) {
  var _a;
  if (typeof elements === "string") {
    if (selectorCache) {
      (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : selectorCache[elements] = document.querySelectorAll(elements);
      elements = selectorCache[elements];
    } else {
      elements = document.querySelectorAll(elements);
    }
  } else if (elements instanceof Element) {
    elements = [elements];
  }
  return Array.from(elements || []);
}

// node_modules/@motionone/dom/dist/animate/utils/controls.es.js
var createAnimation = (factory) => factory();
var withControls = (animationFactory, options, duration = defaults.duration) => {
  return new Proxy({
    animations: animationFactory.map(createAnimation).filter(Boolean),
    duration,
    options
  }, controls);
};
var getActiveAnimation = (state) => state.animations[0];
var controls = {
  get: (target, key) => {
    const activeAnimation = getActiveAnimation(target);
    switch (key) {
      case "duration":
        return target.duration;
      case "currentTime":
        return time.s((activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key]) || 0);
      case "playbackRate":
      case "playState":
        return activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key];
      case "finished":
        if (!target.finished) {
          target.finished = Promise.all(target.animations.map(selectFinished)).catch(noop3);
        }
        return target.finished;
      case "stop":
        return () => {
          target.animations.forEach((animation) => stopAnimation(animation));
        };
      case "forEachNative":
        return (callback) => {
          target.animations.forEach((animation) => callback(animation, target));
        };
      default:
        return typeof (activeAnimation === null || activeAnimation === void 0 ? void 0 : activeAnimation[key]) === "undefined" ? void 0 : () => target.animations.forEach((animation) => animation[key]());
    }
  },
  set: (target, key, value) => {
    switch (key) {
      case "currentTime":
        value = time.ms(value);
      // Fall-through
      case "playbackRate":
        for (let i = 0; i < target.animations.length; i++) {
          target.animations[i][key] = value;
        }
        return true;
    }
    return false;
  }
};
var selectFinished = (animation) => animation.finished;

// node_modules/@motionone/dom/dist/utils/stagger.es.js
function resolveOption(option, i, total) {
  return isFunction2(option) ? option(i, total) : option;
}

// node_modules/tslib/tslib.es6.mjs
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
    t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t[p[i]] = s[p[i]];
    }
  return t;
}

// node_modules/@motionone/dom/dist/timeline/utils/calc-time.es.js
function calcNextTime(current, next, prev, labels) {
  var _a;
  if (isNumber(next)) {
    return next;
  } else if (next.startsWith("-") || next.startsWith("+")) {
    return Math.max(0, current + parseFloat(next));
  } else if (next === "<") {
    return prev;
  } else {
    return (_a = labels.get(next)) !== null && _a !== void 0 ? _a : current;
  }
}

// node_modules/@motionone/dom/dist/timeline/utils/edit.es.js
function eraseKeyframes(sequence, startTime, endTime) {
  for (let i = 0; i < sequence.length; i++) {
    const keyframe = sequence[i];
    if (keyframe.at > startTime && keyframe.at < endTime) {
      removeItem(sequence, keyframe);
      i--;
    }
  }
}
function addKeyframes(sequence, keyframes, easing, offset, startTime, endTime) {
  eraseKeyframes(sequence, startTime, endTime);
  for (let i = 0; i < keyframes.length; i++) {
    sequence.push({
      value: keyframes[i],
      at: mix(startTime, endTime, offset[i]),
      easing: getEasingForSegment(easing, i)
    });
  }
}

// node_modules/@motionone/dom/dist/timeline/utils/sort.es.js
function compareByTime(a, b) {
  if (a.at === b.at) {
    return a.value === null ? 1 : -1;
  } else {
    return a.at - b.at;
  }
}

// node_modules/@motionone/dom/dist/timeline/index.es.js
function timeline10(definition, options = {}) {
  var _a;
  const animationDefinitions = createAnimationsFromTimeline(definition, options);
  const animationFactories = animationDefinitions.map((definition2) => animateStyle(...definition2, Animation)).filter(Boolean);
  return withControls(
    animationFactories,
    options,
    // Get the duration from the first animation definition
    (_a = animationDefinitions[0]) === null || _a === void 0 ? void 0 : _a[3].duration
  );
}
function createAnimationsFromTimeline(definition, _a = {}) {
  var { defaultOptions = {} } = _a, timelineOptions = __rest(_a, ["defaultOptions"]);
  const animationDefinitions = [];
  const elementSequences = /* @__PURE__ */ new Map();
  const elementCache = {};
  const timeLabels = /* @__PURE__ */ new Map();
  let prevTime = 0;
  let currentTime = 0;
  let totalDuration = 0;
  for (let i = 0; i < definition.length; i++) {
    const segment = definition[i];
    if (isString2(segment)) {
      timeLabels.set(segment, currentTime);
      continue;
    } else if (!Array.isArray(segment)) {
      timeLabels.set(segment.name, calcNextTime(currentTime, segment.at, prevTime, timeLabels));
      continue;
    }
    const [elementDefinition, keyframes, options = {}] = segment;
    if (options.at !== void 0) {
      currentTime = calcNextTime(currentTime, options.at, prevTime, timeLabels);
    }
    let maxDuration = 0;
    const elements = resolveElements(elementDefinition, elementCache);
    const numElements = elements.length;
    for (let elementIndex = 0; elementIndex < numElements; elementIndex++) {
      const element = elements[elementIndex];
      const elementSequence = getElementSequence(element, elementSequences);
      for (const key in keyframes) {
        const valueSequence = getValueSequence(key, elementSequence);
        let valueKeyframes = keyframesList(keyframes[key]);
        const valueOptions = getOptions(options, key);
        let { duration = defaultOptions.duration || defaults.duration, easing = defaultOptions.easing || defaults.easing } = valueOptions;
        if (isEasingGenerator(easing)) {
          invariant(key === "opacity" || valueKeyframes.length > 1, "spring must be provided 2 keyframes within timeline()");
          const custom = easing.createAnimation(valueKeyframes, key !== "opacity", () => 0, key);
          easing = custom.easing;
          valueKeyframes = custom.keyframes || valueKeyframes;
          duration = custom.duration || duration;
        }
        const delay = resolveOption(options.delay, elementIndex, numElements) || 0;
        const startTime = currentTime + delay;
        const targetTime = startTime + duration;
        let { offset = defaultOffset(valueKeyframes.length) } = valueOptions;
        if (offset.length === 1 && offset[0] === 0) {
          offset[1] = 1;
        }
        const remainder = offset.length - valueKeyframes.length;
        remainder > 0 && fillOffset(offset, remainder);
        valueKeyframes.length === 1 && valueKeyframes.unshift(null);
        addKeyframes(valueSequence, valueKeyframes, easing, offset, startTime, targetTime);
        maxDuration = Math.max(delay + duration, maxDuration);
        totalDuration = Math.max(targetTime, totalDuration);
      }
    }
    prevTime = currentTime;
    currentTime += maxDuration;
  }
  elementSequences.forEach((valueSequences, element) => {
    for (const key in valueSequences) {
      const valueSequence = valueSequences[key];
      valueSequence.sort(compareByTime);
      const keyframes = [];
      const valueOffset = [];
      const valueEasing = [];
      for (let i = 0; i < valueSequence.length; i++) {
        const { at: at2, value, easing } = valueSequence[i];
        keyframes.push(value);
        valueOffset.push(progress(0, totalDuration, at2));
        valueEasing.push(easing || defaults.easing);
      }
      if (valueOffset[0] !== 0) {
        valueOffset.unshift(0);
        keyframes.unshift(keyframes[0]);
        valueEasing.unshift("linear");
      }
      if (valueOffset[valueOffset.length - 1] !== 1) {
        valueOffset.push(1);
        keyframes.push(null);
      }
      animationDefinitions.push([
        element,
        key,
        keyframes,
        Object.assign(Object.assign(Object.assign({}, defaultOptions), { duration: totalDuration, easing: valueEasing, offset: valueOffset }), timelineOptions)
      ]);
    }
  });
  return animationDefinitions;
}
function getElementSequence(element, sequences) {
  !sequences.has(element) && sequences.set(element, {});
  return sequences.get(element);
}
function getValueSequence(name, sequences) {
  if (!sequences[name])
    sequences[name] = [];
  return sequences[name];
}

// node_modules/@motionone/dom/dist/gestures/in-view.es.js
var thresholds = {
  any: 0,
  all: 1
};
function inView9(elementOrSelector, onStart, { root, margin: rootMargin, amount = "any" } = {}) {
  if (typeof IntersectionObserver === "undefined") {
    return () => {
    };
  }
  const elements = resolveElements(elementOrSelector);
  const activeIntersections = /* @__PURE__ */ new WeakMap();
  const onIntersectionChange = (entries) => {
    entries.forEach((entry) => {
      const onEnd = activeIntersections.get(entry.target);
      if (entry.isIntersecting === Boolean(onEnd))
        return;
      if (entry.isIntersecting) {
        const newOnEnd = onStart(entry);
        if (isFunction2(newOnEnd)) {
          activeIntersections.set(entry.target, newOnEnd);
        } else {
          observer.unobserve(entry.target);
        }
      } else if (onEnd) {
        onEnd(entry);
        activeIntersections.delete(entry.target);
      }
    });
  };
  const observer = new IntersectionObserver(onIntersectionChange, {
    root,
    rootMargin,
    threshold: typeof amount === "number" ? amount : thresholds[amount]
  });
  elements.forEach((element) => observer.observe(element));
  return () => observer.disconnect();
}

// js/common/search/algolia-recommend.js
var AlgoliaRecommend = class extends HTMLElement {
  connectedCallback() {
    this.algoliaProductIndex = `${window.themeVariables.search.products_prefix}_${window.themeVariables.settings.currentLanguage}`;
    this.channelName = `${window.themeVariables.settings.environment.channel_name}`;
    inView9(this, () => {
      const client = (0, import_recommend.default)(window.themeVariables.search.id, window.themeVariables.search.search_key);
      client[this.getAttribute("indice")]([
        {
          indexName: this.algoliaProductIndex,
          objectID: this.getAttribute("current-product"),
          queryParameters: {
            filters: "is_searchable_on_" + this.channelName + ":true"
          },
          maxRecommendations: parseInt(this.getAttribute("limit"))
        }
      ]).then(({ results: results2 }) => {
        this.initProductList(results2[0].hits);
      }).catch((err) => {
        console.log(err);
      });
    });
  }
  initProductList(results2) {
    const priceMarketKey = `p_${window.themeVariables.settings.currentMarket.toUpperCase()}`;
    results2.forEach((item) => {
      var _a, _b, _c, _d;
      item.price = (_b = (_a = item[priceMarketKey]) == null ? void 0 : _a.p) != null ? _b : -1;
      if ((_c = item[priceMarketKey]) == null ? void 0 : _c.c) {
        item.compare_at_price = (_d = item[priceMarketKey]) == null ? void 0 : _d.c;
      }
    });
    const vueComponent = D({
      products: results2,
      // get discount percentage for product card
      getDiscountPercentage: function(basePrice, price) {
        if (!basePrice || !price || basePrice <= price) {
          return null;
        }
        const savings = Math.round((basePrice - price) * 100 / basePrice / 10) * 10;
        return `-${savings}%`;
      },
      // handle click event to send to Algolia WebPixel
      handleClick: function(event, target) {
        if (event.target.closest(".product-card__form")) {
          return;
        }
        const item = {
          objectID: target.objectID,
          queryID: this.queryID,
          position: parseInt(event.currentTarget.getAttribute("position"))
        };
        Shopify.analytics.publish("algolia_product_clicked", item);
      },
      formatMoney: function(price, symbol, currency) {
        if (symbol == "$") {
          price = (Math.round(price * 100) / 100).toFixed(2);
          return `${symbol}${price} ${currency}`;
        }
        return `${price} ${symbol}`;
      },
      formatHandle: function(handles) {
        if (window.themeVariables.search.isDomesticMarket == true) {
          if (window.themeVariables.search.market == "us") {
            return `/products/${handles.shopify_eshop_us}`;
          }
          return `/products/${handles.shopify_eshop}`;
        }
        return `/${window.themeVariables.search.language}-${window.themeVariables.search.market}/products/${handles.shopify_eshop}`;
      }
    });
    Qe({
      vueComponent
    }).mount(this);
    this.replaceWith(...this.childNodes);
  }
};
if (!window.customElements.get("algolia-recommend")) {
  window.customElements.define("algolia-recommend", AlgoliaRecommend);
}

// js/common/search/search-results.js
var import_algoliasearch = __toESM(require_algoliasearch_umd());

// node_modules/@splidejs/splide/dist/js/utils/splide-utils.esm.js
function slice3(arrayLike, start, end) {
  return Array.prototype.slice.call(arrayLike, start, end);
}
function apply3(func) {
  return func.bind(null, ...slice3(arguments, 1));
}
function typeOf3(type, subject) {
  return typeof subject === type;
}
var isArray3 = Array.isArray;
var isFunction3 = apply3(typeOf3, "function");
var isString3 = apply3(typeOf3, "string");
var isUndefined3 = apply3(typeOf3, "undefined");
var { min: min3, max: max3, floor: floor3, ceil: ceil3, abs: abs3 } = Math;

// js/common/search/search-results.js
var SearchResults = class extends HTMLElement {
  constructor() {
    super();
    __publicField(this, "VIEWED_STORAGE_KEY", "algolia_analytics_viewed_objects");
    __publicField(this, "lastPublishedSearchTerm", "");
    this.initVueComponent();
  }
  connectedCallback() {
    this.listenersAbortController = new AbortController();
    this.searchForm = document.querySelector(`[aria-owns="${this.id}"]`);
    this.queryInput = this.searchForm.elements["q"];
    this.initialQuery = "";
    this.publishSearchTermDebounced = debounce(this.publishSearchTerm.bind(this), this.gaSearchPublishDelay);
    this.algoliaClient = (0, import_algoliasearch.default)(window.themeVariables.search.id, window.themeVariables.search.search_key);
    this.algoliaProductIndex = `${window.themeVariables.search.products_prefix}_${window.themeVariables.settings.currentLanguage}`;
    this.channelName = `${window.themeVariables.settings.environment.channel_name}`;
    this.searchForm.addEventListener("submit", this.onFormSubmitted.bind(this), { signal: this.listenersAbortController.signal });
    this.searchForm.addEventListener("reset", this.onSearchCleared.bind(this), { signal: this.listenersAbortController.signal });
    this.queryInput.addEventListener("input", debounce(this.onInputChanged.bind(this), this.autoCompleteDelay, { signal: this.listenersAbortController.signal }));
  }
  disconnectedCallback() {
    this.listenersAbortController.abort();
  }
  /**
   * Return the delay in ms before we send the autocomplete request. Using a value too low can cause the results to
   * refresh too often, so we recommend to keep the default one
   */
  get autoCompleteDelay() {
    return 280;
  }
  /**
   * Delay (ms) before publishing the search term to Shopify.analytics (GA4 via pixels).
   * This is intentionally longer than Algolia's autocomplete debounce to avoid sending on every keystroke.
   */
  get gaSearchPublishDelay() {
    return 900;
  }
  /**
   * Check if the input is not empty, and if so, trigger the search
   */
  onInputChanged() {
    var _a;
    this.searchResults.query = this.queryInput.value;
    if (this.queryInput.value === "") {
      return this.onSearchCleared();
    }
    this.publishSearchTermDebounced();
    this.initialQuery = "";
    (_a = this.fetchAbortController) == null ? void 0 : _a.abort();
    this.fetchAbortController = new AbortController();
    try {
      return this.doAlgoliaSearch();
    } catch (e) {
      if (e.name !== "AbortError") {
        throw e;
      }
    }
  }
  /**
   * Prevent the form submission if the query is empty
   */
  onFormSubmitted(event) {
    return event.preventDefault();
  }
  initVueComponent() {
    let that = this;
    const vueComponent = D({
      query: "",
      queryID: "",
      products: { hits: [] },
      collections: { hits: [] },
      filtersList: {},
      selectedFilters: [],
      selectedPriceRange: "",
      isFilterOpen: false,
      // retrieve color hexadecimal value from translation
      getColor: function(color) {
        return {
          borderWidth: color === "white" ? "1px" : "0",
          backgroundColor: window.themeVariables.metafields.group_color[color] ? window.themeVariables.metafields.group_color[color].color : "000000"
        };
      },
      getColorLabel: function(color) {
        return window.themeVariables.metafields.group_color[color] ? window.themeVariables.metafields.group_color[color].label : color;
      },
      // retrieve material ext informations
      getMaterialImage: function(material) {
        return {
          backgroundImage: window.themeVariables.metafields.material_ext[material] ? `url(${window.themeVariables.search.imageUrl}__${material}.jpg)` : ""
        };
      },
      getMaterialLabel: function(material) {
        return window.themeVariables.metafields.material_ext[material] ? window.themeVariables.metafields.material_ext[material].label : material;
      },
      getMaterialDescription: function(material) {
        return window.themeVariables.metafields.material_ext[material] ? window.themeVariables.metafields.material_ext[material].short_description : material;
      },
      // retrieve gender / family translated labels (fallback to raw value)
      getGenderLabel: function(gender) {
        return window.themeVariables.metafields.gender[gender] ? window.themeVariables.metafields.gender[gender].label : gender;
      },
      getFamilyLabel: function(family) {
        return window.themeVariables.metafields.family[family] ? window.themeVariables.metafields.family[family].label : family;
      },
      // get min price from product list
      getMinPrice: function() {
        return this.filtersList["price"] ? this.filtersList["price"].min : "";
      },
      // get max price from product list
      getMaxPrice: function() {
        return this.filtersList["price"] ? this.filtersList["price"].max : "";
      },
      // get current currency
      getCurrency: function() {
        return window.themeVariables.settings.currencyCode;
      },
      // get discount percentage for product card
      getDiscountPercentage: function(basePrice, price) {
        if (!basePrice || !price || basePrice <= price) {
          return null;
        }
        const savings = Math.round((basePrice - price) * 100 / basePrice / 10) * 10;
        return `-${savings}%`;
      },
      // filter per price range
      filterPriceRange: function(event) {
        let priceRanges = event.target.closest(".range-group").querySelectorAll(".range");
        this.selectedPriceRange = `${priceRanges[0].value} TO ${priceRanges[1].value}`;
      },
      // remove filter after it has been applied
      removeFilter: function(value) {
        this.selectedFilters.splice(this.selectedFilters.indexOf(`${value}`), 1);
        that.doAlgoliaSearch(this.selectedFilters, this.selectedPriceRange);
      },
      removePriceFilter: function() {
        this.selectedPriceRange = "";
        that.doAlgoliaSearch(this.selectedFilters, this.selectedPriceRange);
      },
      getActiveFacetLabel: function(filter) {
        const currentFilter = filter !== "" ? filter.split(":") : "";
        switch (currentFilter[0]) {
          case "material_ext":
            return this.getMaterialLabel(currentFilter[1]);
          case "grouped_color":
            return this.getColorLabel(currentFilter[1]);
          case "line":
            return currentFilter[1];
          case "gender":
            return this.getGenderLabel(currentFilter[1]);
          case "family":
            return this.getFamilyLabel(currentFilter[1]);
          case "price":
            if (this.selectedPriceRange !== "") {
              const currentPrice = this.selectedPriceRange.split("TO");
              return `${currentPrice[0].trim()} ${this.getCurrency()} - ${currentPrice[1].trim()} ${this.getCurrency()}`;
            }
            break;
          default:
            return filter;
        }
      },
      // get collection styles
      getCollectionStyles: function(collection) {
        return {
          backgroundColor: collection.background_color ? collection.background_color : "",
          color: collection.text_color ? collection.text_color : "white"
        };
      },
      // redo Algolia Search when closing filter modal
      attachModalEventListener: async function(element) {
        await V();
        that.querySelector(element).addEventListener("dialog:after-hide", (event) => {
          this.isFilterOpen = false;
          if (Object.keys(this.selectedFilters).length !== 0 || this.selectedPriceRange.length !== 0) {
            that.doAlgoliaSearch(this.selectedFilters, this.selectedPriceRange);
          }
        });
        that.querySelector(element).addEventListener("dialog:before-show", (event) => {
          if (this.selectedFilters.length === 0) {
            this.isFilterOpen = true;
          }
        });
      },
      // reset search when no results
      resetSearch: function() {
        that.queryInput.value = "";
        that.onInputChanged();
      },
      // handle click event to send to Algolia WebPixel
      handleClick: function(event, target) {
        if (event.target.closest(".product-card__form")) {
          return;
        }
        const item = {
          objectID: target.objectID,
          queryID: this.queryID,
          position: parseInt(event.currentTarget.getAttribute("position"))
        };
        Shopify.analytics.publish("algolia_product_clicked", item);
      },
      formatMoney: function(price, symbol, currency) {
        if (symbol == "$") {
          price = (Math.round(price * 100) / 100).toFixed(2);
          return `${symbol}${price} ${currency}`;
        }
        return `${price} ${symbol}`;
      },
      formatHandle: function(handles) {
        if (window.themeVariables.search.isDomesticMarket == true) {
          if (window.themeVariables.search.market == "us") {
            return `/products/${handles.shopify_eshop_us}`;
          }
          return `/products/${handles.shopify_eshop}`;
        }
        return `/${window.themeVariables.search.language}-${window.themeVariables.search.market}/products/${handles.shopify_eshop}`;
      }
    });
    Qe({
      vueComponent
    }).mount("#search-results__content");
    this.searchResults = vueComponent;
  }
  /**
   * Group filters by key to respect algolia behavior
   *
   * from : ["grouped_color:green","grouped_color:blue","line:Emilie"]
   * to: ["grouped_color:green", "grouped_color:blue"], "line:Emilie"]
   *
   */
  buildFacetFilters(selectedFilters = []) {
    const groups = Array.from(selectedFilters).reduce((acc, filter) => {
      var _a;
      if (typeof filter !== "string") {
        return acc;
      }
      const separatorIndex = filter.indexOf(":");
      if (separatorIndex === -1) {
        return acc;
      }
      const attribute = filter.slice(0, separatorIndex);
      if (!attribute) {
        return acc;
      }
      (_a = acc[attribute]) != null ? _a : acc[attribute] = [];
      acc[attribute].push(filter);
      return acc;
    }, {});
    return Object.values(groups).map((group) => {
      return group.length > 1 ? group : group[0];
    });
  }
  /**
   * Do the actual Algolia search
   */
  doAlgoliaSearch(selectedFilters = [], selectedPriceRange = "") {
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
    const priceMarketKey = `p_${window.themeVariables.settings.currentMarket.toUpperCase()}`;
    const queries = [
      {
        indexName: this.algoliaProductIndex,
        query: this.queryInput.value,
        filters: "is_searchable_on_" + this.channelName + ":true",
        facets: ["*"],
        clickAnalytics: true,
        facetFilters: this.buildFacetFilters(selectedFilters),
        numericFilters: selectedPriceRange ? [`${priceMarketKey}.p >= ${selectedPriceRange.split("TO")[0].trim()}`, `${priceMarketKey}.p <= ${selectedPriceRange.split("TO")[1].trim()}`] : [],
        params: {},
        attributesToRetrieve: [
          "title",
          "line",
          "sku",
          "family",
          "gender",
          "groups",
          "grouped_color",
          "main_color_translated",
          "material_ext",
          "images",
          "handle",
          priceMarketKey
        ]
      }
      /*,
            {
              indexName: this.algoliaCollectionIndex,
              query: this.queryInput.value,
              params: {
                hitsPerPage: 4
              }
            }
      
             */
    ];
    this.algoliaClient.multipleQueries(queries).then(async ({ results: results2 }) => {
      var _a;
      this.searchResults.queryID = results2[0].queryID;
      const productResults = this.buildProductResults(results2[0] ? results2[0] : { hits: [] });
      this.searchResults.products = productResults;
      this.searchResults.collections = results2[1] ? results2[1] : { hits: [] };
      const viewStorage = await localStorage.getItem(this.VIEWED_STORAGE_KEY);
      let viewObjects = (_a = JSON.parse(viewStorage)) != null ? _a : [];
      const skus = results2[0].hits.map((product) => product.sku);
      const obj = { queryID: results2[0].queryID, skus };
      if (viewObjects.length == 0) {
        viewObjects.push(obj);
      } else {
        viewObjects.unshift(obj);
      }
      const LIMIT = 10;
      if (viewObjects.length > LIMIT) {
        viewObjects = viewObjects.slice(0, LIMIT);
      }
      await localStorage.setItem(this.VIEWED_STORAGE_KEY, JSON.stringify(viewObjects));
      if (results2[0].query !== this.initialQuery) {
        this.saveFacetsFromRequest(results2[0].facets);
        const prices = results2[0].hits.map((h) => {
          var _a2;
          return (_a2 = h[priceMarketKey]) == null ? void 0 : _a2.p;
        }).filter((p) => p != null);
        if (prices.length > 0) {
          this.searchResults.filtersList["price"] = { min: Math.min(...prices), max: Math.max(...prices) };
        }
        this.initialQuery = this.queryInput.value;
      }
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
      const productList = this.querySelector(".product-list");
      if (productList) {
        await V();
        productList.dispatchEvent(new CustomEvent("product-list:refresh"));
        productList.reveal();
      }
    });
  }
  buildProductResults(results2) {
    const priceMarketKey = `p_${window.themeVariables.settings.currentMarket.toUpperCase()}`;
    results2.hits.forEach((item) => {
      var _a, _b, _c, _d;
      item.price = (_b = (_a = item[priceMarketKey]) == null ? void 0 : _a.p) != null ? _b : -1;
      if ((_c = item[priceMarketKey]) == null ? void 0 : _c.c) {
        item.compare_at_price = (_d = item[priceMarketKey]) == null ? void 0 : _d.c;
      }
    });
    return results2;
  }
  saveFacetsFromRequest(facetList) {
    if (facetList) {
      for (let facet in facetList) {
        if (facet === "grouped_color") this.searchResults.filtersList["group_color"] = facetList[facet];
        if (facet === "line") this.searchResults.filtersList["line"] = facetList[facet];
        if (facet === "price") this.searchResults.filtersList["price"] = facetList[facet];
        if (facet === "material_ext") this.searchResults.filtersList["material_ext"] = facetList[facet];
        if (facet === "gender") this.searchResults.filtersList["gender"] = facetList[facet];
        if (facet === "family") this.searchResults.filtersList["family"] = facetList[facet];
      }
    }
  }
  /**
   * If any search is pending, we abort them, and transition to the idle slot
   */
  onSearchCleared() {
    var _a;
    (_a = this.fetchAbortController) == null ? void 0 : _a.abort();
    this.queryInput.focus();
    this.initialQuery = "";
    this.lastPublishedSearchTerm = "";
  }
  publishSearchTerm() {
    var _a, _b, _c, _d;
    const term = ((_b = (_a = this.queryInput) == null ? void 0 : _a.value) != null ? _b : "").trim();
    const isDebug = (() => {
      try {
        return new URLSearchParams(window.location.search).has("ga_debug");
      } catch (e) {
        return false;
      }
    })();
    if (term === "" || term === this.lastPublishedSearchTerm) {
      if (isDebug) {
        console.log("[SearchResults][GA4] skip publish", { term, lastPublishedSearchTerm: this.lastPublishedSearchTerm });
      }
      return;
    }
    this.lastPublishedSearchTerm = term;
    if (isDebug) {
      console.log("[SearchResults][GA4] publish search term", { term });
    }
    try {
      (_d = (_c = Shopify == null ? void 0 : Shopify.analytics) == null ? void 0 : _c.publish) == null ? void 0 : _d.call(_c, "search", { search_term: term });
    } catch (e) {
      if (isDebug) {
        console.log("[SearchResults][GA4] publish failed", e);
      }
    }
  }
};
if (!window.customElements.get("search-results")) {
  window.customElements.define("search-results", SearchResults);
}

// js/sections/announcement-bar.js
import { animate as animate12 } from "vendor";
var AnnouncementBar = class extends EffectCarousel {
  createOnChangeAnimationControls(fromSlide, toSlide) {
    return {
      leaveControls: () => animate12(fromSlide, { opacity: [1, 0], transform: ["translateY(0)", "translateY(-10px)"] }, { duration: 0.25, easing: [0.55, 0.055, 0.675, 0.19] }),
      enterControls: () => animate12(toSlide, { opacity: [0, 1], transform: ["translateY(10px)", "translateY(0px)"] }, { duration: 0.4, easing: [0.215, 0.61, 0.355, 1] })
    };
  }
};
if (!window.customElements.get("announcement-bar")) {
  window.customElements.define("announcement-bar", AnnouncementBar);
}

// js/sections/before-after-image.js
import { animate as animate13, inView as inView10 } from "vendor";
var _onPointerMoveListener, _onTouchMoveListener, _touchStartTimestamp, _BeforeAfter_instances, onPointerDown_fn, onPointerMove_fn, onTouchMove_fn, onPointerUp_fn, calculatePosition_fn, animateInitialPosition_fn;
var BeforeAfter = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _BeforeAfter_instances);
    __privateAdd(this, _onPointerMoveListener, __privateMethod(this, _BeforeAfter_instances, onPointerMove_fn).bind(this));
    __privateAdd(this, _onTouchMoveListener, __privateMethod(this, _BeforeAfter_instances, onTouchMove_fn).bind(this));
    __privateAdd(this, _touchStartTimestamp, 0);
    this.addEventListener("pointerdown", __privateMethod(this, _BeforeAfter_instances, onPointerDown_fn));
  }
  connectedCallback() {
    inView10(this, __privateMethod(this, _BeforeAfter_instances, animateInitialPosition_fn).bind(this));
  }
};
_onPointerMoveListener = new WeakMap();
_onTouchMoveListener = new WeakMap();
_touchStartTimestamp = new WeakMap();
_BeforeAfter_instances = new WeakSet();
onPointerDown_fn = function(event) {
  if (event.target.tagName === "A") {
    return;
  }
  document.addEventListener("pointerup", __privateMethod(this, _BeforeAfter_instances, onPointerUp_fn).bind(this), { once: true });
  if (matchesMediaQuery("supports-hover")) {
    document.addEventListener("pointermove", __privateGet(this, _onPointerMoveListener));
    __privateMethod(this, _BeforeAfter_instances, calculatePosition_fn).call(this, event);
  } else {
    const cursor = this.querySelector(".before-after__cursor");
    if (event.target === cursor || cursor.contains(event.target)) {
      document.addEventListener("pointermove", __privateGet(this, _onPointerMoveListener));
      this.addEventListener("touchmove", __privateGet(this, _onTouchMoveListener), { passive: false });
    } else {
      __privateSet(this, _touchStartTimestamp, event.timeStamp);
    }
  }
};
onPointerMove_fn = function(event) {
  __privateMethod(this, _BeforeAfter_instances, calculatePosition_fn).call(this, event);
};
onTouchMove_fn = function(event) {
  event.preventDefault();
};
onPointerUp_fn = function(event) {
  this.removeEventListener("touchmove", __privateGet(this, _onTouchMoveListener));
  document.removeEventListener("pointermove", __privateGet(this, _onPointerMoveListener));
  if (!matchesMediaQuery("supports-hover")) {
    if (event.timeStamp - __privateGet(this, _touchStartTimestamp) <= 250) {
      __privateMethod(this, _BeforeAfter_instances, calculatePosition_fn).call(this, event);
    }
  }
};
calculatePosition_fn = function(event) {
  let rectangle = this.getBoundingClientRect(), percentage;
  if (this.hasAttribute("vertical")) {
    percentage = (event.clientY - rectangle.top) / this.clientHeight * 100;
  } else {
    percentage = (event.clientX - rectangle.left) / this.clientWidth * 100;
    percentage = document.dir === "rtl" ? 100 - percentage : percentage;
  }
  this.style.setProperty("--before-after-cursor-position", `${Math.min(Math.max(percentage, 0), 100)}%`);
};
animateInitialPosition_fn = function() {
  animate13((progress2) => {
    this.style.setProperty("--before-after-cursor-position", `calc(var(--before-after-initial-cursor-position) * ${progress2})`);
  }, { duration: 0.6, easing: [0.85, 0, 0.15, 1] });
};
if (!window.customElements.get("before-after")) {
  window.customElements.define("before-after", BeforeAfter);
}

// js/sections/beautiful-materials.js
import { animate as animate14, stagger as stagger2 } from "vendor";
var _abortController10, _MaterialShowMore_instances, getCollectionInfos_fn;
var MaterialShowMore = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _MaterialShowMore_instances);
    __privateAdd(this, _abortController10);
  }
  connectedCallback() {
    __privateSet(this, _abortController10, new AbortController());
    this.querySelector("button").addEventListener("click", __privateMethod(this, _MaterialShowMore_instances, getCollectionInfos_fn).bind(this), { signal: __privateGet(this, _abortController10).signal });
  }
  disconnectedCallback() {
    __privateGet(this, _abortController10).abort();
  }
  get collection() {
    return this.getAttribute("collection-handle");
  }
  get controlledSideBar() {
    return document.getElementById(this.getAttribute("controlled-sidebar"));
  }
};
_abortController10 = new WeakMap();
_MaterialShowMore_instances = new WeakSet();
getCollectionInfos_fn = async function() {
  let response = await fetch(`${Shopify.routes.root}collections/${this.collection}?filter.p.m.custom.gender_web=${GenderManager.getCurrentGender()}&section_id=collection-leather-sidebar`);
  let responseHtml = await response.text();
  let domElement = new DOMParser().parseFromString(responseHtml, "text/html");
  let newDrawerContent = document.createRange().createContextualFragment(domElement.getElementById(`shopify-section-collection-leather-sidebar`).innerHTML);
  this.controlledSideBar.replaceChildren(...newDrawerContent.children);
  let setSectionStacked = this.controlledSideBar.getAttribute("color-slider");
  let sliderColors = this.controlledSideBar.querySelector(".sidebar-colors__carousel-controls");
  if (setSectionStacked === "true") {
    sliderColors.classList.add("hidden");
  }
  this.controlledSideBar.show();
};
var MaterialFilter = class extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", this.setLeatherType.bind(this));
  }
  get leatherType() {
    return this.getAttribute("material-type");
  }
  get controlledElement() {
    return document.getElementById(this.getAttribute("aria-controls"));
  }
  setLeatherType() {
    Array.from(this.parentElement.querySelectorAll("material-filter")).forEach((item) => {
      item.querySelector(".button-tag").classList.remove("active");
      if (item === this) {
        item.querySelector(".button-tag").classList.add("active");
      }
    });
    this.controlledElement.setAttribute("material-type", this.leatherType);
  }
};
var MaterialList = class extends HTMLElement {
  static get observedAttributes() {
    return ["material-type"];
  }
  get materialType() {
    return this.getAttribute("material-type");
  }
  get gender() {
    return localStorage.getItem("letanneur:currentGender");
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "material-type" && oldValue !== newValue) {
      Array.from(this.querySelectorAll(".beautiful-material__list-item")).forEach((item) => {
        let showMaterial = this.gender === null || this.gender === item.getAttribute("data-material-gender") || item.getAttribute("data-material-gender") === "unisex";
        if (this.materialType === "all") {
          item.hidden = !showMaterial;
        } else {
          item.hidden = !(showMaterial && item.getAttribute("data-material-type") === this.materialType);
        }
      });
      animate14(this.querySelectorAll(".beautiful-material__list-item:not([hidden])"), {
        opacity: [0, 1],
        transform: ["translateY(20px)", "translateY(0)"]
      }, {
        duration: 0.2,
        easing: "ease-in",
        delay: stagger2(0.05, { start: 0.2, easing: "ease-out" })
      });
    }
  }
};
if (!window.customElements.get("material-filter")) {
  window.customElements.define("material-filter", MaterialFilter);
}
if (!window.customElements.get("material-show-more")) {
  window.customElements.define("material-show-more", MaterialShowMore);
}
if (!window.customElements.get("material-list")) {
  window.customElements.define("material-list", MaterialList);
}

// node_modules/@mapbox/search-js-core/dist/index-esm.js
var __defProp2 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp2 = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp2 = (obj, key, value) => key in obj ? __defProp2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp2.call(b, prop))
      __defNormalProp2(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp2(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp2.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __accessCheck2 = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet2 = (obj, member, getter) => {
  __accessCheck2(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd2 = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet2 = (obj, member, value, setter) => {
  __accessCheck2(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateMethod2 = (obj, member, method) => {
  __accessCheck2(obj, member, "access private method");
  return method;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
var SEARCH_URL = `https://api.mapbox.com/autofill/v1`;
var ENDPOINT_SUGGEST = "suggest";
var ENDPOINT_RETRIEVE = "retrieve";
var SUGGEST_URL = `${SEARCH_URL}/${ENDPOINT_SUGGEST}`;
var RETRIEVE_URL = `${SEARCH_URL}/${ENDPOINT_RETRIEVE}`;
var LngLat = class {
  constructor(lng, lat) {
    if (isNaN(lng) || isNaN(lat)) {
      throw new Error(`Invalid LngLat object: (${lng}, ${lat})`);
    }
    this.lng = +lng;
    this.lat = +lat;
    if (this.lat > 90 || this.lat < -90) {
      throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
    }
    if (this.lng > 180 || this.lng < -180) {
      throw new Error("Invalid LngLat longitude value: must be between -180 and 180");
    }
  }
  toArray() {
    return [this.lng, this.lat];
  }
  toString() {
    return `LngLat(${this.lng}, ${this.lat})`;
  }
  static convert(input) {
    if (input instanceof LngLat) {
      return new LngLat(input.lng, input.lat);
    }
    if (Array.isArray(input) && input.length === 2) {
      return new LngLat(Number(input[0]), Number(input[1]));
    }
    if (!Array.isArray(input) && typeof input == "object" && input !== null && ("lng" in input || "lon" in input) && "lat" in input) {
      return new LngLat(Number("lng" in input ? input.lng : input.lon), Number(input.lat));
    }
    throw new Error("`LngLatLike` argument must be specified as an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
  }
};
var LngLatBounds = class {
  constructor(sw, ne2) {
    this._sw = LngLat.convert(sw);
    this._ne = LngLat.convert(ne2);
  }
  getSouthWest() {
    return this._sw;
  }
  getNorthEast() {
    return this._ne;
  }
  getNorthWest() {
    return new LngLat(this.getWest(), this.getNorth());
  }
  getSouthEast() {
    return new LngLat(this.getEast(), this.getSouth());
  }
  getWest() {
    return this._sw.lng;
  }
  getSouth() {
    return this._sw.lat;
  }
  getEast() {
    return this._ne.lng;
  }
  getNorth() {
    return this._ne.lat;
  }
  toArray() {
    return [this._sw.toArray(), this._ne.toArray()];
  }
  toFlatArray() {
    return [this._sw.lng, this._sw.lat, this._ne.lng, this._ne.lat];
  }
  toString() {
    return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
  }
  static convert(input) {
    if (!input) {
      throw new Error("Invalid LngLatBounds convert value: falsy");
    }
    if (input instanceof LngLatBounds) {
      return new LngLatBounds(input.getSouthWest(), input.getNorthEast());
    }
    if (Array.isArray(input) && input.length === 2) {
      return new LngLatBounds(LngLat.convert(input[0]), LngLat.convert(input[1]));
    }
    if (Array.isArray(input) && input.length === 4) {
      return new LngLatBounds(LngLat.convert([input[0], input[1]]), LngLat.convert([input[2], input[3]]));
    }
    throw new Error("`LngLatBoundsLike` argument must be specified as an array [<LngLatLike>, <LngLatLike>] or an array [<west>, <south>, <east>, <north>]");
  }
};
function generateUUID() {
  const randomString = Math.random().toString(16) + Date.now().toString(16) + Math.random().toString(16);
  const uuidString = randomString.replace(/\./g, "");
  const uuid = [
    uuidString.slice(0, 8),
    uuidString.slice(8, 12),
    "4" + uuidString.slice(12, 15) + "-8" + uuidString.slice(15, 18),
    uuidString.slice(18, 30)
  ].join("-");
  return uuid;
}
var SessionToken = class {
  constructor(id) {
    this.id = id != null ? id : generateUUID();
  }
  toString() {
    return this.id;
  }
  static convert(token) {
    return new SessionToken(token instanceof SessionToken ? token.id : token.toString());
  }
};
var UNKNOWN_ERROR = "Unknown error";
var MapboxError = class extends Error {
  constructor(json, statusCode) {
    super(String(json.message || json.error || UNKNOWN_ERROR));
    this.name = "MapboxError";
    this.statusCode = statusCode;
  }
  toString() {
    return `${this.name} (${this.statusCode}): ${this.message}`;
  }
};
function handleNonOkRes(res) {
  return __async(this, null, function* () {
    if (!res.ok) {
      const json = yield res.json();
      throw new MapboxError(json, res.status);
    }
  });
}
var _fetchImpl = globalThis.fetch;
var _abortControllerImpl = globalThis.AbortController;
function getFetch() {
  if (!_fetchImpl) {
    throw new Error("Fetch implementation not found. Please include a fetch polyfill in your application or use `polyfillFetch` from `@mapbox/search-js-core` to fix this issue.");
  }
  return {
    fetch: _fetchImpl,
    AbortController: _abortControllerImpl
  };
}
function queryParams(...objects) {
  const params = [];
  for (const obj of objects) {
    if (!obj)
      continue;
    const entries = Object.entries(obj);
    for (const [key, value] of entries) {
      if (value == null)
        continue;
      params.push(`${key}=${encodeURIComponent(String(value))}`);
    }
  }
  return params.join("&");
}
var _getQueryParams;
var getQueryParams_fn;
var _AddressAutofillCore = class {
  constructor(options = {}) {
    __privateAdd2(this, _getQueryParams);
    const _a = options, { accessToken } = _a, defaults2 = __objRest(_a, ["accessToken"]);
    this.accessToken = accessToken;
    this.defaults = __spreadValues(__spreadValues({}, _AddressAutofillCore.defaults), defaults2);
  }
  suggest(searchText, optionsArg) {
    return __async(this, null, function* () {
      if (!searchText) {
        throw new Error("searchText is required");
      }
      const { sessionToken, signal } = optionsArg;
      const options = __spreadProps(__spreadValues(__spreadValues({}, this.defaults), optionsArg), {
        sessionToken
      });
      const url = new URL(`${SUGGEST_URL}/${encodeURIComponent(searchText)}`);
      url.search = __privateMethod2(this, _getQueryParams, getQueryParams_fn).call(this, options);
      const { fetch: fetch2 } = getFetch();
      const res = yield fetch2(url.toString(), {
        signal
      });
      yield handleNonOkRes(res);
      const json = yield res.json();
      return __spreadProps(__spreadValues({}, json), {
        suggestions: json.suggestions.map((suggestion) => {
          return __spreadProps(__spreadValues({}, suggestion), {
            original_search_text: searchText
          });
        }),
        url: url.toString()
      });
    });
  }
  retrieve(suggestion, optionsArg) {
    return __async(this, null, function* () {
      if (!suggestion) {
        throw new Error("suggestion is required");
      }
      if (!this.canRetrieve(suggestion)) {
        throw new Error("suggestion cannot be retrieved");
      }
      const { sessionToken: sessionTokenLike, signal } = optionsArg;
      const sessionToken = SessionToken.convert(sessionTokenLike);
      const url = new URL(`${RETRIEVE_URL}/${suggestion.action.id}`);
      url.search = queryParams({
        access_token: this.accessToken,
        session_token: sessionToken.id
      });
      const { fetch: fetch2 } = getFetch();
      const res = yield fetch2(url.toString(), { signal });
      yield handleNonOkRes(res);
      const json = yield res.json();
      json.url = url.toString();
      return json;
    });
  }
  canRetrieve(suggestion) {
    const action = suggestion.action;
    return typeof (action == null ? void 0 : action.id) === "string";
  }
};
var AddressAutofillCore = _AddressAutofillCore;
_getQueryParams = /* @__PURE__ */ new WeakSet();
getQueryParams_fn = function(options) {
  return queryParams({
    types: "address",
    access_token: this.accessToken,
    streets: options.streets,
    language: options.language,
    country: options.country,
    limit: options.limit
  }, options.sessionToken && {
    session_token: SessionToken.convert(options.sessionToken).id
  }, options.proximity && {
    proximity: typeof options.proximity === "string" ? options.proximity : LngLat.convert(options.proximity).toArray().join(",")
  }, options.bbox && {
    bbox: typeof options.bbox === "string" ? options.bbox : LngLatBounds.convert(options.bbox).toFlatArray().join(",")
  });
};
AddressAutofillCore.defaults = {
  language: "en",
  proximity: "ip",
  streets: true
};
var SEARCH_URL2 = `https://api.mapbox.com/search/searchbox/v1`;
var ENDPOINT_SUGGEST2 = "suggest";
var ENDPOINT_RETRIEVE2 = "retrieve";
var ENDPOINT_CATEGORY = "category";
var ENDPOINT_REVERSE = "reverse";
var SUGGEST_URL2 = `${SEARCH_URL2}/${ENDPOINT_SUGGEST2}`;
var RETRIEVE_URL2 = `${SEARCH_URL2}/${ENDPOINT_RETRIEVE2}`;
var CATEGORY_URL = `${SEARCH_URL2}/${ENDPOINT_CATEGORY}`;
var REVERSE_URL = `${SEARCH_URL2}/${ENDPOINT_REVERSE}`;
var _getQueryParams2;
var getQueryParams_fn2;
var _SearchBoxCore = class {
  constructor(options = {}) {
    __privateAdd2(this, _getQueryParams2);
    const _a = options, { accessToken } = _a, defaults2 = __objRest(_a, ["accessToken"]);
    this.accessToken = accessToken;
    this.defaults = __spreadValues(__spreadValues({}, _SearchBoxCore.defaults), defaults2);
  }
  suggest(searchText, optionsArg) {
    return __async(this, null, function* () {
      if (!searchText) {
        throw new Error("searchText is required");
      }
      const { sessionToken, signal } = optionsArg;
      const options = __spreadProps(__spreadValues(__spreadValues({}, this.defaults), optionsArg), {
        q: searchText,
        sessionToken
      });
      if (options.eta_type && (!options.origin || !options.navigation_profile)) {
        throw new Error("to provide eta estimate: eta, navigation_profile, and origin are required");
      }
      if (options.origin && !options.navigation_profile) {
        throw new Error("to provide distance estimate: both navigation_profile and origin are required");
      }
      const url = new URL(SUGGEST_URL2);
      url.search = __privateMethod2(this, _getQueryParams2, getQueryParams_fn2).call(this, options);
      const { fetch: fetch2 } = getFetch();
      const res = yield fetch2(url.toString(), {
        signal
      });
      yield handleNonOkRes(res);
      const json = yield res.json();
      json.url = url.toString();
      return json;
    });
  }
  retrieve(suggestion, optionsArg) {
    return __async(this, null, function* () {
      if (!suggestion) {
        throw new Error("suggestion is required");
      }
      const { sessionToken: sessionTokenLike, signal } = optionsArg;
      const sessionToken = SessionToken.convert(sessionTokenLike);
      const url = new URL(`${RETRIEVE_URL2}/${encodeURIComponent(suggestion.mapbox_id)}`);
      url.search = queryParams({
        access_token: this.accessToken,
        session_token: sessionToken.id
      });
      const { fetch: fetch2 } = getFetch();
      const res = yield fetch2(url.toString(), {
        signal
      });
      yield handleNonOkRes(res);
      const json = yield res.json();
      json.url = url.toString();
      return json;
    });
  }
  category(_0) {
    return __async(this, arguments, function* (category, optionsArg = {}) {
      if (!category) {
        throw new Error("category is required");
      }
      const options = __spreadValues(__spreadValues({}, this.defaults), optionsArg);
      const url = new URL(`${CATEGORY_URL}/${encodeURIComponent(category)}`);
      url.search = __privateMethod2(this, _getQueryParams2, getQueryParams_fn2).call(this, options);
      const { fetch: fetch2 } = getFetch();
      const res = yield fetch2(url.toString(), {
        signal: options.signal
      });
      yield handleNonOkRes(res);
      const json = yield res.json();
      json.url = url.toString();
      return json;
    });
  }
  reverse(_0) {
    return __async(this, arguments, function* (lngLat, optionsArg = {}) {
      if (!lngLat) {
        throw new Error("lngLat is required");
      }
      const [lng, lat] = typeof lngLat === "string" ? lngLat.split(",").map((x) => parseFloat(x)) : LngLat.convert(lngLat).toArray();
      if (isNaN(lng) || isNaN(lat)) {
        throw new Error("lngLat is required");
      }
      const options = __spreadValues(__spreadValues({}, this.defaults), optionsArg);
      const url = new URL(REVERSE_URL);
      url.search = queryParams({
        access_token: this.accessToken,
        language: options.language,
        limit: options.limit,
        longitude: lng,
        latitude: lat
      }, options.types && {
        types: typeof options.types === "string" ? options.types : [...options.types].join(",")
      });
      const { fetch: fetch2 } = getFetch();
      const res = yield fetch2(url.toString(), {
        signal: options.signal
      });
      yield handleNonOkRes(res);
      const json = yield res.json();
      json.url = url.toString();
      return json;
    });
  }
};
var SearchBoxCore = _SearchBoxCore;
_getQueryParams2 = /* @__PURE__ */ new WeakSet();
getQueryParams_fn2 = function(options) {
  return queryParams({
    q: options.q,
    access_token: this.accessToken,
    language: options.language,
    limit: options.limit,
    navigation_profile: options.navigation_profile,
    route: options.route,
    route_geometry: options.route_geometry,
    sar_type: options.sar_type,
    time_deviation: options.time_deviation,
    eta_type: options.eta_type,
    country: options.country,
    poi_category: options.poi_category,
    radius: options.radius,
    user_id: options.user_id,
    rich_metadata_provider: options.rich_metadata_provider,
    poi_category_exclusions: options.poi_category_exclusions
  }, options.sessionToken && {
    session_token: SessionToken.convert(options.sessionToken).id
  }, options.proximity && {
    proximity: typeof options.proximity === "string" ? options.proximity : LngLat.convert(options.proximity).toArray().join(",")
  }, options.origin && {
    origin: typeof options.origin === "string" ? options.origin : LngLat.convert(options.origin).toArray().join(",")
  }, options.bbox && {
    bbox: typeof options.bbox === "string" ? options.bbox : LngLatBounds.convert(options.bbox).toFlatArray().join(",")
  }, options.types && {
    types: typeof options.types === "string" ? options.types : [...options.types].join(",")
  });
};
SearchBoxCore.defaults = {
  language: "en"
};
var SEARCH_URL3 = `https://api.mapbox.com/autofill/v1`;
var ENDPOINT_VALIDATE = "retrieve";
var VALIDATE_URL = `${SEARCH_URL3}/${ENDPOINT_VALIDATE}`;
var _getQueryParams3;
var getQueryParams_fn3;
var _ValidationCore = class {
  constructor(options = {}) {
    __privateAdd2(this, _getQueryParams3);
    const _a = options, { accessToken } = _a, defaults2 = __objRest(_a, ["accessToken"]);
    this.accessToken = accessToken;
    this.defaults = __spreadValues(__spreadValues({}, _ValidationCore.defaults), defaults2);
  }
  validate(searchText, optionsArg) {
    return __async(this, null, function* () {
      if (!searchText) {
        throw new Error("searchText is required");
      }
      const { sessionToken, signal } = optionsArg;
      const options = __spreadProps(__spreadValues(__spreadValues({}, this.defaults), optionsArg), {
        sessionToken
      });
      const url = new URL(`${VALIDATE_URL}/${encodeURIComponent(searchText)}`);
      url.search = __privateMethod2(this, _getQueryParams3, getQueryParams_fn3).call(this, options);
      const { fetch: fetch2 } = getFetch();
      const res = yield fetch2(url.toString(), {
        signal
      });
      yield handleNonOkRes(res);
      const json = yield res.json();
      json.url = url.toString();
      if (json.features.length > 0) {
        json.features = [json.features[0]];
      }
      return json;
    });
  }
};
var ValidationCore = _ValidationCore;
_getQueryParams3 = /* @__PURE__ */ new WeakSet();
getQueryParams_fn3 = function(options) {
  return queryParams({
    access_token: this.accessToken,
    language: options.language,
    country: options.country
  }, options.sessionToken && {
    session_token: SessionToken.convert(options.sessionToken).id
  }, options.proximity && {
    proximity: typeof options.proximity === "string" ? options.proximity : LngLat.convert(options.proximity).toArray().join(",")
  }, options.bbox && {
    bbox: typeof options.bbox === "string" ? options.bbox : LngLatBounds.convert(options.bbox).toFlatArray().join(",")
  });
};
ValidationCore.defaults = {
  language: "en",
  proximity: "ip"
};
var BASE_URL = `https://api.mapbox.com/search/geocode/v6`;
var FORWARD_URL = `${BASE_URL}/forward`;
var REVERSE_URL2 = `${BASE_URL}/reverse`;
var BATCH_URL = `${BASE_URL}/batch`;
var REVERSE_GEOCODE_COORD_REGEX = /^[ ]*(-?\d{1,3}(\.\d{0,256})?)[, ]+(-?\d{1,3}(\.\d{0,256})?)[ ]*$/;
var SPACES_OR_COMMA_REGEX = /[\s,]+/;
var _getQueryParams4;
var getQueryParams_fn4;
var GeocodingCore = class {
  constructor(options = {}) {
    __privateAdd2(this, _getQueryParams4);
    const _a = options, { accessToken } = _a, defaults2 = __objRest(_a, ["accessToken"]);
    this.accessToken = accessToken;
    this.defaults = __spreadValues({}, defaults2);
  }
  forward(searchText, optionsArg) {
    return __async(this, null, function* () {
      if (!searchText) {
        throw new Error("searchText is required");
      }
      let signal;
      if (optionsArg) {
        ({ signal } = optionsArg);
      }
      const options = __spreadProps(__spreadValues(__spreadValues({}, this.defaults), optionsArg), {
        q: searchText
      });
      const url = new URL(`${FORWARD_URL}`);
      url.search = __privateMethod2(this, _getQueryParams4, getQueryParams_fn4).call(this, options);
      const { fetch: fetch2 } = getFetch();
      const fetchInit = signal ? { signal } : {};
      const res = yield fetch2(url.toString(), fetchInit);
      yield handleNonOkRes(res);
      const json = yield res.json();
      json.url = url.toString();
      return json;
    });
  }
  reverse(lngLat, optionsArg) {
    return __async(this, null, function* () {
      if (!lngLat) {
        throw new Error("lngLat is required");
      }
      let signal;
      if (optionsArg) {
        ({ signal } = optionsArg);
      }
      let lngLatObj;
      if (typeof lngLat === "string") {
        const [lng, lat] = lngLat.split(",");
        lngLatObj = new LngLat(Number(lng), Number(lat));
      } else {
        lngLatObj = LngLat.convert(lngLat);
      }
      const options = __spreadProps(__spreadValues(__spreadValues({}, this.defaults), optionsArg), {
        longitude: lngLatObj.lng,
        latitude: lngLatObj.lat
      });
      const url = new URL(`${REVERSE_URL2}`);
      url.search = __privateMethod2(this, _getQueryParams4, getQueryParams_fn4).call(this, options, true);
      const { fetch: fetch2 } = getFetch();
      const fetchInit = signal ? { signal } : {};
      const res = yield fetch2(url.toString(), fetchInit);
      yield handleNonOkRes(res);
      const json = yield res.json();
      json.url = url.toString();
      return json;
    });
  }
  suggest(searchText, optionsArg) {
    return __async(this, null, function* () {
      const isReverseQuery = REVERSE_GEOCODE_COORD_REGEX.test(searchText);
      if (isReverseQuery) {
        const coordinates = searchText.trim().split(SPACES_OR_COMMA_REGEX).map((part) => part.trim()).join(",");
        return this.reverse(coordinates, optionsArg);
      } else {
        return this.forward(searchText, optionsArg);
      }
    });
  }
  retrieve(suggestion) {
    return __async(this, null, function* () {
      return suggestion;
    });
  }
};
_getQueryParams4 = /* @__PURE__ */ new WeakSet();
getQueryParams_fn4 = function(options, isReverse = false) {
  if (isReverse) {
    ["proximity", "autocomplete", "bbox"].forEach((key) => {
      if (key in options) {
        delete options[key];
      }
    });
  }
  return queryParams({
    q: options.q,
    longitude: options.longitude,
    latitude: options.latitude,
    access_token: this.accessToken,
    permanent: options.permanent,
    language: options.language,
    country: options.country,
    limit: options.limit,
    autocomplete: options.autocomplete,
    worldview: options.worldview
  }, options.proximity && {
    proximity: typeof options.proximity === "string" ? options.proximity : LngLat.convert(options.proximity).toArray().join(",")
  }, options.bbox && {
    bbox: typeof options.bbox === "string" ? options.bbox : LngLatBounds.convert(options.bbox).toFlatArray().join(",")
  }, options.types && {
    types: typeof options.types === "string" ? options.types : [...options.types].join(",")
  });
};
var _listeners;
var Evented = class {
  constructor() {
    __privateAdd2(this, _listeners, {});
  }
  addEventListener(type, listener) {
    const listenersArr = __privateGet2(this, _listeners);
    if (!listenersArr[type]) {
      listenersArr[type] = [];
    }
    listenersArr[type].push(listener);
  }
  removeEventListener(type, listener) {
    const listenersArr = __privateGet2(this, _listeners);
    if (!listenersArr[type]) {
      return;
    }
    const listeners = listenersArr[type];
    const index = listeners.indexOf(listener);
    if (index !== -1) {
      listeners.splice(index, 1);
    }
  }
  fire(type, arg0) {
    const listenersArr = __privateGet2(this, _listeners);
    if (!listenersArr[type]) {
      return;
    }
    const listeners = listenersArr[type];
    for (const listener of listeners) {
      listener(arg0);
    }
  }
};
_listeners = /* @__PURE__ */ new WeakMap();
function debounce2(func, wait, signalFn) {
  let timeout = null;
  return (...args) => {
    if (timeout !== null) {
      clearTimeout(timeout);
    }
    const signal = signalFn && signalFn();
    timeout = setTimeout(() => {
      timeout = null;
      if (signal == null ? void 0 : signal.aborted) {
        return;
      }
      func(...args);
    }, wait);
  };
}
function createAbortController() {
  const { AbortController: AbortController2 } = getFetch();
  return new AbortController2();
}
var _suggestions;
var _abort;
var _suggestDebounce;
var SearchSession = class extends Evented {
  constructor(search, wait = 0) {
    super();
    this.sessionToken = new SessionToken();
    __privateAdd2(this, _suggestions, void 0);
    __privateAdd2(this, _abort, createAbortController());
    __privateAdd2(this, _suggestDebounce, void 0);
    __privateSet2(this, _suggestDebounce, debounce2((_0, ..._1) => __async(this, [_0, ..._1], function* (searchText, options = {}) {
      __privateGet2(this, _abort).abort();
      __privateSet2(this, _abort, createAbortController());
      if (!searchText) {
        __privateSet2(this, _suggestions, null);
        this.fire("suggest", __privateGet2(this, _suggestions));
        return;
      }
      try {
        const res = yield this.search.suggest(searchText, __spreadProps(__spreadValues({
          sessionToken: this.sessionToken
        }, options), {
          signal: __privateGet2(this, _abort).signal
        }));
        __privateSet2(this, _suggestions, res);
        this.fire("suggest", res);
      } catch (err) {
        if (err.name === "AbortError") {
          return;
        }
        this.fire("suggesterror", err);
      }
    }), wait, () => __privateGet2(this, _abort).signal));
    Object.defineProperties(this, {
      search: {
        value: search,
        writable: false
      },
      debounce: {
        value: wait,
        writable: false
      }
    });
  }
  get suggestions() {
    return __privateGet2(this, _suggestions);
  }
  suggest(searchText, options) {
    __privateGet2(this, _suggestDebounce).call(this, searchText, options);
    return new Promise((resolve, reject) => {
      let suggestFn;
      let suggestErrorFn;
      suggestFn = (res) => {
        this.removeEventListener("suggest", suggestFn);
        this.removeEventListener("suggesterror", suggestErrorFn);
        resolve(res);
      };
      suggestErrorFn = (err) => {
        this.removeEventListener("suggest", suggestFn);
        this.removeEventListener("suggesterror", suggestErrorFn);
        reject(err);
      };
      this.addEventListener("suggest", suggestFn);
      this.addEventListener("suggesterror", suggestErrorFn);
    });
  }
  clear() {
    this.suggest("");
  }
  retrieve(suggestion, options) {
    return __async(this, null, function* () {
      const res = yield this.search.retrieve(suggestion, __spreadValues({
        sessionToken: this.sessionToken
      }, options));
      this.fire("retrieve", res);
      return res;
    });
  }
  canRetrieve(suggestion) {
    if (!this.search.canRetrieve) {
      return true;
    }
    return this.search.canRetrieve(suggestion);
  }
  canSuggest(suggestion) {
    if (!this.search.canSuggest) {
      return true;
    }
    return this.search.canSuggest(suggestion);
  }
  abort() {
    __privateGet2(this, _abort).abort();
    __privateSet2(this, _abort, createAbortController());
  }
};
_suggestions = /* @__PURE__ */ new WeakMap();
_abort = /* @__PURE__ */ new WeakMap();
_suggestDebounce = /* @__PURE__ */ new WeakMap();

// js/sections/boutiques.js
import { Delegate as Delegate5 } from "vendor";

// js/common/utilities/distance.js
function getDistance(startCoords, destCoords) {
  let startingLat = degreesToRadians(startCoords.latitude);
  let startingLong = degreesToRadians(startCoords.longitude);
  let destinationLat = degreesToRadians(destCoords.latitude);
  let destinationLong = degreesToRadians(destCoords.longitude);
  let radius = 6571;
  return Math.acos(Math.sin(startingLat) * Math.sin(destinationLat) + Math.cos(startingLat) * Math.cos(destinationLat) * Math.cos(startingLong - destinationLong)) * radius;
}
function degreesToRadians(degrees) {
  return degrees * Math.PI / 180;
}

// js/sections/boutiques.js
import { inView as inView11, animate as animate15, stagger as stagger3 } from "vendor";
var Boutiques = class extends HTMLElement {
  constructor() {
    super();
    this.initMapBox();
  }
  connectedCallback() {
    this.delegate = new Delegate5(this);
    this.listenersAbortController = new AbortController();
    this.onInputChangeListener = this.onInputChange.bind(this);
    this.searchForm = this.querySelector("#boutiques__form");
    this.inputSearch = this.querySelector("#boutiques__input");
    this.inputClose = this.querySelector(".boutiques__input--close");
    this.inputArrow = this.querySelector(".boutiques__input--arrow");
    this.mapBoxResults = this.querySelector("#boutiques__suggestions-list");
    this.countryList = this.querySelectorAll(".boutiques__section");
    this.initialBoutiquesCount = this.querySelector("[data-update-count]").getAttribute("data-update-count");
    this.filtersList = this.querySelectorAll(".boutique-filter");
    this.filterForm = this.querySelector("#boutiques-filter-form");
    this.shopFilters = this.querySelector(".boutiques__filters");
    this.stickyOffset = parseInt(this.shopFilters.getAttribute("sticky-offset"));
    this.maxDistanceInKilometers = 50;
    if (matchesMediaQuery("motion-safe") && this.querySelectorAll('.boutique[reveal-on-scroll="true"]').length > 0) {
      inView11(this, this.reveal.bind(this));
    }
    this.searchForm.addEventListener("submit", this.onSubmittedForm.bind(this));
    this.inputSearch.addEventListener("input", debounce(this.onInputChangeListener, this.autoCompleteDelay, { signal: this.listenersAbortController.signal }));
    this.delegate.on("click", '[data-action="mapbox-select-address"]', this.onMapBoxAddressSelected.bind(this));
    this.inputClose.addEventListener("click", this.onInputClose.bind(this));
    this.initStickyObserver();
    Array.from(this.querySelectorAll("form")).forEach((form) => {
      form.addEventListener("change", (event) => {
        this.setFilter(event.target, event.target.getAttribute("data-attribute-name"));
      });
    });
    this.querySelector(".boutiques-reset-button").addEventListener("click", this.onInputClose.bind(this));
    this.countBoutiquesByCountry();
  }
  disconnectedCallback() {
    this.listenersAbortController.abort();
  }
  reveal() {
    animate15(this.querySelectorAll('.boutique[reveal-on-scroll="true"]'), {
      opacity: [0, 1],
      transform: ["translateY(20px)", "translateY(0)"]
    }, {
      duration: 0.2,
      easing: "ease-in",
      delay: stagger3(0.075, { start: 0.2, easing: "ease-out" })
    });
  }
  initStickyObserver() {
    const shopFiltersOffsetTop = this.shopFilters.getBoundingClientRect().top + window.scrollY - 75;
    window.addEventListener("scroll", () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition >= shopFiltersOffsetTop) {
        this.shopFilters.classList.add("boutiques__filters--is-sticky");
      } else {
        this.shopFilters.classList.remove("boutiques__filters--is-sticky");
      }
    });
  }
  initMapBox() {
    this.mapBoxSearch = new SearchBoxCore({
      accessToken: window.themeVariables.mapBoxId
    });
    this.mapBoxSession = new SearchSession(this.mapBoxSearch);
    this.mapBoxSession.addEventListener("suggest", (res) => this.showResults(res.suggestions));
    this.mapBoxSession.addEventListener("retrieve", (res) => this.getSelectedAddressCoordinates(res));
  }
  /**
   * Handle input change and send input value to MapBox Search
   */
  async onInputChange(event) {
    let inputValue = event.target.value;
    if (inputValue.length > 2) {
      this.mapBoxSession.suggest(event.target.value);
    }
    if (inputValue.length === 0) {
      this.resetCountryDisplay();
      this.resetAddressBox();
      this.updateBoutiquesCount(this.initialBoutiquesCount);
    }
  }
  /**
   * Display address list from MapBox data
   */
  showResults(suggestions) {
    let resultItem = "";
    this.mapBoxSuggestionsArray = suggestions;
    this.mapBoxSuggestionsArray.forEach((item, index) => {
      if (item.full_address) {
        resultItem += ` 
          <li data-action="mapbox-select-address" data-index="${index}">${item.full_address}</li>
        `;
      }
    });
    this.inputClose.classList.remove("hidden");
    this.inputArrow.classList.add("hidden");
    this.mapBoxResults.innerHTML = `<ul class="v-stack gap-3">${resultItem}</ul>`;
  }
  /**
   * Handle address selected by user and send it to MapBox to retrieve Coordinates
   */
  onMapBoxAddressSelected(event) {
    let addressIndex = parseInt(event.target.getAttribute("data-index"));
    if (this.mapBoxSession.canRetrieve(this.mapBoxSuggestionsArray[addressIndex])) {
      this.mapBoxSession.retrieve(this.mapBoxSuggestionsArray[addressIndex]);
      this.resetAddressBox();
      this.resetFilters();
    }
    this.inputClose.classList.remove("hidden");
    this.inputArrow.classList.add("hidden");
    this.filterForm.style.visibility = "hidden";
    this.filterForm.style.opacity = 0;
    this.querySelector(".boutiques__filters-text").style.opacity = 0;
    this.querySelector(".boutiques-per-country").textContent = "";
  }
  /**
   * Get coordinated from input form
   */
  async onSubmittedForm(event) {
    event.preventDefault();
    if (this.inputSearch.value.length === 0) return;
    const geocode = new GeocodingCore(this.mapBoxSearch);
    const results2 = await geocode.forward(this.inputSearch.value);
    if (results2.features.length === 0) return;
    this.getSelectedAddressCoordinates(results2);
  }
  /**
   * Get coordinated from selected address
   */
  getSelectedAddressCoordinates(item) {
    const longitude = item.features[0].geometry.coordinates[0];
    const latitude = item.features[0].geometry.coordinates[1];
    this.calculateDistance({ longitude, latitude });
    this.reveal();
  }
  calculateDistance(startCoords) {
    this.resetCountryDisplay();
    let activeBoutiquesCount = 0;
    Array.from(this.countryList).forEach((section) => {
      let sectionBoutiquesCount = 0;
      let hideSection = true;
      Array.from(section.querySelectorAll(".boutique")).forEach((boutique) => {
        let boutiqueLongitude = boutique.getAttribute("data-longitude");
        let boutiqueLatitude = boutique.getAttribute("data-latitude");
        if (getDistance(startCoords, { longitude: boutiqueLongitude, latitude: boutiqueLatitude }) > this.maxDistanceInKilometers) {
          boutique.setAttribute("hidden", "");
          boutique.setAttribute("reveal-on-scroll", "false");
        } else {
          boutique.setAttribute("reveal-on-scroll", "true");
          hideSection = false;
          activeBoutiquesCount++;
          sectionBoutiquesCount++;
        }
      });
      if (hideSection) {
        section.setAttribute("hidden", "");
      }
      this.countBoutiquesByCountry(section, sectionBoutiquesCount);
    });
    this.updateBoutiquesCount(activeBoutiquesCount);
  }
  resetCountryDisplay() {
    this.countryList.forEach((country) => {
      country.removeAttribute("hidden");
      Array.from(country.querySelectorAll(".boutique")).forEach((boutique) => {
        boutique.removeAttribute("hidden");
      });
    });
  }
  resetFilters() {
    Array.from(this.filtersList).forEach((filter) => filter.checked = false);
  }
  resetAddressBox() {
    this.inputClose.classList.add("hidden");
    this.inputArrow.classList.remove("hidden");
    this.mapBoxResults.innerHTML = "";
  }
  onInputClose() {
    this.resetAddressBox();
    this.resetCountryDisplay();
    this.resetFilters();
    this.updateBoutiquesCount(this.initialBoutiquesCount);
    this.inputSearch.value = "";
    this.filterForm.style.visibility = "visible";
    this.filterForm.style.opacity = 1;
    this.querySelector(".boutiques__filters-text").style.opacity = 1;
    this.countBoutiquesByCountry();
    this.shopFilters.removeAttribute("selected-country");
    this.shopFilters.removeAttribute("selected-type");
    this.shopFilters.removeAttribute("selected-services");
    this.reveal();
  }
  updateBoutiquesCount(count) {
    const noResultsMessage = this.querySelector(".no-boutiques-message");
    this.querySelector("[data-update-count]").innerHTML = count;
    if (count === 0) {
      noResultsMessage.classList.remove("hidden");
    } else {
      noResultsMessage.classList.add("hidden");
    }
  }
  onFilterSelected(event) {
    this.filterBoutiques(event.target.value);
  }
  filterBoutiques() {
    const selectedCountries = (this.shopFilters.getAttribute("selected-country") || "").split(",");
    const selectedShopTypes = (this.shopFilters.getAttribute("selected-type") || "").split(",");
    const selectedServices = (this.shopFilters.getAttribute("selected-services") || "").split(",");
    this.resetCountryDisplay();
    let activeBoutiquesCount = 0;
    Array.from(this.countryList).forEach((section) => {
      let sectionBoutiquesCount = 0;
      let hideSection = true;
      Array.from(section.querySelectorAll(".boutique")).forEach((boutique) => {
        let boutiqueCountry = boutique.getAttribute("data-country");
        let boutiqueShopType = boutique.getAttribute("data-type");
        let boutiqueServices = boutique.getAttribute("data-services") ? boutique.getAttribute("data-services").split(",") : [];
        let serviceMatch = boutiqueServices.some((service) => selectedServices.includes(service)) || selectedServices[0] === "";
        if ((selectedCountries.includes(boutiqueCountry) || selectedCountries[0] === "") && (selectedShopTypes.includes(boutiqueShopType) || selectedShopTypes[0] === "") && serviceMatch) {
          hideSection = false;
          boutique.removeAttribute("hidden");
          boutique.setAttribute("reveal-on-scroll", "true");
          activeBoutiquesCount++;
          sectionBoutiquesCount++;
        } else {
          boutique.setAttribute("hidden", "");
          boutique.setAttribute("reveal-on-scroll", "false");
        }
      });
      if (hideSection) {
        section.setAttribute("hidden", "");
      } else {
        section.removeAttribute("hidden");
      }
      this.countBoutiquesByCountry(section, sectionBoutiquesCount);
    });
    this.updateBoutiquesCount(activeBoutiquesCount);
    this.reveal();
  }
  countBoutiquesByCountry(section, count) {
    if (section) {
      section.querySelector("[section-boutique-count]").innerHTML = `(${count})`;
    } else {
      Array.from(this.countryList).forEach((section2) => {
        const initialValue = section2.querySelector('input[type="hidden"]').value;
        section2.querySelector("[section-boutique-count]").innerHTML = `(${initialValue})`;
      });
    }
  }
  setFilter(selector, attributeName) {
    let selectedFilters = this.shopFilters.getAttribute(attributeName) ? this.shopFilters.getAttribute(attributeName).split(",") : [];
    const isChecked = selector.checked;
    const filterValue = selector.value;
    if (isChecked) {
      if (!selectedFilters.includes(filterValue)) {
        selectedFilters.push(filterValue);
      }
    } else {
      selectedFilters = selectedFilters.filter((value) => value !== filterValue);
    }
    this.shopFilters.setAttribute(attributeName, selectedFilters.join(","));
    this.filterBoutiques();
  }
  get autoCompleteDelay() {
    return 200;
  }
};
if (!window.customElements.get("main-boutiques")) {
  window.customElements.define("main-boutiques", Boutiques);
}

// js/sections/cart-drawer.js
import { animate as animate16, stagger as stagger4 } from "vendor";
var _sectionId, _CartDrawer_instances, onBundleSection_fn, onCartChange_fn, onPageShow_fn, refreshCart_fn, replaceContent_fn;
var CartDrawer = class extends Drawer {
  constructor() {
    super(...arguments);
    __privateAdd(this, _CartDrawer_instances);
    __privateAdd(this, _sectionId);
  }
  // We have to save the section ID, as the drawer may be replaced in the DOM
  connectedCallback() {
    var _a;
    super.connectedCallback();
    (_a = __privateGet(this, _sectionId)) != null ? _a : __privateSet(this, _sectionId, extractSectionId(this));
    document.addEventListener("cart:prepare-bundled-sections", __privateMethod(this, _CartDrawer_instances, onBundleSection_fn).bind(this), { signal: this.abortController.signal });
    document.addEventListener("cart:change", __privateMethod(this, _CartDrawer_instances, onCartChange_fn).bind(this), { signal: this.abortController.signal });
    document.addEventListener("cart:refresh", __privateMethod(this, _CartDrawer_instances, refreshCart_fn).bind(this), { signal: this.abortController.signal });
    window.addEventListener("pageshow", __privateMethod(this, _CartDrawer_instances, onPageShow_fn).bind(this), { signal: this.abortController.signal });
    this.addEventListener("dialog:before-show", this.onCartDrawerShow.bind(this), { signal: this.abortController.signal });
    this.initCartContent();
  }
  async initCartContent() {
    this.cartContent = await fetchCart;
    this.currentItemCount = this.cartContent.item_count;
  }
  onCartDrawerShow() {
    Shopify.analytics.publish("cart_drawer_viewed", {
      cart: {
        lines: this.cartContent.items,
        cost: {
          totalAmount: {
            amount: this.cartContent.total_price / 100,
            currencyCode: this.cartContent.currency
          }
        }
      }
    });
  }
};
_sectionId = new WeakMap();
_CartDrawer_instances = new WeakSet();
/**
 * This method is called when the cart is changing, and allow custom sections to order a "re-render"
 */
onBundleSection_fn = function(event) {
  event.detail.sections.push(__privateGet(this, _sectionId));
};
/**
 * When the cart changes, we need to re-render the cart drawer
 */
onCartChange_fn = function(event) {
  __privateMethod(this, _CartDrawer_instances, replaceContent_fn).call(this, event.detail.cart["sections"][__privateGet(this, _sectionId)]);
  if (window.themeVariables.settings.cartType === "drawer" && event.detail.baseEvent === "variant:add") {
    this.show();
  }
};
onPageShow_fn = async function(event) {
  if (!event.persisted) {
    return;
  }
  __privateMethod(this, _CartDrawer_instances, refreshCart_fn).call(this);
};
refreshCart_fn = async function() {
  __privateMethod(this, _CartDrawer_instances, replaceContent_fn).call(this, await (await fetch(`${Shopify.routes.root}?section_id=${__privateGet(this, _sectionId)}`)).text());
};
replaceContent_fn = async function(html) {
  const domElement = new DOMParser().parseFromString(html, "text/html"), newCartDrawer = document.createRange().createContextualFragment(domElement.getElementById(`shopify-section-${__privateGet(this, _sectionId)}`).querySelector("cart-drawer").innerHTML), itemCount = (await fetchCart)["item_count"];
  if (itemCount === 0) {
    this.replaceChildren(...newCartDrawer.children);
    this.classList.add("cart-drawer--empty");
  } else if (this.currentItemCount === 0 && itemCount === 1) {
    this.replaceChildren(...newCartDrawer.children);
    this.classList.remove("cart-drawer--empty");
  } else {
    this.querySelector("#cart-drawer-content").replaceChildren(...newCartDrawer.querySelector("#cart-drawer-content").children);
    animate16(this.querySelectorAll("#cart-drawer-content .line-item"), {
      opacity: [0, 1],
      transform: ["translateX(-10px)", "translateX(0)"]
    }, {
      duration: 0.3,
      easing: "ease",
      delay: stagger4(0.05, { start: 0.2, easing: "ease" })
    });
    this.querySelector("#cart-drawer-form").replaceChildren(...newCartDrawer.querySelector("#cart-drawer-form").children);
  }
  this.currentItemCount = itemCount;
};
if (!window.customElements.get("cart-drawer")) {
  window.customElements.define("cart-drawer", CartDrawer);
}

// js/sections/collection.js
import { Delegate as Delegate6 } from "vendor";
var _delegate2, _CollectionLayoutSwitch_instances, onLayoutSwitch_fn, setCartAttribute_fn;
var CollectionLayoutSwitch = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _CollectionLayoutSwitch_instances);
    __privateAdd(this, _delegate2, new Delegate6(this));
  }
  connectedCallback() {
    __privateGet(this, _delegate2).on("click", 'button[type="button"]', __privateMethod(this, _CollectionLayoutSwitch_instances, onLayoutSwitch_fn).bind(this));
  }
  get controlledList() {
    return document.getElementById(this.getAttribute("aria-controls"));
  }
};
_delegate2 = new WeakMap();
_CollectionLayoutSwitch_instances = new WeakSet();
onLayoutSwitch_fn = async function(event, target) {
  if (target.classList.contains("is-active")) {
    return;
  }
  document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
  await __privateMethod(this, _CollectionLayoutSwitch_instances, setCartAttribute_fn).call(this, target.value);
  let sectionId = this.getAttribute("aria-controls").replace("product-list-", "");
  let shopifySection = document.getElementById(`shopify-section-${sectionId}`);
  let response = await fetch(`${Shopify.routes.root}collections/${this.getAttribute("collection-handle")}section_id=${sectionId}`);
  let contentHtml = new DOMParser().parseFromString(await response.text(), "text/html");
  this.controlledList.innerHTML = contentHtml.getElementById(this.getAttribute("aria-controls")).innerHTML;
  document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
  const scrollToProductList = () => shopifySection.querySelector(".collection").scrollIntoView({ block: "start", behavior: "smooth" });
  if ("requestIdleCallback" in window) {
    requestIdleCallback(scrollToProductList, { timeout: 500 });
  } else {
    requestAnimationFrame(scrollToProductList);
  }
  Array.from(this.querySelectorAll("button")).forEach((item) => item.classList.toggle("is-active", item === target));
  this.controlledList.setAttribute(`collection-layout`, target.value);
  this.controlledList.reveal();
};
setCartAttribute_fn = async function(newLayout) {
  const attributeProperty = `products_grid_mode`;
  await fetch(`${Shopify.routes.root}cart/update.js`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      attributes: {
        [attributeProperty]: newLayout
      }
    }),
    keepalive: true
    // Allows to make sure the request is fired even when submitting the form
  });
};
if (!window.customElements.get("collection-layout-switch")) {
  window.customElements.define("collection-layout-switch", CollectionLayoutSwitch);
}

// js/sections/countdown-timer.js
import { inView as inView12 } from "vendor";
var _flips, _expirationDate, _interval, _isVisible, _CountdownTimer_instances, recalculateFlips_fn;
var CountdownTimer = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _CountdownTimer_instances);
    __privateAdd(this, _flips);
    __privateAdd(this, _expirationDate);
    __privateAdd(this, _interval);
    __privateAdd(this, _isVisible);
  }
  connectedCallback() {
    __privateSet(this, _flips, Array.from(this.querySelectorAll("countdown-timer-flip")));
    const expiresAt = this.getAttribute("expires-at");
    if (expiresAt !== "") {
      __privateSet(this, _expirationDate, new Date(expiresAt));
      __privateSet(this, _interval, setInterval(__privateMethod(this, _CountdownTimer_instances, recalculateFlips_fn).bind(this), 1e3));
      __privateMethod(this, _CountdownTimer_instances, recalculateFlips_fn).call(this);
    }
    inView12(this, () => {
      __privateSet(this, _isVisible, true);
      return () => __privateSet(this, _isVisible, false);
    }, { margin: "500px" });
  }
  disconnectedCallback() {
    clearInterval(__privateGet(this, _interval));
  }
  get daysFlip() {
    return __privateGet(this, _flips).find((flip) => flip.getAttribute("type") === "days");
  }
  get hoursFlip() {
    return __privateGet(this, _flips).find((flip) => flip.getAttribute("type") === "hours");
  }
  get minutesFlip() {
    return __privateGet(this, _flips).find((flip) => flip.getAttribute("type") === "minutes");
  }
  get secondsFlip() {
    return __privateGet(this, _flips).find((flip) => flip.getAttribute("type") === "seconds");
  }
};
_flips = new WeakMap();
_expirationDate = new WeakMap();
_interval = new WeakMap();
_isVisible = new WeakMap();
_CountdownTimer_instances = new WeakSet();
recalculateFlips_fn = function() {
  var _a, _b, _c, _d;
  const dateNow = /* @__PURE__ */ new Date();
  if (__privateGet(this, _expirationDate) < dateNow) {
    if (this.getAttribute("expiration-behavior") === "hide") {
      this.closest(".shopify-section").remove();
    } else {
      return clearInterval(__privateGet(this, _interval));
    }
  }
  if (!__privateGet(this, _isVisible)) {
    return;
  }
  let delta = Math.abs(__privateGet(this, _expirationDate) - dateNow) / 1e3;
  const days = Math.floor(delta / 86400);
  delta -= days * 86400;
  const hours = Math.floor(delta / 3600) % 24;
  delta -= hours * 3600;
  const minutes = Math.floor(delta / 60) % 60;
  delta -= minutes * 60;
  const seconds = Math.floor(delta % 60);
  (_a = this.daysFlip) == null ? void 0 : _a.updateValue(days);
  (_b = this.hoursFlip) == null ? void 0 : _b.updateValue(hours);
  (_c = this.minutesFlip) == null ? void 0 : _c.updateValue(minutes);
  (_d = this.secondsFlip) == null ? void 0 : _d.updateValue(seconds);
};
var CountdownTimerFlip = class extends HTMLElement {
  updateValue(value) {
    this.textContent = value.toString().padStart(2, "0");
  }
};
if (!window.customElements.get("countdown-timer")) {
  window.customElements.define("countdown-timer", CountdownTimer);
}
if (!window.customElements.get("countdown-timer-flip")) {
  window.customElements.define("countdown-timer-flip", CountdownTimerFlip);
}

// js/sections/customer.js
import { animate as animate17 } from "vendor";
var AccountLogin = class extends HTMLElement {
  constructor() {
    super();
    window.addEventListener("hashchange", this.switchForm.bind(this));
    if (window.location.hash === "#recover") {
      this.loginForm.hidden = true;
      this.recoverForm.hidden = false;
    }
  }
  get loginForm() {
    return this.querySelector("#login");
  }
  get recoverForm() {
    return this.querySelector("#recover");
  }
  async switchForm() {
    const fromForm = window.location.hash === "#recover" ? this.loginForm : this.recoverForm, toForm = window.location.hash === "#recover" ? this.recoverForm : this.loginForm;
    await animate17(fromForm, { transform: ["translateY(0)", "translateY(10px)"], opacity: [1, 0] }, { duration: 0.3, easing: "ease" }).finished;
    fromForm.hidden = true;
    toForm.hidden = false;
    await animate17(toForm, { transform: ["translateY(10px)", "translateY(0)"], opacity: [0, 1] }, { duration: 0.3, easing: "ease" });
  }
};
var AccountForm = class extends HTMLElement {
  constructor() {
    super();
    this.querySelector("form").addEventListener("submit", this.submitAccountForm.bind(this));
  }
  submitAccountForm(e) {
    this.querySelector('button[type="submit"]').classList.add("is-loading");
  }
};
var AccountRegister = class extends HTMLElement {
  constructor() {
    super();
    __publicField(this, "form");
    __publicField(this, "CFformID");
    __publicField(this, "errorFormMessage");
    this.form = this.querySelector("#create-customer-form");
    this.CFformID = this.getAttribute("data-form-id");
    this.errorFormMessage = this.form.querySelector(".banner--error");
    CF.customerReady(() => {
      this.form.addEventListener("submit", this._submitForm.bind(this));
    });
  }
  _submitForm(event) {
    event.preventDefault();
    let data2 = new FormData(this.form);
    let formData = {};
    for (const [key, value] of data2) {
      let current_key = key.substring(key.indexOf("[") + 1, key.lastIndexOf("]"));
      formData[current_key] = value;
    }
    let check_email = false;
    let check_sms = false;
    if (data2.get("optin_email")) {
      check_email = true;
    }
    if (data2.get("optin_sms")) {
      check_sms = true;
    }
    const optinData = {
      optin_email: check_email,
      optin_sms: check_sms
    };
    sessionStorage.setItem("lt-first-login", JSON.stringify(optinData));
    CF.customer.set(formData);
    let customerSaveOptions = {
      redirect: true,
      login: true,
      redirectUrl: "/account",
      formId: this.CFformID
    };
    CF.customer.save(customerSaveOptions).then((errorObj) => {
      if (errorObj) {
        console.error("CF.customer.save", errorObj);
        this.querySelector('button[type="submit"]:not(.link)').classList.remove("is-loading");
        if (errorObj.phone) {
          this.errorFormMessage.innerText = window.themeVariables.strings.customer.register.phone_error;
        }
        if (errorObj.email) {
          this.errorFormMessage.innerText = window.themeVariables.strings.customer.register.email_error;
        }
        if (errorObj) {
          this.errorFormMessage.removeAttribute("hidden");
        }
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }).catch(function(error) {
      alert("Failed to save customer! :(");
      console.error(error);
    });
    return false;
  }
};
var AccountCustomerInfo = class extends HTMLElement {
  constructor() {
    super();
    __publicField(this, "form");
    __publicField(this, "CFformID");
    __publicField(this, "successFormMessage");
    this.form = this.querySelector("#update-customer-form");
    this.successFormMessage = this.form.querySelector(".banner--success");
    this.CFformID = this.getAttribute("data-form-id");
    CF.customerReady(() => {
      this._getCustomerInfos();
      this.form.addEventListener("submit", this._submitForm.bind(this));
    });
  }
  _getCustomerInfos() {
    let data2 = CF.customer.get("gender", "birthday");
    if (data2.gender) this.form.querySelector('[name="customer[gender]"][value="' + data2.gender + '"]').checked = true;
    if (data2.birthday) this.form.querySelector('[name="customer[birthday]"]').value = new Date(data2.birthday).toLocaleDateString();
  }
  _submitForm(event) {
    event.preventDefault();
    let formData = {};
    let check_email = false;
    let check_sms = false;
    Array.from(this.form.querySelectorAll("input")).forEach((el) => {
      let current_name = el.getAttribute("name");
      let current_key = current_name.substring(current_name.indexOf("[") + 1, current_name.lastIndexOf("]"));
      if (current_name === "optin_email" || current_name === "optin_sms") {
        if (el.checked) {
          if (current_name === "optin_sms") {
            check_sms = true;
          } else {
            check_email = true;
          }
        }
      } else {
        if (current_key === "gender" && el.checked) formData[current_key] = el.value;
        else if (current_key !== "gender") formData[current_key] = el.value;
      }
    });
    CF.customer.set(formData);
    let customerSaveOptions = {
      redirect: false,
      formId: this.CFformID
    };
    CF.customer.save(customerSaveOptions).then((errorObj) => {
      this.form.querySelector('button[type="submit"]:not(.link)').classList.remove("is-loading");
      this.successFormMessage.hidden = false;
      setTimeout(() => {
        this.successFormMessage.hidden = true;
      }, 5e3);
      if (errorObj) {
        console.error("CF.customer.save", errorObj);
      } else {
        let formData2 = new FormData();
        formData2.append("email", CF.customer.get("email"));
        formData2.append("optin_email", check_email);
        formData2.append("optin_sms", check_sms);
        if (window.themeVariables.customerId) {
          formData2.append("shopify_customer_id", window.themeVariables.customerId);
        }
        ltRequest(formData2, "optin", "optin_edit");
        console.log("customer has been saved !");
      }
    }).catch(function(error) {
      alert("Failed to save customer! :(");
      console.error(error);
    });
    return false;
  }
};
var AccountCustomerHome = class extends HTMLElement {
  constructor() {
    super();
    CF.customerReady(() => {
      this._getCustomerInfos();
    });
  }
  _getCustomerInfos() {
    if (sessionStorage.getItem("lt-first-login")) {
      let formData = new FormData();
      const optinData = JSON.parse(sessionStorage.getItem("lt-first-login"));
      formData.append("email", CF.customer.get("email"));
      formData.append("optin_email", optinData.optin_email);
      formData.append("optin_sms", optinData.optin_sms);
      if (window.themeVariables.customerId) {
        formData.append("shopify_customer_id", window.themeVariables.customerId);
      }
      ltRequest(formData, "optin", "optin_register");
      sessionStorage.removeItem("lt-first-login");
    }
  }
};
if (!window.customElements.get("account-login")) {
  window.customElements.define("account-login", AccountLogin);
}
if (!window.customElements.get("account-register")) {
  window.customElements.define("account-register", AccountRegister);
}
if (!window.customElements.get("account-form")) {
  window.customElements.define("account-form", AccountForm);
}
if (!window.customElements.get("account-customer-info")) {
  window.customElements.define("account-customer-info", AccountCustomerInfo);
}
if (!window.customElements.get("account-customer-home")) {
  window.customElements.define("account-customer-home", AccountCustomerHome);
}

// js/sections/faq-anchor.js
var FaqAnchor = class extends HTMLElement {
  constructor() {
    super();
    this.anchorTags = this.querySelectorAll(".button-tag");
    this.currentActiveAnchor = null;
    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
      root: null,
      rootMargin: "0px 0px -70% 0px",
      threshold: 1
    });
  }
  connectedCallback() {
    this.anchorTags.forEach((anchorTag) => {
      anchorTag.addEventListener("click", this.handleAnchorClick.bind(this));
      const href = anchorTag.getAttribute("href");
      if (href && href.startsWith("#")) {
        const targetElement = document.querySelector(href);
        if (targetElement) {
          this.observer.observe(targetElement);
        }
      }
    });
  }
  disconnectedCallback() {
    this.observer.disconnect();
  }
  handleAnchorClick(event) {
    event.preventDefault();
    const anchorTag = event.target.closest("a");
    const href = anchorTag.getAttribute("href");
    if (href && href.startsWith("#")) {
      const targetElement = document.querySelector(href);
      const headerHeight = document.querySelector(".header").offsetHeight;
      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - headerHeight;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  }
  handleIntersection(entries) {
    entries.forEach((entry) => {
      const activeAnchor = Array.from(this.anchorTags).find((anchor) => anchor.getAttribute("href") === `#${entry.target.id}`);
      if (!activeAnchor) return;
      if (entry.isIntersecting) {
        if (this.currentActiveAnchor && this.currentActiveAnchor !== activeAnchor) {
          this.currentActiveAnchor.classList.remove("active");
        }
        activeAnchor.classList.add("active");
        this.currentActiveAnchor = activeAnchor;
      }
    });
  }
};
if (!window.customElements.get("faq-anchor")) {
  window.customElements.define("faq-anchor", FaqAnchor);
}

// js/sections/geolocation-popup.js
import { timeline as timeline11 } from "vendor";
var GeolocationPopup = class extends Modal {
  connectedCallback() {
    super.connectedCallback();
    if (sessionStorage.getItem("lt-geolocation") !== "true") {
      fetch("https://get.geojs.io/v1/ip/geo.json").then((response) => {
        return response.json();
      }).then((data2) => {
        let geoLocation = data2.country_code || "";
        let currentDomain = window.location.origin;
        let countryUrl = window.themeVariables.settings.environment[`url_${geoLocation}`];
        if (countryUrl && countryUrl !== currentDomain) {
          let countryText = this.querySelector(".country-text_" + geoLocation);
          if (countryText) {
            countryText.classList.remove("hidden");
          }
          Array.from(this.querySelectorAll('[country-code][aria-selected="false"]')).forEach((el) => {
            if (el.getAttribute("country-code") !== geoLocation.toLowerCase()) {
              el.hidden = true;
            }
          });
          Array.from(this.querySelectorAll("[data-code]")).forEach((el) => el.innerHTML = geoLocation);
          this.show();
          sessionStorage.setItem("lt-geolocation", "true");
        }
      }).catch((error) => {
        console.error("Erreur:", error);
      });
    }
  }
  getStyleProperties() {
    if (matchesMediaQuery("md")) {
      this.transform = ["translateY(0)", "translateY(-50%)"];
    } else {
      this.transform = ["translateY(100%)", "translateY(0)"];
    }
  }
  createEnterAnimationControls() {
    this.getStyleProperties();
    return timeline11([
      [this.getShadowPartByName("overlay"), { opacity: [0, 1] }, { duration: 0.15 }],
      [this.getShadowPartByName("content"), { transform: this.transform }, { duration: 0.15, at: "-0.1" }]
    ]);
  }
  createLeaveAnimationControls() {
    return timeline11([
      [this.getShadowPartByName("overlay"), { opacity: [1, 0] }, { duration: 0.15 }],
      [this.getShadowPartByName("content"), { transform: this.transform.reverse() }, { duration: 0.15, at: "<" }]
    ]);
  }
};
if (!window.customElements.get("geolocation-popup")) {
  window.customElements.define("geolocation-popup", GeolocationPopup);
}

// js/sections/country-switcher-popup.js
import { timeline as timeline12 } from "vendor";
var CountrySwitcherPopup = class extends Modal {
  constructor() {
    super();
    this.currentCountry = null;
    this.elements = {
      form: {},
      country: {},
      lang: {}
    };
    this.elements.form.form = this.querySelector("form");
    this.elements.form.country = this.elements.form.form.querySelector('input[name="country_code"]');
    this.elements.form.language = this.elements.form.form.querySelector('input[name="language_code"]');
    this.elements.country.select = this.querySelector("country-switcher-custom-select");
    this.elements.country.options = this.elements.country.select.querySelectorAll("button");
    this.elements.lang.select = this.querySelector("country-switcher-lang-custom-select");
    this.elements.lang.options = this.elements.lang.select.querySelectorAll("button");
    this.elements.lang.listbox = this.elements.lang.select.querySelector("x-listbox");
    this.elements.submit = this.querySelector('button[type="submit"]');
    this.elements.country.select.addEventListener("changed-value", this.handleCountryChange.bind(this));
    this.elements.lang.select.addEventListener("changed-value", this.handleLangChange.bind(this));
    this.elements.submit.addEventListener("click", (e) => {
      this.elements.form.form.submit();
    });
  }
  connectedCallback() {
    super.connectedCallback();
  }
  handleCountryChange(e) {
    var _a, _b, _c;
    const country_code = (_a = e.detail) == null ? void 0 : _a.iso_code.toLowerCase();
    this.elements.form.country.value = country_code;
    const languages = (_c = (_b = e.detail) == null ? void 0 : _b.languages) != null ? _c : [];
    const locales = languages.map((item) => item.shop_locale.locale);
    const primaryLocale = locales[0];
    this.elements.lang.options.forEach((option) => {
      option.removeAttribute("aria-invisible");
    });
    this.elements.lang.options.forEach((option) => {
      if (locales.indexOf(option.getAttribute("value")) == -1) {
        option.setAttribute("aria-invisible", "true");
      }
    });
    const primaryOption = this.elements.lang.select.querySelector(`button[value="${primaryLocale}"]`);
    this.elements.lang.listbox.insertBefore(primaryOption, this.elements.lang.listbox.firstElementChild);
    primaryOption.click();
  }
  handleLangChange(e) {
    this.elements.form.language.value = e.detail;
  }
  getStyleProperties() {
    if (matchesMediaQuery("md")) {
      this.transform = ["translateY(0)", "translateY(-50%)"];
    } else {
      this.transform = ["translateY(100%)", "translateY(0)"];
    }
  }
  createEnterAnimationControls() {
    this.getStyleProperties();
    return timeline12([
      [this.getShadowPartByName("overlay"), { opacity: [0, 1] }, { duration: 0.15 }],
      [this.getShadowPartByName("content"), { transform: this.transform }, { duration: 0.15, at: "-0.1" }]
    ]);
  }
  createLeaveAnimationControls() {
    return timeline12([
      [this.getShadowPartByName("overlay"), { opacity: [1, 0] }, { duration: 0.15 }],
      [this.getShadowPartByName("content"), { transform: this.transform.reverse() }, { duration: 0.15, at: "<" }]
    ]);
  }
};
if (!window.customElements.get("country-switcher-popup")) {
  window.customElements.define("country-switcher-popup", CountrySwitcherPopup);
}

// js/sections/country-switcher-custom-select.js
var CountrySwitcherCustomSelect = class extends Popover {
  constructor() {
    super();
    this.value = null;
    this.elements = {
      listbox: this.querySelector("x-listbox")
    };
    const value = this.elements.listbox.querySelector('button[aria-selected="true"]').value;
    this.value = JSON.parse(value);
    this.triggerChangedValue();
    this.addEventListener("listbox:change", (e) => {
      this.value = JSON.parse(e.detail.value);
      this.triggerChangedValue();
    });
  }
  triggerChangedValue() {
    this.dispatchEvent(new CustomEvent("changed-value", {
      bubbles: false,
      detail: this.value
    }));
  }
  getValue() {
    return this.value;
  }
};
if (!window.customElements.get("country-switcher-custom-select")) {
  window.customElements.define("country-switcher-custom-select", CountrySwitcherCustomSelect);
}

// js/sections/country-switcher-lang-custom-select.js
var CountrySwitcherLangCustomSelect = class extends Popover {
  constructor() {
    super();
    this.value = null;
    this.addEventListener("listbox:change", (e) => {
      this.value = e.detail.value;
      this.triggerChangedValue();
    });
  }
  triggerChangedValue() {
    this.dispatchEvent(new CustomEvent("changed-value", {
      bubbles: false,
      detail: this.value
    }));
  }
};
if (!window.customElements.get("country-switcher-lang-custom-select")) {
  window.customElements.define("country-switcher-lang-custom-select", CountrySwitcherLangCustomSelect);
}

// js/sections/header.js
import { animate as animate18, timeline as timeline13 } from "vendor";
var Header = class extends HTMLElement {
  connectedCallback() {
    var _a;
    this.onScrollListener = throttle(this.onScroll.bind(this));
    this.isVisible = false;
    this.stickyOffset = parseInt(this.getAttribute("sticky-offset"));
    this.announcementBarOffset = (_a = document.querySelector(".shopify-section--announcement-bar")) == null ? void 0 : _a.clientHeight;
    this.headerSection = this.closest(".shopify-section");
    window.addEventListener("scroll", this.onScrollListener);
    this.onScroll();
  }
  onScroll() {
    if (window.scrollY >= this.stickyOffset && !this.isVisible) {
      this.isVisible = true;
      this.headerSection.classList.add("is-visible");
      animate18(this, { transform: ["translateY(-100%)", "translateY(0)"] }, { duration: 0.3, easing: "ease" }).finished.then(() => {
        document.documentElement.dispatchEvent(new CustomEvent("theme:header:sticky-visible", { bubbles: true, detail: { isSticky: true } }));
      });
    } else if (window.scrollY < this.stickyOffset) {
      if (this.isVisible) {
        this.isVisible = false;
        animate18(this, { transform: ["translateY(0)", "translateY(-100%)"] }, { duration: 0.3, easing: "ease" }).finished.then(() => {
          this.style.transform = null;
          this.headerSection.classList.remove("is-visible");
          document.documentElement.dispatchEvent(new CustomEvent("theme:header:sticky-hidden", { bubbles: true, detail: { isSticky: false } }));
        });
      }
    }
  }
};
var HeaderSearch = class extends DialogElement {
  constructor() {
    super();
    this.addEventListener("dialog:before-show", this.toggleOpen.bind(this));
    this.headerSection = document.querySelector(".shopify-section--header");
    this.addEventListener("dialog:before-show", () => this.headerSection.classList.add("is-open"));
    this.addEventListener("dialog:after-hide", () => this.headerSection.classList.remove("is-open"));
  }
  get shadowDomTemplate() {
    return "header-search-default-template";
  }
  get shouldLock() {
    return true;
  }
  createEnterAnimationControls() {
    return timeline13([
      [this.getShadowPartByName("overlay"), { opacity: [0, 1] }, { duration: 0.2, easing: [0.645, 0.045, 0.355, 1] }],
      [this.getShadowPartByName("content"), { opacity: [0, 1], transform: ["translateY(calc(-1 * var(--header-height)))", "translateY(0)"] }, { duration: 0.2, at: "<", easing: [0.645, 0.045, 0.355, 1] }]
    ]);
  }
  createLeaveAnimationControls() {
    return timeline13([
      [this.getShadowPartByName("overlay"), { opacity: [1, 0] }, { duration: 0.2, easing: [0.645, 0.045, 0.355, 1] }],
      [this.getShadowPartByName("content"), { opacity: [1, 0], transform: ["translateY(0)", "translateY(calc(-1 * var(--header-height)))"] }, { duration: 0.2, at: "<", easing: [0.645, 0.045, 0.355, 1] }]
    ]);
  }
  toggleOpen() {
    const boundingRect = this.getBoundingClientRect(), maxHeight = window.innerHeight - boundingRect.top, headerPosition = this.headerSection.getBoundingClientRect().height + this.headerSection.getBoundingClientRect().y;
    this.style.setProperty("--header-search-max-height", `${maxHeight}px`);
    this.style.setProperty("top", `${headerPosition}px`);
    window.dispatchEvent(new Event("resize"));
  }
};
var _detectHoverListener2, _hoverTimer2, _DropdownMenuCustom_instances, detectHover_fn2, toggleOpen_fn;
var DropdownMenuCustom = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _DropdownMenuCustom_instances);
    __privateAdd(this, _detectHoverListener2, __privateMethod(this, _DropdownMenuCustom_instances, detectHover_fn2).bind(this));
    __privateAdd(this, _hoverTimer2);
    this.addEventListener("mouseover", __privateGet(this, _detectHoverListener2));
    this.addEventListener("mouseout", __privateGet(this, _detectHoverListener2));
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => __privateMethod(this, _DropdownMenuCustom_instances, toggleOpen_fn).call(this, true));
      this.addEventListener("shopify:block:deselect", () => __privateMethod(this, _DropdownMenuCustom_instances, toggleOpen_fn).call(this, false));
    }
  }
  get contentElement() {
    return this.lastElementChild;
  }
  createShowAnimationControls() {
    return animate18(this.contentElement, { opacity: [0, 1] }, { duration: 0.25 });
  }
  createHideAnimationControls() {
    return animate18(this.contentElement, { opacity: [1, 0] }, { duration: 0.4 });
  }
};
_detectHoverListener2 = new WeakMap();
_hoverTimer2 = new WeakMap();
_DropdownMenuCustom_instances = new WeakSet();
detectHover_fn2 = function(event) {
  if (!document.documentElement.classList.contains("lock")) {
    if (event.type === "mouseover") {
      clearTimeout(__privateGet(this, _hoverTimer2));
      __privateMethod(this, _DropdownMenuCustom_instances, toggleOpen_fn).call(this, true);
    } else if (event.type === "mouseout") {
      __privateSet(this, _hoverTimer2, setTimeout(() => __privateMethod(this, _DropdownMenuCustom_instances, toggleOpen_fn).call(this, false), 125));
    }
  }
};
toggleOpen_fn = function(open) {
  if (open) {
    if (this.getAttribute("aria-expanded") === "true") {
      return;
    }
  }
  this.setAttribute("aria-expanded", open ? "true" : "false");
  if (open) this.createShowAnimationControls();
  if (!open) this.createHideAnimationControls();
  document.querySelector(".shopify-section--header").classList.toggle("is-open", open);
};
var _DropdownLinks_instances, displayLinkList_fn;
var DropdownLinks = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _DropdownLinks_instances);
    Array.from(this.querySelectorAll("[data-parent-index]")).forEach((item) => item.addEventListener("mouseover", __privateMethod(this, _DropdownLinks_instances, displayLinkList_fn).bind(this)));
    this.subLinks = this.querySelectorAll(".sub_sub_links");
    this.maxHeight = 260;
  }
  connectedCallback() {
    this.adjustGridColumn();
    window.addEventListener("resize", () => {
      this.adjustGridColumn();
    });
  }
  adjustGridColumn() {
    Array.from(this.subLinks).forEach((subLink) => {
      const contentHeight = subLink.scrollHeight;
      if (contentHeight > this.maxHeight) {
        subLink.style.gridTemplateColumns = `repeat(${Math.ceil(contentHeight / this.maxHeight)}, minmax(0, 1fr))`;
        subLink.style.gap = "0.5rem 1rem";
      } else {
        subLink.style.gridTemplateColumns = "repeat(1, minmax(0, 1fr))";
      }
    });
  }
};
_DropdownLinks_instances = new WeakSet();
displayLinkList_fn = function(event) {
  Array.from(this.querySelectorAll("[data-parent-index]")).forEach((item) => item.setAttribute("aria-selected", "false"));
  event.currentTarget.setAttribute("aria-selected", "true");
  Array.from(this.querySelectorAll("[data-child-index]")).forEach((item) => item.setAttribute("aria-selected", "false"));
  let parentItem = this.querySelector(`[data-child-index="${event.currentTarget.getAttribute("data-parent-index")}"]`);
  if (parentItem) {
    parentItem.setAttribute("aria-selected", "true");
  }
};
if (!window.customElements.get("x-header")) {
  window.customElements.define("x-header", Header);
}
if (!window.customElements.get("header-search")) {
  window.customElements.define("header-search", HeaderSearch);
}
if (!window.customElements.get("dropdown-menu")) {
  window.customElements.define("dropdown-menu", DropdownMenuCustom);
}
if (!window.customElements.get("dropdown-links")) {
  window.customElements.define("dropdown-links", DropdownLinks);
}

// js/sections/lines-drawer-button.js
var LinesDrawerButton = class extends HTMLElement {
  connectedCallback() {
    let elementsToObserve = document.querySelector("#main ~ *");
    this.options = {
      root: null,
      rootMargin: "10%",
      threshold: 0
    };
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        this.getButton.style.opacity = entry.isIntersecting ? 0 : 1;
      });
    }, this.options);
    this.observer.observe(elementsToObserve);
  }
  get getButton() {
    return this.querySelector("button");
  }
};
if (!window.customElements.get("lines-drawer-button")) {
  window.customElements.define("lines-drawer-button", LinesDrawerButton);
}

// js/sections/menu-drawer.js
import { Delegate as Delegate7, timeline as timeline14, stagger as stagger5 } from "vendor";
var MenuDrawer = class extends Drawer {
  constructor() {
    super();
    this.delegate = new Delegate7(this);
    this.headerSection = document.querySelector(".shopify-section--header");
    this.delegate.on("click", "[data-panel]", this.openPanel.bind(this));
    this.addEventListener("dialog:before-show", this.toggleOpen.bind(this));
    this.addEventListener("dialog:before-show", () => this.headerSection.classList.add("is-open"));
    this.addEventListener("dialog:after-hide", () => this.headerSection.classList.remove("is-open"));
    this.querySelector(".menu-drawer__tabs").addEventListener("tab:changed", this.onPanelSwitched.bind(this));
  }
  connectedCallback() {
    super.connectedCallback();
    if (Shopify.designMode) {
    }
  }
  get shouldAppendToBody() {
    return false;
  }
  toggleOpen() {
    const headerPosition = this.headerSection.getBoundingClientRect().height + this.headerSection.getBoundingClientRect().y;
    this.style.setProperty("--menu-drawer-position-start", `${headerPosition}px`);
  }
  getCurrentPanel(target) {
    return target.querySelector('.menu-drawer__content:not([hidden]) .panel[aria-selected="true"]');
  }
  openPanel(event, target) {
    this.switchToPanel(target.closest(".panel"), target.getAttribute("data-panel")).finished.then(() => {
      target.closest(".panel").setAttribute("aria-selected", "false");
    });
  }
  switchToPanel(currentPanel, panelId) {
    let targetPanel = this.querySelector(`#${panelId}`);
    if (targetPanel) targetPanel.setAttribute("aria-selected", "true");
    timeline14([
      [currentPanel, { opacity: [1, 0], transform: ["translateX(0)", "translateX(20px)"] }, { duration: 0.3 }],
      [targetPanel, { opacity: [0, 1], transform: ["translateX(-20px)", "translateX(0)"] }, { duration: 0.3, at: "<", delay: 0.4 }]
    ]);
    return this.secondPanelAnimation(targetPanel);
  }
  /*-- Items animation when change panel --*/
  onPanelSwitched(event) {
    let currentPanel = this.getCurrentPanel(event.target);
    currentPanel.classList.contains("menu-drawer__sub-panel") ? this.secondPanelAnimation(currentPanel) : this.firstPanelAnimation(currentPanel);
  }
  firstPanelAnimation(currentPanel) {
    return timeline14([
      [currentPanel.querySelectorAll(".menu-drawer__item"), { opacity: [0, 1], transform: ["translateX(-20px)", "translateX(0)"] }, { duration: 0.5, at: "<", delay: stagger5(0.02, { start: 0.03, easing: [0.25, 0.46, 0.45, 0.94] }) }]
    ]);
  }
  secondPanelAnimation(currentPanel) {
    return timeline14([
      [currentPanel.querySelectorAll(".menu-drawer__item"), { opacity: [0, 1], transform: ["translateX(-20px)", "translateX(0)"] }, { duration: 0.5, at: "<", delay: stagger5(0.02, { start: 0.4, easing: [0.25, 0.46, 0.45, 0.94] }) }],
      [currentPanel.querySelectorAll(".menu-drawer__sub-panel-medias a"), { opacity: [0, 1], transform: ["translateY(20px)", "translateX(0)"] }, { duration: 0.3, at: "<", delay: stagger5(0.02, { start: 0.5, easing: [0.25, 0.46, 0.45, 0.94] }) }]
    ]);
  }
  createEnterAnimationControls() {
    this.setStyleProperties();
    timeline14([
      [this.getShadowPartByName("overlay"), { opacity: [0, 1] }, { duration: 0.3, easing: [0.645, 0.045, 0.355, 1] }],
      [this.getShadowPartByName("content"), { transform: this.transform }, { duration: 0.3, at: "<", easing: [0.5, 0.5, 0.5, 1] }]
    ]);
    return this.firstPanelAnimation(this.getCurrentPanel(this));
  }
};
if (!window.customElements.get("menu-drawer")) {
  window.customElements.define("menu-drawer", MenuDrawer);
}

// js/sections/multi-column.js
var MultiColumn = class extends HTMLElement {
  constructor() {
    super();
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => {
        event.target.scrollIntoView({ inline: "center", block: "nearest", behavior: event.detail["load"] ? "auto" : "smooth" });
      });
    }
  }
};
if (!window.customElements.get("multi-column")) {
  window.customElements.define("multi-column", MultiColumn);
}

// js/sections/newsletter-popup.js
import { timeline as timeline15 } from "vendor";
var NewsletterPopup = class extends Modal {
  connectedCallback() {
    super.connectedCallback();
    if (this.shouldAppearAutomatically) {
      setTimeout(() => this.show(), this.apparitionDelay);
    }
  }
  get apparitionDelay() {
    return parseInt(this.getAttribute("apparition-delay") || 0) * 1e3;
  }
  get shouldAppendToBody() {
    return false;
  }
  get shouldAppearAutomatically() {
    return !(this.hasAttribute("only-once") && localStorage.getItem("theme:popup-appeared") === "true");
  }
  get openFrom() {
    return this.getAttribute("open-from") || "right";
  }
  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    if (name === "open" && this.open) {
      localStorage.setItem("theme:popup-appeared", "true");
    }
  }
  getStyleProperties(direction) {
    if (matchesMediaQuery("md")) {
      switch (direction) {
        case "right":
          this.transform = ["translateX(100%)", "translateX(0)"];
          break;
        case "bottom":
          this.transform = ["translateY(0)", "translateY(-50%)"];
          break;
      }
    } else {
      this.transform = ["translateY(100%)", "translateY(0)"];
    }
  }
  createEnterAnimationControls() {
    this.getStyleProperties(this.openFrom);
    return timeline15([
      [this.getShadowPartByName("overlay"), { opacity: [0, 1] }, { duration: 0.15 }],
      [this.getShadowPartByName("content"), { transform: this.transform }, { duration: 0.15, at: "-0.1" }]
    ]);
  }
  createLeaveAnimationControls() {
    return timeline15([
      [this.getShadowPartByName("overlay"), { opacity: [1, 0] }, { duration: 0.15 }],
      [this.getShadowPartByName("content"), { transform: this.transform.reverse() }, { duration: 0.15, at: "<" }]
    ]);
  }
};
if (!window.customElements.get("newsletter-popup")) {
  window.customElements.define("newsletter-popup", NewsletterPopup);
}

// js/sections/privacy-banner.js
import { Delegate as Delegate8 } from "vendor";
var _delegate3, _PrivacyBanner_instances, onConsentLibraryLoaded_fn, acceptPolicy_fn, declinePolicy_fn;
var PrivacyBanner = class extends DialogElement {
  constructor() {
    super();
    __privateAdd(this, _PrivacyBanner_instances);
    __privateAdd(this, _delegate3, new Delegate8(this));
    window.Shopify.loadFeatures([{
      name: "consent-tracking-api",
      version: "0.1",
      onLoad: __privateMethod(this, _PrivacyBanner_instances, onConsentLibraryLoaded_fn).bind(this)
    }]);
  }
  connectedCallback() {
    super.connectedCallback();
    __privateGet(this, _delegate3).on("click", '[data-action="accept"]', __privateMethod(this, _PrivacyBanner_instances, acceptPolicy_fn).bind(this));
    __privateGet(this, _delegate3).on("click", '[data-action="decline"]', __privateMethod(this, _PrivacyBanner_instances, declinePolicy_fn).bind(this));
  }
  disconnectedCallback() {
    __privateGet(this, _delegate3).off();
  }
};
_delegate3 = new WeakMap();
_PrivacyBanner_instances = new WeakSet();
onConsentLibraryLoaded_fn = function() {
  var _a;
  if ((_a = window.Shopify.customerPrivacy) == null ? void 0 : _a.shouldShowBanner()) {
    this.show();
  }
};
acceptPolicy_fn = function() {
  var _a;
  (_a = window.Shopify.customerPrivacy) == null ? void 0 : _a.setTrackingConsent({ "analytics": true, "marketing": true }, this.hide.bind(this));
};
declinePolicy_fn = function() {
  var _a;
  (_a = window.Shopify.customerPrivacy) == null ? void 0 : _a.setTrackingConsent({ "analytics": false, "marketing": false }, this.hide.bind(this));
};
if (!window.customElements.get("privacy-banner")) {
  window.customElements.define("privacy-banner", PrivacyBanner);
}

// js/sections/product-recommendations.js
var _isLoaded, _ProductRecommendations_instances, loadRecommendations_fn2;
var ProductRecommendations = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _ProductRecommendations_instances);
    __privateAdd(this, _isLoaded, false);
  }
  connectedCallback() {
    __privateMethod(this, _ProductRecommendations_instances, loadRecommendations_fn2).call(this);
  }
};
_isLoaded = new WeakMap();
_ProductRecommendations_instances = new WeakSet();
loadRecommendations_fn2 = async function() {
  if (__privateGet(this, _isLoaded)) {
    return;
  }
  __privateSet(this, _isLoaded, true);
  const section = this.closest(".shopify-section"), intent = this.getAttribute("intent") || "related", url = `${Shopify.routes.root}recommendations/products?product_id=${this.getAttribute("product")}&limit=${this.getAttribute("limit") || 4}&section_id=${extractSectionId(section)}&intent=${intent}`, response = await fetch(url, { priority: intent === "related" ? "low" : "auto" });
  const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html"), productRecommendationsElement = tempDiv.querySelector("product-recommendations");
  if (productRecommendationsElement.childElementCount > 0) {
    this.replaceChildren(...document.importNode(productRecommendationsElement, true).childNodes);
    this.hidden = false;
  } else {
    this.remove();
  }
};
if (!window.customElements.get("product-recommendations")) {
  window.customElements.define("product-recommendations", ProductRecommendations);
}

// js/sections/quick-links-sticky.js
import { animate as animate19, timeline as timeline16, stagger as stagger6 } from "vendor";
var QuickLinksSticky = class extends HTMLElement {
  connectedCallback() {
    let quickLinksElement = this.parentElement;
    quickLinksElement.style.height = quickLinksElement.offsetHeight + "px";
    let footer = document.querySelector(".shopify-section--footer");
    let elementsToObserve = [quickLinksElement, footer];
    this.options = {
      root: null,
      rootMargin: "0%",
      threshold: 0
    };
    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting || window.scrollY < quickLinksElement.offsetTop) {
          this.disappearStickyAnimation();
        } else {
          this.appearStickyAnimation();
        }
      });
    }, this.options);
    elementsToObserve.forEach((el) => {
      this.observer.observe(el);
    });
  }
  appearStickyAnimation() {
    this.setAttribute("aria-hidden", "false");
    animate19(this, { transform: ["translateY(100%)", "translateY(0)"] }, { duration: 0.3, easing: "ease" });
  }
  disappearStickyAnimation() {
    animate19(this, { transform: ["translateY(0)", "translateY(100%)"] }, { duration: 0.3, easing: "ease" }).finished.then(() => {
      this.setAttribute("aria-hidden", "true");
    });
  }
};
if (!window.customElements.get("quick-links-sticky")) {
  window.customElements.define("quick-links-sticky", QuickLinksSticky);
}

// js/sections/article-progress-bar.js
import { animate as animate20 } from "vendor";
var ArticleProgressBar = class extends HTMLElement {
  constructor() {
    super();
    this.progressBar = this.initializeProgressBar();
    this.stickyOffset = parseInt(this.getAttribute("sticky-offset"));
  }
  connectedCallback() {
    this.articleSection = document.querySelector(".shopify-section--main-article");
    if (!this.articleSection) return;
    this.stickyProgressBar = this.querySelector(".article-sticky-info");
    window.addEventListener("scroll", this.handleScroll.bind(this));
    window.addEventListener("resize", this.handleScroll.bind(this));
    this.handleScroll();
  }
  handleScroll() {
    if (window.scrollY >= this.stickyOffset && !this.isVisible) {
      this.isVisible = true;
      animate20(this, { transform: ["translateY(-100%)", "translateY(var(--header-height))"] }, { duration: 0.15, easing: "ease" });
    } else if (window.scrollY < this.stickyOffset) {
      if (this.isVisible) {
        this.isVisible = false;
        animate20(this, { transform: ["translateY(var(--header-height))", "translateY(-100%)"] }, { duration: 0.15, easing: "ease" }).finished.then(() => {
          this.style.transform = null;
        });
      }
    }
    this.updateProgressOnScroll();
  }
  initializeProgressBar() {
    return this.querySelector(".article-progress-bar--reading");
  }
  updateProgressOnScroll() {
    const articleRect = this.articleSection.getBoundingClientRect();
    const scrollPosition = window.scrollY;
    const articleStart = scrollPosition + articleRect.top;
    const articleEnd = articleStart + articleRect.height;
    const windowHeight = window.innerHeight;
    const scrolled = scrollPosition + windowHeight;
    let progress2 = 0;
    if (scrolled >= articleStart && scrolled <= articleEnd) {
      progress2 = (scrolled - articleStart) / (articleEnd - articleStart);
    } else if (scrolled > articleEnd) {
      progress2 = 1;
    }
    this.progressBar.style.width = `${progress2 * 100}%`;
  }
};
window.customElements.define("article-progress-bar", ArticleProgressBar);

// js/sections/read-more.js
import { timeline as timeline17 } from "vendor";
var _onSummaryClickedListener2, _switcherButtons;
var ReadMore = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _onSummaryClickedListener2, this._onSummaryClicked.bind(this));
    __privateAdd(this, _switcherButtons, this.querySelectorAll("[data-switcher]"));
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => this.show(!event.detail.load));
      this.addEventListener("shopify:block:deselect", this.hide);
    }
  }
  static get observedAttributes() {
    return ["open"];
  }
  connectedCallback() {
    this.summaryElement.addEventListener("click", __privateGet(this, _onSummaryClickedListener2));
  }
  disconnectedCallback() {
    this.summaryElement.removeEventListener("click", __privateGet(this, _onSummaryClickedListener2).bind(this));
  }
  get summaryElement() {
    return this.lastElementChild;
  }
  get contentElement() {
    return this.firstElementChild;
  }
  show(animate23 = true) {
    if (this.hasAttribute("open")) {
      return;
    }
    this.isConnected ? this._openTransition(animate23) : this.setAttribute("open", "");
    this.classList.add("is-expanded");
  }
  hide() {
    if (!this.hasAttribute("open")) {
      return;
    }
    this.classList.remove("is-expanded");
    this.isConnected ? this._closeTransition() : this.removeAttribute("open");
  }
  attributeChangedCallback(name, oldValue, newValue) {
    this.classList.toggle("is-expanded", newValue === "");
    this.setAttribute("aria-expanded", newValue !== null ? "true" : "false");
  }
  _onSummaryClicked(event) {
    event.preventDefault();
    this.hasAttribute("open") ? this.hide() : this.show();
    Array.from(__privateGet(this, _switcherButtons)).forEach((el) => {
      el.hidden = !el.hidden;
    });
  }
  /**
   * Open transition
   */
  async _openTransition(animate23 = true) {
    this.style.overflow = "hidden";
    this.setAttribute("open", "");
    const animationControls = timeline17([
      [this.contentElement, { height: [`${this.contentElement.clientHeight}px`, `${this.contentElement.scrollHeight + 10}px`] }, { duration: 0.25, easing: "ease" }]
    ]);
    animate23 ? animationControls.play() : animationControls.finish();
    await animationControls.finished;
    this.style.height = "auto";
    this.style.overflow = "visible";
  }
  /**
   * Close transition
   */
  async _closeTransition(animate23 = true) {
    this.style.overflow = "hidden";
    this.removeAttribute("open");
    const animationControls = timeline17([
      [this.contentElement, { height: [`${this.contentElement.scrollHeight}px`, `${getComputedStyle(this.contentElement).getPropertyValue("--seo-read-more-content-height")}`] }, { duration: 0.25, at: "<", easing: "ease" }]
    ]);
    animate23 ? animationControls.play() : animationControls.finish();
    await animationControls.finished;
    this.style.height = "auto";
    this.style.overflow = "visible";
  }
};
_onSummaryClickedListener2 = new WeakMap();
_switcherButtons = new WeakMap();
if (!window.customElements.get("read-more")) {
  window.customElements.define("read-more", ReadMore);
}

// js/sections/recently-viewed-products.js
var _isLoaded2, _RecentlyViewedProducts_instances, searchQueryString_get, loadProducts_fn;
var RecentlyViewedProducts = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _RecentlyViewedProducts_instances);
    __privateAdd(this, _isLoaded2, false);
  }
  connectedCallback() {
    __privateMethod(this, _RecentlyViewedProducts_instances, loadProducts_fn).call(this);
  }
};
_isLoaded2 = new WeakMap();
_RecentlyViewedProducts_instances = new WeakSet();
searchQueryString_get = function() {
  const items = new Set(JSON.parse(localStorage.getItem("theme:recently-viewed-products") || "[]"));
  if (this.hasAttribute("exclude-id")) {
    items.delete(parseInt(this.getAttribute("exclude-id")));
  }
  return Array.from(items.values(), (item) => `id:${item}`).slice(0, parseInt(this.getAttribute("products-count"))).join(" OR ");
};
loadProducts_fn = async function() {
  if (__privateGet(this, _isLoaded2)) {
    return;
  }
  __privateSet(this, _isLoaded2, true);
  const section = this.closest(".shopify-section"), url = `${Shopify.routes.root}search?type=product&q=${__privateGet(this, _RecentlyViewedProducts_instances, searchQueryString_get)}&section_id=${extractSectionId(section)}`, response = await fetch(url, { priority: "low" });
  const tempDiv = new DOMParser().parseFromString(await response.text(), "text/html"), recentlyViewedProductsElement = tempDiv.querySelector("recently-viewed-products");
  if (recentlyViewedProductsElement.childElementCount > 0) {
    this.replaceChildren(...document.importNode(recentlyViewedProductsElement, true).childNodes);
  } else {
    section.remove();
  }
};
if (!window.customElements.get("recently-viewed-products")) {
  window.customElements.define("recently-viewed-products", RecentlyViewedProducts);
}

// js/sections/slideshow.js
import { timeline as timeline18, Delegate as Delegate9 } from "vendor";
var _delegate4, _onVideoEndedListener, _SlideshowCarousel_instances, autoplayPauseOnVideo_get, getSlideEnteringSequence_fn, getSlideLeavingSequence_fn, muteVideo_fn, unmuteVideo_fn, onVolumeChange_fn, onSlideSettle_fn, onVideoEnded_fn, onNextButtonClicked_fn;
var SlideshowCarousel = class extends EffectCarousel {
  constructor() {
    super();
    __privateAdd(this, _SlideshowCarousel_instances);
    __privateAdd(this, _delegate4, new Delegate9(this));
    __privateAdd(this, _onVideoEndedListener, __privateMethod(this, _SlideshowCarousel_instances, onVideoEnded_fn).bind(this));
    __privateGet(this, _delegate4).on("click", '[data-action="navigate-next"]', __privateMethod(this, _SlideshowCarousel_instances, onNextButtonClicked_fn).bind(this));
    __privateGet(this, _delegate4).on("click", '[data-action="unmute"]', __privateMethod(this, _SlideshowCarousel_instances, unmuteVideo_fn).bind(this));
    __privateGet(this, _delegate4).on("click", '[data-action="mute"]', __privateMethod(this, _SlideshowCarousel_instances, muteVideo_fn).bind(this));
    this.addEventListener("volumechange", __privateMethod(this, _SlideshowCarousel_instances, onVolumeChange_fn), { capture: true });
    this.addEventListener("carousel:settle", __privateMethod(this, _SlideshowCarousel_instances, onSlideSettle_fn));
    if (this.querySelector(".slideshow__cursor")) {
      this.addEventListener("tap", this._onSlideshowTap);
    }
    if (this.hasAttribute("pause_on_hover")) {
      __privateGet(this, _delegate4).on("mouseenter", () => {
        this.player.pause();
      });
      __privateGet(this, _delegate4).on("mouseleave", () => {
        this.player.resume();
      });
    }
    if (this.querySelectorAll(".shop-the-look-item")) {
      this.pauseOnShopTheLookOpen();
    }
  }
  disconnectedCallback() {
    __privateGet(this, _delegate4).destroy();
  }
  /**
   * Check when the media is fully loaded so that we can initiate the switch
   */
  async createOnBecameVisibleAnimationControls(toSlide) {
    if (toSlide.getAttribute("media-type") === "image") {
      await imageLoaded(toSlide.querySelectorAll("img"));
    } else {
      await videoLoaded(toSlide.querySelectorAll("video"));
    }
    this.updateHeaderTextColor(toSlide);
    return timeline18([
      ...__privateMethod(this, _SlideshowCarousel_instances, getSlideEnteringSequence_fn).call(this, toSlide)
    ]);
  }
  pauseOnShopTheLookOpen() {
    Array.from(this.querySelectorAll(".shop-the-look-item")).forEach((item) => {
      if (!item.querySelector(".shop-the-look-item-modal")) {
        return;
      }
      item.querySelector(".shop-the-look-item-modal").addEventListener("dialog:after-show", () => {
        this.player.dispatchEvent(new CustomEvent("player:stop"));
        this.player.pause();
      });
      item.querySelector(".shop-the-look-item-modal").addEventListener("dialog:after-show", () => {
        this.player.dispatchEvent(new CustomEvent("player:stop"));
        this.player.pause();
      });
      item.querySelector(".shop-the-look-item-modal").addEventListener("dialog:before-hide", () => {
        this.player.dispatchEvent(new CustomEvent("player:start"));
        this.player.resume();
      });
      item.querySelector(".shop-the-look-item-modal").addEventListener("dialog:before-hide", () => {
        this.player.dispatchEvent(new CustomEvent("player:start"));
        this.player.resume();
      });
    });
  }
  /**
   * Create the animation when it changes from one slide to another, by making sure to properly handling the videos
   */
  createOnChangeAnimationControls(fromSlide, toSlide, { direction } = {}) {
    const fromVideo = Array.from(fromSlide.querySelectorAll("video")), toVideo = Array.from(toSlide.querySelectorAll("video")).filter((video) => video.offsetParent);
    if (this.querySelector("carousel-navigation")) {
      this.querySelector("carousel-navigation").classList.remove(fromSlide.getAttribute("content-color"));
      this.querySelector("carousel-navigation").classList.add(toSlide.getAttribute("content-color"));
    }
    this.updateHeaderTextColor(toSlide);
    fromSlide.removeEventListener("ended", __privateGet(this, _onVideoEndedListener), { capture: true });
    fromVideo.forEach((video) => {
      video.muted = true;
      video.pause();
    });
    toVideo.forEach((video) => {
      video.muted = true;
      video.currentTime = 0;
      video.play();
    });
    return {
      leaveControls: () => timeline18(__privateMethod(this, _SlideshowCarousel_instances, getSlideLeavingSequence_fn).call(this, fromSlide)),
      enterControls: () => timeline18(__privateMethod(this, _SlideshowCarousel_instances, getSlideEnteringSequence_fn).call(this, toSlide))
    };
  }
  /**
   * Update header text color when the slide changes
   */
  updateHeaderTextColor(toSlide) {
    document.querySelector(".shopify-section--header").style.setProperty("--header-text-color", `var(--color-${toSlide.getAttribute("content-color")})`);
  }
  _onSlideshowTap(event) {
    if (event.target.matches("button, a[href], button :scope, a[href] :scope") || !window.matchMedia("screen and (pointer: fine)").matches) {
      return;
    }
    event.detail.originalEvent.clientX > window.innerWidth / 2 ? this.next() : this.previous();
  }
};
_delegate4 = new WeakMap();
_onVideoEndedListener = new WeakMap();
_SlideshowCarousel_instances = new WeakSet();
autoplayPauseOnVideo_get = function() {
  return this.hasAttribute("autoplay-pause-on-video");
};
/**
 * Generate the part of the sequence when the given slide is entering
 */
getSlideEnteringSequence_fn = function(slide) {
  const slideContent = slide.querySelector(".slideshow__slide-content");
  return [
    //[slide, {opacity: [0, 1]}, {duration: 0.8, easing: [0.25, 0.46, 0.45, 0.94]}],
    [slide.querySelectorAll(".content-over-media > :is(video-media, svg), .content-over-media > picture img"), { opacity: [0, 1], transform: ["scale(1.2)", "scale(1)"] }, { duration: 0.6, at: "<", easing: [0.25, 0.46, 0.45, 0.94] }],
    [slideContent.querySelectorAll(".prose"), { opacity: [0, 1], transform: ["translateY(30px)", "translateY(0)"] }, { duration: 0.6, at: "-0.4", easing: [0.215, 0.61, 0.355, 1] }],
    [slideContent.querySelector(".button-group"), { opacity: [0, 1], transform: ["translateY(20px)", "translateY(0)"] }, { duration: 0.6, at: "-0.4", easing: [0.215, 0.61, 0.355, 1] }]
  ];
};
/**
 * Generate the part of the sequence when the given slide is leaving
 */
getSlideLeavingSequence_fn = function(slide) {
  const slideContent = slide.querySelector(".slideshow__slide-content");
  return [
    //[slide.querySelectorAll('.content-over-media > :is(video-media, svg), .content-over-media > picture img'), {opacity: [1, 0]}, {duration: 0.2, at: '<', easing: [0.55, 0.055, 0.675, 0.19]}],
    [slideContent.querySelectorAll(".prose"), { opacity: [1, 0], transform: ["translateY(0)", "translateY(10px)"] }, { duration: 0.25, at: "-0.4", easing: [0.55, 0.055, 0.675, 0.19] }],
    [slideContent.querySelector(".button-group"), { opacity: [1, 0], transform: ["translateY(0)", "translateY(20px)"] }, { duration: 0.25, at: "-0.4", easing: [0.55, 0.055, 0.675, 0.19] }]
  ];
};
/**
 * Mute the video for the active slide, by ignoring the video that may not be visible
 */
muteVideo_fn = function(event) {
  event.preventDefault();
  Array.from(this.selectedCell.querySelectorAll("video")).filter((video) => video.offsetParent).forEach((video) => video.muted = true);
};
/**
 * Unmute the video for the active slide, by ignoring the video that may not be visible
 */
unmuteVideo_fn = function(event) {
  event.preventDefault();
  Array.from(this.selectedCell.querySelectorAll("video")).filter((video) => video.offsetParent).forEach((video) => video.muted = false);
};
/**
 * Update the volume controls button (if any) based on whether the video is mute or not
 */
onVolumeChange_fn = function(event) {
  const volumeControl = event.target.closest(".slideshow__slide").querySelector(".slideshow__volume-control");
  if (volumeControl) {
    volumeControl.querySelector('[data-action="unmute"]').hidden = !event.target.muted;
    volumeControl.querySelector('[data-action="mute"]').hidden = event.target.muted;
  }
};
/**
 * Do action when the slide settles
 */
onSlideSettle_fn = function(event) {
  var _a;
  const videoList = Array.from(event.detail.cell.querySelectorAll("video"));
  if (__privateGet(this, _SlideshowCarousel_instances, autoplayPauseOnVideo_get) && this.cells.length > 1 && videoList.length > 0) {
    (_a = this.player) == null ? void 0 : _a.pause();
    videoList.forEach((video) => video.loop = false);
    event.detail.cell.addEventListener("ended", __privateGet(this, _onVideoEndedListener), { capture: true, once: true });
  }
};
/**
 * If the merchant decide to autorotate but to stop autoplay when video is playing, we register a listener that
 * will move to the next slide (if any)
 */
onVideoEnded_fn = function() {
  this.next();
};
/**
 * Scroll to the next section when the button is clicked, by leveraging JS native scroll
 */
onNextButtonClicked_fn = function() {
  var _a;
  (_a = this.closest(".shopify-section").nextElementSibling) == null ? void 0 : _a.scrollIntoView({ block: "start", behavior: "smooth" });
};
if (!window.customElements.get("slideshow-carousel")) {
  window.customElements.define("slideshow-carousel", SlideshowCarousel);
}

// js/sections/smart-grid.js
import { animate as animate21, scroll as scroll3 } from "vendor";
var _SmartGrid_instances, setupNativeScrollTimeline_fn, setupEmulateScrollTimeline_fn;
var SmartGrid = class extends HTMLElement {
  constructor() {
    super();
    __privateAdd(this, _SmartGrid_instances);
    if (Shopify.designMode) {
      this.closest(".shopify-section").addEventListener("shopify:section:select", () => this.classList.add("editor-is-selected"));
      this.closest(".shopify-section").addEventListener("shopify:section:deselect", () => this.classList.remove("editor-is-selected"));
      this.addEventListener("shopify:block:select", (event) => event.target.classList.add("editor-is-selected"));
      this.addEventListener("shopify:block:deselect", (event) => event.target.classList.remove("editor-is-selected"));
    }
  }
  connectedCallback() {
    if (window.ScrollTimeline) {
      __privateMethod(this, _SmartGrid_instances, setupNativeScrollTimeline_fn).call(this);
    } else {
      __privateMethod(this, _SmartGrid_instances, setupEmulateScrollTimeline_fn).call(this);
    }
  }
};
_SmartGrid_instances = new WeakSet();
/**
 * On modern browsers (as of today only Chrome) we can take advantage of ScrollTimeline feature, which
 * allows to perform parallax outside the main thread. This allows for butter smooth animations even
 * with a lot of elements
 */
setupNativeScrollTimeline_fn = function() {
  Array.from(this.querySelectorAll("[data-parallax-speed]")).forEach((element) => {
    const parallaxSpeed = parseInt(element.getAttribute("data-parallax-speed"));
    if (parallaxSpeed === 0) {
      return;
    }
    const offsetAmount = `${parallaxSpeed * 10 / 2}vmin`;
    element.animate({
      transform: element.getAttribute("data-parallax-direction") === "horizontal" ? [`translateX(calc(-1 * ${offsetAmount}))`, `translateX(${offsetAmount})`] : [`translateY(calc(-1 * ${offsetAmount}))`, `translateY(${offsetAmount})`]
    }, {
      fill: "forwards",
      timeline: new ViewTimeline({
        subject: this.closest(".shopify-section"),
        axis: "block"
      }),
      rangeStart: "cover 0%",
      rangeEnd: "cover 100%"
    });
  });
};
/**
 * On older browsers, we fallback to a more standard "scroll listener" based approach, by using MotionJS.
 */
setupEmulateScrollTimeline_fn = function() {
  Array.from(this.querySelectorAll("[data-parallax-speed]")).forEach((element) => {
    const parallaxSpeed = parseInt(element.getAttribute("data-parallax-speed"));
    if (parallaxSpeed === 0) {
      return;
    }
    const offsetAmount = `${parallaxSpeed * 10 / 2}vmin`;
    scroll3(
      animate21(element, {
        transform: element.getAttribute("data-parallax-direction") === "horizontal" ? [`translateX(calc(-1 * ${offsetAmount}))`, `translateX(${offsetAmount})`] : [`translateY(calc(-1 * ${offsetAmount}))`, `translateY(${offsetAmount})`]
      }),
      {
        offset: ["start end", "end start"],
        target: this.closest(".shopify-section")
      }
    );
  });
};
if (!window.customElements.get("smart-grid")) {
  window.customElements.define("smart-grid", SmartGrid);
}

// js/sections/timeline.js
import { animate as animate22, inView as inView13 } from "vendor";
var _abortController11;
var TimelineContent = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _abortController11);
  }
  connectedCallback() {
    __privateSet(this, _abortController11, new AbortController());
    this.headerHeight = getComputedStyle(document.documentElement).getPropertyValue("--header-height") ? parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-height")) : 0;
    inView13(this, () => {
      window.addEventListener("scroll", this.getTimelineCurrentDate.bind(this));
    });
  }
  get controlledElement() {
    return document.getElementById(this.getAttribute("aria-controls"));
  }
  disconnectedCallback() {
    __privateGet(this, _abortController11).abort();
  }
  getTimelineCurrentDate() {
    Array.from(this.children).forEach((item) => {
      let offsetTop = item.getBoundingClientRect().top;
      let offsetBottom = offsetTop + item.offsetHeight;
      let dateListOffset = this.controlledElement.getBoundingClientRect().top + this.controlledElement.offsetHeight / 2;
      if (this.controlledElement.getBoundingClientRect().top === this.headerHeight) {
        if (!this.controlledElement.querySelector(".timeline__date-list--sticky")) {
          this.controlledElement.parentElement.classList.add("timeline__date-list--sticky");
        }
      } else {
        if (this.controlledElement.querySelector(".timeline__date-list--sticky")) {
          this.controlledElement.parentElement.classList.remove("timeline__date-list--sticky");
        }
      }
      if (offsetTop < dateListOffset && dateListOffset < offsetBottom) {
        this.controlledElement.currentDate = item.getAttribute("data-date");
      }
    });
  }
};
_abortController11 = new WeakMap();
var _abortController12;
var TimelineDateList = class extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _abortController12);
  }
  static get observedAttributes() {
    return ["current-date"];
  }
  connectedCallback() {
    __privateSet(this, _abortController12, new AbortController());
  }
  get currentDate() {
    return this.getAttribute("current-date");
  }
  set currentDate(value) {
    this.setAttribute("current-date", value);
  }
  disconnectedCallback() {
    __privateGet(this, _abortController12).abort();
  }
  updateDate(oldDate, newDate) {
    animate22(newDate, { opacity: [0, 1] }, { duration: 0 });
    if (parseInt(this.currentDate) > parseInt(oldDate.getAttribute("data-date"))) {
      if (oldDate.querySelector("[first-two-digit]").innerText !== newDate.querySelector("[first-two-digit]").innerText) {
        timeline10([
          [oldDate.querySelector("[first-two-digit]"), { transform: ["translateY(0)", "translateY(-100%)"] }, { duration: 0.3, easing: "ease" }],
          [newDate.querySelector("[first-two-digit]"), { transform: ["translateY(100%)", "translateY(0)"] }, { duration: 0.3, easing: "ease", at: "<" }]
        ]);
        oldDate.querySelector("[last-two-digit]").style.transform = "translateY(-100%)";
        newDate.querySelector("[last-two-digit]").style.transform = "translateY(0)";
      }
      if (oldDate.querySelector("[last-two-digit]").innerText !== newDate.querySelector("[last-two-digit]").innerText) {
        timeline10([
          [oldDate.querySelector("[last-two-digit]"), { transform: ["translateY(0)", "translateY(-100%)"] }, { duration: 0.3, easing: "ease" }],
          [newDate.querySelector("[last-two-digit]"), { transform: ["translateY(100%)", "translateY(0)"] }, { duration: 0.3, easing: "ease", at: "<" }]
        ]);
        oldDate.querySelector("[first-two-digit]").style.transform = "translateY(-100%)";
        newDate.querySelector("[first-two-digit]").style.transform = "translateY(0)";
      }
    } else {
      if (oldDate.querySelector("[first-two-digit]").innerText !== newDate.querySelector("[first-two-digit]").innerText) {
        timeline10([
          [oldDate.querySelector("[first-two-digit]"), { transform: ["translateY(0)", "translateY(100%)"] }, { duration: 0.3, easing: "ease" }],
          [newDate.querySelector("[first-two-digit]"), { transform: ["translateY(-100%)", "translateY(0)"] }, { duration: 0.3, easing: "ease", at: "<" }]
        ]);
        oldDate.querySelector("[last-two-digit]").style.transform = "translateY(100%)";
        newDate.querySelector("[last-two-digit]").style.transform = "translateY(0)";
      }
      if (oldDate.querySelector("[last-two-digit]").innerText !== newDate.querySelector("[last-two-digit]").innerText) {
        timeline10([
          [oldDate.querySelector("[last-two-digit]"), { transform: ["translateY(0)", "translateY(100%)"] }, { duration: 0.3, easing: "ease" }],
          [newDate.querySelector("[last-two-digit]"), { transform: ["translateY(-100%)", "translateY(0)"] }, { duration: 0.3, easing: "ease", at: "<" }]
        ]);
        oldDate.querySelector("[first-two-digit]").style.transform = "translateY(100%)";
        newDate.querySelector("[first-two-digit]").style.transform = "translateY(0)";
      }
    }
    animate22(oldDate, { opacity: [1, 0] }, { duration: 0, delay: 0.3 });
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "current-date" && oldValue !== newValue) {
      let oldDate;
      let newDate;
      Array.from(this.children).forEach((item) => {
        if (item.getAttribute("data-date") === oldValue) {
          oldDate = item;
        }
        if (item.getAttribute("data-date") === newValue) {
          newDate = item;
        }
      });
      if (oldDate && newDate) {
        this.updateDate(oldDate, newDate);
      }
    }
  }
};
_abortController12 = new WeakMap();
if (!window.customElements.get("timeline-content")) {
  window.customElements.define("timeline-content", TimelineContent);
}
if (!window.customElements.get("timeline-date-list")) {
  window.customElements.define("timeline-date-list", TimelineDateList);
}

// js/theme.js
import { Delegate as Delegate10 } from "vendor";
(() => {
  const delegateDocument = new Delegate10(document.documentElement);
  delegateDocument.on("click", 'a[href*="#"]', (event, target) => {
    if (event.defaultPrevented || target.matches("[allow-hash-change]") || target.pathname !== window.location.pathname || target.search !== window.location.search) {
      return;
    }
    const url = new URL(target.href);
    if (url.hash === "") {
      return;
    }
    const anchorElement = document.querySelector(url.hash);
    if (anchorElement) {
      event.preventDefault();
      anchorElement.scrollIntoView({ block: "start", behavior: window.matchMedia("(prefers-reduced-motion: no-preference)").matches ? "smooth" : "auto" });
      document.documentElement.dispatchEvent(new CustomEvent("hashchange:simulate", { bubbles: true, detail: { hash: url.hash } }));
    }
  });
  Array.from(document.querySelectorAll(".prose table")).forEach((table) => {
    table.outerHTML = '<div class="table-scroller">' + table.outerHTML + "</div>";
  });
})();
export {
  AccordionDisclosure,
  AccountForm,
  AccountLogin,
  AlgoliaRecommend,
  AnnouncementBar,
  ArticleProgressBar,
  BadgeList,
  BeforeAfter,
  BoutiqueCarousel,
  Boutiques,
  BuyButtons,
  CarouselNavigation,
  CarouselNextButton,
  CarouselPrevButton,
  CartCount,
  CartCrossSellRecommendation,
  CartDrawer,
  CartNote,
  CheckoutButton,
  CollectionLayoutSwitch,
  CompareAtPrice,
  CopyButton,
  CountdownTimer,
  CountdownTimerFlip,
  CountrySelector,
  CountrySwitcherCustomSelect,
  CountrySwitcherLangCustomSelect,
  CountrySwitcherPopup,
  CustomCursor,
  CustomDetails,
  CustomForm,
  CustomerFieldsHandler,
  DateInput,
  DialogCloseButton,
  DialogElement,
  DimensionConverter,
  Drawer,
  EffectCarousel,
  FacetLink,
  FacetsBanner,
  FacetsDrawer,
  FacetsForm,
  FacetsSortPopover,
  FaqAnchor,
  GWPBar,
  GenderManager,
  GeolocationPopup,
  GestureArea,
  GiftCardCustomSelect,
  GiftPackage,
  Header,
  HeightObserver,
  HotspotsCarousel,
  KspCarousel,
  LineItemQuantity,
  LinesDrawerButton,
  Listbox,
  LoadingBar,
  LocalizationForm,
  MarqueeText,
  MaterialFilter,
  MaterialFocusImage,
  MaterialShowMore,
  MenuDisclosure,
  MenuDrawer,
  Modal,
  ModelMedia,
  MultiColumn,
  NewsletterPopup,
  OnSaleBadge,
  PageAnchors,
  PaymentTerms,
  PickupAvailability,
  Player,
  Popover,
  PressReviewCarousel,
  PriceRange,
  PrivacyBanner,
  ProductBackInStock,
  ProductCard,
  ProductForm,
  ProductGallery,
  ProductList,
  ProductListColumns,
  ProductLoadMore,
  ProductLoader,
  ProductMaterialInfo,
  ProductRecommendations,
  ProductScrollCarousel,
  ProductSticky,
  ProgressBar,
  QrCode,
  QuantityInput,
  QuantitySelector,
  QuickLinksSticky,
  ReadMore,
  RecentlyViewedProducts,
  SafeSticky,
  SalePrice,
  ScrollCarousel,
  ScrollingContent,
  ScrollingNav,
  SearchResults,
  SizeCompareCarousel,
  SizeCompareDrawer,
  SlideshowCarousel,
  SmartGrid,
  SoldOutBadge,
  Tabs,
  TimelineContent,
  TimelineDateList,
  UnitPrice,
  VariantInventory,
  VariantMedia,
  VariantPicker,
  VariantSku,
  VideoMedia,
  cachedFetch,
  createMediaImg,
  debounce,
  extractSectionId,
  fetchCart,
  formatMoney,
  generateSrcset,
  imageLoaded,
  ltRequest,
  matchesMediaQuery,
  mediaQueryListener,
  throttle,
  videoLoaded,
  waitForEvent
};
/*! Bundled license information:

@algolia/recommend/dist/recommend.umd.js:
  (*! recommend.umd.js | 4.24.0 | © Algolia, inc. | https://github.com/algolia/algoliasearch-client-javascript *)

algoliasearch/dist/algoliasearch.umd.js:
  (*! algoliasearch.umd.js | 4.24.0 | © Algolia, inc. | https://github.com/algolia/algoliasearch-client-javascript *)

@splidejs/splide/dist/js/splide.esm.js:
  (*!
   * Splide.js
   * Version  : 4.1.4
   * License  : MIT
   * Copyright: 2022 Naotoshi Fujita
   *)

@splidejs/splide-extension-auto-scroll/dist/js/splide-extension-auto-scroll.esm.js:
  (*!
   * @splidejs/splide-extension-auto-scroll
   * Version  : 0.5.3
   * License  : MIT
   * Copyright: 2022 Naotoshi Fujita
   *)
*/
